/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 43);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = cc;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixture = exports._c = exports.formatter = undefined;

var _formatter = __webpack_require__(9);

var _formatter2 = _interopRequireDefault(_formatter);

var _constants = __webpack_require__(42);

var _constants2 = _interopRequireDefault(_constants);

var _fixture = __webpack_require__(7);

var _fixture2 = _interopRequireDefault(_fixture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.formatter = _formatter2.default;
exports._c = _constants2.default;
exports.fixture = _fixture2.default; /*
                                      * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                      */

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = d3;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright JS Foundation and other contributors <https://js.foundation/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.2';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      reLeadingDot = /^\./,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * Adds the key-value `pair` to `map`.
   *
   * @private
   * @param {Object} map The map to modify.
   * @param {Array} pair The key-value pair to add.
   * @returns {Object} Returns `map`.
   */
  function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
  }

  /**
   * Adds `value` to `set`.
   *
   * @private
   * @param {Object} set The set to modify.
   * @param {*} value The value to add.
   * @returns {Object} Returns `set`.
   */
  function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
  }

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array of at least `200` elements
     * and any iteratees accept only one argument. The heuristic for whether a
     * section qualifies for shortcut fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE ||
          (arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function assignInDefaults(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, baseClone, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      value = Object(value);
      return (symToStringTag && symToStringTag in value)
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
      }
      if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        if (isObject(srcValue)) {
          stack || (stack = new Stack);
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = object[key],
          srcValue = source[key],
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      object = Object(object);
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `map`.
     *
     * @private
     * @param {Object} map The map to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned map.
     */
    function cloneMap(map, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
      return arrayReduce(array, addMapEntry, new map.constructor);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of `set`.
     *
     * @private
     * @param {Object} set The set to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned set.
     */
    function cloneSet(set, isDeep, cloneFunc) {
      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
      return arrayReduce(array, addSetEntry, new set.constructor);
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 &&
              isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = nativeMin(toInteger(precision), 292);
        if (precision) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] == null
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {Function} cloneFunc The function to clone values.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, cloneFunc, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return cloneMap(object, isDeep, cloneFunc);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return cloneSet(object, isDeep, cloneFunc);

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length &&
        (typeof value == 'number' || reIsUint.test(value)) &&
        (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function mergeDefaults(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, mergeDefaults, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (reLeadingDot.test(string)) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            result = wait - timeSinceLastCall;

        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are **not** supported.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(args) {
      args.push(undefined, assignInDefaults);
      return apply(assignInWith, undefined, args);
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, mergeDefaults);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = baseClamp(toInteger(position), 0, string.length);
      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, assignInDefaults);

      var imports = assignInWith({}, options.imports, settings.imports, assignInDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = (lodashFunc.name + ''),
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11), __webpack_require__(67)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.extend = extend;
exports.indexOf = indexOf;
exports.escapeExpression = escapeExpression;
exports.isEmpty = isEmpty;
exports.createFrame = createFrame;
exports.blockParams = blockParams;
exports.appendContextPath = appendContextPath;
var escape = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#x27;',
  '`': '&#x60;',
  '=': '&#x3D;'
};

var badChars = /[&<>"'`=]/g,
    possible = /[&<>"'`=]/;

function escapeChar(chr) {
  return escape[chr];
}

function extend(obj /* , ...source */) {
  for (var i = 1; i < arguments.length; i++) {
    for (var key in arguments[i]) {
      if (Object.prototype.hasOwnProperty.call(arguments[i], key)) {
        obj[key] = arguments[i][key];
      }
    }
  }

  return obj;
}

var toString = Object.prototype.toString;

exports.toString = toString;
// Sourced from lodash
// https://github.com/bestiejs/lodash/blob/master/LICENSE.txt
/* eslint-disable func-style */
var isFunction = function isFunction(value) {
  return typeof value === 'function';
};
// fallback for older versions of Chrome and Safari
/* istanbul ignore next */
if (isFunction(/x/)) {
  exports.isFunction = isFunction = function (value) {
    return typeof value === 'function' && toString.call(value) === '[object Function]';
  };
}
exports.isFunction = isFunction;

/* eslint-enable func-style */

/* istanbul ignore next */
var isArray = Array.isArray || function (value) {
  return value && typeof value === 'object' ? toString.call(value) === '[object Array]' : false;
};

exports.isArray = isArray;
// Older IE versions do not directly support indexOf so we must implement our own, sadly.

function indexOf(array, value) {
  for (var i = 0, len = array.length; i < len; i++) {
    if (array[i] === value) {
      return i;
    }
  }
  return -1;
}

function escapeExpression(string) {
  if (typeof string !== 'string') {
    // don't escape SafeStrings, since they're already safe
    if (string && string.toHTML) {
      return string.toHTML();
    } else if (string == null) {
      return '';
    } else if (!string) {
      return string + '';
    }

    // Force a string conversion as this will be done by the append regardless and
    // the regex test will do this transparently behind the scenes, causing issues if
    // an object's to string has escaped characters in it.
    string = '' + string;
  }

  if (!possible.test(string)) {
    return string;
  }
  return string.replace(badChars, escapeChar);
}

function isEmpty(value) {
  if (!value && value !== 0) {
    return true;
  } else if (isArray(value) && value.length === 0) {
    return true;
  } else {
    return false;
  }
}

function createFrame(object) {
  var frame = extend({}, object);
  frame._parent = object;
  return frame;
}

function blockParams(params, ids) {
  params.path = ids;
  return params;
}

function appendContextPath(contextPath, id) {
  return (contextPath ? contextPath + '.' : '') + id;
}
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var errorProps = ['description', 'fileName', 'lineNumber', 'message', 'name', 'number', 'stack'];

function Exception(message, node) {
  var loc = node && node.loc,
      line = undefined,
      column = undefined;
  if (loc) {
    line = loc.start.line;
    column = loc.start.column;

    message += ' - ' + line + ':' + column;
  }

  var tmp = Error.prototype.constructor.call(this, message);

  // Unfortunately errors are not enumerable in Chrome (at least), so `for prop in tmp` doesn't work.
  for (var idx = 0; idx < errorProps.length; idx++) {
    this[errorProps[idx]] = tmp[errorProps[idx]];
  }

  /* istanbul ignore else */
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, Exception);
  }

  try {
    if (loc) {
      this.lineNumber = line;

      // Work around issue under safari where we can't directly set the column value
      /* istanbul ignore next */
      if (Object.defineProperty) {
        Object.defineProperty(this, 'column', { value: column });
      } else {
        this.column = column;
      }
    }
  } catch (nop) {
    /* Ignore if the browser is very particular */
  }
}

Exception.prototype = new Error();

exports['default'] = Exception;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = __webpack_require__(52)['default'];


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var data = [];
  var length = p.length || 21;
  var dataConfig = p.data || {
    t: { linear: true, range: [1475760930000, 1475800930000] },
    x: { linear: true, range: [0, length] },
    a: { linear: true, range: [0, length * 3] },
    b: { linear: true, range: [0, length * 5] },
    c: { linear: true, range: [0, length * 7] },
    d: { linear: true, range: [0, length * 4] },
    random: { random: true, range: [0, length * 7] }
  };
  _lodash2.default.each(dataConfig, function (config, key) {
    if (config.linear) config.scale = d3Scale.scaleLinear().domain([0, length]).range(config.range);
    if (config.random) config.scale = d3Scale.scaleLinear().domain([0, 1]).range(config.range);
    for (var i = 0; i < length; i++) {
      var datum = void 0;
      if (config.linear) datum = config.scale(i);
      if (config.random) datum = config.scale(Math.random());

      // Gap between data
      if (config.gap && i > Math.floor(length * 0.5) && i < Math.floor(length * 0.7)) continue;

      // Repeating region
      if (config.repeat && i > Math.floor(length * 0.2) && i < Math.floor(length * 0.4)) {
        datum = _lodash2.default.get(data[i - 1], key);
      }

      data[i] = data[i] || {};
      _lodash2.default.set(data[i], key, datum);
    }
  });
  return data;
};

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _d3Scale = __webpack_require__(2);

var d3Scale = _interopRequireWildcard(_d3Scale);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = undefined;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Format = __webpack_require__(2);

var d3Format = _interopRequireWildcard(_d3Format);

var _d3TimeFormat = __webpack_require__(2);

var d3TimeFormat = _interopRequireWildcard(_d3TimeFormat);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */

var extendedISOTime = d3TimeFormat.timeFormat('%H:%M:%S');
var toInteger = d3Format.format('.0f');
var toFixed1 = d3Format.format('.1f');
var commaGroupedInteger = d3Format.format(',.0f');

function toFixedNumberFactory(digits) {
  return d3Format.format('.' + digits + 'f');
}

function byteFormatter1K(bytes) {
  bytes *= 1024;
  return byteFormatter(bytes);
}

function byteFormatter(bytes) {
  var unit = 1024;

  if (bytes < 0) bytes *= -1;
  if (bytes < unit) return bytes + ' B';

  var scale = Math.floor(Math.log(bytes) / Math.log(unit));
  var unitPre = 'KMGTPE'.substr(scale - 1, 1);

  return (bytes / Math.pow(unit, scale)).toFixed(1) + ' ' + unitPre + 'B';
}

function toFixedPercentage1(number) {
  return number.toFixed(1) + '%';
}

exports.default = {
  extendedISOTime: extendedISOTime,
  toInteger: toInteger,
  toFixed1: toFixed1,
  toFixedNumberFactory: toFixedNumberFactory,
  commaGroupedInteger: commaGroupedInteger,
  byteFormatter: byteFormatter,
  toFixedPercentage1: toFixedPercentage1,
  byteFormatter1K: byteFormatter1K
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HandlebarsEnvironment = HandlebarsEnvironment;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

var _helpers = __webpack_require__(55);

var _decorators = __webpack_require__(53);

var _logger = __webpack_require__(63);

var _logger2 = _interopRequireDefault(_logger);

var VERSION = '4.0.5';
exports.VERSION = VERSION;
var COMPILER_REVISION = 7;

exports.COMPILER_REVISION = COMPILER_REVISION;
var REVISION_CHANGES = {
  1: '<= 1.0.rc.2', // 1.0.rc.2 is actually rev2 but doesn't report it
  2: '== 1.0.0-rc.3',
  3: '== 1.0.0-rc.4',
  4: '== 1.x.x',
  5: '== 2.0.0-alpha.x',
  6: '>= 2.0.0-beta.1',
  7: '>= 4.0.0'
};

exports.REVISION_CHANGES = REVISION_CHANGES;
var objectType = '[object Object]';

function HandlebarsEnvironment(helpers, partials, decorators) {
  this.helpers = helpers || {};
  this.partials = partials || {};
  this.decorators = decorators || {};

  _helpers.registerDefaultHelpers(this);
  _decorators.registerDefaultDecorators(this);
}

HandlebarsEnvironment.prototype = {
  constructor: HandlebarsEnvironment,

  logger: _logger2['default'],
  log: _logger2['default'].log,

  registerHelper: function registerHelper(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple helpers');
      }
      _utils.extend(this.helpers, name);
    } else {
      this.helpers[name] = fn;
    }
  },
  unregisterHelper: function unregisterHelper(name) {
    delete this.helpers[name];
  },

  registerPartial: function registerPartial(name, partial) {
    if (_utils.toString.call(name) === objectType) {
      _utils.extend(this.partials, name);
    } else {
      if (typeof partial === 'undefined') {
        throw new _exception2['default']('Attempting to register a partial called "' + name + '" as undefined');
      }
      this.partials[name] = partial;
    }
  },
  unregisterPartial: function unregisterPartial(name) {
    delete this.partials[name];
  },

  registerDecorator: function registerDecorator(name, fn) {
    if (_utils.toString.call(name) === objectType) {
      if (fn) {
        throw new _exception2['default']('Arg not supported with multiple decorators');
      }
      _utils.extend(this.decorators, name);
    } else {
      this.decorators[name] = fn;
    }
  },
  unregisterDecorator: function unregisterDecorator(name) {
    delete this.decorators[name];
  }
};

var log = _logger2['default'].log;

exports.log = log;
exports.createFrame = _utils.createFrame;
exports.logger = _logger2['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 11 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _d3Scale = __webpack_require__(2);

var d3Scale = _interopRequireWildcard(_d3Scale);

var _data = __webpack_require__(38);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var chart = void 0; /*
                     * Copyright (c) Juniper Networks, Inc. All rights reserved.
                     */

var config = {
  id: 'chartBox',
  components: [{
    id: 'sankey-chart-component',
    type: 'Sankey',
    config: {
      margin: {
        left: 80,
        right: 80,
        bottom: 40,
        top: 5
      },
      colorScheme: d3Scale.schemeCategory20,
      levels: [{ level: 0, label: 'Virtual Network' }, { level: 1, label: 'IP' }, { level: 2, label: 'Port' }],
      parseConfig: {
        parse: function parse(d) {
          var links = [];
          var srcHierarchy = [d.sourcevn, d.sourceip, d.sport];
          var dstHierarchy = [d.destvn, d.destip, d.dport];
          links.push({
            source: 'svn-' + srcHierarchy[0] + '-sip-' + srcHierarchy[1] + '-sport-' + srcHierarchy[2],
            target: 'svn-' + srcHierarchy[0] + '-sip-' + srcHierarchy[1],
            value: d['agg-bytes'],
            sourceNode: { label: srcHierarchy[2], level: 2 },
            targetNode: { label: srcHierarchy[1], level: 1 },
            label: srcHierarchy[2] + ' - ' + srcHierarchy[1]
          });
          links.push({
            source: 'svn-' + srcHierarchy[0] + '-sip-' + srcHierarchy[1],
            target: 'svn-' + srcHierarchy[0],
            value: d['agg-bytes'],
            sourceNode: { label: srcHierarchy[1], level: 1 },
            targetNode: { label: srcHierarchy[0], level: 0 },
            label: srcHierarchy[1] + ' - ' + srcHierarchy[0]
          });
          links.push({
            source: 'svn-' + srcHierarchy[0],
            target: 'dvn-' + dstHierarchy[0],
            value: d['agg-bytes'],
            sourceNode: { label: srcHierarchy[0], level: 0 },
            targetNode: { label: dstHierarchy[0], level: 0 },
            label: srcHierarchy[0] + ' - ' + dstHierarchy[0]
          });
          links.push({
            source: 'dvn-' + dstHierarchy[0],
            target: 'dvn-' + dstHierarchy[0] + '-dip-' + dstHierarchy[1],
            value: d['agg-bytes'],
            sourceNode: { label: dstHierarchy[0], level: 0 },
            targetNode: { label: dstHierarchy[1], level: 1 },
            label: dstHierarchy[0] + ' - ' + dstHierarchy[1]
          });
          links.push({
            source: 'dvn-' + dstHierarchy[0] + '-dip-' + dstHierarchy[1],
            target: 'dvn-' + dstHierarchy[0] + '-dip-' + dstHierarchy[1] + '-dport-' + dstHierarchy[2],
            value: d['agg-bytes'],
            sourceNode: { label: dstHierarchy[1], level: 1 },
            targetNode: { label: dstHierarchy[2], level: 2 },
            label: dstHierarchy[1] + ' - ' + dstHierarchy[2]
          });
          return links;
        }
      },
      tooltip: 'tooltip-id'
    }
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      formatter: function formatter(d) {
        var type = ['Virtual Network', 'IP', 'Port'];
        var content = { title: d.data.label, items: [] };
        content.items.push({
          label: 'Source',
          value: type[d.data.sourceNode.level] + ' ' + d.data.sourceNode.label
        }, {
          label: 'Target',
          value: type[d.data.targetNode.level] + ' ' + d.data.targetNode.label
        }, {
          label: 'Flow',
          value: d.data.value
        });
        return content;
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(_data2.default.data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _formatter = __webpack_require__(9);

var _formatter2 = _interopRequireDefault(_formatter);

var _fixture = __webpack_require__(7);

var _fixture2 = _interopRequireDefault(_fixture);

var _d3Scale = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 10;
var data = (0, _fixture2.default)({
  length: length,
  data: {
    'group.t': { linear: true, range: [1475760930000, 1475800930000] },
    'group.a': { random: true, range: [0, length * 3] },
    b: { random: true, range: [0, -length * 5] },
    c: { random: true, range: [0, -length * 7] }
  }
});
data[5].a = -10;

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'legend-id',
    type: 'LegendPanel',
    config: {
      editable: {
        color: true
      }
    }
  }, {
    id: 'compositey-id',
    type: 'CompositeY',
    config: {
      crosshair: 'crosshair-id',
      legend: 'legend-id',
      plot: {
        x: {
          accessor: 'group.t',
          axis: 'x'
        },
        y: [{
          accessor: 'group.a',
          chart: 'Area',
          stack: 'positive',
          axis: 'y',
          color: _d3Scale.schemeCategory20[0],
          tooltip: 'default-tooltip'
        }, {
          accessor: 'b',
          chart: 'Area',
          stack: 'negative',
          axis: 'y',
          color: _d3Scale.schemeCategory20[1],
          tooltip: 'default-tooltip'
        }, {
          accessor: 'c',
          chart: 'Area',
          stack: 'negative',
          axis: 'y',
          color: _d3Scale.schemeCategory20[8],
          tooltip: 'default-tooltip'
        }]
      },
      axes: {
        x: {
          formatter: _formatter2.default.extendedISOTime
        },
        y: {
          ticks: 10
        }
      }
    }
  }, {
    id: 'crosshair-id',
    type: 'Crosshair',
    config: {
      tooltip: 'default-tooltip'
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 'group.t',
        labelFormatter: 'Time',
        valueFormatter: _formatter2.default.extendedISOTime
      }, {
        accessor: 'group.a',
        valueFormatter: _formatter2.default.toInteger
      }, {
        accessor: 'b',
        valueFormatter: _formatter2.default.toInteger
      }, {
        accessor: 'c',
        valueFormatter: _formatter2.default.toInteger
      }]
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _world110m = __webpack_require__(40);

var _world110m2 = _interopRequireDefault(_world110m);

var _cities = __webpack_require__(39);

var _cities2 = _interopRequireDefault(_cities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chart = void 0; /*
                     * Copyright (c) Juniper Networks, Inc. All rights reserved.
                     */

var config = {
  id: 'chartBox',
  components: [{
    id: 'map-id',
    type: 'Map',
    config: {
      map: _world110m2.default,
      feature: 'countries',
      fit: 'land',
      tooltip: 'tooltip-id'
    }
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      title: {
        accessor: 'city'
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(_cities2.default);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

__webpack_require__(44);

var data = (0, _commons.fixture)({
  length: 20,
  data: {
    'group.x': { linear: true, range: [1475760930000, 1475800930000] },
    'group.data1': { random: true, range: [0, 50], gap: true },
    data2: { random: true, range: [0, 100], repeat: true },
    data3: { random: true, range: [0, 100] },
    'group.size1': { random: true, range: [0, 10] },
    size2: { random: true, range: [0, 20] },
    nav: { random: true, range: [0, 10] }
  }
}); /*
     * Copyright (c) Juniper Networks, Inc. All rights reserved.
     */


var colorScheme = _commons._c.palette;
var bubbleShapes = _contrailCharts.Util.bubbleShapes;

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'legend-id',
    type: 'LegendPanel',
    config: {
      editable: {
        color: true
      }
    }
  }, {
    id: 'multishape-bubble-chart',
    type: 'CompositeY',
    config: {
      legend: 'legend-id',
      bucket: 'bucket-id',
      update: ['navigation-id'],
      height: 450,
      plot: {
        x: {
          accessor: 'group.x',
          axis: 'x'
        },
        y: [{
          accessor: 'group.data1',
          label: 'Data 1',
          chart: 'ScatterPlot',
          size: {
            accessor: 'group.size1',
            range: [200, 100]
          },
          // this is a circle symbol from fontawesome
          // shape: bubbleShapes.circleFill,
          color: function color(d) {
            return colorScheme[0];
          },
          axis: 'y1',
          tooltip: 'tooltip-id'
        }, {
          accessor: 'data2',
          label: 'Data 2',
          chart: 'ScatterPlot',
          size: {
            accessor: 'size2',
            range: [400, 2000]
          },
          color: colorScheme[5],
          shape: bubbleShapes.cloud,
          axis: 'y2',
          tooltip: 'tooltip-id'
        }, {
          accessor: 'data3',
          label: 'Data 3',
          chart: 'ScatterPlot',
          size: {
            accessor: 'size2',
            range: [400, 2000]
          },
          shape: bubbleShapes.network,
          color: function color(d) {
            return d.data3 > 80 ? colorScheme[9] : colorScheme[8];
          },
          axis: 'y2',
          tooltip: 'tooltip-id'
        }]
      },
      axes: {
        x: {
          formatter: _commons.formatter.extendedISOTime
        },
        y1: {
          position: 'left',
          formatter: _commons.formatter.toInteger,
          label: 'Y value of circles'
        },
        y2: {
          position: 'right',
          formatter: _commons.formatter.toInteger,
          label: 'Y value of Cloud and Network'
        }
      }
    }
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      title: {
        accessor: 'group.x',
        valueFormatter: _commons.formatter.extendedISOTime
      },
      dataConfig: [{
        accessor: 'group.data1',
        labelFormatter: 'Circle',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'data2',
        labelFormatter: 'Cloud',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'data3',
        labelFormatter: 'Network',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'group.size1',
        labelFormatter: 'Size of Circle',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'size2',
        labelFormatter: 'Size of Cloud and Network',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }, {
    id: 'bucket-id',
    type: 'Bucket',
    config: {
      range: [500, 800],
      shape: bubbleShapes.bucket,
      tooltip: 'tooltip-bucket'
    }
  }, {
    id: 'tooltip-bucket',
    type: 'Tooltip',
    config: {
      title: {
        accessor: function accessor(d) {
          return 'Points in Bucket: ' + d.length;
        }
      }
    }
  }, {
    id: 'navigation-id',
    type: 'Navigation',
    config: {
      height: 200,
      selection: [50, 100],
      update: ['multishape-bubble-chart'],
      plot: {
        x: {
          accessor: 'group.x'
        },
        y: [{
          accessor: 'nav',
          chart: 'Line',
          color: colorScheme[1]
        }]
      },
      axes: {
        x: {
          formatter: _commons.formatter.extendedISOTime
        },
        y: {
          ticks: 6
        }
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _template = __webpack_require__(47);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var colorScheme = _commons._c.palette;

var now = _lodash2.default.now();
var length = 100;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    x: { linear: true, range: [now - 30000000, now] },
    a: { random: true, range: [2, (length - 1) * 2] },
    b: { random: true, range: [3, (length - 1) * 3] },
    c: { random: true, range: [7, (length - 1) * 7] },
    d: { random: true, range: [9, (length - 1) * 9] }
  }
});

function pieDataParser(tsData) {
  var tsSumData = _lodash2.default.reduce(tsData, function (v1, v2) {
    return {
      a: v1.a + v2.a,
      b: v1.b + v2.b,
      c: v1.c + v2.c
    };
  });
  return _lodash2.default.map(tsSumData, function (v, k) {
    return {
      label: k,
      value: v
    };
  });
}

var chart = void 0;
var config = {
  id: 'chartBox',
  template: _template2.default,
  components: [{
    id: 'legend-panel-id',
    type: 'LegendPanel',
    config: {}
  }, {
    id: 'compositey-chart-id',
    type: 'CompositeY',
    config: {
      legend: 'legend-panel-id',
      crosshair: 'crosshair-id',
      plot: {
        x: {
          accessor: 'x',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          chart: 'GroupedBar',
          color: colorScheme[0],
          axis: 'y'
        }, {
          accessor: 'b',
          chart: 'GroupedBar',
          color: colorScheme[1],
          axis: 'y'
        }]
      },
      axes: {
        x: {
          ticks: 6,
          formatter: _commons.formatter.extendedISOTime
        },
        y: {
          ticks: 5
        }
      }
    }
  }, {
    id: 'crosshair-id',
    config: {
      container: 'compositey-chart-id',
      tooltip: 'tooltip-id'
    },
    type: 'Crosshair'
  }, {
    id: 'message-id',
    type: 'Message',
    config: {}
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      title: {
        accessor: 'x',
        valueFormatter: _commons.formatter.extendedISOTime
      },
      dataConfig: [{
        accessor: 'a',
        labelFormatter: 'Label A',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'b',
        labelFormatter: 'Label B',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'c',
        labelFormatter: 'Label C',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'd',
        labelFormatter: 'Label D',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }, {
    id: 'legend-panel-id2',
    type: 'LegendPanel',
    config: {}
  }, {
    type: 'CompositeY',
    id: 'compositey-chart-id2',
    config: {
      legend: 'legend-panel-id2',
      height: 300,
      plot: {
        x: {
          accessor: 'x',
          axis: 'x'
        },
        y: [{
          accessor: 'c',
          chart: 'Line',
          axis: 'y',
          color: colorScheme[2]
        }]
      },
      axes: {
        x: {
          formatter: _commons.formatter.extendedISOTime,
          ticks: 4
        },
        y: {
          ticks: 5
        }
      }
    }
  }, {
    id: 'pie-chart-id',
    type: 'Pie',
    model: {
      formatter: pieDataParser
    },
    config: {
      legend: 'legend-pie',
      type: 'donut',
      radius: 100,
      width: 200,
      height: 300,
      colorScale: d3.scaleOrdinal().range([colorScheme[3], colorScheme[5], colorScheme[9]]), // eslint-disable-line no-undef
      serie: {
        getValue: function getValue(serie) {
          return serie.value;
        },
        getLabel: function getLabel(serie) {
          return serie.label;
        },
        valueFormatter: _commons.formatter.commaGroupedInteger
      },
      tooltip: 'tooltip-id2',
      action: {
        'click node': function clickNode(data) {
          chart.actionman.fire('SendMessage', {
            action: 'update',
            messages: [{
              level: 'info',
              title: 'Pie chart message',
              text: 'Sum of selected "' + data.label + '" values: ' + data.value
            }]
          });
        }
      }
    }
  }, {
    id: 'tooltip-id2',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 'value',
        labelFormatter: function labelFormatter(serie) {
          return serie.label;
        },
        valueFormatter: _commons.formatter.commaGroupedInteger
      }]
    }
  }, {
    id: 'legend-pie',
    type: 'Legend',
    config: {}
  }, {
    id: 'navigation-id',
    type: 'Navigation',
    config: {
      height: 250,
      selection: [75, 100],
      update: ['compositey-chart-id2'],
      plot: {
        x: {
          accessor: 'x',
          axis: 'x',
          label: 'Time'
        },
        y: [{
          accessor: 'd',
          label: 'Label D',
          chart: 'Line',
          color: colorScheme[4],
          axis: 'y'
        }]
      },
      axes: {
        x: {
          ticks: 8,
          formatter: _commons.formatter.extendedISOTime
        },
        y: {
          ticks: 6
        }
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);

    // Update pie chart data on Navigation zoom
    var navigation = chart.composite.get('navigation-id');
    var zoom = navigation.actionman.get('Zoom');
    var pie = chart.composite.get('pie-chart-id');
    zoom.on('fired', function (componentIds, ranges) {
      var data = navigation.model.filter('x', ranges['x']);
      pie.model.data = data;
    });
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _template = __webpack_require__(48);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorScheme = _commons._c.paletteSoft; /*
                                            * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                            */


var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    x: { linear: true, range: [0, length] },
    a: { random: true, range: [0, length * 5], repeat: true },
    b: { linear: true, range: [0, length * 3], repeat: true },
    c: { random: true, range: [0, -length * 3] },
    d: { linear: true, range: [0, length * 5] }
  }
});

var chart = void 0;
var config = {
  id: 'chartBox',
  template: _template2.default,
  components: [{
    id: 'stacked-bar-id',
    type: 'CompositeY',
    config: {
      height: 350,
      plot: {
        x: {
          accessor: 'x',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          label: 'Label A',
          chart: 'StackedBar',
          color: colorScheme[0],
          axis: 'y'
        }, {
          accessor: 'b',
          label: 'Label B',
          chart: 'StackedBar',
          color: colorScheme[2],
          axis: 'y'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear',
          label: 'X'
        },
        y: {
          ticks: 10
        }
      }
    }
  }, {
    id: 'grouped-bar-id',
    type: 'CompositeY',
    config: {
      height: 350,
      plot: {
        x: {
          accessor: 'x',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          label: 'Label A',
          chart: 'GroupedBar',
          color: colorScheme[12],
          axis: 'y'
        }, {
          accessor: 'b',
          label: 'Label B',
          chart: 'GroupedBar',
          color: colorScheme[14],
          axis: 'y'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear',
          label: 'X'
        },
        y: {
          ticks: 10
        }
      }
    }
  }, {
    id: 'area-id',
    type: 'CompositeY',
    config: {
      height: 300,
      plot: {
        x: {
          accessor: 'x',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          label: 'Label A',
          chart: 'Area',
          axis: 'y',
          color: colorScheme[3]
        }, {
          accessor: 'c',
          label: 'Label C',
          chart: 'Area',
          stack: 'negative',
          axis: 'y',
          color: colorScheme[9]
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear',
          label: 'X'
        },
        y: {
          ticks: 10
        }
      }
    }
  }, {
    id: 'line-id',
    type: 'CompositeY',
    config: {
      height: 300,
      plot: {
        x: {
          accessor: 'd',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          label: 'Label A',
          chart: 'Line',
          axis: 'y',
          color: colorScheme[4]
        }, {
          accessor: 'c',
          label: 'Label C',
          chart: 'Line',
          axis: 'y',
          color: colorScheme[6]
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear',
          label: 'D',
          ticks: 8
        },
        y: {
          ticks: 10
        }
      }
    }
  }, {
    id: 'navigation-id',
    type: 'Navigation',
    config: {
      height: 250,
      selection: [60, 100],
      update: ['area-id', 'stacked-bar-id', 'grouped-bar-id'],
      plot: {
        x: {
          accessor: 'x',
          axis: 'x',
          label: 'X'
        },
        y: [{
          accessor: 'a',
          label: 'Label D',
          color: colorScheme[0],
          chart: 'Line',
          axis: 'y'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear'
        },
        y: {
          ticks: 5
        }
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    b: { linear: true, range: [5, (length - 1) * 5], repeat: true },
    c: { linear: true, range: [7, (length - 1) * 7] }
  }
});

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'stacked-bar-compositey',
    type: 'CompositeY',
    config: {
      plot: {
        x: {
          accessor: 'group.x',
          labelFormatter: 'Value',
          axis: 'x'
        },
        y: [{
          accessor: 'group.a',
          chart: 'GroupedBar',
          labelFormatter: 'Label Group.A',
          tooltip: 'default-tooltip',
          axis: 'y1'
        }, {
          accessor: 'b',
          chart: 'GroupedBar',
          labelFormatter: 'Label B',
          tooltip: 'default-tooltip',
          axis: 'y1'
        }, {
          accessor: 'c',
          chart: 'GroupedBar',
          labelFormatter: 'Label C',
          tooltip: 'default-tooltip',
          axis: 'y1',
          color: '#ffbb78'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear'
        },
        y1: {
          position: 'left'
        }
      }
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 'group.x',
        labelFormatter: 'Value'
      }, {
        accessor: 'group.a',
        labelFormatter: 'Tooltip Group.A'
      }, {
        accessor: 'b',
        labelFormatter: 'Tooltip B'
      }, {
        accessor: 'c',
        labelFormatter: 'Tooltip C'
      }]
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var colorScheme = _commons._c.palette;

var length = 100;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    x: { linear: true, range: [0, length] },
    a: { random: true, range: [3, (length - 1) * 3] },
    b: { random: true, range: [5, (length - 1) * 5], repeat: true },
    c: { random: true, range: [7, (length - 1) * 7] },
    d: { linear: true, range: [7, (length - 1) * 7] },
    e: { random: true, range: [2, (length - 1) * 2] }
  }
});

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'legend-id',
    type: 'LegendPanel',
    config: {
      editable: {
        color: true,
        chart: true
      }
    }
  }, {
    id: 'compositey-chart-id',
    type: 'CompositeY',
    config: {
      legend: 'legend-id',
      crosshair: 'crosshair-id',
      margin: {
        left: 16,
        right: 20
      },
      height: 400,
      chartTypes: {
        y1: ['GroupedBar', 'StackedBar'],
        y2: ['Line']
      },
      plot: {
        x: {
          accessor: 'x',
          labelFormatter: 'X Values',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          labelFormatter: 'Label A',
          chart: 'GroupedBar',
          axis: 'y1',
          tooltip: 'default-tooltip',
          color: colorScheme[0]
        }, {
          accessor: 'b',
          labelFormatter: 'Label B',
          chart: 'GroupedBar',
          axis: 'y1',
          tooltip: 'default-tooltip',
          color: colorScheme[1]
        }, {
          accessor: 'c',
          labelFormatter: 'Label C',
          disabled: true,
          chart: 'GroupedBar',
          axis: 'y1',
          tooltip: 'default-tooltip',
          color: colorScheme[2]
        }, {
          accessor: 'd',
          labelFormatter: 'Label D',
          color: colorScheme[6],
          chart: 'Line',
          axis: 'y2',
          tooltip: 'default-tooltip'
        }, {
          accessor: 'e',
          labelFormatter: 'Label E',
          color: colorScheme[4],
          chart: 'Line',
          axis: 'y2',
          tooltip: 'default-tooltip'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear',
          label: 'X'
        },
        y1: {
          position: 'left',
          formatter: _commons.formatter.toInteger,
          domain: [-10, undefined]
        },
        y2: {
          position: 'right',
          formatter: _commons.formatter.toFixed1
        }
      }
    }
  }, {
    type: 'Navigation',
    config: {
      margin: {
        left: 16
      },
      height: 200,
      selection: [75, 100],
      update: ['compositey-chart-id'],
      plot: {
        x: {
          accessor: 'x',
          labelFormatter: 'X Values'
        },
        y: [{
          accessor: 'a',
          labelFormatter: 'Label A',
          chart: 'StackedBar',
          color: colorScheme[0]
        }, {
          accessor: 'b',
          labelFormatter: 'Label B',
          chart: 'StackedBar',
          color: colorScheme[1]
        }, {
          accessor: 'd',
          labelFormatter: 'Label D',
          chart: 'Line',
          color: colorScheme[6]
        }]
      },
      axis: {
        x: {
          scale: 'scaleLinear'
        },
        y: {
          formatter: _commons.formatter.toInteger,
          ticks: 5
        }
      }
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      title: {
        accessor: 'x'
      },
      dataConfig: [{
        accessor: 'a',
        labelFormatter: 'Label A',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'b',
        labelFormatter: 'Label B',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'c',
        labelFormatter: 'Label C',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'd',
        labelFormatter: 'Label D',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'e',
        labelFormatter: 'Label E',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }, {
    id: 'message-id',
    type: 'Message',
    config: {}
  }, {
    id: 'crosshair-id',
    type: 'Crosshair',
    config: {
      tooltip: 'default-tooltip'
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
    chart.actionman.fire('SendMessage', {
      action: 'once',
      messages: [{
        level: 'info',
        title: 'Message 1',
        text: 'This is an example message. It will disappear after 5 seconds.'
      }, {
        level: 'error',
        title: 'A Fatal Error',
        text: 'This is an error.'
      }, {
        level: 'warn',
        title: 'A warning message',
        text: 'This is another example message.'
      }]
    });
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _template = __webpack_require__(49);

var _template2 = _interopRequireDefault(_template);

__webpack_require__(45);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var length = 20; /*
                  * Copyright (c) Juniper Networks, Inc. All rights reserved.
                  */

var counter = length;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    x: { linear: true, range: [0, length] },
    a: { linear: true, range: [0, length * 3] }
  }
});

var chart = void 0;
var config = {
  id: 'chartBox',
  template: _template2.default,
  components: [{
    id: 'control-panel-id',
    type: 'ControlPanel',
    config: {
      menu: [{
        id: 'Halt'
      }],
      update: ['compositey-id']
    }
  }, {
    id: 'compositey-id',
    type: 'CompositeY',
    config: {
      height: 600,
      crosshair: 'crosshair-id',
      plot: {
        x: {
          accessor: 'x',
          labelFormatter: 'X Value',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          labelFormatter: 'Label A',
          chart: 'StackedBar',
          axis: 'y1',
          tooltip: 'default-tooltip'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear'
        },
        y1: {
          formatter: _commons.formatter.toInteger
        }
      }
    }
  }, {
    id: 'crosshair-id',
    type: 'Crosshair',
    config: {
      tooltip: 'default-tooltip'
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 'x',
        labelFormatter: 'X value'
      }, {
        accessor: 'a',
        labelFormatter: 'Tooltip A',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }]
};

var intervalId = -1;

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
    intervalId = setInterval(function () {
      data.shift();
      data.push({ x: counter, a: _lodash2.default.random(0, length * 3) });
      chart.setData(data);
      counter++;
    }, 1000);
  },
  remove: function remove() {
    clearInterval(intervalId);
    chart.remove();
  },
  stopUpdating: function stopUpdating() {
    clearInterval(intervalId);
    intervalId = -1;
  }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    'group.b': { linear: true, range: [4, (length - 1) * 4] },
    'group.c': { linear: true, range: [-3, (length - 1) * -3] },
    b: { linear: true, range: [5, (length - 1) * 5], repeat: true },
    c: { linear: true, range: [7, (length - 1) * 7] }
  }
});

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'grouped-bar-compositey',
    type: 'CompositeY',
    config: {
      crosshair: 'crosshair-id',
      plot: {
        x: {
          accessor: 'group.x',
          labelFormatter: 'Value',
          axis: 'x'
        },
        y: [{
          accessor: 'group.a',
          labelFormatter: 'Label Group.A',
          chart: 'StackedBar',
          stack: 'positive',
          axis: 'y1',
          tooltip: 'default-tooltip'
        }, {
          accessor: 'group.b',
          labelFormatter: 'Label Group.B',
          chart: 'StackedBar',
          stack: 'positive',
          axis: 'y1',
          tooltip: 'default-tooltip'
          //}, {
          //accessor: 'group.c',
          //labelFormatter: 'Label Group.C',
          //chart: 'StackedBar',
          //stack: 'negative',
          //axis: 'y1',
          //tooltip: 'default-tooltip',
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear'
        },
        y1: {},
        y2: {
          position: 'right'
        }
      }
    }
  }, {
    id: 'crosshair-id',
    type: 'Crosshair',
    config: {
      tooltip: 'default-tooltip'
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 'group.x',
        labelFormatter: 'Value'
      }, {
        accessor: 'group.a',
        labelFormatter: 'Tooltip Group.A'
      }, {
        accessor: 'b',
        labelFormatter: 'Tooltip B'
      }, {
        accessor: 'c',
        labelFormatter: 'Tooltip C'
      }]
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = (0, _commons.fixture)(); /*
                                     * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                     */

var template = _lodash2.default.template('<div component="chart-id"></div>\n  <div component="timeline-id"></div>');

var chart = void 0;
var config = {
  id: 'chartBox',
  template: template,
  components: [{
    id: 'chart-id',
    type: 'CompositeY',
    config: {
      height: 300,
      plot: {
        x: {
          accessor: 'x',
          labelFormatter: 'Time',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          chart: 'Line',
          axis: 'y1',
          color: '#1f77b4'
        }, {
          accessor: 'b',
          chart: 'GroupedBar',
          axis: 'y1',
          color: '#aec7e8'
        }]
      },
      axes: {
        x: {
          scale: 'scaleLinear'
        },
        y1: {
          position: 'left',
          formatter: _commons.formatter.toInteger
        }
      }
    }
  }, {
    id: 'timeline-id',
    type: 'Timeline',
    config: {
      selection: [55, 85],
      accessor: 'x',
      update: ['chart-id']
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _template = __webpack_require__(50);

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var colorScheme = _commons._c.palette; /*
                                        * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                        */


var data = (0, _commons.fixture)();

var chart = void 0;
var config = {
  id: 'chartBox',
  template: _template2.default,
  components: [{
    id: 'compositey-id1',
    type: 'CompositeY',
    config: {
      height: 300,
      plot: {
        x: {
          accessor: 't',
          labelFormatter: 'Time',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          chart: 'StackedBar',
          axis: 'y1',
          tooltip: 'default-tooltip'
        }, {
          accessor: 'b',
          chart: 'StackedBar',
          axis: 'y1',
          tooltip: 'custom-tooltip'
        }, {
          accessor: 'c',
          color: colorScheme[2],
          chart: 'Line',
          axis: 'y2',
          tooltip: 'default-tooltip'
        }]
      },
      axes: {
        x: {
          formatter: _commons.formatter.extendedISOTime
        },
        y1: {
          position: 'left',
          formatter: _commons.formatter.toInteger,
          ticks: 5
        },
        y2: {
          position: 'right',
          formatter: _commons.formatter.toFixed1,
          ticks: 5
        }
      }
    }
  }, {
    id: 'default-tooltip',
    type: 'Tooltip',
    config: {
      dataConfig: [{
        accessor: 't',
        labelFormatter: 'Time',
        valueFormatter: _commons.formatter.extendedISOTime
      }, {
        accessor: 'a',
        labelFormatter: 'Tooltip A',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'b',
        labelFormatter: 'Tooltip B',
        valueFormatter: _commons.formatter.toInteger
      }, {
        accessor: 'c',
        labelFormatter: 'Tooltip C',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }, {
    id: 'custom-tooltip',
    type: 'Tooltip',
    config: {
      template: function template(data) {
        return '<div class="tooltip-content">Custom tooltip</div>';
      }
    }
  }, {
    id: 'compositey-id2',
    type: 'CompositeY',
    config: {
      enable: false,
      height: 200,
      plot: {
        x: {
          accessor: 't',
          labelFormatter: 'Time',
          axis: 'x'
        },
        y: [{
          accessor: 'a',
          chart: 'GroupedBar',
          axis: 'y1',
          tooltip: 'sticky-tooltip'
        }]
      },
      axis: {
        x: {
          formatter: _commons.formatter.extendedISOTime
        },
        y1: {
          position: 'left',
          formatter: _commons.formatter.toInteger,
          ticks: 5
        }
      }
    }
  }, {
    id: 'sticky-tooltip',
    type: 'Tooltip',
    config: {
      sticky: true,
      dataConfig: [{
        accessor: 't',
        labelFormatter: 'Time',
        valueFormatter: _commons.formatter.extendedISOTime
      }, {
        accessor: 'a',
        labelFormatter: 'Tooltip A',
        valueFormatter: _commons.formatter.toInteger
      }]
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _data = __webpack_require__(41);

var _data2 = _interopRequireDefault(_data);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chart = void 0; /*
                     * Copyright (c) Juniper Networks, Inc. All rights reserved.
                     */

var config = {
  id: 'chartBox',
  components: [{
    id: 'legend-id',
    type: 'LegendPanel',
    config: {
      editable: {
        color: true
      }
    }
  }, {
    id: 'dendrogram-chart-id',
    type: 'RadialDendrogram',
    config: {
      legend: 'legend-id',
      parentSeparation: 1.0,
      parentSeparationShrinkFactor: 0.05,
      parentSeparationDepthThreshold: 4,
      colorScheme: _commons._c.palette,
      drawLinks: false,
      drawRibbons: true,
      arcWidth: 15,
      arcLabelLetterWidth: 5,
      showArcLabels: true,
      // labelFlow: 'along-arc',
      labelFlow: 'perpendicular',
      // arcLabelXOffset: 2,
      arcLabelXOffset: 0,
      // arcLabelYOffset: 25,
      arcLabelYOffset: 20,
      levels: [{ level: 0, label: 'Virtual Network' }, { level: 1, label: 'IP' }, { level: 2, label: 'Port' }],
      hierarchyConfig: {
        parse: function parse(d) {
          var srcHierarchy = [d.sourcevn, d.sourceip, d.sport];
          var src = {
            names: srcHierarchy,
            id: srcHierarchy.join('-'),
            value: d['agg-bytes']
          };
          var dstHierarchy = [d.destvn, d.destip, d.dport];
          var dst = {
            names: dstHierarchy,
            id: dstHierarchy.join('-'),
            value: d['agg-bytes']
          };
          return [src, dst];
        }
      },
      drillDownLevel: 3,
      tooltip: 'tooltip-id',
      action: {
        'click node': function clickNode(data) {
          return console.warn('click node');
        },
        'click ribbon': function clickRibbon(data) {
          return console.warn('click ribbon');
        },
        'dblclick node': function dblclickNode(data) {
          return console.warn('dblclick node');
        },
        'dblclick ribbon': function dblclickRibbon(data) {
          return console.warn('dblclick ribbon');
        }
      }
    }
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      formatter: function formatter(data) {
        var type = ['Virtual Network', 'IP', 'Port'];
        var content = { title: data.name, items: [] };
        content.items.push({
          label: 'Type',
          value: type[data.level - 1]
        }, {
          label: 'Flow Count',
          value: data.children.length
        });
        return content;
      }
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(_data2.default.data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _d3Scale = __webpack_require__(2);

var d3Scale = _interopRequireWildcard(_d3Scale);

var _template = __webpack_require__(51);

var _template2 = _interopRequireDefault(_template);

__webpack_require__(46);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var data = [{ label: 'Process 1', value: 2704659 }, { label: 'Process 2', value: 2159981 }, { label: 'Process 3', value: 3853788 }, { label: 'Process 4', value: 14106543 }, { label: 'Process 5', value: 8819342 }, { label: 'Process 6', value: 612463 }, { label: 'Process 7', value: 4499890 }]; /*
                                                                                                                                                                                                                                                                                                      * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                                                                                                                                                                                                                                                                                      */


function getLabel(serie) {
  return serie.label;
}
function getValue(serie) {
  return serie.value;
}

var chart = void 0;
var config = {
  id: 'chartBox',
  template: _template2.default,
  title: 'Donut Chart',
  components: [{
    id: 'control-panel-id',
    type: 'ControlPanel',
    config: {
      menu: [{
        id: 'Refresh'
      }]
    }
  }, {
    id: 'donut-id',
    type: 'Pie',
    config: {
      legend: 'legend-id',
      tooltip: 'tooltip-id',
      type: 'donut',
      radius: 150,
      colorScale: d3Scale.scaleOrdinal(d3Scale.schemeCategory20c),
      // this will not make effect as colorScale takes precendence
      colorScheme: d3Scale.schemeCategory20,
      serie: {
        getValue: getValue,
        getLabel: getLabel,
        valueFormatter: _commons.formatter.commaGroupedInteger
      }
    }
  }, {
    id: 'tooltip-id',
    type: 'Tooltip',
    config: {
      title: 'Process Info',
      color: '#333',
      backgroundColor: '#fafafa',
      dataConfig: [{
        accessor: 'value',
        labelFormatter: getLabel,
        valueFormatter: _commons.formatter.commaGroupedInteger
      }]
    }
  }, {
    id: 'legend-id',
    type: 'Legend',
    config: {}
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _fixture = __webpack_require__(7);

var _fixture2 = _interopRequireDefault(_fixture);

var _d3Scale = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var data = (0, _fixture2.default)();

var chart = void 0;
var config = {
  id: 'chartBox',
  components: [{
    id: 'legend-id',
    type: 'LegendPanel',
    config: {
      editable: {
        color: true,
        chart: true
      }
    }
  }, {
    id: 'compositeRadial-chart-id',
    type: 'CompositeRadial',
    config: {
      legend: 'legend-id',
      colorScheme: _commons._c.radialColorScheme10,
      margin: {
        left: 30,
        right: 30,
        top: 5,
        bottom: 5
      },
      accessors: [{
        chart: 'RadialBar',
        labelFormatter: 'D Values',
        angular: 'x',
        radial: 'd',
        angularAxis: 'angularAxis',
        radialAxis: 'radialAxis2',
        color: _d3Scale.schemeCategory20[0],
        barPadding: 20
      }, {
        chart: 'RadialLine',
        labelFormatter: 'A Values',
        angular: 'x',
        radial: 'a',
        angularAxis: 'angularAxis',
        radialAxis: 'radialAxis1',
        color: _d3Scale.schemeCategory20[4]
      }, {
        chart: 'RadialLine',
        labelFormatter: 'B Values',
        angular: 'x',
        radial: 'b',
        angularAxis: 'angularAxis',
        radialAxis: 'radialAxis1',
        color: _d3Scale.schemeCategory20[6]
      }, {
        chart: 'RadialLine',
        labelFormatter: 'Random Values',
        angular: 'x',
        radial: 'random',
        angularAxis: 'angularAxis',
        radialAxis: 'radialAxis2',
        color: _d3Scale.schemeCategory20[1]
      }, {
        chart: 'RadialLine',
        labelFormatter: 'C Values',
        angular: 'x',
        radial: 'c',
        angularAxis: 'angularAxis',
        radialAxis: 'radialAxis2',
        color: _d3Scale.schemeCategory20[8]
      }],
      axes: {
        angularAxis: {
          scale: 'scaleLinear',
          label: 'Angle',
          range: [0, 6.0],
          removeLastAngularTick: false
        },
        radialAxis1: {
          scale: 'scaleLinear',
          label: 'R1',
          range: ['5%', '45%'],
          ticks: 4
        },
        radialAxis2: {
          scale: 'scaleLinear',
          label: 'R2',
          range: ['55%', '95%'],
          ticks: 4
        }
      }
    }
  }]
};

exports.default = {
  render: function render() {
    // Create new chart with config if it's available
    // chart.setConfig is designed for chart update already rendered with data
    chart = new _contrailCharts.composites.CompositeView({ config: config });
    // chart = new composites.CompositeRadialView({config, container})
    chart.setData(data);
  },

  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _d3Scale = __webpack_require__(2);

var length = 20; /*
                  * Copyright (c) Juniper Networks, Inc. All rights reserved.
                  */

var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { random: true, range: [0, length * 3] },
    b: { random: true, range: [0, (length - 1) * -5] },
    c: { linear: true, range: [-5, (length - 1) * -7] }
  }
});

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  x: {
    accessor: 'group.x'
  },
  y: [{
    accessor: 'group.a',
    stack: 'positive',
    color: _d3Scale.schemeCategory10[2]
  }, {
    accessor: 'b',
    stack: 'negative',
    color: _d3Scale.schemeCategory10[3]
  }, {
    accessor: 'c',
    stack: 'negative',
    color: _d3Scale.schemeCategory10[4]
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.AreaView({ config: config, container: container });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var data = (0, _commons.fixture)(); /*
                                     * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                     */


var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  height: 300,
  plot: {
    x: {
      accessor: 'x',
      labelFormatter: 'Value',
      axis: 'x'
    },
    y: [{
      accessor: 'a',
      labelFormatter: 'Label Group.A',
      chart: 'Line',
      axis: 'y1'
    }, {
      accessor: 'b',
      labelFormatter: 'Label B',
      chart: 'Line',
      axis: 'y1'
    }, {
      accessor: 'c',
      disabled: true,
      labelFormatter: 'Label C',
      chart: 'StackedBar',
      axis: 'y2'
    }]
  },
  axes: {
    x: {
      scale: 'scaleLinear',
      label: 'X'
    },
    y1: {
      ticks: 6
    },
    y2: {
      position: 'right',
      // this value is ignored because second axis is synced with previous
      ticks: 5
    }
  }
};

exports.default = {
  render: function render() {
    // Create new chart with config if it's available
    // chart.setConfig is designed for chart update already rendered with data
    chart = new _contrailCharts.composites.CompositeYView({ config: config, container: container });
    chart.setData(data);

    setTimeout(function () {
      config.plot.y[2].disabled = false;
      chart.setConfig(config);
    }, 2000);
    setTimeout(function () {
      config.plot.y[0].disabled = true;
      config.plot.y[1].disabled = true;
      chart.setConfig(config);
    }, 4000);
    setTimeout(function () {
      var length = _lodash2.default.random(3, 20);
      chart.setData(data.slice(0, length));
    }, 6000);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    b: { linear: true, range: [5, (length - 1) * 5], repeat: true }
  }
});

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  margin: {
    top: 10
  },
  x: {
    accessor: 'group.x'
  },
  y: [{
    accessor: 'group.a'
  }, {
    accessor: 'b',
    color: function color(d) {
      return d.b > 80 ? 'red' : undefined;
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.GroupedBarView({ config: config, container: container });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _d3Scale = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    b: { random: true, range: [0, -length * 5] }
  }
});

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  height: 200,
  margin: {
    left: 10
  },
  x: {
    accessor: 'group.x',
    scale: 'scaleLinear'
  },
  y: {
    accessor: 'group.a',
    color: _d3Scale.schemeCategory10[2]
  }
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.LineView({ config: config, container: container });
    chart.setData(data);

    setTimeout(function () {
      config.y.accessor = 'b';
      config.y.color = _d3Scale.schemeCategory10[3];
      chart.setConfig(config);
    }, 1000);
    setTimeout(function () {
      var length = _lodash2.default.random(3, 20);
      chart.setData(data.slice(0, length));
    }, 2000);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _d3Scale = __webpack_require__(2);

var d3Scale = _interopRequireWildcard(_d3Scale);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var length = 20;
var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.value': { random: true, range: [0, length] },
    'group.label': { linear: true, range: [1, length - 1] }
  }
});

var chart = void 0;
var intervalId = -1;
var container = document.querySelector('#chartBox');

var config = {
  type: 'donut',
  radius: 150,
  serie: {
    getValue: function getValue(serie) {
      return serie.group.value;
    },
    getLabel: function getLabel(serie) {
      return serie.group.label;
    },
    valueFormatter: _commons.formatter.commaGroupedInteger
  }
};

exports.default = {
  render: function render() {
    clearInterval(intervalId);
    chart = new _contrailCharts.components.PieView({ config: config, container: container });
    chart.setData(data);

    setTimeout(function () {
      config.type = _lodash2.default.sample(['pie', 'donut']);
      config.colorScheme = d3Scale.schemeCategory20b;
      chart.setConfig(config);
    }, 1000);

    intervalId = setInterval(function () {
      var length = _lodash2.default.random(3, 20);
      chart.setData(data.slice(0, length));
    }, 2000);
  },
  remove: function remove() {
    chart.remove();
  },
  stopUpdating: function stopUpdating() {
    clearInterval(intervalId);
    intervalId = -1;
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

var _d3Scale = __webpack_require__(2);

var length = 20; /*
                  * Copyright (c) Juniper Networks, Inc. All rights reserved.
                  */

var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    b: { random: true, range: [0, -length * 5] }
  }
});

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  margin: {
    left: 10,
    right: 10,
    top: 10,
    bottom: 10
  },
  angular: {
    accessor: 'group.x',
    labelFormatter: 'Value'
    //scale: 'scaleLinear',
  },
  radial: {
    accessor: 'group.a',
    labelFormatter: 'Label Group.A',
    color: _d3Scale.schemeCategory10[2]
  }
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.RadialLineView({ config: config, container: container });
    chart.setData(data);
  },

  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
var data = (0, _commons.fixture)({
  length: 40,
  data: {
    'group.x': { linear: true, range: [1475760930000, 1475800930000] },
    'group.data1': { random: true, range: [0, 50], gap: true },
    'group.size1': { random: true, range: [0, 10] }
  }
});

var bubbleShapes = _contrailCharts.Util.bubbleShapes;

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  height: 450,
  x: {
    accessor: 'group.x'
  },
  y: {
    accessor: 'group.data1',
    shape: bubbleShapes.circle,
    color: function color(d) {
      return d.group.size1 > 8 ? 'red' : null;
    }
  },
  size: {
    accessor: 'group.size1'
  }
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.ScatterPlotView({ config: config, container: container });
    chart.setData(data);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _contrailCharts = __webpack_require__(0);

var _commons = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var length = 20; /*
                  * Copyright (c) Juniper Networks, Inc. All rights reserved.
                  */

var data = (0, _commons.fixture)({
  length: length,
  data: {
    'group.x': { linear: true, range: [0, length] },
    'group.a': { linear: true, range: [3, (length - 1) * 3] },
    b: { linear: true, range: [5, (length - 1) * 5], repeat: true },
    c: { linear: true, range: [7, (length - 1) * 7] }
  }
});

var chart = void 0;
var container = document.querySelector('#chartBox');
var config = {
  x: {
    accessor: 'group.x',
    domain: [5, length]
  },
  y: [{
    accessor: 'group.a'
  }, {
    accessor: 'b',
    color: function color(d) {
      return d.group.a > 50 ? 'red' : undefined;
    }
  }]
};

exports.default = {
  render: function render() {
    chart = new _contrailCharts.components.StackedBarView({ config: config, container: container });
    chart.setData(data);

    setTimeout(function () {
      config.y.push({
        accessor: 'c'
      });
      chart.setConfig(config);
    }, 1000);
    setTimeout(function () {
      config.y[1].enabled = false;
      config.x.domain = [0, length];
      chart.setConfig(config);
    }, 2000);
    setTimeout(function () {
      var length = _lodash2.default.random(3, 20);
      chart.setData(data.slice(0, length));
    }, 3000);
  },
  remove: function remove() {
    chart.remove();
  }
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * metismenu - v2.7.0
 * A jQuery menu plugin
 * https://github.com/onokumus/metismenu#readme
 *
 * Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
 * Under MIT License
 */

(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(8)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== "undefined") {
    factory(require('jquery'));
  } else {
    var mod = {
      exports: {}
    };
    factory(global.jquery);
    global.metisMenu = mod.exports;
  }
})(this, function (_jquery) {
  'use strict';

  var _jquery2 = _interopRequireDefault(_jquery);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var Util = function ($) {
    var transition = false;

    var TransitionEndEvent = {
      WebkitTransition: 'webkitTransitionEnd',
      MozTransition: 'transitionend',
      OTransition: 'oTransitionEnd otransitionend',
      transition: 'transitionend'
    };

    function getSpecialTransitionEndEvent() {
      return {
        bindType: transition.end,
        delegateType: transition.end,
        handle: function handle(event) {
          if ($(event.target).is(this)) {
            return event.handleObj.handler.apply(this, arguments);
          }
          return undefined;
        }
      };
    }

    function transitionEndTest() {
      if (window.QUnit) {
        return false;
      }

      var el = document.createElement('mm');

      for (var name in TransitionEndEvent) {
        if (el.style[name] !== undefined) {
          return {
            end: TransitionEndEvent[name]
          };
        }
      }

      return false;
    }

    function transitionEndEmulator(duration) {
      var _this2 = this;

      var called = false;

      $(this).one(Util.TRANSITION_END, function () {
        called = true;
      });

      setTimeout(function () {
        if (!called) {
          Util.triggerTransitionEnd(_this2);
        }
      }, duration);

      return this;
    }

    function setTransitionEndSupport() {
      transition = transitionEndTest();
      $.fn.emulateTransitionEnd = transitionEndEmulator;

      if (Util.supportsTransitionEnd()) {
        $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
      }
    }

    var Util = {
      TRANSITION_END: 'mmTransitionEnd',

      triggerTransitionEnd: function triggerTransitionEnd(element) {
        $(element).trigger(transition.end);
      },
      supportsTransitionEnd: function supportsTransitionEnd() {
        return Boolean(transition);
      }
    };

    setTransitionEndSupport();

    return Util;
  }(jQuery);

  var MetisMenu = function ($) {

    var NAME = 'metisMenu';
    var DATA_KEY = 'metisMenu';
    var EVENT_KEY = '.' + DATA_KEY;
    var DATA_API_KEY = '.data-api';
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var TRANSITION_DURATION = 350;

    var Default = {
      toggle: true,
      preventDefault: true,
      activeClass: 'active',
      collapseClass: 'collapse',
      collapseInClass: 'in',
      collapsingClass: 'collapsing',
      triggerElement: 'a',
      parentTrigger: 'li',
      subMenu: 'ul'
    };

    var Event = {
      SHOW: 'show' + EVENT_KEY,
      SHOWN: 'shown' + EVENT_KEY,
      HIDE: 'hide' + EVENT_KEY,
      HIDDEN: 'hidden' + EVENT_KEY,
      CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
    };

    var MetisMenu = function () {
      function MetisMenu(element, config) {
        _classCallCheck(this, MetisMenu);

        this._element = element;
        this._config = this._getConfig(config);
        this._transitioning = null;

        this.init();
      }

      MetisMenu.prototype.init = function init() {
        var self = this;
        $(this._element).find(this._config.parentTrigger + '.' + this._config.activeClass).has(this._config.subMenu).children(this._config.subMenu).attr('aria-expanded', true).addClass(this._config.collapseClass + ' ' + this._config.collapseInClass);

        $(this._element).find(this._config.parentTrigger).not('.' + this._config.activeClass).has(this._config.subMenu).children(this._config.subMenu).attr('aria-expanded', false).addClass(this._config.collapseClass);

        $(this._element).find(this._config.parentTrigger).has(this._config.subMenu).children(this._config.triggerElement).on(Event.CLICK_DATA_API, function (e) {
          var _this = $(this);
          var _parent = _this.parent(self._config.parentTrigger);
          var _siblings = _parent.siblings(self._config.parentTrigger).children(self._config.triggerElement);
          var _list = _parent.children(self._config.subMenu);
          if (self._config.preventDefault) {
            e.preventDefault();
          }
          if (_this.attr('aria-disabled') === 'true') {
            return;
          }
          if (_parent.hasClass(self._config.activeClass)) {
            _this.attr('aria-expanded', false);
            self._hide(_list);
          } else {
            self._show(_list);
            _this.attr('aria-expanded', true);
            if (self._config.toggle) {
              _siblings.attr('aria-expanded', false);
            }
          }

          if (self._config.onTransitionStart) {
            self._config.onTransitionStart(e);
          }
        });
      };

      MetisMenu.prototype._show = function _show(element) {
        if (this._transitioning || $(element).hasClass(this._config.collapsingClass)) {
          return;
        }
        var _this = this;
        var _el = $(element);

        var startEvent = $.Event(Event.SHOW);
        _el.trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        _el.parent(this._config.parentTrigger).addClass(this._config.activeClass);

        if (this._config.toggle) {
          this._hide(_el.parent(this._config.parentTrigger).siblings().children(this._config.subMenu + '.' + this._config.collapseInClass).attr('aria-expanded', false));
        }

        _el.removeClass(this._config.collapseClass).addClass(this._config.collapsingClass).height(0);

        this.setTransitioning(true);

        var complete = function complete() {

          _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass + ' ' + _this._config.collapseInClass).height('').attr('aria-expanded', true);

          _this.setTransitioning(false);

          _el.trigger(Event.SHOWN);
        };

        if (!Util.supportsTransitionEnd()) {
          complete();
          return;
        }

        _el.height(_el[0].scrollHeight).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      };

      MetisMenu.prototype._hide = function _hide(element) {

        if (this._transitioning || !$(element).hasClass(this._config.collapseInClass)) {
          return;
        }
        var _this = this;
        var _el = $(element);

        var startEvent = $.Event(Event.HIDE);
        _el.trigger(startEvent);

        if (startEvent.isDefaultPrevented()) {
          return;
        }

        _el.parent(this._config.parentTrigger).removeClass(this._config.activeClass);
        _el.height(_el.height())[0].offsetHeight;

        _el.addClass(this._config.collapsingClass).removeClass(this._config.collapseClass).removeClass(this._config.collapseInClass);

        this.setTransitioning(true);

        var complete = function complete() {
          if (_this._transitioning && _this._config.onTransitionEnd) {
            _this._config.onTransitionEnd();
          }

          _this.setTransitioning(false);
          _el.trigger(Event.HIDDEN);

          _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass).attr('aria-expanded', false);
        };

        if (!Util.supportsTransitionEnd()) {
          complete();
          return;
        }

        _el.height() == 0 || _el.css('display') == 'none' ? complete() : _el.height(0).one(Util.TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
      };

      MetisMenu.prototype.setTransitioning = function setTransitioning(isTransitioning) {
        this._transitioning = isTransitioning;
      };

      MetisMenu.prototype.dispose = function dispose() {
        $.removeData(this._element, DATA_KEY);

        $(this._element).find(this._config.parentTrigger).has(this._config.subMenu).children(this._config.triggerElement).off('click');

        this._transitioning = null;
        this._config = null;
        this._element = null;
      };

      MetisMenu.prototype._getConfig = function _getConfig(config) {
        config = $.extend({}, Default, config);
        return config;
      };

      MetisMenu._jQueryInterface = function _jQueryInterface(config) {
        return this.each(function () {
          var $this = $(this);
          var data = $this.data(DATA_KEY);
          var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

          if (!data && /dispose/.test(config)) {
            this.dispose();
          }

          if (!data) {
            data = new MetisMenu(this, _config);
            $this.data(DATA_KEY, data);
          }

          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error('No method named "' + config + '"');
            }
            data[config]();
          }
        });
      };

      return MetisMenu;
    }();

    /**
     * ------------------------------------------------------------------------
     * jQuery
     * ------------------------------------------------------------------------
     */

    $.fn[NAME] = MetisMenu._jQueryInterface;
    $.fn[NAME].Constructor = MetisMenu;
    $.fn[NAME].noConflict = function () {
      $.fn[NAME] = JQUERY_NO_CONFLICT;
      return MetisMenu._jQueryInterface;
    };
    return MetisMenu;
  }(jQuery);
});


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = undefined;

/***/ }),
/* 38 */
/***/ (function(module, exports) {

module.exports = {"data":[{"UuidKey":"b06ead72-a0ac-4c06-bb1b-98c4ab6a4a09","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862738592189,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31506,"vrouter":"a7s12"},{"UuidKey":"b5ba466a-9e56-42e8-8cf5-e75d27c62f7a","action":"pass","agg-bytes":474325736,"agg-packets":1410948,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228799929030,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49726,"vrouter":"a7s12"},{"UuidKey":"b5ac8195-6662-4e2e-9984-782b3ce0a62e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862792622235,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32385,"vrouter":"a7s12"},{"UuidKey":"b5611e6e-85ee-46eb-98f7-fb2450299785","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863008786257,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2867,"vrouter":"a7s12"},{"UuidKey":"b54b4943-786b-4503-8e32-8821ccd34647","action":"pass","agg-bytes":1808558414,"agg-packets":5399039,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50543,"protocol":6,"setup_time":1478625028489461,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"b473ed8c-d340-4f54-8bbb-ed87a7e0b696","action":"pass","agg-bytes":473639780,"agg-packets":1408160,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228800153058,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58219,"vrouter":"a7s12"},{"UuidKey":"b3f000c6-ddc9-4f7e-8288-36f6e3b09428","action":"pass","agg-bytes":472868952,"agg-packets":1410688,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58219,"protocol":6,"setup_time":1483228800152916,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"b28c2df0-daa3-4e8f-85b7-b37feb14119c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862954756764,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1942,"vrouter":"a7s12"},{"UuidKey":"b20de521-3147-4b01-9d08-905663fd4b7e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863161886000,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5724,"vrouter":"a7s12"},{"UuidKey":"b17f4f11-1c95-44ce-80dd-d722a46845ed","action":"pass","agg-bytes":1808179662,"agg-packets":5392803,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1478625115801894,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44890,"vrouter":"a7s12"},{"UuidKey":"b5debe8f-6fe1-4a9c-abf6-2fcc97204186","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863071825952,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3868,"vrouter":"a7s12"},{"UuidKey":"afafd179-0109-4759-b435-b78a94ce6efc","action":"pass","agg-bytes":473502602,"agg-packets":1412295,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1483228799559851,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50754,"vrouter":"a7s12"},{"UuidKey":"af86f5fe-6871-44ec-b0af-523245c86810","action":"pass","agg-bytes":473410966,"agg-packets":1411745,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49726,"protocol":6,"setup_time":1483228799928947,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"ae5eca19-6464-439a-9bf2-c4e67366cc30","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862873692353,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":906,"vrouter":"a7s12"},{"UuidKey":"ae527eb6-f069-4aac-b566-713533eac584","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862648516698,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29810,"vrouter":"a7s12"},{"UuidKey":"add4a583-9c6f-4be4-9b8e-62854c00208d","action":"pass","agg-bytes":1809375098,"agg-packets":5402091,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1478625093704916,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57225,"vrouter":"a7s12"},{"UuidKey":"ac5393ea-8132-4714-b4b8-96bee9ff56e5","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863035803549,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3782,"vrouter":"a7s12"},{"UuidKey":"aac73f9c-cbb4-48ca-9b5a-d7e027c3598a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862729581094,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31438,"vrouter":"a7s12"},{"UuidKey":"aab94f33-53cb-4fb3-be22-c32606b86b1a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862630504256,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29768,"vrouter":"a7s12"},{"UuidKey":"a8d3060f-1429-4d92-a89c-b9b14ff3fd6f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862981771777,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2827,"vrouter":"a7s12"},{"UuidKey":"beee6f56-a111-4020-864c-3e5122ec2b3d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863062823413,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3834,"vrouter":"a7s12"},{"UuidKey":"c44dbc1f-4b95-4a7e-ab61-d37f379199e9","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863062823441,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3834,"vrouter":"a7s12"},{"UuidKey":"c3fd2442-b414-4e39-8e4c-e4566b127a56","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862720571085,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30724,"vrouter":"a7s12"},{"UuidKey":"c373ad13-7335-46b1-a888-0348bfd4e501","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862711568011,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30721,"vrouter":"a7s12"},{"UuidKey":"c22bd6cf-7f0a-4a2c-acd0-39d47ceb2c36","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862621492710,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29730,"vrouter":"a7s12"},{"UuidKey":"c0add3fb-3acb-45ed-ba0b-efba8f965681","action":"pass","agg-bytes":1809435586,"agg-packets":5395825,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1478625026483133,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50541,"vrouter":"a7s12"},{"UuidKey":"c094a260-ede9-4a42-ac3f-7eec6e14a77b","action":"pass","agg-bytes":1809845784,"agg-packets":5399612,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50753,"protocol":6,"setup_time":1478625100743948,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"c08a76a4-9b6c-4498-a803-3591e25cfa01","action":"pass","agg-bytes":473886608,"agg-packets":1411272,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228800094416,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53189,"vrouter":"a7s12"},{"UuidKey":"c00f6439-ba52-42a2-a03c-fcb83d6cba7c","action":"pass","agg-bytes":474609746,"agg-packets":1411657,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1483228802135433,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43882,"vrouter":"a7s12"},{"UuidKey":"bfde7a27-94e0-4c09-9e05-1cb5c6866360","action":"pass","agg-bytes":473406584,"agg-packets":1415446,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228800134161,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57222,"vrouter":"a7s12"},{"UuidKey":"a7f4abad-52f7-4050-a328-0b7dbaf945fa","action":"pass","agg-bytes":473537876,"agg-packets":1412718,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228801716987,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50540,"vrouter":"a7s12"},{"UuidKey":"be7b40a0-f6a4-45bc-aaee-3ec6c061386f","action":"pass","agg-bytes":474615638,"agg-packets":1415025,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1483228799559566,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47808,"vrouter":"a7s12"},{"UuidKey":"bb7078a1-3c80-4f4c-a683-052f6942b2d7","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863170903815,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5728,"vrouter":"a7s12"},{"UuidKey":"bae401c0-32e0-4600-b168-24a4395acf05","action":"pass","agg-bytes":1808494272,"agg-packets":5394836,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56179,"protocol":6,"setup_time":1478625044539080,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"bad7ea91-a007-4e2a-bf78-e3d5705af3d5","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863179901368,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5763,"vrouter":"a7s12"},{"UuidKey":"b9c301ab-b767-4555-9f62-85f97b69667e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862999784784,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2864,"vrouter":"a7s12"},{"UuidKey":"b823507e-e092-4844-90ee-2aa2b85ba783","action":"pass","agg-bytes":473277618,"agg-packets":1413511,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228802612312,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35156,"vrouter":"a7s12"},{"UuidKey":"b67a6c22-f3c8-4ff7-94d5-f4cdc5b2473e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863017796044,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2923,"vrouter":"a7s12"},{"UuidKey":"b610d00f-167f-4816-8aec-58c8add58f8f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862594466891,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28927,"vrouter":"a7s12"},{"UuidKey":"93a7a188-9c24-430a-aaed-9fecf725916f","action":"pass","agg-bytes":474351306,"agg-packets":1408583,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228802116453,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57224,"vrouter":"a7s12"},{"UuidKey":"99093d4b-2d2f-4a65-8465-e4cbcdf11e2b","action":"pass","agg-bytes":474041898,"agg-packets":1414279,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35154,"protocol":6,"setup_time":1483228800133483,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"97e3689f-c3bb-4f88-8f9a-e0769fd863f4","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862531418334,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27886,"vrouter":"a7s12"},{"UuidKey":"95be19d8-b567-4382-977d-77819b327179","action":"pass","agg-bytes":473839090,"agg-packets":1413705,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1483228799882423,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58424,"vrouter":"a7s12"},{"UuidKey":"9559a05a-2b3c-4f9a-b2bf-5cbfddf2e47c","action":"pass","agg-bytes":1809820638,"agg-packets":5400647,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":51384,"protocol":6,"setup_time":1478625074642454,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9111,"vrouter":"a7s12"},{"UuidKey":"94cf645d-399d-47f0-882d-2430b7433ab9","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862918732060,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1844,"vrouter":"a7s12"},{"UuidKey":"94b6df14-abd2-4c52-9bcd-efff95a8c37c","action":"pass","agg-bytes":474149102,"agg-packets":1414995,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49730,"protocol":6,"setup_time":1483228799925672,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"946370ce-2680-4a7f-96d9-7249f7a584cd","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863026800235,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3626,"vrouter":"a7s12"},{"UuidKey":"93d26c4a-0e2a-42e2-bd8d-6f3d9fa3d467","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862702558780,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30679,"vrouter":"a7s12"},{"UuidKey":"93c5cabe-6078-4b4b-8d1d-905ae6631b27","action":"pass","agg-bytes":473051156,"agg-packets":1408398,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9111,"protocol":6,"setup_time":1483228799926954,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":51387,"vrouter":"a7s12"},{"UuidKey":"9922338a-7bd4-421a-a229-950168b43fc6","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863188916527,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":5766,"vrouter":"a7s12"},{"UuidKey":"92faeb1b-3caa-4f8b-96ce-3303a5d31734","action":"pass","agg-bytes":474305144,"agg-packets":1414314,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35155,"protocol":6,"setup_time":1483228801931706,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"92c379f6-836f-4cb6-bd94-983b62050c78","action":"pass","agg-bytes":474221878,"agg-packets":1417601,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53711,"protocol":6,"setup_time":1483228800152387,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"9212cfcb-70f9-4f21-af04-dff4cb814157","action":"pass","agg-bytes":1807317112,"agg-packets":5396590,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625086674417,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36819,"vrouter":"a7s12"},{"UuidKey":"915ee779-93fb-4479-840f-46a7530015a7","action":"pass","agg-bytes":473634472,"agg-packets":1413662,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54508,"protocol":6,"setup_time":1483228800153082,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"91257fff-47a2-4ebb-8b37-558d06ec8e35","action":"pass","agg-bytes":473541810,"agg-packets":1412151,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56180,"protocol":6,"setup_time":1483228799882461,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"8f85b369-d5f9-40bc-8510-795c4bb1c61c","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862819648698,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32425,"vrouter":"a7s12"},{"UuidKey":"8f32cacb-16b1-4cfa-93af-b0e8fede592d","action":"pass","agg-bytes":473036308,"agg-packets":1409896,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1483228800153097,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54508,"vrouter":"a7s12"},{"UuidKey":"8f22de94-008c-4d0d-8fd2-df6dc50da71d","action":"pass","agg-bytes":473892802,"agg-packets":1415501,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56048,"protocol":6,"setup_time":1483228799715271,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"a0472292-b81f-4112-b563-e9a5469b2977","action":"pass","agg-bytes":473899662,"agg-packets":1414079,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58424,"protocol":6,"setup_time":1483228799882319,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"a5c68496-2dae-4af6-bb1c-23279d3305a8","action":"pass","agg-bytes":473104048,"agg-packets":1411824,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1483228800152448,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56183,"vrouter":"a7s12"},{"UuidKey":"a56a0f8a-833c-4604-adf2-524a397651de","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863008786407,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2867,"vrouter":"a7s12"},{"UuidKey":"a5570509-bf72-4a67-bcb6-ba1f76d64d1a","action":"pass","agg-bytes":473722670,"agg-packets":1412967,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":38175,"protocol":6,"setup_time":1483228800313951,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9108,"vrouter":"a7s12"},{"UuidKey":"a4e95787-8d73-4e76-b405-a18e3019ebfb","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863071825892,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3868,"vrouter":"a7s12"},{"UuidKey":"a4b743b0-40f2-466c-9335-4f59f4b40214","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862666536292,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30366,"vrouter":"a7s12"},{"UuidKey":"a3997b38-99c3-466f-9b6b-3dec0bfe174b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862540430642,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27945,"vrouter":"a7s12"},{"UuidKey":"a30039ef-9968-412e-90d4-2f062f05f422","action":"pass","agg-bytes":474035522,"agg-packets":1413301,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1483228799715309,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56048,"vrouter":"a7s12"},{"UuidKey":"a1dd6a20-bf20-4c62-b447-2c5ebceb4557","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862549439813,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28756,"vrouter":"a7s12"},{"UuidKey":"a1a86051-e143-491c-89df-e1acff3c4e76","action":"pass","agg-bytes":474452456,"agg-packets":1415496,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1483228800313467,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43884,"vrouter":"a7s12"},{"UuidKey":"c5f54fc8-b92b-48d2-8e4f-b4f6ac4e501a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862693556353,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30675,"vrouter":"a7s12"},{"UuidKey":"9fdd5c96-5417-443b-b9a5-671119452140","action":"pass","agg-bytes":1808060370,"agg-packets":5399935,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54507,"protocol":6,"setup_time":1478625071631122,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"9f69ddfc-c73c-47c4-89e9-f07081d95345","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862657518803,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29828,"vrouter":"a7s12"},{"UuidKey":"9f451c04-1931-497f-968d-3cc34dc90071","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862963760677,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2333,"vrouter":"a7s12"},{"UuidKey":"9f3326c1-15c6-49d3-a0e1-dd2612540f76","action":"pass","agg-bytes":1808961058,"agg-packets":5394777,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1478625022469775,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56051,"vrouter":"a7s12"},{"UuidKey":"9cf8bd20-b7b9-499d-9f5d-d810569cf6e7","action":"pass","agg-bytes":473824208,"agg-packets":1414136,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56183,"protocol":6,"setup_time":1483228800152434,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"9b8b2499-e9e5-47b8-90eb-acbdb305086b","action":"pass","agg-bytes":1810817926,"agg-packets":5399081,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1478625051565195,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58426,"vrouter":"a7s12"},{"UuidKey":"99f3129a-392e-493c-8764-d412b6719311","action":"pass","agg-bytes":1809998040,"agg-packets":5400958,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47805,"protocol":6,"setup_time":1478625035511532,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"9958adcf-c5a2-4cd6-a541-a303f7aaaff3","action":"pass","agg-bytes":474396986,"agg-packets":1414567,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57222,"protocol":6,"setup_time":1483228800134131,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"e942ac0f-c4cd-4bb4-9020-06d98c35e9f0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862918732140,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1844,"vrouter":"a7s12"},{"UuidKey":"ef75ee20-2fdb-4ed9-a439-825f8c91eb75","action":"pass","agg-bytes":1808475352,"agg-packets":5398312,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56050,"protocol":6,"setup_time":1478625021467206,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"ef1f1fc1-dea1-404d-a0a4-8b0752c7ab01","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862603483560,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29283,"vrouter":"a7s12"},{"UuidKey":"ed898d55-a641-4cde-8333-e4ffca1221d6","action":"pass","agg-bytes":1810035936,"agg-packets":5397686,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1478625098727092,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53192,"vrouter":"a7s12"},{"UuidKey":"eaf7a1bb-dba4-4c63-bd05-2a3417b5f4a1","action":"pass","agg-bytes":1808952820,"agg-packets":5395006,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47806,"protocol":6,"setup_time":1478625036513079,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"eab42cf7-6aff-436b-9ec6-3562a6ca4729","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862513404282,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27840,"vrouter":"a7s12"},{"UuidKey":"ea720d11-758f-4aff-9d5a-e380aeb55c7f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862810637221,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32391,"vrouter":"a7s12"},{"UuidKey":"ea637c0d-1bf2-453e-aa71-c9e207d62395","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862666531291,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30366,"vrouter":"a7s12"},{"UuidKey":"e9992025-9306-4657-93cb-e8ac9eb957bd","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862738592220,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31506,"vrouter":"a7s12"},{"UuidKey":"e942c57a-0b01-49d2-a3e7-0024c49f6048","action":"pass","agg-bytes":1808869756,"agg-packets":5399552,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35152,"protocol":6,"setup_time":1478625054576520,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"f0f6810e-2a18-407f-b6e6-7e2e97273b1a","action":"pass","agg-bytes":473071300,"agg-packets":1412790,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53189,"protocol":6,"setup_time":1483228800093438,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"e70c1d77-b78e-4967-9c5f-290edb4b323d","action":"pass","agg-bytes":474117018,"agg-packets":1415539,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1483228800153133,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44889,"vrouter":"a7s12"},{"UuidKey":"e6b87dc1-b53e-4fcc-8677-ff0ac30d63f1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862774615945,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31605,"vrouter":"a7s12"},{"UuidKey":"e66476d2-1248-4a72-bef5-444159519968","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862648516639,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29810,"vrouter":"a7s12"},{"UuidKey":"e65576a6-2adb-4e65-bf73-814e79d353a0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862783620699,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31939,"vrouter":"a7s12"},{"UuidKey":"e43a8862-2af2-404e-9b5c-5ebb0b6b4ce2","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862801631872,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32388,"vrouter":"a7s12"},{"UuidKey":"e34c5016-9a2e-4e75-b344-53ab4ba07da9","action":"pass","agg-bytes":473366428,"agg-packets":1408854,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58425,"protocol":6,"setup_time":1483228799457309,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"e300769a-cbca-4794-a1d9-263d3877170a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863044811781,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3785,"vrouter":"a7s12"},{"UuidKey":"e2fe7f46-9426-4f9e-ac68-43d5fa18ed3f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862558441910,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28831,"vrouter":"a7s12"},{"UuidKey":"f57901f1-026b-4a72-be3a-0c034c91922f","action":"pass","agg-bytes":472767532,"agg-packets":1412274,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53188,"protocol":6,"setup_time":1483228799927657,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"ffab970b-b69b-4241-b781-56e6aa13c55b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863107850696,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4721,"vrouter":"a7s12"},{"UuidKey":"fe756ec0-f08d-492c-905c-2bc3bab0cfd7","action":"pass","agg-bytes":474026712,"agg-packets":1414718,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50883,"protocol":6,"setup_time":1483228799715592,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"fab78cb4-cb26-4e13-94f5-7dcc7886d7d6","action":"pass","agg-bytes":473870834,"agg-packets":1414431,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43882,"protocol":6,"setup_time":1483228802135396,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"fa74c8ef-0a8d-44b7-ad2f-5833ef37b397","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862891704867,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":975,"vrouter":"a7s12"},{"UuidKey":"fa6d978d-bc0f-4b71-9688-d7ec83c4284f","action":"pass","agg-bytes":473886504,"agg-packets":1409206,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228799929728,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50542,"vrouter":"a7s12"},{"UuidKey":"f7fa208a-6b04-4f5d-9108-c2140d7d62f6","action":"pass","agg-bytes":473943032,"agg-packets":1414238,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54505,"protocol":6,"setup_time":1483228806583525,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"f6cc4f54-ed81-417f-9617-92425ea2d60f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862999784595,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2864,"vrouter":"a7s12"},{"UuidKey":"f68e709c-54f3-4c7c-80c1-67346474031e","action":"pass","agg-bytes":1808759976,"agg-packets":5400208,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1478625110786654,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50880,"vrouter":"a7s12"},{"UuidKey":"f59db293-a3e0-4ff4-96b9-392a1484607b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863206936910,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6431,"vrouter":"a7s12"},{"UuidKey":"e23adc86-81ea-49cc-a4fb-49c9c90a7a22","action":"pass","agg-bytes":473708134,"agg-packets":1415077,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47808,"protocol":6,"setup_time":1483228799559520,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"f5324dfe-c0bf-422d-9342-f643ad6f34b6","action":"pass","agg-bytes":474144448,"agg-packets":1416098,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49727,"protocol":6,"setup_time":1483228802174776,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"f4ce69d4-7ed8-4671-9de1-70f31d4f2302","action":"pass","agg-bytes":1811276198,"agg-packets":5399977,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57225,"protocol":6,"setup_time":1478625093704814,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"f4cc14ec-e162-49bd-92f6-e7a11e0464c7","action":"pass","agg-bytes":473636494,"agg-packets":1413297,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9108,"protocol":6,"setup_time":1483228800313968,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":38175,"vrouter":"a7s12"},{"UuidKey":"f497a4b8-686b-4867-a18c-9cb5a0d7e47a","action":"pass","agg-bytes":1807918706,"agg-packets":5397917,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50752,"protocol":6,"setup_time":1478625099737770,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"f3900a9d-ea8f-43f3-b8c8-1069d7a75dfc","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862828651434,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32466,"vrouter":"a7s12"},{"UuidKey":"f2bcc6c0-b94b-4da1-ab64-53e1620e3eb9","action":"pass","agg-bytes":1808305120,"agg-packets":5394400,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1478625044539116,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56179,"vrouter":"a7s12"},{"UuidKey":"f2085188-bbc7-4463-9f2a-8412ae5d9fa0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862846663235,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":730,"vrouter":"a7s12"},{"UuidKey":"f196e30b-dfff-4e42-bfc5-0996a97f93fa","action":"pass","agg-bytes":474317084,"agg-packets":1411390,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57223,"protocol":6,"setup_time":1483228799929652,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"cb68293c-56c4-4264-af05-193b996733df","action":"pass","agg-bytes":473068862,"agg-packets":1410621,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50540,"protocol":6,"setup_time":1483228801716947,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"d14bb5a5-9596-4986-ac00-6f1f44161673","action":"pass","agg-bytes":475271022,"agg-packets":1415953,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1483228799714232,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36817,"vrouter":"a7s12"},{"UuidKey":"cfdd289f-5aea-4633-ba61-bd351c490d2d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863215948868,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":6606,"vrouter":"a7s12"},{"UuidKey":"cebb73bd-07ea-4b11-b58e-0e6ee8f8a8ea","action":"pass","agg-bytes":1808347660,"agg-packets":5396634,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54509,"protocol":6,"setup_time":1478625073649027,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"ce9f7a14-42e1-417a-b6a7-ecb7c5176c3a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863116859919,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4754,"vrouter":"a7s12"},{"UuidKey":"ce2f4105-2c3a-49a1-9528-7661a1fbd6c5","action":"pass","agg-bytes":473728238,"agg-packets":1413327,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50754,"protocol":6,"setup_time":1483228799559819,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"ce025d2d-f65b-47a3-98b7-7ec60b2af79f","action":"pass","agg-bytes":1807314070,"agg-packets":5394841,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50755,"protocol":6,"setup_time":1478625102750751,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"cdd4bd28-ac5f-44fb-8570-ae502e9d883a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862927734206,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1847,"vrouter":"a7s12"},{"UuidKey":"cbe1dac6-9ce3-45fd-88a3-cd2d6b1c388b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862963760646,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2333,"vrouter":"a7s12"},{"UuidKey":"cb9731ad-e77a-49f0-b3d3-90df99b1afff","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862792622207,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32385,"vrouter":"a7s12"},{"UuidKey":"d3b5cb96-30c4-4f20-b4f7-f8f535848022","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862882695139,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":913,"vrouter":"a7s12"},{"UuidKey":"c94aa498-f8cb-457d-99aa-4bf7f92f50bb","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863161885943,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":5724,"vrouter":"a7s12"},{"UuidKey":"c8ce6452-be24-490c-aec0-14aa81210134","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862711567980,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30721,"vrouter":"a7s12"},{"UuidKey":"c844defd-a7da-4820-9972-1b76f6d214f1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862882695176,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":913,"vrouter":"a7s12"},{"UuidKey":"c83063bf-8c9d-46e3-8c70-bd97eabdeff1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863224950369,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6609,"vrouter":"a7s12"},{"UuidKey":"c826acdd-8072-4365-8da8-ff97ecc2415e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863206936884,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":6431,"vrouter":"a7s12"},{"UuidKey":"c7c2784c-f1e0-479a-81ad-5d04a62ed614","action":"pass","agg-bytes":160159146,"agg-packets":1634277,"destip":"10.1.1.6","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1483228799242850,"sourceip":"10.1.1.5","sourcevn":"default-domain:admin:frontend","sport":18401,"vrouter":"a7s12"},{"UuidKey":"c6a048fb-24b4-4805-b9a5-2277ee57524d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862936744268,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1882,"vrouter":"a7s12"},{"UuidKey":"c6120fea-c2cb-42cd-9b53-16ed373fd760","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862576453682,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28881,"vrouter":"a7s12"},{"UuidKey":"dcf42d1d-dd7e-4b22-9655-6f0220320178","action":"pass","agg-bytes":473742664,"agg-packets":1413864,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1483228800093365,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53714,"vrouter":"a7s12"},{"UuidKey":"e1e26951-8b2c-4e3f-ad98-3de8abfbf9da","action":"pass","agg-bytes":1810453624,"agg-packets":5395034,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43883,"protocol":6,"setup_time":1478625106777071,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"e1c0df42-8916-441c-b9a7-59f0b4102e4f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862531418376,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27886,"vrouter":"a7s12"},{"UuidKey":"e18267ef-661c-4285-a850-8dbb25e041c2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862747594533,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31509,"vrouter":"a7s12"},{"UuidKey":"e02becc0-5ad7-4580-8952-74a9b29b4ad7","action":"pass","agg-bytes":1809695658,"agg-packets":5394131,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":38177,"protocol":6,"setup_time":1478625062604786,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9108,"vrouter":"a7s12"},{"UuidKey":"df9b7fdc-678a-45b2-8f42-10f2e7d1ddc8","action":"pass","agg-bytes":1810967602,"agg-packets":5393905,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1478625036523438,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47806,"vrouter":"a7s12"},{"UuidKey":"df81d3d5-f68e-4aa0-90e6-1ee433cb83c8","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862765605589,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31561,"vrouter":"a7s12"},{"UuidKey":"df433a77-f3a7-4dbe-b314-3ce5fceabfbe","action":"pass","agg-bytes":1807690180,"agg-packets":5401398,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50880,"protocol":6,"setup_time":1478625110786625,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"df365c7c-e617-4921-8e7d-e6fff2e3fb18","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862945746127,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1885,"vrouter":"a7s12"},{"UuidKey":"ddd26fd6-97e4-4bb3-9c51-9e164ec8befc","action":"pass","agg-bytes":1808504882,"agg-packets":5395885,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9111,"protocol":6,"setup_time":1478625074642494,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":51384,"vrouter":"a7s12"},{"UuidKey":"8d9be6a4-9278-4f87-af26-98cbac9e5850","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862684547530,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30629,"vrouter":"a7s12"},{"UuidKey":"dbdfac51-4f48-45db-9873-b79524468f00","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863233961169,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":6622,"vrouter":"a7s12"},{"UuidKey":"db087131-8a87-47fa-8157-7842d77ca8b1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862540430890,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27945,"vrouter":"a7s12"},{"UuidKey":"da86701b-c7ca-4281-8814-42613305a7c6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863251985171,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6661,"vrouter":"a7s12"},{"UuidKey":"d9406176-edca-4609-b99a-f23bbf344d7a","action":"pass","agg-bytes":1807746306,"agg-packets":5399477,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43881,"protocol":6,"setup_time":1478625104768837,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"d67bc661-47bd-49f7-a328-08fce2f8e021","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862981771697,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2827,"vrouter":"a7s12"},{"UuidKey":"d65b7afe-2cc0-4d9f-8bf8-543a8ed4ea4b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863026800170,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3626,"vrouter":"a7s12"},{"UuidKey":"d5536b4b-cec9-43c4-9f16-abe0881aa06e","action":"pass","agg-bytes":1809791380,"agg-packets":5396686,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56051,"protocol":6,"setup_time":1478625022469735,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"d3f0bb0a-62d6-4b7f-976c-15d05d7085c7","action":"pass","agg-bytes":1807451656,"agg-packets":5394784,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1478625068634541,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58223,"vrouter":"a7s12"},{"UuidKey":"2a43b52e-610c-4b2d-ba48-452e71bfea99","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862756604290,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31556,"vrouter":"a7s12"},{"UuidKey":"34df4ffb-5e83-4168-8cce-3bbdbeece450","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863089838404,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4651,"vrouter":"a7s12"},{"UuidKey":"3342664a-bcf5-49c0-b3eb-551fafcd63cf","action":"pass","agg-bytes":1808743556,"agg-packets":5390082,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36821,"protocol":6,"setup_time":1478625088680818,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"32f96d08-b86d-4867-ac52-cae3c808e851","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862567452548,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28848,"vrouter":"a7s12"},{"UuidKey":"3134cf1c-5c98-4556-8d26-cbba8152fb68","action":"pass","agg-bytes":473811638,"agg-packets":1412281,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228799901114,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57221,"vrouter":"a7s12"},{"UuidKey":"2fce770c-07e3-4cb4-bc30-af8a323b6561","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862972761949,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2824,"vrouter":"a7s12"},{"UuidKey":"2e5f0bdf-a536-4656-85f5-be5143fc9f2e","action":"pass","agg-bytes":474099900,"agg-packets":1413622,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228800133556,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35154,"vrouter":"a7s12"},{"UuidKey":"2dd883f4-50dd-4717-9740-627a96a00925","action":"pass","agg-bytes":1810613712,"agg-packets":5396832,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625099737870,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50752,"vrouter":"a7s12"},{"UuidKey":"2cedab73-e407-4691-80e8-73bacfc5cb9c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862828651405,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32466,"vrouter":"a7s12"},{"UuidKey":"2abdb70a-6555-4c21-b700-99756f585aa8","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862801631927,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32388,"vrouter":"a7s12"},{"UuidKey":"362bd3be-270d-487f-b54e-22c116cdd3b7","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862549440165,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28756,"vrouter":"a7s12"},{"UuidKey":"29343c95-5ee2-474e-a1c9-4f3b582390e4","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862783620656,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31939,"vrouter":"a7s12"},{"UuidKey":"2915b2b3-ee9a-48d3-9e99-bf39fba86c17","action":"pass","agg-bytes":473455276,"agg-packets":1411512,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1483228799882484,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56180,"vrouter":"a7s12"},{"UuidKey":"284f1ced-1e86-46db-a6d9-4025db293859","action":"pass","agg-bytes":160159244,"agg-packets":1634278,"destip":"10.1.1.5","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1483228799243049,"sourceip":"10.1.1.6","sourcevn":"default-domain:admin:frontend","sport":18401,"vrouter":"a7s12"},{"UuidKey":"27fc6dc4-2ec1-4490-b1e1-1801b883a38c","action":"pass","agg-bytes":1808173698,"agg-packets":5393623,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50541,"protocol":6,"setup_time":1478625026482950,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"2760018a-8e4d-4f0c-83ff-7ad47ebb0813","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862837659573,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32486,"vrouter":"a7s12"},{"UuidKey":"23cf3a36-8474-46bd-ba75-15b68073ceda","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863035803623,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3782,"vrouter":"a7s12"},{"UuidKey":"227139cf-167a-4bb6-a44d-3e04bddb8ab1","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862774615887,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31605,"vrouter":"a7s12"},{"UuidKey":"21fbc59d-7a96-4d2f-89ca-381c863fd8ec","action":"pass","agg-bytes":473693732,"agg-packets":1415202,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53714,"protocol":6,"setup_time":1483228800093325,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"214438ce-4581-4207-832b-eb36ebaa0b24","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862900717275,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":978,"vrouter":"a7s12"},{"UuidKey":"41f5c885-c8e1-4f06-88ec-67b5ad3253ae","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862639506018,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29783,"vrouter":"a7s12"},{"UuidKey":"4c18506b-9899-441d-9bf8-db3ba0947262","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862684547579,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30629,"vrouter":"a7s12"},{"UuidKey":"4c0a29b4-5c92-43f6-8af1-6b80394e2f69","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862576453783,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28881,"vrouter":"a7s12"},{"UuidKey":"4b9926b5-ff0d-47d7-99ff-3595312070b7","action":"pass","agg-bytes":473799870,"agg-packets":1410195,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57224,"protocol":6,"setup_time":1483228802116421,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"481246f8-b481-45ae-84da-815a8cc27caa","action":"pass","agg-bytes":1807742822,"agg-packets":5397827,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58426,"protocol":6,"setup_time":1478625051565043,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"47e0c661-214e-4e9b-92bb-64318ec3bbc2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863089838602,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4651,"vrouter":"a7s12"},{"UuidKey":"460f469d-f895-494a-a0cc-e876de5343e6","action":"pass","agg-bytes":473645962,"agg-packets":1413471,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1483228799928332,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44892,"vrouter":"a7s12"},{"UuidKey":"44849659-8002-4a83-a344-cc611fcd7d52","action":"pass","agg-bytes":1809675092,"agg-packets":5394322,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53710,"protocol":6,"setup_time":1478625039522789,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"42925e5c-9d51-48af-a4d7-2c6ab0e8930f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863188916554,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5766,"vrouter":"a7s12"},{"UuidKey":"42441ecb-ab13-4983-b574-0ba4edd102fa","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862657518766,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29828,"vrouter":"a7s12"},{"UuidKey":"20b78f94-1d4e-407f-a380-ac77952c30e3","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862486381967,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27548,"vrouter":"a7s12"},{"UuidKey":"4123ce43-ac18-436a-a17d-17d31320fe2e","action":"pass","agg-bytes":1809751864,"agg-packets":5397678,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1478625104768873,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43881,"vrouter":"a7s12"},{"UuidKey":"4086e356-2d01-4578-abcd-54730ca977e0","action":"pass","agg-bytes":473210892,"agg-packets":1414398,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57221,"protocol":6,"setup_time":1483228799900927,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"40071376-a4c3-4c7e-aa5e-7c83aa2c8d60","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863098847607,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4718,"vrouter":"a7s12"},{"UuidKey":"3f097795-5f41-484a-851b-326f8ae6d10d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862495392461,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27788,"vrouter":"a7s12"},{"UuidKey":"3eb6d124-7eb0-48b0-b07d-8ad5979ac57e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862747594391,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31509,"vrouter":"a7s12"},{"UuidKey":"3e1366d0-a9b4-49d6-8b91-1448f61bd298","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862504394195,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27809,"vrouter":"a7s12"},{"UuidKey":"3dea7e29-9699-4f09-a20d-44381341ae24","action":"pass","agg-bytes":1808782488,"agg-packets":5399660,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1478625028489515,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50543,"vrouter":"a7s12"},{"UuidKey":"3b4cfbf7-2629-4b5a-820c-3834a571339c","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863152885761,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5721,"vrouter":"a7s12"},{"UuidKey":"08bd32aa-afb6-477d-b786-8a037769ca5b","action":"pass","agg-bytes":473860248,"agg-packets":1415138,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50539,"protocol":6,"setup_time":1483228799287970,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"0e939910-3e8c-43c6-bef0-c98d1c0f6e9c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862846663207,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":730,"vrouter":"a7s12"},{"UuidKey":"0d8d0ebc-3679-4228-a45c-42c282336042","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862945746184,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1885,"vrouter":"a7s12"},{"UuidKey":"0ce37063-5fa6-4650-9254-e85e37ce782b","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862990773767,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2830,"vrouter":"a7s12"},{"UuidKey":"0c339972-af63-4a9b-8cdc-3dcc338b7303","action":"pass","agg-bytes":473130260,"agg-packets":1414222,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1483228799715635,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50883,"vrouter":"a7s12"},{"UuidKey":"0bbd327d-61aa-4847-869d-86478cf1507d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862990773739,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":2830,"vrouter":"a7s12"},{"UuidKey":"0b4f5229-4b94-4e28-9340-8c44a728eca2","action":"pass","agg-bytes":474411512,"agg-packets":1416662,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36817,"protocol":6,"setup_time":1483228799714183,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"0a91e7a2-ef72-4ae3-b153-abd42d609c65","action":"pass","agg-bytes":474298886,"agg-packets":1414843,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53190,"protocol":6,"setup_time":1483228800152469,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"0a7c0e82-c66f-43f8-8d0d-9fd3e1bf9c99","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862900717314,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":978,"vrouter":"a7s12"},{"UuidKey":"08e48c40-b0bd-40cf-a020-3d152784b30e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862513404201,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27840,"vrouter":"a7s12"},{"UuidKey":"0f77c9ec-5ae1-4a80-a834-728abfec5af8","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863152885723,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":5721,"vrouter":"a7s12"},{"UuidKey":"07c80b14-5e76-48bb-887f-821c1307fb27","action":"pass","agg-bytes":1810378852,"agg-packets":5392318,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625085672627,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36818,"vrouter":"a7s12"},{"UuidKey":"077ca2c3-e82e-4f69-8570-c2bd2edc07d7","action":"pass","agg-bytes":1809674684,"agg-packets":5395920,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625088681108,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36821,"vrouter":"a7s12"},{"UuidKey":"069960c6-4d13-4049-abe7-1c6f9caa4cb0","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863098847554,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4718,"vrouter":"a7s12"},{"UuidKey":"050771a8-10ed-407c-8b82-284cd4b44918","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863215948911,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6606,"vrouter":"a7s12"},{"UuidKey":"0397e3a9-efed-4d3a-9747-fe75ec0981c2","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862864686974,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":877,"vrouter":"a7s12"},{"UuidKey":"03414545-c2c7-43f5-bc7d-79743bfdd02e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862612483077,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29727,"vrouter":"a7s12"},{"UuidKey":"02f1735f-5562-424a-b98a-2797b5092f53","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863053816339,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":3812,"vrouter":"a7s12"},{"UuidKey":"02a04753-9be4-49d6-907b-f83f81c0138c","action":"pass","agg-bytes":474269978,"agg-packets":1413849,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35156,"protocol":6,"setup_time":1483228802612282,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"169d10d2-4544-438f-b58c-570996303dff","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862567452637,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28848,"vrouter":"a7s12"},{"UuidKey":"2058748e-86a0-4326-97d5-1eeca27cc4f2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862585463675,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28909,"vrouter":"a7s12"},{"UuidKey":"1fd2fc97-7338-4166-aa39-511e197ba73f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863233961237,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6622,"vrouter":"a7s12"},{"UuidKey":"1dd0c348-d47a-44fd-95bd-3062e7b7cff7","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862855665789,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":874,"vrouter":"a7s12"},{"UuidKey":"1ce0168e-e92a-4aa0-9a17-29020fcbfb33","action":"pass","agg-bytes":474359470,"agg-packets":1415209,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44892,"protocol":6,"setup_time":1483228799928278,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"1cd7c3f9-ce48-4b3e-9d8c-c8cebe341456","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862810637185,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32391,"vrouter":"a7s12"},{"UuidKey":"19be7945-7a4a-4fd2-a82c-444abaac9749","action":"pass","agg-bytes":1810743886,"agg-packets":5401979,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44278,"protocol":6,"setup_time":1478625080663103,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9112,"vrouter":"a7s12"},{"UuidKey":"18e6e4de-cb32-46a1-a895-a56b1771946f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862630504110,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29768,"vrouter":"a7s12"},{"UuidKey":"18565b44-5c7e-4e87-adfc-f9e4b2128596","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862702558732,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30679,"vrouter":"a7s12"},{"UuidKey":"177bcb69-1524-4082-86c0-b9403bd0a98c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862504394116,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27809,"vrouter":"a7s12"},{"UuidKey":"4d13ad6c-980a-45f2-aa24-fe2163baa273","action":"pass","agg-bytes":473509722,"agg-packets":1411481,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228799929612,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58221,"vrouter":"a7s12"},{"UuidKey":"15e3de3b-d310-44c0-933b-112501b97a99","action":"pass","agg-bytes":1808469574,"agg-packets":5393999,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36818,"protocol":6,"setup_time":1478625085672590,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"15d90ff4-0298-4d60-b919-5e3056acf0de","action":"pass","agg-bytes":1808730812,"agg-packets":5398352,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1478625021467242,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56050,"vrouter":"a7s12"},{"UuidKey":"14274b76-e6d9-4828-91d7-2d3dc1599711","action":"pass","agg-bytes":473333106,"agg-packets":1411657,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56049,"protocol":6,"setup_time":1483228799715787,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"140684d2-01d7-4b95-9e3c-fab7d3385dfc","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862909722566,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":1774,"vrouter":"a7s12"},{"UuidKey":"12bda384-234f-496e-8275-c491dc744dac","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862819648591,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":32425,"vrouter":"a7s12"},{"UuidKey":"11fb2010-b2bf-43da-bd24-413a6fb00cbe","action":"pass","agg-bytes":473597246,"agg-packets":1414247,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228799925716,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49730,"vrouter":"a7s12"},{"UuidKey":"10dba9ea-e5ab-45c1-a8f9-6953e4f36f96","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862837659645,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":32486,"vrouter":"a7s12"},{"UuidKey":"1095681d-f823-402a-b782-917d697ef0cf","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863179901341,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":5763,"vrouter":"a7s12"},{"UuidKey":"71d7d08e-6b32-47fe-b5c7-e4f7a5f8183a","action":"pass","agg-bytes":473652506,"agg-packets":1412193,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228799927695,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53188,"vrouter":"a7s12"},{"UuidKey":"7afb2b9a-410b-4bba-bcc3-00b4ddd5242f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863080836262,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4066,"vrouter":"a7s12"},{"UuidKey":"79e2d400-28cd-4bca-a6df-382b21688906","action":"pass","agg-bytes":474097710,"agg-packets":1413661,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50756,"protocol":6,"setup_time":1483228800313726,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"7848f747-afce-402e-aa10-c5cbb732d0fe","action":"pass","agg-bytes":1808750150,"agg-packets":5400011,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1478625054576681,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35152,"vrouter":"a7s12"},{"UuidKey":"78040e3d-7754-45b0-a220-9745c2ae2274","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862927734240,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1847,"vrouter":"a7s12"},{"UuidKey":"77e54f5b-cd44-4e4d-a385-1c194d01e0ba","action":"pass","agg-bytes":474136562,"agg-packets":1418221,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1483228800152414,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53711,"vrouter":"a7s12"},{"UuidKey":"77ace095-5362-4a8a-97b8-1e63959a3d15","action":"pass","agg-bytes":474359058,"agg-packets":1415193,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228801931742,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35155,"vrouter":"a7s12"},{"UuidKey":"772c875c-a8fe-4d3e-9571-9777f81e59f9","action":"pass","agg-bytes":1807965120,"agg-packets":5399510,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625102750788,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50755,"vrouter":"a7s12"},{"UuidKey":"74d78a11-f301-495e-bd54-ec91140b6a5b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862891704827,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":975,"vrouter":"a7s12"},{"UuidKey":"73ce07ee-69b1-438f-8d81-5b41d17e2640","action":"pass","agg-bytes":473772094,"agg-packets":1409831,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228799929675,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57223,"vrouter":"a7s12"},{"UuidKey":"7d868439-3838-4eeb-8779-e05abe095950","action":"pass","agg-bytes":474987262,"agg-packets":1414319,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50879,"protocol":6,"setup_time":1483228800114186,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"71670f95-d881-40ea-926f-8a06daaaa6ff","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863224950323,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":6609,"vrouter":"a7s12"},{"UuidKey":"70d057df-cbf9-499d-9bbe-71312c29e41f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863125862686,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4757,"vrouter":"a7s12"},{"UuidKey":"6ffb1594-ec00-4db6-ad78-23e4aa357202","action":"pass","agg-bytes":474657274,"agg-packets":1412129,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":51387,"protocol":6,"setup_time":1483228799926918,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9111,"vrouter":"a7s12"},{"UuidKey":"6d3c9d1f-4abc-4dd0-bb6e-c3d66b7442bd","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862486381938,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27548,"vrouter":"a7s12"},{"UuidKey":"6cca97ab-8e69-476d-9336-bc7b0311c367","action":"pass","agg-bytes":474533510,"agg-packets":1414985,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228800152482,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53190,"vrouter":"a7s12"},{"UuidKey":"6aa30ea8-e3df-4cb3-b0e7-a0ec086e9258","action":"pass","agg-bytes":1809941446,"agg-packets":5402165,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9112,"protocol":6,"setup_time":1478625080663284,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44278,"vrouter":"a7s12"},{"UuidKey":"69d784e8-aa3c-4cc9-ac4f-8cf3ea2aa794","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862621492757,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29730,"vrouter":"a7s12"},{"UuidKey":"69028f35-ba94-4b02-9d82-3916cc4a56ea","action":"pass","agg-bytes":474267050,"agg-packets":1414319,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58220,"protocol":6,"setup_time":1483228800153283,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"84466486-84ab-4fc5-83ef-c35243168952","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863080836236,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4066,"vrouter":"a7s12"},{"UuidKey":"8ca8f255-b89e-4483-bc71-a8247c628390","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863017796083,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2923,"vrouter":"a7s12"},{"UuidKey":"8b3b78b7-d010-4510-9abf-fe007b3cd757","action":"pass","agg-bytes":474095734,"agg-packets":1412537,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228799288082,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50539,"vrouter":"a7s12"},{"UuidKey":"8ad67e72-aa75-4301-8a41-96ea806e4a58","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863116860006,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4754,"vrouter":"a7s12"},{"UuidKey":"897d76da-3c37-403f-8f78-c61164990dc6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862594466938,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":28927,"vrouter":"a7s12"},{"UuidKey":"87c7ec2a-5b18-4a07-bb5c-5ff99ffd8b2f","action":"pass","agg-bytes":473642192,"agg-packets":1410308,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1483228799457594,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58425,"vrouter":"a7s12"},{"UuidKey":"87690c50-38e6-4511-92d4-4b64dd666b79","action":"pass","agg-bytes":1808486618,"agg-packets":5395303,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1478625106777115,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43883,"vrouter":"a7s12"},{"UuidKey":"8678c61e-d9fa-4156-9f91-08807d9ff1dc","action":"pass","agg-bytes":473452468,"agg-packets":1415010,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44889,"protocol":6,"setup_time":1483228800153115,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"86661158-e19d-4aff-b9e7-5c1bded93687","action":"pass","agg-bytes":1810391096,"agg-packets":5392714,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1478625039522848,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53710,"vrouter":"a7s12"},{"UuidKey":"8641c687-df4f-4753-9d1c-552e01682a33","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862729581064,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31438,"vrouter":"a7s12"},{"UuidKey":"685a338d-6601-4174-8ef8-66326b6e9786","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862873692483,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":906,"vrouter":"a7s12"},{"UuidKey":"832449c9-2486-401e-8b23-f1eb415499fe","action":"pass","agg-bytes":1808833378,"agg-packets":5396353,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44890,"protocol":6,"setup_time":1478625115801862,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"830782b3-5259-4f83-b6f6-0644db65032b","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862495392495,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27788,"vrouter":"a7s12"},{"UuidKey":"829f80dd-84e6-4292-96a3-648e9d3225be","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862936744315,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1882,"vrouter":"a7s12"},{"UuidKey":"8219dbfb-bebe-4d8a-b436-d7e236e412ce","action":"pass","agg-bytes":1807732680,"agg-packets":5398932,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36819,"protocol":6,"setup_time":1478625086674383,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"81fe7ecb-dd67-466b-b78b-f13dfd3f495d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863143873665,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":5151,"vrouter":"a7s12"},{"UuidKey":"8163d676-6900-429e-9dda-0ea4c34e741b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863242977177,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":6643,"vrouter":"a7s12"},{"UuidKey":"7f33dea5-97c9-4d48-9258-900ef605e167","action":"pass","agg-bytes":473516750,"agg-packets":1412733,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58221,"protocol":6,"setup_time":1483228799929416,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"7e4adafd-2027-4987-9e4a-9786e0a46702","action":"pass","agg-bytes":1809609478,"agg-packets":5395617,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9108,"protocol":6,"setup_time":1478625062604817,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":38177,"vrouter":"a7s12"},{"UuidKey":"5506a0c2-b8e4-4e9f-89bc-ee6643312f72","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862585463633,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28909,"vrouter":"a7s12"},{"UuidKey":"5f1de339-2ebe-409a-8fb6-73b5f110809e","action":"pass","agg-bytes":1807618744,"agg-packets":5389536,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58223,"protocol":6,"setup_time":1478625068634496,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"5cbd4174-0837-474d-88a7-a449685ced27","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862603483533,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":29283,"vrouter":"a7s12"},{"UuidKey":"5c82ec78-de7b-4d0a-9ff5-ea25e1525319","action":"pass","agg-bytes":1808582458,"agg-packets":5399493,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53192,"protocol":6,"setup_time":1478625098727034,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"5b6701e2-9bbf-451e-bc5a-d9adf3f64dc6","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862675538252,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30626,"vrouter":"a7s12"},{"UuidKey":"5a37e0e3-1648-4875-ab56-6b0c0fb61758","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862522406525,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":27844,"vrouter":"a7s12"},{"UuidKey":"58d5f36e-ed86-4185-b2cc-7bf558f391a5","action":"pass","agg-bytes":1809243854,"agg-packets":5398867,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625100743975,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50753,"vrouter":"a7s12"},{"UuidKey":"566068c3-a229-47a6-93e6-a82b10026275","action":"pass","agg-bytes":474523890,"agg-packets":1413687,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1483228800114228,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50879,"vrouter":"a7s12"},{"UuidKey":"557f5f52-71b1-4f91-85bc-bee786d9edf6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862864687010,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":877,"vrouter":"a7s12"},{"UuidKey":"551273c9-2335-4f58-9f11-0a96de2f7c54","action":"pass","agg-bytes":474155390,"agg-packets":1410387,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50542,"protocol":6,"setup_time":1483228799929707,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"5f814e1f-834b-4455-ad40-f3dd5d6fae83","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863134875537,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4800,"vrouter":"a7s12"},{"UuidKey":"5409f722-d7cb-4b3b-bd0b-5dce88cba791","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862972761975,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":2824,"vrouter":"a7s12"},{"UuidKey":"50c39545-dd69-4bbf-ac11-80299525afcc","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862558441874,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":28831,"vrouter":"a7s12"},{"UuidKey":"50932449-db6a-498b-9e25-b9f8cd2a4c77","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863125862652,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":4757,"vrouter":"a7s12"},{"UuidKey":"4fcb8848-c01d-4a1c-96b5-257ff73bd106","action":"pass","agg-bytes":1808214284,"agg-packets":5391524,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1478625073649057,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54509,"vrouter":"a7s12"},{"UuidKey":"4fc4e089-a1fc-4aaf-a331-cc1c8ce54f93","action":"pass","agg-bytes":1809363790,"agg-packets":5400923,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1478625035511579,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47805,"vrouter":"a7s12"},{"UuidKey":"4e61865f-ec0f-47be-a667-be528d0b8573","action":"pass","agg-bytes":474009092,"agg-packets":1413866,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228802174811,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49727,"vrouter":"a7s12"},{"UuidKey":"4e22e45f-00c6-4144-a7f7-f2f9062b65c4","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862675538334,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30626,"vrouter":"a7s12"},{"UuidKey":"4deedbc6-1eba-4574-b1fd-a875a6a6bf2f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863197918397,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5809,"vrouter":"a7s12"},{"UuidKey":"6392e389-4b05-4ac4-a3e1-babad3115d9d","action":"pass","agg-bytes":473383434,"agg-packets":1413171,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228800153301,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58220,"vrouter":"a7s12"},{"UuidKey":"68418cad-359b-47ed-92f8-6348a7b49c6a","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863134875569,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":4800,"vrouter":"a7s12"},{"UuidKey":"67a034dd-7ec1-47cb-a94c-76f509ea3ed5","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863053814957,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3812,"vrouter":"a7s12"},{"UuidKey":"6774bbfa-2acd-4e03-8b67-c966b250fdda","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863044811754,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":3785,"vrouter":"a7s12"},{"UuidKey":"67728105-06c9-4a41-b117-0eec7fd88f3f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862954756860,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1942,"vrouter":"a7s12"},{"UuidKey":"660be59e-4e19-4b10-a4f5-5de26f18e26b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862720570950,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":30724,"vrouter":"a7s12"},{"UuidKey":"655acb9a-9e1c-47a9-892f-23247f1a1733","action":"pass","agg-bytes":473416150,"agg-packets":1411259,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1483228799715852,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56049,"vrouter":"a7s12"},{"UuidKey":"64f57acc-458f-4cf3-8c2f-e3febc13035f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863143873692,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":5151,"vrouter":"a7s12"},{"UuidKey":"646efdec-c1fc-489a-a375-e662be3aa58c","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862909722597,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":1774,"vrouter":"a7s12"},{"UuidKey":"644bc582-8cc3-48b7-a756-c8123f905bb7","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862765605518,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":31561,"vrouter":"a7s12"},{"UuidKey":"0118202d-ed98-4f09-880f-13f2429b7786","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862756604348,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":31556,"vrouter":"a7s12"},{"UuidKey":"632ab520-11ce-4bdd-b873-d503216448fa","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862639506107,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":29783,"vrouter":"a7s12"},{"UuidKey":"63242d49-267e-45c7-b8c7-06143756d286","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862522406490,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:backend","sport":27844,"vrouter":"a7s12"},{"UuidKey":"629662cb-61b5-4d95-b850-e19d64986c24","action":"pass","agg-bytes":1810563144,"agg-packets":5395772,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1478625071631155,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54507,"vrouter":"a7s12"},{"UuidKey":"624efc69-e445-4a65-91d0-8195cacc53fb","action":"pass","agg-bytes":474226410,"agg-packets":1413041,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1483228800313745,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50756,"vrouter":"a7s12"},{"UuidKey":"621005e0-73a5-4688-abb1-cc9a35376ed7","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862693556422,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":30675,"vrouter":"a7s12"},{"UuidKey":"6097b316-5aab-4182-9d7a-2aeb2b2ebe8d","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:backend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862855665879,"sourceip":"30.30.31.2","sourcevn":"default-domain:admin:frontend","sport":874,"vrouter":"a7s12"},{"UuidKey":"6015cf2c-f698-4361-adc8-f69091c93da5","action":"pass","agg-bytes":474822928,"agg-packets":1416000,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43884,"protocol":6,"setup_time":1483228800313449,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"5fa00954-0c99-4d2a-bd84-e7c7c132d27a","action":"pass","agg-bytes":473323238,"agg-packets":1414019,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1483228806583558,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54505,"vrouter":"a7s12"}],"total":306,"queryJSON":{"table":"FlowRecordTable","start_time":1484862660000000,"end_time":1484863260000000,"select_fields":["direction_ing","vrouter","sourcevn","sourceip","destvn","destip","protocol","sport","dport","setup_time","agg-packets","agg-bytes","action"],"filter":[[]],"limit":150000,"sort":1,"dir":1},"chunk":1,"chunkSize":306,"serverSideChunking":true}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = [{"id":"FRPAR","latitude":48.86,"longitude":2.3444,"city":"Paris","links":[{"id":"USNYC","factor":-0.3,"width":2},{"id":"USSAN","factor":-0.5,"width":4},{"id":"BRBSB","factor":-0.8,"width":1}]},{"id":"USNYC","latitude":40.667,"longitude":-73.833,"city":"New york"},{"id":"USSAN","latitude":37.792032,"longitude":-122.394613,"city":"San Francisco"},{"id":"BRBSB","latitude":-15.781682,"longitude":-47.924195,"city":"Brasilia"},{"id":"ITROM","latitude":41.827637,"longitude":12.462732,"city":"Roma","links":[{"id":"USMIA","factor":0.2,"width":4}]},{"id":"USMIA","latitude":25.789125,"longitude":-80.205674,"city":"Miami"},{"id":"JPTYO","latitude":35.687418,"longitude":139.692306,"city":"Tokyo"},{"id":"AUSYD","latitude":-33.917,"longitude":151.167,"city":"Sydney","links":[{"id":"JPTYO","factor":0.2,"width":6}]}]

/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = {"type":"Topology","transform":{"scale":[0.03600360036003601,0.017366249624962495],"translate":[-180,-90]},"objects":{"land":{"type":"MultiPolygon","arcs":[[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28,29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41,42]],[[43]],[[44]],[[45]],[[46,47,48,49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61,62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75,76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89,90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124,125,126,127,128,129,130,131,132,133,134,135,136,137,138,139,140,141,142,143,144,145,146,147,148,149,150,151,152]],[[153,154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161,162,163,164]],[[165]],[[166]],[[167]],[[168]],[[169]],[[170]],[[171]],[[172]],[[173,174,175,176,177,178,179,180,181,182,183,184,185,186,187,188,189,190,191,192,193,194,195,196,197,198,199,200,201,202,203,204,205,206,207,208,209,210,211,212,213,214,215,216,217,218,219,220,221,222,223,224,225,226,227,228,229,230,231,232,233,234,235,236,237,238,239,240,241,242,243,244,245,246,247,248,249,250,251,252,253,254,255,256,257,258,259,260,261,262,263,264,265,266,267,268,269,270,271,272,273,274,275,276,277],[278,279,280,281,282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]],[[290]],[[291]],[[292]],[[293]],[[294]],[[295]],[[296]]]},"countries":{"type":"GeometryCollection","geometries":[{"type":"Polygon","id":4,"arcs":[[297,298,299,300,301,302]]},{"type":"MultiPolygon","id":24,"arcs":[[[303,304,211,305]],[[213,306,307]]]},{"type":"Polygon","id":8,"arcs":[[308,248,309,310,311]]},{"type":"Polygon","id":784,"arcs":[[312,195,313,314,193]]},{"type":"MultiPolygon","id":32,"arcs":[[[315,10]],[[316,317,318,131,319,320]]]},{"type":"Polygon","id":51,"arcs":[[321,322,323,324,325]]},{"type":"MultiPolygon","id":10,"arcs":[[[0]],[[1]],[[2]],[[3]],[[4]],[[5]],[[6]],[[326]]]},{"type":"Polygon","id":260,"arcs":[[327]]},{"type":"MultiPolygon","id":36,"arcs":[[[13]],[[23]]]},{"type":"Polygon","id":40,"arcs":[[328,329,330,331,332,333,334]]},{"type":"MultiPolygon","id":31,"arcs":[[[335,-323]],[[282,336,-326,337,338]]]},{"type":"Polygon","id":108,"arcs":[[339,340,341]]},{"type":"Polygon","id":56,"arcs":[[342,343,344,258,345]]},{"type":"Polygon","id":204,"arcs":[[346,347,348,219,349]]},{"type":"Polygon","id":854,"arcs":[[350,351,-347,352,353,354]]},{"type":"Polygon","id":50,"arcs":[[184,355,356]]},{"type":"Polygon","id":100,"arcs":[[245,357,358,359,360,361]]},{"type":"MultiPolygon","id":44,"arcs":[[[70]],[[72]],[[73]]]},{"type":"Polygon","id":70,"arcs":[[362,363,364]]},{"type":"Polygon","id":112,"arcs":[[365,366,367,368,369]]},{"type":"Polygon","id":84,"arcs":[[118,370,371]]},{"type":"Polygon","id":68,"arcs":[[372,373,374,375,-321]]},{"type":"Polygon","id":76,"arcs":[[376,-375,377,378,379,380,381,382,129,383,-318]]},{"type":"Polygon","id":96,"arcs":[[384,47]]},{"type":"Polygon","id":64,"arcs":[[385,386]]},{"type":"Polygon","id":72,"arcs":[[387,388,389,390]]},{"type":"Polygon","id":140,"arcs":[[391,392,393,394,395,396,397]]},{"type":"MultiPolygon","id":124,"arcs":[[[83]],[[84]],[[85]],[[86]],[[398]],[[95]],[[96]],[[98]],[[100]],[[102]],[[399,146,400,148,401,150,402,152]],[[153,403]],[[155]],[[156]],[[157]],[[158]],[[160]],[[161,404,163,405]],[[166]],[[168]],[[169]],[[171]],[[172]],[[283]],[[284]],[[286]],[[287]],[[288]],[[294]],[[295]]]},{"type":"Polygon","id":756,"arcs":[[406,407,408,-331]]},{"type":"MultiPolygon","id":152,"arcs":[[[409,410,411,-316]],[[-320,132,412,-373]]]},{"type":"MultiPolygon","id":156,"arcs":[[[63]],[[413,177,414,415,416,417,-386,418,419,420,421,-300,422,423,424,425,426,427]]]},{"type":"Polygon","id":384,"arcs":[[428,429,430,-355,431,222]]},{"type":"Polygon","id":120,"arcs":[[432,217,433,434,435,-397,436,437]]},{"type":"Polygon","id":180,"arcs":[[438,-342,439,440,-306,212,-308,441,-395,442,443]]},{"type":"Polygon","id":178,"arcs":[[214,444,-437,-396,-442,-307]]},{"type":"Polygon","id":170,"arcs":[[135,445,124,446,-379,447,448]]},{"type":"Polygon","id":188,"arcs":[[449,122,450,137]]},{"type":"Polygon","id":192,"arcs":[[451]]},{"type":"Polygon","id":-1,"arcs":[[452,76]]},{"type":"Polygon","id":196,"arcs":[[-453,75]]},{"type":"Polygon","id":203,"arcs":[[453,454,455,-333]]},{"type":"Polygon","id":276,"arcs":[[456,-454,-332,-409,457,458,-343,459,260,460,262]]},{"type":"Polygon","id":262,"arcs":[[461,462,463,203]]},{"type":"MultiPolygon","id":208,"arcs":[[[91]],[[-461,261]]]},{"type":"Polygon","id":214,"arcs":[[464,61]]},{"type":"Polygon","id":12,"arcs":[[465,466,467,468,233,469,470,471]]},{"type":"Polygon","id":218,"arcs":[[-449,472,134]]},{"type":"Polygon","id":818,"arcs":[[473,474,236,475,200]]},{"type":"Polygon","id":232,"arcs":[[476,202,-464,477]]},{"type":"Polygon","id":724,"arcs":[[478,254,479,256]]},{"type":"Polygon","id":233,"arcs":[[480,481,267]]},{"type":"Polygon","id":231,"arcs":[[-463,482,483,484,485,486,487,-478]]},{"type":"Polygon","id":246,"arcs":[[269,488,489,490]]},{"type":"MultiPolygon","id":242,"arcs":[[[17]],[[18]],[[19]]]},{"type":"Polygon","id":238,"arcs":[[491]]},{"type":"MultiPolygon","id":250,"arcs":[[[492,493,494,128,-383]],[[81]],[[495,-458,-408,496,253,-479,257,-345]]]},{"type":"Polygon","id":266,"arcs":[[497,-438,-445,215]]},{"type":"MultiPolygon","id":826,"arcs":[[[498,89]],[[499,500,501,502]]]},{"type":"Polygon","id":268,"arcs":[[503,-338,-325,504,241]]},{"type":"Polygon","id":288,"arcs":[[-432,-354,505,221]]},{"type":"Polygon","id":324,"arcs":[[506,225,507,508,509,-430,510]]},{"type":"Polygon","id":270,"arcs":[[228,511]]},{"type":"Polygon","id":624,"arcs":[[512,-508,226]]},{"type":"Polygon","id":226,"arcs":[[-433,-498,216]]},{"type":"MultiPolygon","id":300,"arcs":[[[77]],[[247,-309,513,-359,514]]]},{"type":"Polygon","id":304,"arcs":[[515]]},{"type":"Polygon","id":320,"arcs":[[516,-371,119,517,518,143]]},{"type":"Polygon","id":328,"arcs":[[519,-381,520,126]]},{"type":"Polygon","id":340,"arcs":[[521,-518,120,522,139]]},{"type":"Polygon","id":191,"arcs":[[-364,523,250,524,525,526]]},{"type":"Polygon","id":332,"arcs":[[-465,62]]},{"type":"Polygon","id":348,"arcs":[[527,528,529,530,-526,531,-335]]},{"type":"MultiPolygon","id":360,"arcs":[[[25]],[[532,29]],[[30]],[[31]],[[34]],[[35]],[[38]],[[39]],[[533,42]],[[43]],[[44]],[[534,49]],[[45]]]},{"type":"Polygon","id":356,"arcs":[[535,-419,-387,-418,536,-356,185,537,-421]]},{"type":"Polygon","id":372,"arcs":[[-499,90]]},{"type":"Polygon","id":364,"arcs":[[-302,538,187,539,540,-336,-322,-337,278,541]]},{"type":"Polygon","id":368,"arcs":[[188,542,543,544,545,546,-540]]},{"type":"Polygon","id":352,"arcs":[[99]]},{"type":"Polygon","id":376,"arcs":[[547,-476,237,548,549,550,551]]},{"type":"MultiPolygon","id":380,"arcs":[[[78]],[[79]],[[552,252,-497,-407,-330]]]},{"type":"Polygon","id":388,"arcs":[[553]]},{"type":"Polygon","id":400,"arcs":[[-545,554,199,-548,555,-551,556]]},{"type":"MultiPolygon","id":392,"arcs":[[[74]],[[80]],[[82]]]},{"type":"Polygon","id":398,"arcs":[[557,280,558,-425,559,560]]},{"type":"Polygon","id":404,"arcs":[[206,561,562,563,-485,564]]},{"type":"Polygon","id":417,"arcs":[[-424,565,566,-560]]},{"type":"Polygon","id":116,"arcs":[[567,568,569,179]]},{"type":"Polygon","id":410,"arcs":[[570,175]]},{"type":"Polygon","id":-2,"arcs":[[-311,571,572,573]]},{"type":"Polygon","id":414,"arcs":[[574,-543,189]]},{"type":"Polygon","id":418,"arcs":[[575,-416,576,-569,577]]},{"type":"Polygon","id":422,"arcs":[[238,578,-549]]},{"type":"Polygon","id":430,"arcs":[[579,-511,-429,223]]},{"type":"Polygon","id":434,"arcs":[[-471,580,235,-475,581,582,583]]},{"type":"Polygon","id":144,"arcs":[[584]]},{"type":"Polygon","id":426,"arcs":[[585]]},{"type":"Polygon","id":440,"arcs":[[265,586,-370,587,588]]},{"type":"Polygon","id":442,"arcs":[[-496,-344,-459]]},{"type":"Polygon","id":428,"arcs":[[-482,589,-366,-587,266]]},{"type":"Polygon","id":504,"arcs":[[-469,590,591,592,593]]},{"type":"Polygon","id":498,"arcs":[[594,595]]},{"type":"Polygon","id":450,"arcs":[[596]]},{"type":"Polygon","id":484,"arcs":[[-372,-517,144,597,598]]},{"type":"Polygon","id":807,"arcs":[[599,-360,-514,-312,-574]]},{"type":"Polygon","id":466,"arcs":[[-466,600,-351,-431,-510,601,602]]},{"type":"Polygon","id":104,"arcs":[[183,-357,-537,-417,-576,603]]},{"type":"Polygon","id":499,"arcs":[[249,-524,-363,604,-572,-310]]},{"type":"Polygon","id":496,"arcs":[[-427,605]]},{"type":"Polygon","id":508,"arcs":[[208,606,607,608,609,610,611,612]]},{"type":"Polygon","id":478,"arcs":[[230,613,-467,-603,614]]},{"type":"Polygon","id":454,"arcs":[[615,616,-612]]},{"type":"MultiPolygon","id":458,"arcs":[[[181,617]],[[-535,46,-385,48]]]},{"type":"Polygon","id":516,"arcs":[[-305,618,-389,619,210]]},{"type":"Polygon","id":540,"arcs":[[620]]},{"type":"Polygon","id":562,"arcs":[[-601,-472,-584,621,-435,622,-348,-352]]},{"type":"Polygon","id":566,"arcs":[[-349,-623,-434,218]]},{"type":"Polygon","id":558,"arcs":[[-523,121,-450,138]]},{"type":"Polygon","id":528,"arcs":[[-460,-346,259]]},{"type":"MultiPolygon","id":578,"arcs":[[[623,-490,624,271]],[[285]],[[290]],[[291]]]},{"type":"Polygon","id":524,"arcs":[[-420,-536]]},{"type":"MultiPolygon","id":554,"arcs":[[[14]],[[15]]]},{"type":"MultiPolygon","id":512,"arcs":[[[625,626,-314,196]],[[-313,194]]]},{"type":"Polygon","id":586,"arcs":[[-538,186,-539,-301,-422]]},{"type":"Polygon","id":591,"arcs":[[-451,123,-446,136]]},{"type":"Polygon","id":604,"arcs":[[133,-473,-448,-378,-374,-413]]},{"type":"MultiPolygon","id":608,"arcs":[[[50]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]]]},{"type":"MultiPolygon","id":598,"arcs":[[[36]],[[37]],[[-534,41]],[[40]]]},{"type":"Polygon","id":616,"arcs":[[263,627,-588,-369,628,629,-455,-457]]},{"type":"Polygon","id":630,"arcs":[[630]]},{"type":"Polygon","id":408,"arcs":[[-571,176,-414,631,174]]},{"type":"Polygon","id":620,"arcs":[[255,-480]]},{"type":"Polygon","id":600,"arcs":[[-377,-317,-376]]},{"type":"Polygon","id":275,"arcs":[[-552,-556]]},{"type":"Polygon","id":634,"arcs":[[632,191]]},{"type":"Polygon","id":642,"arcs":[[-595,633,244,-362,634,-530,635]]},{"type":"MultiPolygon","id":643,"arcs":[[[88]],[[264,-589,-628]],[[101]],[[103]],[[104]],[[159]],[[165]],[[167]],[[170]],[[173,-632,-428,-606,-426,-559,281,-339,-504,242,636,-367,-590,-481,268,-491,-624,637,638,639,640,274,641,276,642]],[[289]],[[292]],[[293]]]},{"type":"Polygon","id":646,"arcs":[[-340,-439,643,644]]},{"type":"Polygon","id":732,"arcs":[[-468,-614,231,-591]]},{"type":"Polygon","id":682,"arcs":[[-555,-544,-575,190,-633,192,-315,-627,645,198]]},{"type":"Polygon","id":729,"arcs":[[646,-582,-474,201,-477,-488,647,648,649,-392]]},{"type":"Polygon","id":728,"arcs":[[-564,650,-443,-394,651,-649,652,-486]]},{"type":"Polygon","id":686,"arcs":[[-615,-602,-509,-513,227,-512,229]]},{"type":"MultiPolygon","id":90,"arcs":[[[24]],[[26]],[[27]],[[32]],[[33]]]},{"type":"Polygon","id":694,"arcs":[[-507,-580,224]]},{"type":"Polygon","id":222,"arcs":[[142,-519,-522,140,653]]},{"type":"Polygon","id":-3,"arcs":[[-483,-462,204,654]]},{"type":"Polygon","id":706,"arcs":[[-565,-484,-655,205]]},{"type":"Polygon","id":688,"arcs":[[-361,-600,-573,-605,-365,-527,-531,-635]]},{"type":"Polygon","id":740,"arcs":[[-495,655,656,-382,-520,127]]},{"type":"Polygon","id":703,"arcs":[[657,-528,-334,-456,-630]]},{"type":"Polygon","id":705,"arcs":[[-532,-525,251,-553,-329]]},{"type":"Polygon","id":752,"arcs":[[-625,-489,270]]},{"type":"Polygon","id":748,"arcs":[[-608,658]]},{"type":"Polygon","id":760,"arcs":[[-550,-579,239,659,-546,-557]]},{"type":"Polygon","id":148,"arcs":[[-583,-647,-398,-436,-622]]},{"type":"Polygon","id":768,"arcs":[[-353,-350,220,-506]]},{"type":"Polygon","id":764,"arcs":[[-618,182,-604,-578,-568,180]]},{"type":"Polygon","id":762,"arcs":[[-423,-299,660,-566]]},{"type":"Polygon","id":795,"arcs":[[279,-558,661,-303,-542]]},{"type":"Polygon","id":626,"arcs":[[-533,28]]},{"type":"Polygon","id":780,"arcs":[[662]]},{"type":"Polygon","id":788,"arcs":[[234,-581,-470]]},{"type":"MultiPolygon","id":792,"arcs":[[[-505,-324,-541,-547,-660,240]],[[-515,-358,246]]]},{"type":"Polygon","id":158,"arcs":[[663]]},{"type":"Polygon","id":834,"arcs":[[207,-613,-617,664,-440,-341,-645,665,-562]]},{"type":"Polygon","id":800,"arcs":[[-644,-444,-651,-563,-666]]},{"type":"Polygon","id":804,"arcs":[[243,-634,-596,-636,-529,-658,-629,-368,-637]]},{"type":"Polygon","id":858,"arcs":[[130,-319,-384]]},{"type":"MultiPolygon","id":840,"arcs":[[[64]],[[65]],[[66]],[[67]],[[68]],[[105,666,107,667,109,668,111,669,113,670,115,-598,671,672,673,-400]],[[92]],[[94]],[[97]],[[-401,147]]]},{"type":"Polygon","id":860,"arcs":[[-561,-567,-661,-298,-662]]},{"type":"Polygon","id":862,"arcs":[[-521,-380,-447,125]]},{"type":"Polygon","id":704,"arcs":[[-570,-577,-415,178]]},{"type":"MultiPolygon","id":548,"arcs":[[[20]],[[21]]]},{"type":"Polygon","id":887,"arcs":[[-646,-626,197]]},{"type":"Polygon","id":710,"arcs":[[-620,-388,674,-609,-659,-607,209],[-586]]},{"type":"Polygon","id":894,"arcs":[[-611,675,-390,-619,-304,-441,-665,-616]]},{"type":"Polygon","id":716,"arcs":[[-391,-676,-610,-675]]}]}},"arcs":[[[3344,573],[-8,-29],[-8,-26],[-58,8],[-62,-4],[-35,19],[0,3],[-15,17],[62,-3],[60,-5],[21,23],[15,21],[28,-24]],[[577,604],[-53,-8],[-37,21],[-16,20],[-1,3],[-18,16],[17,22],[51,-9],[28,-18],[21,-21],[8,-26]],[[3745,688],[34,-25],[12,-35],[3,-25],[1,-29],[-43,-18],[-45,-15],[-52,-13],[-58,-12],[-66,4],[-36,19],[4,24],[60,15],[24,20],[17,24],[13,22],[16,20],[18,24],[15,0],[41,12],[42,-12]],[[1632,950],[36,-9],[33,10],[-15,-21],[-26,-14],[-39,4],[-28,21],[6,19],[33,-10]],[[1512,951],[42,-23],[-16,2],[-36,6],[-38,16],[20,12],[28,-13]],[[2250,1040],[30,-8],[31,7],[16,-33],[-22,4],[-33,-2],[-35,2],[-37,-3],[-29,11],[-14,24],[17,10],[36,-8],[40,-4]],[[3098,1096],[3,-26],[-5,-22],[-7,-22],[-33,-8],[-31,-11],[-37,1],[14,23],[-33,-8],[-31,-8],[-21,17],[-1,23],[30,23],[19,7],[32,-2],[8,29],[2,21],[-1,47],[16,27],[26,9],[14,-22],[7,-21],[12,-26],[9,-25],[8,-26]],[[108,339],[4,0],[3,-1],[41,-24],[35,24],[6,3],[82,11],[26,-14],[13,-7],[42,-19],[79,-15],[62,-18],[108,-13],[80,16],[118,-12],[66,-18],[74,17],[77,16],[6,27],[-109,2],[-90,14],[-23,23],[-75,12],[5,26],[10,24],[11,21],[-6,24],[-46,16],[-21,20],[-43,18],[67,-4],[64,10],[41,-20],[49,17],[46,22],[22,19],[-10,24],[-35,15],[-41,17],[-57,4],[-50,8],[-54,5],[-18,22],[-36,18],[-22,20],[-9,65],[14,-5],[25,-18],[46,5],[44,8],[23,-25],[44,6],[37,13],[35,15],[31,20],[42,5],[-1,22],[-10,21],[8,20],[36,10],[16,-19],[43,12],[32,14],[40,1],[37,6],[38,14],[30,12],[33,12],[22,-3],[19,-5],[42,8],[37,-10],[38,1],[36,8],[38,-5],[41,-6],[39,2],[40,-1],[41,-1],[38,2],[29,17],[33,9],[35,-12],[33,10],[30,20],[18,-18],[10,-20],[18,-19],[29,17],[33,-22],[37,-7],[33,-15],[39,3],[35,10],[42,-2],[37,-8],[39,-10],[14,25],[-18,19],[-13,20],[-36,5],[-16,21],[-6,22],[-10,42],[21,-7],[37,-4],[36,4],[32,-9],[29,-17],[12,-21],[37,-3],[36,8],[38,11],[35,7],[28,-14],[37,5],[24,44],[22,-26],[32,-10],[35,5],[23,-22],[36,-2],[34,-7],[33,-13],[22,22],[11,20],[28,-22],[38,5],[28,-12],[19,-19],[37,5],[29,13],[28,14],[34,8],[39,7],[35,8],[28,12],[16,18],[6,25],[-3,24],[-9,22],[-9,23],[-9,23],[-7,20],[-2,22],[3,23],[13,21],[11,24],[4,23],[-5,25],[-4,22],[14,26],[15,17],[18,21],[19,18],[23,17],[10,25],[16,16],[17,15],[27,3],[17,18],[20,11],[23,7],[20,15],[16,18],[21,7],[17,-15],[-11,-19],[-28,-17],[-12,-13],[-21,9],[-22,-5],[-20,-14],[-20,-14],[-13,-17],[-4,-23],[2,-21],[13,-19],[-19,-14],[-27,-5],[-15,-19],[-16,-18],[-17,-25],[-5,-21],[10,-24],[15,-18],[22,-13],[22,-18],[11,-23],[6,-21],[8,-23],[13,-19],[8,-22],[4,-53],[8,-21],[3,-23],[8,-22],[-3,-31],[-16,-23],[-16,-20],[-37,-7],[-13,-21],[-16,-19],[-42,-21],[-37,-9],[-35,-13],[-38,-12],[-22,-24],[-45,-2],[-49,2],[-44,-4],[-46,0],[8,-23],[43,-10],[31,-16],[17,-20],[-31,-18],[-48,5],[-39,-14],[-2,-24],[-1,-23],[33,-19],[6,-21],[35,-22],[59,-9],[50,-15],[39,-18],[51,-19],[69,-9],[68,-15],[47,-17],[52,-19],[27,-28],[14,-21],[34,20],[45,17],[49,18],[57,15],[50,16],[69,1],[68,-8],[56,-14],[18,25],[39,17],[70,1],[55,13],[52,12],[58,8],[61,10],[43,15],[-20,20],[-12,20],[0,22],[-53,-2],[-57,-9],[-55,0],[-8,21],[4,43],[13,12],[40,14],[46,13],[34,17],[34,17],[25,23],[38,10],[37,8],[19,4],[43,3],[41,8],[34,11],[34,13],[31,14],[38,18],[25,19],[26,17],[8,23],[-29,13],[9,24],[19,18],[29,11],[30,14],[29,18],[21,22],[14,27],[20,16],[33,-3],[14,-19],[33,-3],[1,22],[14,22],[30,-5],[7,-22],[33,-3],[36,10],[35,7],[32,-3],[12,-24],[30,19],[28,10],[32,8],[31,8],[28,14],[31,9],[24,12],[17,20],[21,-14],[29,8],[20,-28],[15,-20],[32,11],[13,23],[28,16],[36,-4],[11,-21],[23,21],[30,7],[33,2],[29,-1],[31,-6],[30,-4],[13,-19],[18,-17],[30,10],[33,2],[32,0],[31,2],[27,7],[30,7],[24,16],[26,10],[29,6],[21,16],[15,31],[16,19],[29,-9],[10,-20],[24,-13],[29,4],[20,-20],[20,-15],[29,14],[10,24],[25,11],[28,19],[28,8],[32,11],[22,12],[23,14],[22,12],[26,-6],[25,20],[18,16],[26,-2],[23,14],[5,20],[24,16],[22,11],[28,9],[26,5],[24,-3],[26,-6],[23,-16],[2,-25],[25,-19],[17,-16],[33,-6],[18,-16],[23,-16],[27,-3],[22,11],[24,24],[26,-13],[27,-7],[26,-6],[28,-5],[27,0],[23,-60],[-1,-14],[-3,-26],[-27,-15],[-22,-21],[4,-23],[31,1],[-3,-22],[-15,-22],[-13,-24],[22,-18],[32,-5],[32,10],[15,22],[9,22],[15,18],[18,17],[7,20],[15,28],[17,6],[32,2],[27,7],[29,9],[13,23],[8,21],[19,22],[28,14],[23,11],[15,20],[16,10],[20,9],[28,-6],[25,6],[27,7],[31,-4],[20,16],[14,38],[10,-15],[13,-27],[24,-12],[26,-4],[27,6],[28,-4],[26,-1],[18,5],[23,-3],[21,-12],[25,8],[30,0],[26,7],[29,-7],[18,19],[14,19],[19,16],[35,43],[18,-8],[21,-16],[19,-20],[35,-35],[27,-1],[26,0],[30,6],[30,8],[23,16],[19,17],[31,2],[20,13],[22,-12],[14,-18],[20,-18],[30,2],[19,-14],[34,-15],[34,-6],[29,5],[22,18],[18,18],[25,5],[25,-8],[29,-6],[26,9],[25,0],[25,-6],[26,-5],[25,10],[29,9],[29,2],[31,0],[26,6],[25,4],[8,29],[1,23],[17,-15],[5,-26],[9,-24],[12,-19],[23,-10],[32,3],[36,1],[25,3],[36,0],[27,2],[36,-3],[31,-4],[20,-18],[-6,-22],[18,-17],[30,-13],[31,-15],[36,-10],[37,-9],[29,-9],[31,-1],[18,19],[25,-16],[21,-18],[24,-13],[34,-6],[32,-7],[14,-22],[31,-14],[22,-20],[31,-9],[32,1],[30,-3],[33,1],[33,-5],[31,-8],[29,-13],[29,-12],[19,-17],[-3,-22],[-15,-20],[-12,-26],[-10,-21],[-13,-23],[-36,-9],[-17,-21],[-36,-12],[-12,-23],[-19,-21],[-20,-18],[-12,-24],[-7,-21],[-3,-26],[1,-22],[16,-22],[6,-22],[13,-20],[51,-8],[11,-25],[-50,-9],[-42,-12],[-53,-2],[-23,-33],[-5,-27],[-12,-22],[-15,-21],[37,-19],[14,-24],[24,-21],[34,-20],[39,-18],[41,-18],[64,-18],[14,-28],[80,-12],[6,-5],[20,-17],[77,15],[64,-18],[48,-14],[-9998,-1],[25,34],[50,-18],[3,2]],[[79,321],[8,5],[9,6],[8,5],[4,2]],[[3139,2021],[-9,-23],[-24,-18],[-30,6],[-20,17],[-29,9],[-35,32],[-28,31],[-39,64],[23,-12],[39,-38],[37,-21],[14,27],[9,39],[26,24],[20,-7]],[[3093,2151],[10,-27],[14,-43],[36,-34],[39,-15],[-12,-29],[-27,-2],[-14,20]],[[3373,2239],[22,-25],[-8,-21],[-38,-17],[-12,20],[-24,-26],[-14,26],[33,35],[24,-15],[17,23]],[[6951,2320],[-43,-4],[0,30],[4,24],[2,12],[18,-18],[26,-7],[1,-11],[-8,-26]],[[9037,2833],[27,-20],[15,8],[22,11],[17,-4],[2,-68],[-10,-20],[-3,-46],[-9,15],[-20,-40],[-5,3],[-18,2],[-17,50],[-3,38],[-16,50],[0,26],[18,-5]],[[9805,2826],[6,-24],[20,23],[8,-24],[0,-24],[-11,-27],[-18,-42],[-14,-24],[10,-27],[-21,-1],[-24,-22],[-7,-37],[-16,-59],[-22,-25],[-14,-17],[-25,1],[-18,19],[-31,4],[-4,22],[15,42],[35,57],[18,11],[20,22],[23,30],[17,30],[12,43],[11,14],[4,33],[19,26],[7,-24]],[[9849,3100],[20,-61],[1,40],[12,-16],[4,-44],[23,-18],[18,-5],[16,22],[14,-7],[-6,-51],[-9,-33],[-21,1],[-7,-18],[2,-24],[-4,-11],[-10,-31],[-14,-40],[-22,-23],[-4,16],[-12,8],[16,47],[-9,32],[-30,23],[1,21],[20,20],[4,44],[-1,37],[-11,39],[1,10],[-14,24],[-21,51],[-12,41],[10,4],[15,-32],[22,-15],[8,-51]],[[9641,3906],[-11,-14],[-15,16],[-20,26],[-18,30],[-18,41],[-4,19],[12,-1],[15,-19],[13,-20],[9,-16],[22,-36],[15,-26]],[[9953,4183],[10,-16],[-5,-30],[-17,-8],[-15,7],[-3,25],[11,20],[12,-7],[7,9]],[[9981,4214],[-18,-12],[-3,22],[13,12],[9,3],[17,18],[0,-28],[-18,-15]],[[2,4232],[-2,-3],[0,28],[5,2],[-3,-27]],[[9661,4234],[-9,-8],[-10,25],[1,16],[18,-33]],[[9640,4322],[5,-46],[-8,7],[-5,-3],[-4,16],[-1,44],[13,-18]],[[6389,4401],[5,-69],[7,-27],[-3,-27],[-5,-17],[-9,33],[-5,-17],[5,-42],[-3,-25],[-7,-13],[-2,-49],[-11,-67],[-14,-79],[-17,-109],[-10,-80],[-13,-67],[-23,-14],[-24,-24],[-16,14],[-22,21],[-7,30],[-2,51],[-10,46],[-3,42],[5,41],[13,10],[0,19],[13,44],[3,37],[-6,27],[-6,36],[-2,53],[10,33],[4,36],[13,2],[16,12],[10,11],[12,0],[16,33],[23,36],[8,29],[-3,24],[11,-7],[16,40],[0,35],[9,26],[10,-25],[7,-25],[7,-38]],[[8986,4389],[10,-45],[18,22],[9,-24],[14,-23],[-3,-25],[6,-50],[4,-29],[7,-7],[8,-49],[-3,-30],[9,-39],[30,-30],[20,-27],[18,-25],[-3,-14],[16,-36],[10,-63],[11,13],[12,-25],[6,9],[5,-61],[20,-35],[13,-22],[22,-47],[7,-46],[1,-33],[-2,-36],[13,-49],[-1,-51],[-5,-26],[-8,-52],[1,-33],[-5,-41],[-13,-52],[-20,-29],[-10,-44],[-10,-29],[-8,-49],[-11,-29],[-7,-43],[-3,-40],[1,-18],[-16,-20],[-31,-2],[-25,-24],[-13,-22],[-17,-25],[-23,26],[-17,10],[4,30],[-15,-11],[-24,-42],[-24,16],[-16,9],[-16,4],[-27,17],[-18,35],[-5,44],[-6,29],[-14,23],[-27,7],[9,28],[-6,43],[-14,-40],[-25,-10],[15,31],[4,34],[11,28],[-2,42],[-23,-49],[-17,-19],[-11,-46],[-22,24],[1,30],[-17,42],[-15,21],[5,14],[-35,35],[-20,1],[-26,28],[-50,-5],[-36,-21],[-32,-19],[-26,4],[-30,-30],[-24,-13],[-5,-30],[-10,-24],[-24,-1],[-17,-5],[-25,10],[-20,-6],[-19,-2],[-16,-31],[-9,2],[-14,-16],[-13,-18],[-20,2],[-19,0],[-29,37],[-15,11],[0,33],[14,8],[5,13],[-1,20],[3,41],[-3,34],[-14,58],[-5,33],[1,33],[-11,37],[-1,17],[-12,23],[-3,45],[-16,46],[-4,24],[12,-25],[-9,54],[14,-17],[8,-22],[-1,29],[-13,45],[-3,19],[-6,17],[3,33],[5,14],[4,29],[-3,34],[12,41],[2,-44],[11,40],[23,19],[13,25],[22,21],[12,4],[8,-7],[22,22],[17,6],[4,13],[7,5],[16,-1],[29,17],[15,25],[7,31],[16,29],[2,23],[0,31],[20,49],[11,-49],[12,11],[-10,27],[9,28],[12,-12],[4,44],[15,28],[7,23],[13,9],[1,17],[12,-7],[1,14],[12,9],[13,7],[21,-26],[15,-34],[18,-1],[17,-5],[-6,32],[14,46],[12,15],[-4,14],[12,33],[17,20],[14,-6],[23,10],[0,30],[-21,19],[15,8],[19,-14],[14,-24],[24,-14],[8,5],[17,-17],[16,16],[11,-5],[6,11],[13,-28],[-8,-31],[-10,-23],[-10,-2],[4,-23],[-9,-29],[-9,-28],[2,-17],[22,-31],[21,-19],[14,-20],[20,-34],[8,0],[15,-15],[4,-17],[26,-20],[19,20],[5,31],[6,25],[3,32],[9,46],[-4,27],[2,17],[-3,33],[3,44],[6,11],[-5,19],[7,31],[5,32],[1,16],[10,22],[8,-29],[2,-36],[7,-7],[1,-24],[10,-29],[2,-33],[-1,-21]],[[9502,4578],[8,-19],[-20,0],[-10,35],[16,-14],[6,-2]],[[8352,4592],[-12,-1],[-37,41],[26,11],[15,-18],[10,-17],[-2,-16]],[[9467,4613],[-11,-1],[-17,6],[-6,9],[2,23],[18,-9],[9,-12],[5,-16]],[[9490,4629],[-5,-10],[-20,49],[-6,35],[10,0],[10,-46],[11,-28]],[[8470,4670],[3,13],[24,13],[20,2],[8,8],[11,-8],[-10,-15],[-29,-25],[-24,-17]],[[8473,4641],[-18,-43],[-24,-13],[-3,7],[3,20],[12,35],[27,23]],[[8274,4716],[10,-16],[17,5],[7,-24],[-32,-12],[-20,-8],[-15,1],[10,33],[15,0],[8,21]],[[8413,4716],[-4,-32],[-42,-16],[-37,7],[0,21],[22,12],[17,-18],[19,5],[25,21]],[[9440,4702],[1,-12],[-22,25],[-15,20],[-11,20],[4,5],[13,-13],[23,-27],[7,-18]],[[9375,4759],[-6,-3],[-12,13],[-11,23],[1,10],[17,-24],[11,-19]],[[8016,4792],[53,-6],[6,24],[52,-28],[10,-37],[42,-11],[34,-34],[-32,-22],[-31,23],[-25,-1],[-28,4],[-26,10],[-33,22],[-20,6],[-12,-7],[-50,23],[-5,25],[-25,4],[19,55],[33,-3],[23,-22],[11,-5],[4,-20]],[[8741,4824],[-14,-39],[-3,43],[5,21],[6,19],[6,-16],[0,-28]],[[9329,4789],[-8,-6],[-12,23],[-12,36],[-6,44],[3,6],[3,-18],[9,-13],[13,-36],[13,-20],[-3,-16]],[[9220,4867],[-14,-5],[-5,-16],[-15,-14],[-14,-14],[-15,0],[-23,17],[-15,16],[2,18],[25,-9],[15,5],[4,28],[4,1],[3,-31],[16,5],[8,20],[15,20],[-3,34],[17,1],[5,-9],[0,-32],[-10,-35]],[[8533,4983],[-10,-19],[-19,10],[-6,25],[28,3],[7,-19]],[[8623,5004],[10,-44],[-24,24],[-23,4],[-15,-3],[-20,2],[7,31],[34,3],[31,-17]],[[9252,4923],[-8,-15],[-5,33],[-7,23],[-12,19],[-16,24],[-20,17],[7,14],[15,-16],[10,-13],[11,-14],[12,-24],[10,-18],[3,-30]],[[8915,5032],[48,-39],[52,-33],[19,-30],[15,-29],[5,-34],[46,-35],[7,-31],[-26,-6],[6,-38],[25,-38],[18,-61],[16,2],[-1,-26],[21,-10],[-8,-11],[30,-24],[-4,-16],[-18,-4],[-7,14],[-24,7],[-28,9],[-21,36],[-16,32],[-15,50],[-36,26],[-23,-17],[-17,-19],[3,-42],[-21,-20],[-16,10],[-29,2]],[[8916,4657],[-25,47],[-28,12],[-7,-17],[-35,-1],[12,46],[18,16],[-8,63],[-13,48],[-54,49],[-23,5],[-42,53],[-8,-28],[-10,-5],[-7,21],[0,25],[-21,29],[30,20],[20,-1],[-3,15],[-40,1],[-11,34],[-25,10],[-12,29],[38,14],[14,19],[44,-24],[5,-21],[8,-93],[28,-35],[24,61],[31,35],[25,0],[24,-20],[20,-21],[30,-11]],[[8478,5264],[-23,-57],[-21,-11],[-26,11],[-47,-3],[-24,-8],[-4,-44],[25,-51],[15,26],[52,20],[-2,-27],[-13,8],[-12,-33],[-24,-23],[26,-73],[-5,-20],[25,-67],[0,-38],[-15,-16],[-11,20],[14,47],[-28,-22],[-7,16],[4,22],[-20,34],[2,56],[-19,-18],[3,-67],[1,-82],[-18,-9],[-12,17],[8,53],[-4,56],[-12,0],[-8,40],[11,37],[4,46],[14,87],[6,24],[24,42],[21,-17],[35,-8],[32,3],[28,42],[5,-13]],[[8573,5247],[-1,-50],[-14,5],[-5,-35],[12,-30],[-8,-7],[-11,37],[-8,73],[5,46],[9,21],[2,-31],[17,-5],[2,-24]],[[7938,4845],[-31,-1],[-23,48],[-36,47],[-12,35],[-21,47],[-13,43],[-22,81],[-24,48],[-8,49],[-10,45],[-25,36],[-15,49],[-21,33],[-29,63],[-2,30],[18,-3],[43,-11],[24,-56],[22,-39],[15,-24],[26,-62],[29,-1],[23,-39],[16,-49],[21,-26],[-11,-47],[16,-20],[10,-2],[5,-40],[9,-32],[21,-5],[13,-36],[-7,-72],[-1,-89]],[[8045,5298],[20,-20],[22,11],[5,48],[12,11],[33,13],[20,45],[14,37]],[[8171,5443],[11,21],[24,32]],[[8206,5496],[21,40],[14,45],[11,0],[15,-29],[1,-25],[18,-16],[23,-18],[-2,-22],[-18,-3],[5,-28],[-21,-20]],[[8273,5420],[-16,-52],[21,-54],[-5,-27],[31,-53],[-33,-7],[-9,-39],[1,-52],[-27,-40],[0,-57],[-11,-88],[-4,20],[-32,-26],[-11,36],[-19,3],[-14,18],[-33,-20],[-10,28],[-19,-4],[-23,7],[-4,77],[-14,16],[-13,50],[-4,50],[3,53],[17,39]],[[8509,5667],[3,-39],[2,-32],[-10,-53],[-10,59],[-13,-29],[9,-43],[-8,-27],[-33,34],[-8,41],[9,28],[-18,27],[-8,-24],[-14,2],[-20,-32],[-5,17],[11,49],[18,16],[15,22],[10,-27],[21,16],[4,26],[20,1],[-2,45],[23,-27],[2,-29],[2,-21]],[[7255,5539],[-24,-13],[-14,45],[-4,83],[12,94],[19,-32],[13,-41],[14,-60],[-5,-60],[-11,-16]],[[3307,5764],[-24,-6],[-5,5],[8,16],[0,23],[16,7],[6,-2],[-1,-43]],[[8443,5774],[-10,-19],[-9,-36],[-9,-18],[-17,40],[6,16],[7,16],[3,36],[15,3],[-4,-39],[20,56],[-2,-55]],[[8290,5718],[-36,-54],[13,40],[20,36],[17,39],[14,58],[5,-47],[-18,-32],[-15,-40]],[[8384,5867],[17,-18],[18,0],[-1,-24],[-13,-25],[-17,-17],[-1,27],[2,29],[-5,28]],[[8485,5882],[8,-64],[-22,15],[1,-19],[7,-36],[-14,-12],[-1,40],[-8,3],[-4,35],[16,-5],[-1,22],[-16,44],[26,-1],[8,-22]],[[8374,5935],[-7,-50],[-12,29],[-14,43],[24,-2],[9,-20]],[[8369,6247],[17,-16],[8,15],[3,-15],[-5,-23],[10,-42],[-7,-48],[-17,-19],[-4,-46],[6,-46],[15,-6],[12,7],[35,-32],[-3,-32],[9,-14],[-3,-26],[-21,28],[-11,30],[-7,-21],[-17,35],[-26,-9],[-14,13],[2,24],[9,14],[-9,14],[-3,-21],[-14,33],[-4,25],[-1,55],[11,-19],[3,90],[9,53],[17,-1]],[[3177,6232],[-7,-15],[-21,0],[-16,-2],[-2,25],[4,8],[23,0],[14,-5],[5,-11]],[[2863,6211],[-8,-10],[-16,9],[-16,21],[4,14],[11,4],[7,-2],[18,-5],[15,-14],[5,-16],[-20,-1]],[[3007,6317],[4,10],[21,0],[17,-15],[7,1],[5,-20],[15,1],[-1,-17],[13,-2],[13,-21],[-10,-24],[-13,13],[-13,-3],[-9,3],[-5,-10],[-11,-4],[-4,14],[-9,-8],[-11,-40],[-7,9],[-2,17]],[[3007,6221],[-18,10],[-13,-4],[-17,4],[-13,-11],[-15,18],[2,19],[26,-8],[21,-5],[10,13],[-13,25],[0,22],[-17,9],[6,16],[17,-3],[24,-9]],[[8064,6258],[-24,-28],[-23,18],[-1,49],[14,26],[30,16],[16,-1],[6,-22],[-12,-25],[-6,-33]],[[679,6281],[-4,-10],[-7,8],[1,17],[-5,21],[1,6],[5,9],[-2,12],[2,5],[2,-1],[11,-10],[5,-5],[4,-7],[7,-21],[0,-3],[-11,-12],[-9,-9]],[[664,6371],[-9,-4],[-5,12],[-3,4],[-1,4],[3,5],[10,-6],[7,-8],[-2,-7]],[[645,6401],[-1,-6],[-15,2],[2,7],[14,-3]],[[620,6410],[-1,-4],[-2,1],[-10,2],[-3,13],[-2,3],[8,7],[2,-3],[8,-19]],[[573,6448],[-3,-6],[-9,11],[1,4],[4,5],[7,-1],[0,-13]],[[2786,6493],[11,-21],[26,6],[10,-13],[23,-36],[18,-26],[9,1],[16,-12],[-2,-16],[21,-2],[21,-24],[-4,-13],[-18,-8],[-19,-3],[-19,5],[-40,-6],[19,32],[-11,15],[-18,4],[-10,17],[-6,33],[-16,-3],[-26,16],[-8,12],[-37,9],[-9,11],[10,14],[-27,3],[-20,-30],[-12,0],[-4,-14],[-13,-7],[-12,6],[14,18],[7,20],[12,13],[14,11],[21,6],[7,6],[24,-4],[22,-1],[26,-19]],[[2845,6550],[-6,-3],[-7,33],[-11,17],[6,37],[9,-3],[9,-47],[0,-34]],[[8365,6494],[-12,-47],[-15,49],[-3,42],[16,57],[23,44],[12,-18],[-5,-34],[-16,-93]],[[2838,6713],[-31,-10],[-2,22],[13,4],[19,-2],[1,-14]],[[2860,6713],[-4,-41],[-6,8],[1,30],[-13,22],[0,7],[22,-26]],[[8739,7148],[3,-19],[-16,-35],[-11,18],[-14,-13],[-8,-34],[-18,17],[1,27],[15,34],[16,-6],[11,24],[21,-13]],[[5943,7201],[0,-5],[-28,-23],[-14,7],[-6,23],[13,2]],[[5908,7205],[2,1],[4,14],[20,-1],[25,17],[-18,-24],[2,-11]],[[5657,7238],[15,-19],[22,3],[21,-4],[-1,-10],[15,7],[-3,-17],[-40,-5],[0,9],[-34,11],[5,25]],[[5430,7383],[-10,-45],[4,-18],[-6,-29],[-21,21],[-14,7],[-39,29],[4,29],[33,-5],[28,6],[21,5]],[[5255,7555],[16,-41],[-3,-76],[-13,4],[-11,-20],[-11,16],[-1,69],[-6,33],[15,-3],[14,18]],[[8915,7321],[-11,-46],[5,-29],[-14,-41],[-36,-27],[-49,-3],[-39,-66],[-19,22],[-1,43],[-48,-13],[-33,-27],[-33,-1],[28,-42],[-18,-98],[-18,-24],[-14,22],[7,52],[-17,17],[-12,39],[27,18],[14,36],[28,30],[20,39],[56,17],[29,-11],[30,102],[18,-27],[41,57],[16,23],[17,70],[-5,65],[12,36],[30,11],[15,-80],[-1,-47],[-26,-58],[1,-59]],[[5265,7609],[-10,-44],[-12,11],[-7,39],[6,22],[18,22],[5,-50]],[[8996,7726],[20,-13],[19,25],[6,-65],[-41,-16],[-24,-57],[-44,40],[-15,-63],[-31,-1],[-4,57],[14,44],[30,3],[8,80],[8,45],[33,-60],[21,-19]],[[3231,7862],[20,-7],[26,1],[-14,-23],[-10,-4],[-36,24],[-7,20],[11,17],[10,-28]],[[3282,8010],[-13,-1],[-36,18],[-26,27],[10,5],[36,-15],[29,-24],[0,-10]],[[1569,7975],[-14,-8],[-46,26],[-8,21],[-25,20],[-5,16],[-29,11],[-11,31],[3,13],[29,-12],[17,-9],[26,-6],[10,-20],[13,-27],[28,-24],[12,-32]],[[3440,8101],[-19,-51],[19,20],[18,-13],[-9,-20],[24,-15],[13,14],[28,-18],[-9,-42],[20,10],[3,-31],[9,-36],[-12,-50],[-13,-3],[-18,11],[6,47],[-8,8],[-32,-50],[-16,2],[19,27],[-26,14],[-30,-4],[-54,2],[-4,17],[17,20],[-12,16],[23,35],[29,91],[17,33],[24,20],[13,-2],[-5,-16],[-15,-36]],[[1313,8294],[27,4],[-9,-65],[25,-46],[-12,0],[-16,26],[-11,27],[-14,18],[-5,25],[2,18],[13,-7]],[[8989,8104],[28,-102],[-41,19],[-17,-83],[27,-59],[-1,-40],[-21,34],[-18,-44],[-6,48],[4,56],[-4,62],[7,44],[1,77],[-16,57],[2,78],[26,27],[-11,26],[12,9],[7,-39],[10,-55],[-1,-57],[12,-58]],[[4789,8357],[23,2],[30,-36],[-15,-39]],[[4827,8284],[4,-41],[-21,-52],[-49,-34],[-39,9],[22,60],[-14,59],[38,45],[21,27]],[[5351,8384],[-16,-46],[-29,32],[-4,24],[41,19],[8,-29]],[[749,8471],[-27,-22],[-15,15],[-4,27],[25,20],[15,9],[19,-4],[11,-18],[-24,-27]],[[4916,8558],[-30,-62],[28,8],[31,0],[-8,-47],[-25,-52],[29,-4],[27,-74],[19,-9],[17,-65],[8,-23],[34,-11],[-4,-37],[-14,-17],[11,-30],[-25,-30],[-37,1],[-47,-16],[-13,11],[-18,-27],[-26,7],[-20,-22],[-14,11],[40,61],[25,12],[-43,10],[-8,23],[29,18],[-15,31],[5,37],[41,-5],[4,34],[-19,36],[-34,10],[-6,16],[10,25],[-9,16],[-15,-27],[-2,55],[-14,30],[10,59],[22,47],[22,-5],[34,5]],[[400,8632],[-17,-9],[-18,11],[-17,15],[27,10],[22,-5],[3,-22]],[[2797,8761],[-10,-30],[-13,5],[-7,17],[1,4],[11,17],[11,-1],[7,-12]],[[2724,8793],[-32,-32],[-20,2],[-6,15],[21,27],[38,-1],[-1,-11]],[[229,8855],[17,-11],[18,6],[22,-15],[28,-8],[-3,-6],[-21,-13],[-21,13],[-10,10],[-25,-3],[-6,5],[1,22]],[[2634,8963],[5,-26],[14,9],[16,-15],[31,-20],[31,-18],[3,-27],[20,5],[20,-20],[-25,-18],[-43,14],[-15,26],[-28,-31],[-39,-29],[-10,33],[-38,-5],[25,28],[3,46],[10,52],[20,-4]],[[4596,9009],[-6,-38],[31,-39],[-36,-44],[-80,-39],[-24,-11],[-37,9],[-77,18],[27,25],[-60,29],[49,11],[-1,17],[-59,13],[19,38],[42,8],[43,-39],[43,31],[35,-16],[45,31],[46,-4]],[[2892,9049],[-31,-3],[-7,28],[12,32],[25,8],[22,-16],[0,-24],[-3,-8],[-18,-17]],[[138,9016],[19,-14],[-7,42],[76,-9],[54,-54],[-27,-25],[-46,-6],[-1,-56],[-11,-12],[-26,2],[-21,20],[-37,16],[-6,25],[-28,10],[-32,-8],[-15,20],[6,22],[-33,-14],[12,-27],[-15,-24],[0,229],[68,-44],[72,-57],[-2,-36]],[[2342,9161],[-17,-20],[-37,18],[-23,-7],[-38,26],[25,18],[19,25],[29,-16],[17,-11],[8,-11],[17,-22]],[[9999,9261],[-31,-3],[-5,18],[36,24],[0,-39]],[[36,9264],[-36,-3],[0,39],[3,2],[24,0],[40,-16],[-3,-8],[-28,-14]],[[3134,7781],[5,-19],[-30,-28],[-28,-20],[-29,-17]],[[3052,7697],[-16,-37],[-4,-10]],[[3032,7650],[0,-30],[9,-31],[12,-1],[-3,21],[8,-13],[-2,-16],[-19,-10],[-13,1],[-21,-10],[-12,-3],[-16,-2],[-23,-17]],[[2952,7539],[41,11],[8,-11]],[[3001,7539],[-39,-17],[-18,-1],[1,8],[-8,-16],[8,-3],[-6,-41],[-21,-45],[-2,15],[-6,3],[-9,14],[6,-31],[7,-10],[0,-22],[-9,-22],[-15,-46],[-3,2],[9,39]],[[2896,7366],[-14,23],[-4,47]],[[2878,7436],[-5,-25],[6,-36],[-18,9],[19,-19],[1,-54],[8,-4],[3,-20],[4,-58],[-18,-43],[-29,-17],[-18,-34],[-14,-3],[-14,-21],[-4,-20],[-30,-37],[-16,-27],[-13,-35],[-4,-41],[5,-39],[9,-50],[12,-41],[0,-24],[13,-67],[0,-39],[-2,-22],[-7,-36],[-8,-7],[-14,7],[-4,25],[-10,14],[-15,49],[-13,44],[-4,23],[5,38],[-7,32],[-22,48],[-11,9],[-28,-26],[-5,2],[-13,27],[-18,14],[-31,-7],[-25,7],[-21,-4]],[[2522,6928],[-12,-8],[6,-17]],[[2516,6903],[-1,-23],[6,-11],[-5,-8],[-11,9],[-10,-11],[-20,1],[-21,31],[-24,-7],[-20,13],[-18,-4],[-23,-13],[-25,-43],[-28,-25]],[[2316,6812],[-15,-27],[-6,-26]],[[2295,6759],[-1,-40],[2,-28],[5,-19]],[[2301,6672],[0,-1],[-11,-50]],[[2290,6621],[-5,-41],[-2,-78],[-2,-28],[4,-31],[9,-28],[6,-45],[18,-43],[6,-33],[11,-28],[30,-15],[11,-24],[25,16],[21,6],[21,10],[17,10],[18,23],[6,34],[3,48],[5,17],[18,15],[30,14],[24,-2],[17,5],[7,-13],[-1,-27],[-15,-35],[-7,-35],[5,-10],[-4,-25],[-7,-45],[-7,15],[-6,-1]],[[2546,6247],[1,-8],[5,0],[-1,-16],[-4,-25],[2,-9],[-3,-21],[2,-5],[-3,-29],[-6,-15],[-5,-2],[-5,-20]],[[2529,6097],[9,-11],[2,9],[9,-7]],[[2549,6088],[2,-3],[7,10],[7,1],[3,-4],[4,2],[13,-5],[13,2],[9,6],[3,7],[9,-3],[7,-4],[7,1],[6,5],[12,-8],[5,-1],[8,-11],[8,-13],[10,-9],[8,-16]],[[2690,6045],[-3,-5],[-1,-13],[3,-21],[-7,-20],[-3,-23],[-1,-25],[2,-15],[1,-26],[-5,-6],[-2,-24],[2,-15],[-6,-15],[1,-16],[4,-9]],[[2675,5812],[8,-31],[10,-24],[13,-24]],[[2706,5733],[10,-21],[0,-12],[11,-3],[2,5],[8,-14],[14,4],[12,15],[16,11],[10,17],[15,-3],[-1,-6],[16,-2],[12,-10],[9,-17],[11,-16]],[[2851,5681],[14,-2],[21,41],[11,6],[0,19],[6,48],[15,27],[18,1],[2,12],[22,-5],[22,30],[11,12],[13,28],[10,-3],[7,-16],[-5,-19]],[[3018,5860],[-1,-14],[-16,-6],[9,-26],[-1,-30],[-12,-34],[11,-46],[12,4],[6,42],[-9,20],[-1,44],[34,23],[-3,27],[9,18],[10,-40],[20,-1],[18,-32],[1,-19],[25,-1],[30,6],[15,-26],[22,-7],[15,18],[1,15],[34,3],[33,1],[-23,-17],[9,-27],[22,-5],[21,-28],[5,-46],[14,1],[11,-13]],[[3339,5664],[18,-21],[18,-38],[0,-30],[11,-1],[15,-28],[11,-20]],[[3412,5526],[33,-12],[3,11],[22,4],[30,-16]],[[3500,5513],[10,-6],[20,-14],[30,-48],[4,-24]],[[3564,5421],[10,3],[7,-32],[15,-101],[15,-9],[1,-40],[-21,-47],[8,-18],[50,-9],[1,-57],[21,37],[35,-20],[46,-35],[13,-34],[-4,-32],[32,18],[54,-31],[42,3],[41,-48],[35,-65],[22,-16],[23,-3],[10,-18],[10,-73],[4,-35],[-11,-95],[-14,-38],[-39,-80],[-18,-65],[-20,-50],[-7,-1],[-8,-42],[2,-108],[-8,-89],[-3,-38],[-8,-23],[-5,-77],[-29,-75],[-4,-59],[-23,-25],[-6,-35],[-30,0],[-44,-22],[-20,-25],[-31,-17],[-32,-46],[-24,-57],[-4,-43],[5,-32],[-6,-58],[-6,-28],[-19,-32],[-31,-101],[-25,-46],[-18,-27],[-13,-55],[-18,-33]],[[3517,3237],[-12,-36],[-32,-32],[-20,12],[-15,-6],[-26,24],[-19,-1],[-17,31]],[[3376,3229],[-2,-30],[36,-49],[-4,-40],[17,-25],[-1,-28],[-27,-74],[-41,-31],[-56,-12],[-30,6],[5,-34],[-5,-43],[5,-29],[-17,-21],[-28,-8],[-27,21],[-11,-15],[4,-57],[19,-17],[15,18],[8,-30],[-25,-18],[-22,-36],[-5,-58],[-6,-30],[-26,-1],[-22,-29],[-8,-43],[27,-42],[27,-12],[-10,-52],[-33,-32],[-18,-68],[-25,-22],[-11,-27],[9,-60],[18,-34],[-12,3]],[[3094,2170],[-24,1],[-14,-14],[-25,-21],[-4,-54],[-12,-1],[-31,18],[-32,41],[-35,33],[-8,36],[8,34],[-14,38],[-4,98],[12,56],[29,44],[-42,17],[26,51],[10,95],[31,-20],[14,119],[-18,16],[-9,-72],[-18,8],[9,82],[10,107],[12,39],[-8,57],[-2,64],[12,2],[17,93],[19,92],[12,86],[-7,86],[9,48],[-4,71],[17,70],[5,112],[9,119],[8,129],[-2,94],[-6,81]],[[3044,4125],[-27,33],[-3,24],[-55,58],[-50,63],[-21,35],[-12,48],[5,17],[-24,75],[-27,106],[-26,115],[-12,26],[-8,43],[-22,37],[-20,24],[9,25],[-13,55],[8,41],[23,36]],[[2769,4986],[14,43],[-6,25],[-10,-27],[-17,26],[6,16],[-5,52],[10,9],[5,36],[10,37],[-2,23],[16,13],[19,22]],[[2809,5261],[-4,18],[10,5],[-1,29],[7,20],[13,4],[12,36],[11,31],[-10,13],[5,34],[-6,52],[5,16],[-4,48],[-11,31]],[[2836,5598],[-9,17],[-6,31],[6,15],[-7,4],[-5,19],[-14,16],[-12,-4],[-5,-20],[-12,-14],[-6,-2],[-2,-12],[13,-31],[-8,-8],[-4,-8],[-13,-3],[-4,34],[-4,-10],[-9,4],[-6,23],[-11,4],[-7,6],[-12,0],[-1,-12],[-3,9]],[[2695,5656],[-15,12],[-6,12],[3,10],[-1,13],[-8,14],[-11,11],[-9,8],[-2,17],[-7,10],[2,-17],[-6,-14],[-6,16],[-9,6],[-4,12],[0,17],[4,18],[-8,8],[6,11]],[[2618,5820],[-9,19],[-13,23],[-6,19],[-12,18],[-14,26],[3,9],[5,-8],[2,4]],[[2574,5930],[-5,18],[-8,5]],[[2561,5953],[-4,-14],[-16,1]],[[2541,5940],[-10,5],[-11,12]],[[2520,5957],[-16,4],[-7,12]],[[2497,5973],[-15,10],[-17,1],[-13,11],[-15,24]],[[2437,6019],[-31,62],[-14,19],[-23,15],[-16,-4],[-22,-22],[-14,-6],[-19,16],[-21,10],[-26,27],[-21,8],[-32,27],[-23,27],[-7,16],[-15,3],[-29,18],[-11,27],[-30,32],[-14,37],[-7,28],[10,5],[-3,17],[6,15],[0,20],[-9,25],[-3,23],[-9,29],[-24,58],[-28,45],[-14,35],[-24,24],[-5,14],[4,36],[-14,13],[-16,28],[-7,40],[-15,5],[-16,30],[-13,28],[-1,18],[-15,44],[-10,44],[0,22],[-20,23],[-9,-3],[-16,16],[-4,-23],[4,-28],[3,-43],[9,-24],[21,-40],[5,-13],[4,-4],[4,-20],[4,1],[6,-37],[8,-15],[6,-20],[18,-30],[9,-53],[8,-25],[8,-27],[2,-31],[13,-2],[11,-26],[10,-26],[-1,-10],[-11,-21],[-5,0],[-7,35],[-19,33],[-20,28],[-14,14],[1,43],[-4,31],[-13,18],[-19,25],[-4,-7],[-7,15],[-17,14],[-17,33],[2,5],[12,-4],[10,22],[1,26],[-21,41],[-17,16],[-10,36],[-10,38],[-13,46],[-11,51]],[[1746,7055],[-5,30],[-18,33],[-13,7],[-3,16],[-15,3],[-10,16],[-26,6],[-7,9],[-4,31],[-27,58],[-23,80],[1,14],[-12,19],[-22,48],[-3,47],[-15,31],[6,48],[-1,49],[-9,45],[11,54],[7,104],[-5,78],[-9,49],[-8,27],[3,11],[40,-20],[15,-54],[7,15],[-4,47],[-10,48]],[[1587,8004],[-4,0],[-53,56],[-20,25],[-51,24],[-15,51],[4,35],[-36,25],[-4,46],[-34,42],[-1,30]],[[1373,8338],[-15,21],[-24,19],[-8,50],[-36,46],[-15,55],[-27,4],[-44,1],[-32,17],[-58,59],[-26,11],[-49,21],[-38,-5],[-55,26],[-33,25],[-31,-12],[6,-40],[-16,-4],[-32,-12],[-24,-19],[-31,-13],[-4,34],[13,57],[29,17],[-8,15],[-35,-32],[-19,-39],[-40,-40],[20,-28],[-26,-42],[-30,-24],[-27,-17],[-7,-26],[-44,-30],[-8,-27],[-33,-24],[-19,4],[-26,-16],[-28,-20],[-23,-19],[-48,-16],[-4,9],[30,27],[27,18],[30,32],[34,6],[14,24],[39,34],[6,12],[20,20],[5,44],[14,34],[-32,-18],[-9,10],[-15,-21],[-18,29],[-7,-20],[-11,28],[-28,-23],[-17,0],[-2,35],[5,21],[-18,20],[-36,-11],[-23,27],[-19,14],[-1,33],[-21,24],[11,33],[22,33],[10,29],[23,4],[19,-9],[22,28],[20,-5],[22,18],[-6,26],[-15,10],[20,23],[-17,-1],[-29,-13],[-9,-12],[-22,12],[-39,-6],[-40,14],[-12,23],[-35,33],[39,25],[62,28],[23,0],[-4,-29],[58,2],[-22,36],[-34,22],[-20,29],[-27,24],[-38,18],[16,30],[49,2],[35,27],[7,28],[28,27],[27,7],[53,25],[25,-4],[43,31],[42,-12],[20,-26],[12,11],[47,-3],[-1,-14],[42,-9],[29,5],[58,-18],[53,-5],[22,-8],[37,10],[42,-18],[30,-8]],[[1083,9196],[52,-14],[44,-27],[29,-6],[24,24],[34,18],[41,-7],[41,26],[46,14],[19,-24],[21,14],[6,27]],[[1440,9241],[19,-6],[47,-52]],[[1506,9183],[37,39],[4,-44],[34,10],[10,16],[34,-3],[43,-24],[65,-21],[38,-10],[27,4],[37,-29],[-39,-29],[51,-12],[75,6],[23,11],[30,-35],[30,29],[-28,25],[18,19],[33,3],[23,6],[22,-14],[28,-31],[31,4],[49,-26],[43,9],[41,-1],[-3,36],[24,10],[43,-20],[0,-54],[18,46],[22,-2],[13,58],[-30,36],[-32,23],[2,64],[33,41],[36,-9],[28,-25],[38,-65]],[[2457,9224],[-25,-28],[52,-12]],[[2484,9184],[0,-59],[37,45],[33,-37],[-8,-43],[27,-39],[29,42],[20,50],[2,63],[39,-4],[41,-9],[37,-28],[2,-29],[-21,-31],[20,-31],[-4,-28],[-54,-40],[-39,-9],[-28,18],[-9,-29],[-26,-49],[-8,-25],[-33,-39],[-39,-4],[-22,-24],[-2,-38],[-32,-7],[-34,-46],[-31,-65],[-10,-46],[-2,-67],[41,-9],[12,-54],[13,-44],[39,12],[52,-25],[28,-22],[20,-27],[34,-16],[30,-25],[46,-3],[30,-5],[-5,-50],[9,-58],[20,-65],[41,-54],[22,18],[15,60],[-15,91],[-19,30],[44,27],[32,40],[15,40],[-2,39],[-19,49],[-34,43],[33,60],[-12,53],[-9,90],[19,13],[48,-16],[28,-5],[23,15],[26,-20],[34,-33],[9,-23],[49,-4],[-1,-48],[10,-73],[25,-9],[20,-34],[40,32],[27,63],[18,27],[22,-51],[36,-74],[31,-69],[-11,-36],[36,-32],[25,-33],[45,-15],[18,-18],[11,-49],[21,-8],[11,-22],[2,-64],[-20,-22],[-20,-20],[-45,-21],[-35,-47],[-47,-9],[-60,12],[-41,0],[-29,-4],[-23,-41],[-36,-26],[-40,-76],[-32,-53],[24,10],[44,75],[59,48],[41,6],[25,-28],[-27,-39],[9,-62],[9,-43],[36,-29],[46,8],[28,65],[2,-42],[18,-21],[-34,-38],[-62,-34],[-27,-23],[-31,-42],[-22,5],[-1,48],[49,48],[-45,-2],[-31,-7]],[[1852,9128],[-15,28],[-38,15],[-25,-6],[-34,45],[18,7],[43,9],[39,-2],[37,10],[-54,13],[-59,-4],[-40,1],[-14,21],[64,23],[-43,-1],[-48,16],[23,43],[19,23],[75,35],[28,-11],[-14,-27],[62,17],[39,-29],[31,29],[25,-19],[23,-56],[14,24],[-20,59],[25,8],[27,-9],[31,-23],[18,-56],[8,-41],[47,-29],[50,-27],[-3,-25],[-45,-5],[17,-22],[-9,-21],[-50,9],[-48,16],[-32,-4],[-52,-19]],[[1972,9143],[-83,-11],[-37,-4]],[[2097,9410],[-25,-38],[-43,40],[9,8],[37,2],[22,-12]],[[2879,9391],[2,-15],[-29,1],[-30,1],[-31,-7],[-8,3],[-30,31],[1,20],[13,4],[64,-6],[48,-32]],[[2595,9395],[22,-36],[25,46],[71,24],[47,-60],[-4,-37],[55,16],[26,23],[62,-29],[38,-27],[4,-26],[51,13],[29,-36],[67,-23],[25,-23],[26,-54],[-51,-27],[65,-38],[44,-12],[40,-53],[44,-4],[-9,-40],[-48,-67],[-35,24],[-43,56],[-36,-7],[-4,-33],[30,-34],[37,-26],[12,-16],[18,-57],[-10,-41],[-35,16],[-69,46],[39,-50],[29,-35],[4,-20],[-75,23],[-60,34],[-33,28],[9,16],[-41,29],[-41,28],[1,-16],[-80,-10],[-24,20],[18,43],[53,1],[57,7],[-10,21],[10,28],[36,56],[-8,26],[-10,20],[-43,28],[-56,19],[18,15],[-30,36],[-24,3],[-22,19],[-15,-17],[-50,-7],[-101,13],[-59,17],[-45,8],[-23,21],[29,26],[-40,0],[-8,58],[21,52],[28,23],[72,16],[-20,-37]],[[2212,9434],[33,-12],[49,7],[7,-16],[-25,-28],[42,-25],[-5,-52],[-46,-22],[-27,5],[-19,22],[-69,44],[1,19],[56,-7],[-30,37],[33,28]],[[8988,9398],[-43,-1],[-56,7],[-5,3],[26,23],[35,5],[39,-22],[4,-15]],[[2410,9372],[-29,-43],[-32,3],[-17,50],[0,29],[15,24],[27,16],[58,-2],[53,-14],[-41,-51],[-34,-12]],[[1580,9265],[-15,25],[-64,30]],[[1501,9320],[10,19],[21,48]],[[1532,9387],[25,38],[-28,35],[94,9],[40,-12],[71,-3],[27,-17],[30,-24],[-35,-15],[-68,-40],[-35,-40]],[[1653,9318],[0,-25],[-73,-28]],[[9186,9506],[-33,-23],[-44,5],[-52,23],[7,18],[52,-8],[70,-15]],[[2399,9500],[-15,-23],[-41,5],[-33,15],[15,25],[40,16],[24,-20],[10,-18]],[[9029,9533],[-22,-43],[-102,2],[-47,-14],[-55,38],[15,39],[37,11],[73,-2],[101,-31]],[[2263,9600],[21,-27],[1,-30],[-12,-42],[-46,-6],[-30,9],[1,34],[-46,-5],[-2,45],[30,-2],[42,19],[39,-3],[2,8]],[[1993,9570],[11,-21],[25,10],[29,-2],[5,-29],[-17,-27],[-94,-9],[-70,-25],[-42,-1],[-4,19],[58,25],[-126,-7],[-38,10],[37,57],[27,16],[78,-20],[49,-34],[49,-4],[-40,55],[25,21],[29,-7],[9,-27]],[[6597,9254],[-16,-5],[-91,8],[-7,25],[-51,16],[-4,31],[29,12],[-1,32],[55,49],[-26,7],[67,50],[-8,26],[62,31],[92,37],[92,11],[48,21],[54,7],[19,-22],[-18,-18],[-99,-29],[-85,-27],[-86,-55],[-41,-56],[-44,-56],[6,-48],[53,-47]],[[2369,9621],[31,-18],[55,0],[24,-19],[-7,-21],[32,-13],[18,-14],[37,-3],[41,-5],[44,13],[57,5],[45,-4],[29,-22],[7,-24],[-18,-15],[-41,-12],[-36,7],[-79,-9],[-57,-1],[-45,7],[-74,18],[-10,32],[-3,29],[-28,25],[-57,7],[-33,18],[11,23],[57,-4]],[[1772,9653],[-4,-44],[-22,-20],[-26,-3],[-51,-25],[-45,-8],[-37,12],[47,43],[57,37],[42,0],[39,8]],[[8162,9520],[-31,-17],[-73,-32],[-20,-18],[34,-8],[41,-14],[25,11],[14,-37],[12,15],[45,9],[89,-10],[7,-27],[116,-8],[1,44],[59,-10],[45,0],[45,-30],[12,-37],[-16,-24],[35,-46],[44,-23],[26,61],[45,-26],[47,15],[54,-18],[20,17],[46,-9],[-20,54],[37,25],[250,-38],[24,-34],[73,-44],[112,11],[55,-9],[23,-24],[-3,-42],[34,-17],[37,12],[50,2],[52,-12],[53,7],[48,-51],[34,18],[-22,37],[12,25],[89,-16],[58,4],[80,-28],[39,-25],[0,-229],[-1,-1],[-35,-25],[-36,4],[25,-30],[16,-48],[13,-15],[3,-24],[-7,-15],[-52,12],[-77,-43],[-25,-7],[-43,-40],[-40,-36],[-10,-26],[-40,40],[-72,-45],[-13,21],[-27,-25],[-37,8],[-9,-37],[-33,-56],[1,-23],[32,-13],[-4,-84],[-26,-2],[-12,-49],[12,-24],[-49,-30],[-9,-65],[-42,-15],[-8,-58],[-40,-54],[-10,40],[-12,84],[-16,128],[14,80],[23,34],[1,27],[44,13],[49,72],[48,60],[50,46],[22,81],[-33,-5],[-17,-47],[-71,-64],[-22,71],[-72,-19],[-70,-97],[23,-35],[-62,-15],[-43,-6],[2,41],[-43,9],[-34,-28],[-85,10],[-91,-17],[-90,-113],[-107,-136],[44,-7],[14,-36],[27,-13],[17,29],[31,-4],[40,-63],[1,-49],[-22,-58],[-2,-68],[-13,-92],[-42,-84],[-9,-39],[-38,-68],[-37,-66],[-18,-34],[-37,-34],[-18,-1],[-17,28],[-37,-42],[-5,-19]],[[8631,7613],[-10,4],[-12,-20],[-8,-20],[1,-41],[-15,-13],[-5,-10],[-10,-17],[-19,-9],[-12,-16],[-1,-25],[-3,-6],[11,-9],[16,-26]],[[8564,7405],[24,-68],[7,-37],[0,-66],[-10,-32],[-26,-11],[-22,-24],[-25,-5],[-3,32],[5,43],[-12,60],[21,9],[-19,50]],[[8504,7356],[-14,11],[-3,-11],[-8,-5],[-1,11],[-8,5],[-7,9],[7,26],[7,6],[-2,11],[7,31],[-2,9],[-16,7],[-14,15]],[[8450,7481],[-38,-17],[-21,-26],[-30,-16],[15,26],[-6,23],[22,39],[-14,30],[-25,-21],[-31,-40],[-17,-37],[-27,-3],[-15,-26],[15,-39],[23,-10],[1,-26],[22,-16],[31,41],[25,-23],[17,-1],[5,-30],[-39,-17],[-13,-31],[-27,-29],[-15,-40],[30,-31],[11,-57],[17,-53],[19,-44],[0,-43],[-18,-16],[7,-30],[16,-18],[-4,-47],[-7,-46],[-16,-5],[-20,-62],[-23,-76],[-25,-69],[-39,-53],[-38,-48],[-31,-7],[-17,-25],[-10,18],[-16,-28],[-39,-29],[-29,-9],[-9,-61],[-16,-3],[-7,42],[6,22],[-37,18],[-13,-9]],[[8000,6423],[-37,-49],[-23,-55],[-6,-40],[21,-60],[26,-76],[25,-35],[17,-46],[13,-107],[-4,-101],[-23,-38],[-32,-37],[-23,-48],[-34,-54],[-10,37],[7,39],[-20,33]],[[7897,5786],[-23,8],[-12,30],[-14,60]],[[7848,5884],[-25,26],[-23,-1],[4,45],[-25,0],[-2,-63],[-15,-84],[-9,-51],[2,-42],[18,-2],[11,-52],[5,-50],[16,-33],[17,-7],[14,-30]],[[7836,5540],[6,-5],[17,-35],[11,-38],[2,-39],[-3,-26],[3,-20],[2,-34],[10,-16],[10,-51],[0,-20],[-20,-3],[-26,42],[-33,46],[-3,29],[-16,39],[-4,47],[-10,32],[3,42],[-6,24]],[[7779,5554],[-11,22],[-5,29],[-15,32],[-13,28],[-5,-34],[-5,32],[3,36],[8,55]],[[7736,5754],[-2,43],[8,44],[-9,34],[2,63],[-11,29],[-9,69],[-5,73],[-12,48],[-19,-29],[-31,-41],[-16,5],[-17,13],[10,72],[-6,54],[-22,66],[3,21],[-16,7],[-19,47]],[[7565,6372],[-8,30],[-2,30],[-5,27],[-12,34],[-25,2],[2,-24],[-9,-32],[-11,12],[-5,-10],[-7,6],[-11,5]],[[7472,6452],[-4,-21],[-19,1],[-34,-12],[1,-44],[-14,-34],[-40,-38],[-32,-68],[-20,-36],[-28,-38],[0,-27],[-14,-14],[-25,-20],[-13,-4],[-8,-43],[5,-75],[2,-48],[-12,-55],[0,-98],[-14,-2],[-13,-44],[8,-19],[-25,-17],[-9,-39],[-11,-16],[-27,53],[-12,81],[-11,58],[-10,27],[-15,56],[-7,72],[-4,36],[-26,79],[-11,111],[-8,74],[0,70],[-6,54],[-40,-35],[-20,7],[-36,70],[13,21],[-8,22],[-32,49]],[[6893,6546],[-21,15],[-8,41],[-21,44],[-52,-11],[-45,-1],[-39,-8]],[[6707,6626],[-52,17],[-30,14],[-32,7],[-12,71],[-13,10],[-21,-10],[-28,-28],[-34,19],[-28,44],[-27,17],[-19,54],[-20,77],[-15,-9],[-18,19],[-10,-23]],[[6348,6905],[-17,3]],[[6331,6908],[6,-25],[-2,-13],[9,-44]],[[6344,6826],[11,-50],[13,-13],[5,-20],[19,-24],[2,-24],[-3,-19],[3,-19],[8,-17],[4,-18],[4,-15]],[[6410,6607],[-2,42],[8,31],[7,6],[9,-18],[0,-34],[-6,-34]],[[6426,6600],[6,-22]],[[6432,6578],[5,3],[1,-16],[21,9],[23,-1],[17,-2],[19,39],[21,37],[17,35]],[[6556,6682],[8,20],[4,-5],[-3,-24],[-3,-10]],[[6562,6663],[3,-46]],[[6565,6617],[13,-39],[15,-21],[21,-8],[16,-10],[13,-33],[7,-19],[10,-7],[0,-13],[-10,-35],[-4,-16],[-12,-18],[-10,-40],[-13,3],[-6,-13],[-4,-30],[3,-38],[-3,-7],[-12,0],[-18,-21],[-2,-29],[-7,-12],[-17,1],[-11,-15],[0,-23],[-13,-16],[-16,5],[-18,-19],[-13,-3]],[[6474,6141],[-20,-16],[-5,-25],[-1,-20],[-28,-24],[-44,-27],[-25,-41],[-12,-3],[-8,4],[-17,-24],[-17,-11],[-24,-3],[-7,-4],[-6,-15],[-7,-4],[-4,-15],[-14,2],[-9,-8],[-19,3],[-7,33],[0,32],[-4,17],[-6,42],[-8,24],[6,3],[-3,26],[3,11],[-1,25]],[[6187,6123],[-3,25],[-9,17],[-2,23],[-14,21],[-15,48],[-8,47],[-19,40],[-13,9],[-18,55],[-3,40],[1,34],[-16,64],[-13,22],[-15,12],[-9,33],[1,13],[-7,30],[-8,13],[-11,43],[-17,46],[-14,40],[-14,0],[4,31],[1,20],[4,23]],[[5970,6872],[-1,9]],[[5969,6881],[-8,-23],[-6,-44],[-7,-30],[-7,-10],[-9,19],[-13,25],[-19,83],[-3,-5],[11,-61],[17,-58],[21,-90],[11,-31],[8,-33],[25,-63],[-5,-10],[1,-38],[32,-51],[5,-12]],[[6023,6449],[9,-57],[-6,-10],[4,-59],[10,-69],[11,-14],[15,-22]],[[6066,6218],[16,-66],[8,-53],[15,-28],[38,-55],[15,-32],[15,-34],[9,-19],[14,-18]],[[6196,5913],[6,-18],[-1,-23],[-16,-14],[12,-16]],[[6197,5842],[9,-11],[6,-23],[12,-25],[14,0],[26,15],[31,7],[24,18],[14,3],[10,11],[16,2]],[[6359,5839],[8,1],[13,9],[15,6],[13,19],[11,0],[0,-16],[-2,-33],[0,-30],[-6,-21],[-8,-62],[-13,-65],[-17,-73],[-24,-85],[-24,-64],[-33,-79],[-27,-46],[-42,-57],[-26,-44],[-30,-70],[-7,-30],[-6,-14]],[[6154,5085],[-19,-23],[-7,-24],[-11,-4],[-4,-41],[-9,-23],[-5,-38],[-11,-19]],[[6088,4913],[-13,-71],[2,-33],[17,-21],[1,-15],[-7,-35],[1,-17],[-2,-28],[10,-36],[12,-57],[10,-12]],[[6119,4588],[4,-26],[-1,-57],[4,-51],[1,-90],[5,-28],[-9,-41],[-11,-40],[-17,-36],[-26,-22],[-31,-28],[-31,-62],[-11,-10],[-19,-41],[-12,-13],[-2,-41],[13,-44],[5,-34],[1,-17],[5,3],[-1,-57],[-5,-26],[7,-10],[-4,-24],[-12,-21],[-23,-19],[-33,-31],[-12,-21],[2,-25],[7,-4],[-2,-30]],[[5911,3642],[-7,-42],[-3,-48],[-8,-26],[-19,-29],[-5,-8],[-12,-29],[-7,-30],[-16,-41],[-32,-60],[-19,-34],[-21,-26],[-29,-23],[-14,-3],[-4,-16],[-17,9],[-14,-11],[-30,11],[-17,-7],[-11,3],[-29,-23],[-23,-9],[-18,-22],[-12,-1],[-12,21],[-9,1],[-12,25],[-2,-8],[-3,16],[0,34],[-9,38],[9,11],[-1,44],[-18,54],[-14,48],[0,1],[-20,74]],[[5453,3536],[-21,44],[-11,42],[-6,56],[-7,42],[-9,88],[0,69],[-4,32],[-11,23],[-14,48],[-15,69],[-6,36],[-22,56],[-2,45]],[[5325,4186],[-3,36],[4,51],[10,52],[1,25],[9,52],[7,23],[16,38],[9,26],[3,42],[-2,33],[-8,21],[-8,35],[-6,34],[1,12],[9,23],[-9,56],[-5,38],[-14,37],[2,11]],[[5341,4831],[-4,18]],[[5337,4849],[-7,43]],[[5330,4892],[-23,61]],[[5307,4953],[-28,58],[-19,47],[-17,60],[1,19],[6,19],[7,41],[6,43]],[[5263,5240],[-6,9],[10,64]],[[5267,5313],[4,46],[-11,38],[-12,10],[-6,26],[-7,8],[0,16]],[[5235,5457],[-29,-21],[-10,3],[-11,-13],[-22,1],[-15,36],[-9,42],[-20,38],[-21,-1],[-24,0]],[[5074,5542],[-23,-6]],[[5051,5536],[-23,-13]],[[5028,5523],[-43,-33],[-16,-20],[-25,-17],[-24,17]],[[4920,5470],[-13,-1],[-19,11],[-18,0],[-33,-10],[-19,-17],[-28,-21],[-5,1]],[[4785,5433],[-7,0],[-29,27],[-25,44],[-24,32],[-19,37]],[[4681,5573],[-7,4],[-20,23],[-15,31],[-5,21],[-3,43]],[[4631,5695],[-12,34],[-11,22],[-7,8],[-7,11],[-3,26],[-4,12],[-8,10]],[[4579,5818],[-15,24],[-12,4],[-6,16],[0,9],[-8,12],[-2,12]],[[4536,5895],[-5,44]],[[4531,5939],[4,26]],[[4535,5965],[-12,45],[-14,20],[13,11],[13,40],[7,30]],[[4542,6111],[-3,31],[8,28],[4,55],[-4,57],[-3,28],[3,29],[-7,27],[-15,25]],[[4525,6391],[1,25]],[[4526,6416],[2,26],[10,16],[9,30],[-1,19],[9,41],[16,37],[9,9],[7,34],[1,30],[10,36],[18,21],[18,59],[15,22],[25,7],[22,39],[14,16],[23,48],[-7,71],[11,50],[4,30],[18,39],[27,26],[21,24],[19,60],[8,35],[21,0],[16,-25],[27,4],[29,-12],[12,-1]],[[4939,7207],[26,32],[30,10],[18,23],[27,18],[47,10],[46,5],[14,-9],[26,23],[30,0],[11,-13],[19,3]],[[5233,7309],[30,24],[20,-7],[-1,-29],[23,21],[2,-11],[-14,-28],[0,-27],[10,-14],[-4,-50],[-18,-29],[5,-32],[15,-1],[7,-27],[10,-9]],[[5318,7090],[33,-20],[11,5],[24,-9],[36,-26],[13,-51],[25,-11],[40,-25],[29,-28],[14,15],[13,26],[-6,44],[8,28],[20,27],[19,8],[38,-12],[9,-25],[11,-1],[9,-9],[27,-7],[7,-19]],[[5698,7000],[37,1],[27,-15],[27,-17],[13,-9],[21,18],[12,16],[24,5],[20,-7],[8,-29],[6,19],[22,-14],[22,-3],[14,15]],[[5951,6980],[8,19],[-2,3],[7,27],[6,43],[4,15],[1,0]],[[5975,7087],[10,47],[13,41],[1,2]],[[5999,7177],[-3,44],[7,24]],[[6003,7245],[-10,26],[10,21],[-17,-4],[-23,13],[-19,-33],[-42,-7],[-23,31],[-29,2],[-7,-24],[-19,-7],[-27,31],[-30,-1],[-17,57],[-20,32],[14,45],[-18,27],[31,55],[42,3],[12,44],[53,-8],[33,37],[33,17],[46,1],[48,-41],[40,-22],[32,9],[24,-5],[33,30]],[[6153,7574],[4,24],[-7,40],[-16,21],[-15,6],[-10,18]],[[6109,7683],[-36,49],[-31,21],[-24,34],[20,9],[23,49],[-16,22],[41,24],[0,13],[-25,-10]],[[6061,7894],[-23,-4],[-18,-19],[-26,-3],[-24,-21],[2,-36],[13,-14],[29,3],[-6,-20],[-30,-10],[-38,-34],[-15,12],[6,27],[-31,17],[5,11],[27,19],[-8,13],[-43,15],[-2,21],[-26,-7],[-10,-31],[-22,-43]],[[5821,7790],[1,-15],[-14,-12],[-8,5],[-8,-69]],[[5792,7699],[-14,-24],[-10,-41],[9,-33]],[[5777,7601],[3,-22],[24,-19],[-5,-14],[-33,-3],[-12,-18],[-23,-31],[-9,27],[1,12]],[[5723,7533],[-17,1],[-15,6],[-33,-15],[19,-33],[-14,-9],[-16,0],[-14,30],[-6,-13],[7,-34],[14,-27],[-11,-13],[16,-27],[13,-16],[1,-33],[-26,16],[8,-30],[-17,-6],[10,-51],[-18,0],[-23,25],[-11,46],[-4,38],[-11,26],[-14,33],[-2,17]],[[5559,7464],[-5,4],[-1,12],[-15,20],[-2,27],[2,39],[4,18],[-5,9]],[[5537,7593],[-6,5],[-8,19],[-12,11]],[[5511,7628],[-26,21],[-16,21],[-25,17],[-24,43],[6,4],[-13,24],[0,20],[-18,9],[-8,-25],[-9,19],[1,20],[1,1]],[[5380,7802],[6,5]],[[5386,7807],[-22,9],[-23,-21],[2,-28],[-3,-17],[9,-29],[26,-29],[14,-48],[31,-46],[21,0],[7,-13],[-8,-11],[25,-21],[21,-17],[23,-30],[3,-11],[-5,-21],[-15,27],[-24,10],[-12,-37],[20,-22],[-3,-30],[-12,-3],[-15,-50],[-11,-4],[0,17],[5,31],[6,13],[-10,33],[-9,29],[-11,7],[-9,25],[-17,11],[-12,23],[-21,3],[-22,26],[-25,38],[-19,33],[-9,57],[-14,7],[-22,19],[-13,-8],[-16,-27],[-11,-4]],[[5206,7698],[-26,-33],[-54,16],[-41,-19],[-3,-34]],[[5082,7628],[1,-34],[-26,-38],[-35,-12],[-3,-20],[-17,-32],[-11,-46],[11,-33],[-16,-26],[-6,-37],[-21,-12],[-20,-44],[-35,-1],[-26,1],[-18,-20],[-10,-22],[-14,5],[-10,19],[-8,33],[-26,9]],[[4792,7318],[-11,-15],[-15,8],[-14,-6],[4,45],[-3,35],[-12,6],[-7,22],[3,37],[11,21],[2,23],[5,35],[0,24],[-6,21],[-1,20]],[[4748,7594],[1,41],[-11,25],[39,41],[34,-10],[38,0],[29,-10],[23,3],[45,-2]],[[4946,7682],[15,35],[5,115],[-29,60],[-20,29],[-43,22],[-3,42],[36,13],[47,-15],[-9,65],[27,-24],[64,44],[9,48],[24,11]],[[5069,8127],[22,12]],[[5091,8139],[14,15],[25,85],[38,24],[23,-1]],[[5191,8262],[5,12],[23,3],[6,-13],[18,29],[-6,21],[-1,33]],[[5236,8347],[-11,32],[-1,59],[4,15],[8,18],[25,3],[10,16],[22,16],[-1,-29],[-8,-19],[3,-16],[15,-9],[-7,-22],[-8,7],[-20,-42],[8,-28]],[[5275,8348],[0,-22],[28,-14],[0,-20],[28,11],[16,16],[31,-23],[13,-19]],[[5391,8277],[19,17],[43,27],[35,19],[28,-9],[2,-14],[27,-1]],[[5545,8316],[6,25],[39,19]],[[5590,8360],[-6,48]],[[5584,8408],[1,44],[13,36],[27,20],[22,-43],[22,1],[5,44]],[[5674,8510],[4,34],[-11,-7],[-17,20],[-3,33],[35,16],[35,9],[31,-10],[28,2]],[[5776,8607],[32,32],[-29,27]],[[5779,8666],[-51,-5],[-49,-21],[-45,-12],[-16,32],[-27,18],[6,57],[-13,52],[13,34],[25,36],[64,62],[18,12],[-2,25],[-39,27]],[[5663,8983],[-48,-16],[-27,-41],[5,-35],[-45,-46],[-53,-50],[-21,-81],[20,-40],[27,-32],[-26,-65],[-29,-14],[-10,-96],[-16,-54],[-34,5],[-15,-45],[-33,-3],[-8,54],[-24,66],[-21,81]],[[5305,8571],[-18,35],[-55,-66],[-37,-14],[-39,30],[-10,62],[-8,132],[25,37],[74,49],[54,59],[51,81],[67,111],[47,43],[76,72],[61,25],[45,-3],[43,48],[50,-2],[50,11],[87,-42],[-36,-16],[31,-36]],[[5863,9187],[28,20],[46,-34],[76,-14],[105,-65],[21,-28],[2,-38],[-31,-30],[-45,-16],[-124,44],[-20,-7],[45,-42],[4,-86],[35,-17],[22,-15],[4,28]],[[6031,8887],[-18,25],[19,21]],[[6032,8933],[67,-36],[23,14],[-19,42],[65,57],[26,-3],[26,-21],[16,40],[-23,34],[13,35],[-20,35],[78,-18],[15,-32],[-35,-7],[0,-32],[22,-20],[43,12],[7,37],[58,28],[97,49],[21,-3],[-27,-35],[34,-6],[20,20],[52,1],[41,24],[32,-34],[31,38],[-29,33],[15,19],[82,-17],[38,-18],[101,-66],[18,30]],[[6920,9133],[-28,30],[-1,13]],[[6891,9176],[-33,5],[9,28],[-15,45],[-1,18],[52,52],[18,53],[21,11],[73,-15],[6,-32],[-26,-47],[17,-18],[9,-41],[-7,-79],[31,-35],[-12,-38],[-54,-82],[32,-9],[11,21],[30,15],[8,28],[24,28],[-17,33],[13,38],[-30,4],[-7,32],[22,58],[-36,47],[50,39],[-6,41],[14,1],[14,-32],[-11,-55],[30,-11],[-13,42],[47,22],[57,3],[52,-32],[-25,48],[-3,61],[48,11],[67,-2],[60,7],[-22,31],[32,37],[32,2],[54,29],[73,7],[10,16],[73,5],[22,-13],[63,31],[51,-1],[7,25],[27,24],[65,24],[48,-19],[-38,-14],[63,-9],[8,-28],[25,14],[81,-1],[63,-28]],[[8147,9571],[22,-21],[-7,-30]],[[6357,7389],[9,-43],[26,-12],[19,-29],[40,-10],[43,16],[3,13]],[[6497,7324],[-5,41],[4,60],[-22,19],[7,40],[-18,3],[6,49],[26,-14],[24,18],[-20,35],[-8,33],[-22,-15],[-3,-42],[-9,37]],[[6457,7588],[-1,14],[7,24],[-6,20],[-32,20],[-12,51],[-16,15],[-1,19],[27,-6],[1,42],[24,10],[24,-9],[5,56],[-5,36],[-28,-3],[-23,14],[-32,-25],[-26,-12]],[[6363,7854],[-13,-34],[-27,-10],[-27,-59],[25,-55],[-3,-39],[30,-68]],[[6348,7589],[15,-30],[14,-41],[13,-2],[9,-16],[-23,-5],[-5,-44],[-5,-20],[-10,-14],[1,-28]],[[2393,9646],[-13,-2],[-52,4],[-8,16],[56,-1],[20,-11],[-3,-6]],[[1939,9656],[-52,-17],[-41,19],[22,18],[41,6],[39,-9],[-9,-17]],[[5686,9665],[-62,-24],[-49,14],[19,15],[-17,18],[58,12],[11,-22],[40,-13]],[[1953,9708],[-34,-11],[-46,0],[1,8],[28,17],[15,-2],[36,-12]],[[2337,9677],[-41,-12],[-22,13],[-12,22],[-3,24],[36,-3],[17,-3],[33,-20],[-8,-21]],[[2220,9692],[11,-24],[-46,7],[-45,18],[-62,2],[27,17],[-34,14],[-2,22],[54,-7],[76,-21],[21,-28]],[[7917,9691],[-156,-22],[51,75],[22,7],[21,-4],[71,-32],[-9,-24]],[[5506,9771],[91,-43],[-70,-22],[-15,-43],[-24,-10],[-14,-48],[-33,-2],[-60,35],[25,20],[-41,17],[-54,48],[-22,46],[76,20],[15,-20],[40,1],[10,20],[41,2],[35,-21]],[[5706,9812],[54,-20],[-41,-31],[-80,-7],[-82,10],[-5,16],[-40,1],[-31,26],[86,16],[40,-14],[29,17],[70,-14]],[[6419,9820],[-37,-7],[-25,-5],[-4,-9],[-32,-10],[-30,14],[15,18],[-61,2],[54,10],[42,1],[6,-16],[16,14],[26,10],[41,-13],[-11,-9]],[[7775,9724],[-61,-7],[-77,17],[-46,22],[-22,41],[-37,11],[72,40],[60,13],[54,-29],[64,-56],[-7,-52]],[[2582,9769],[34,-19],[-39,-17],[-51,-43],[-49,-4],[-58,7],[-29,24],[0,21],[22,15],[-51,-1],[-31,20],[-17,26],[19,25],[19,18],[29,4],[-12,13],[64,3],[36,-31],[47,-12],[45,-11],[22,-38]],[[3096,9967],[75,-4],[59,-7],[51,-16],[-1,-15],[-68,-25],[-67,-12],[-25,-13],[60,0],[-65,-35],[-46,-16],[-47,-47],[-57,-9],[-18,-12],[-84,-6],[38,-8],[-19,-10],[23,-28],[-26,-20],[-43,-16],[-14,-23],[-38,-17],[4,-13],[47,2],[1,-14],[-75,-34],[-72,15],[-82,-9],[-41,7],[-53,3],[-3,28],[51,13],[-13,42],[17,4],[74,-25],[-38,37],[-45,11],[22,22],[50,14],[7,20],[-39,22],[-12,30],[76,-2],[22,-7],[44,21],[-63,7],[-97,-4],[-49,20],[-23,23],[-33,17],[-6,20],[41,11],[33,2],[54,9],[41,21],[35,-3],[30,-16],[21,31],[36,10],[50,6],[85,2],[15,-6],[80,10],[60,-4],[60,-4]],[[4246,9991],[174,-45],[-51,-23],[-107,-2],[-149,-6],[14,-10],[98,6],[84,-19],[54,17],[23,-21],[-31,-33],[71,21],[135,23],[83,-11],[16,-25],[-113,-41],[-16,-13],[-89,-10],[65,-3],[-33,-42],[-22,-37],[1,-64],[33,-38],[-43,-2],[-46,-19],[51,-30],[7,-49],[-30,-5],[36,-50],[-62,-4],[32,-23],[-9,-21],[-39,-9],[-39,0],[35,-39],[1,-25],[-55,23],[-15,-15],[38,-14],[36,-36],[11,-46],[-50,-11],[-21,22],[-34,33],[9,-39],[-32,-30],[73,-3],[38,-3],[-74,-50],[-76,-45],[-81,-20],[-31,0],[-28,-23],[-39,-60],[-60,-41],[-19,-2],[-37,-14],[-40,-14],[-24,-35],[0,-41],[-14,-38],[-45,-46],[11,-45],[-13,-47],[-14,-56],[-39,-4],[-41,47],[-56,0],[-26,32],[-19,56],[-48,72],[-14,37],[-4,52],[-38,53],[10,43],[-19,20],[27,67],[42,22],[11,24],[6,45],[-32,-21],[-15,-8],[-25,-8],[-34,18],[-2,39],[11,31],[26,1],[57,-15],[-48,36],[-25,20],[-28,-8],[-23,14],[31,54],[-17,21],[-22,40],[-33,61],[-36,22],[1,24],[-75,34],[-59,4],[-74,-2],[-68,-4],[-32,18],[-48,36],[73,18],[56,4],[-119,14],[-63,24],[4,22],[105,28],[102,28],[11,21],[-75,20],[24,23],[96,41],[40,6],[-11,26],[66,15],[85,9],[85,0],[31,-18],[73,32],[67,-21],[39,-5],[57,-19],[-66,31],[4,25],[93,34],[98,-2],[35,21],[98,6],[222,-8]],[[6847,7333],[15,0],[21,-12]],[[6883,7321],[8,-7],[21,18],[9,-11],[9,27],[16,-2],[5,9],[3,23],[12,20],[15,-13],[-3,-18],[8,-2],[-3,-49],[11,-19],[10,13],[12,5],[18,26],[19,-4],[29,0]],[[7082,7337],[5,-17]],[[7087,7320],[-17,-6],[-14,-11],[-32,-7],[-29,-12],[-17,-25],[7,-24],[3,-29],[-14,-24],[1,-22],[-7,-21],[-27,2],[11,-38],[-17,-15],[-12,-34],[1,-35],[-11,-16],[-10,5],[-21,-7],[-3,-17],[-21,1],[-15,-33],[-1,-49],[-36,-24],[-20,5],[-5,-13],[-17,8],[-28,-9],[-46,30]],[[6690,6900],[25,52],[-2,37],[-21,10],[-3,36],[-9,46],[12,32],[-12,8],[8,42],[11,72]],[[6699,7235],[28,-22],[21,8],[6,26],[22,8],[16,18],[5,46],[24,11],[4,21],[13,-16],[9,-2]],[[5663,4553],[3,-18],[-3,-28],[5,-27],[-4,-22],[2,-19],[-58,0],[-1,-183],[19,-47],[18,-36]],[[5644,4173],[-51,-24],[-67,9],[-20,27],[-112,-2],[-5,-4],[-16,26],[-18,1],[-17,-9],[-13,-11]],[[5341,4831],[12,7],[8,-1],[10,7],[81,0],[7,-43],[8,-35],[7,-19],[10,-30],[19,5],[9,8],[15,-8],[4,14],[7,34],[18,2],[1,10],[14,0],[-2,-20],[33,0],[1,-36],[6,-22],[-4,-35],[2,-35],[9,-22],[-2,-68],[7,5],[12,-1],[18,8],[12,-3]],[[5330,4892],[11,25],[9,9],[10,-19]],[[5360,4907],[-10,-12],[-5,-15],[-1,-25],[-7,-6]],[[5583,7534],[-1,-15],[-9,-9],[-1,-18],[-13,-28]],[[5537,7593],[-2,19],[12,28],[2,-11],[7,5]],[[5556,7634],[6,-15],[7,-6],[2,-21]],[[5571,7592],[-4,-19],[4,-25],[12,-14]],[[6556,6682],[6,-19]],[[6565,6617],[-14,0],[-2,-38],[5,-8],[-13,-11],[0,-23],[-8,-24],[-1,-23]],[[6532,6490],[-5,-13],[-84,29],[-10,59],[-1,13]],[[3139,2021],[-17,1],[-29,0],[0,129]],[[3258,3901],[51,-94],[23,-9],[34,-42],[28,-23],[4,-25],[-27,-88],[28,-16],[31,-8],[22,9],[25,44],[5,51]],[[3482,3700],[14,11],[13,-33],[0,-46],[-23,-32],[-19,-24],[-31,-55],[-38,-79]],[[3398,3442],[-6,-46],[-8,-59],[0,-58],[-6,-12],[-2,-38]],[[3094,2170],[-25,9],[-67,8],[-12,34],[1,43],[-19,-4],[-10,21],[-2,61],[21,25],[9,37],[-3,29],[14,49],[11,76],[-3,34],[12,11],[-3,22],[-13,11],[9,25],[-12,21],[-7,67],[11,12],[-4,70],[6,59],[7,51],[17,21],[-8,56],[0,53],[21,38],[-1,48],[16,56],[0,53],[-7,10],[-13,100],[17,59],[-3,56],[10,52],[18,54],[20,36],[-8,23],[6,18],[-1,96],[30,29],[9,59],[-3,15]],[[3135,3873],[23,52],[37,-14],[16,-42],[11,47],[31,-3],[5,-12]],[[6291,7414],[-10,-1]],[[6281,7413],[-12,33],[0,9],[-12,0],[-8,15],[-6,-1]],[[6243,7469],[-11,17],[-20,14],[2,28],[-4,20]],[[6210,7548],[38,9]],[[6248,7557],[6,-15],[10,-10],[-5,-14],[15,-20],[-8,-18],[12,-16],[12,-10],[1,-40]],[[3371,1488],[-12,-13],[-21,9],[-22,-5],[-20,-14],[-20,-14],[-13,-17],[-4,-23],[2,-21],[13,-19],[-19,-14],[-27,-5],[-15,-19],[-16,-18],[-17,-25],[-5,-21],[10,-24],[15,-18],[22,-13],[22,-18],[11,-23],[6,-21],[8,-23],[13,-19],[8,-22],[4,-53],[8,-21],[3,-23],[8,-22],[-3,-31],[-16,-23],[-16,-20],[-37,-7],[-13,-21],[-16,-19],[-42,-21],[-37,-9],[-35,-13],[-38,-12],[-22,-24],[-45,-2],[-49,2],[-44,-4],[-46,0],[8,-23],[43,-10],[31,-16],[17,-20],[-31,-18],[-48,5],[-39,-14],[-2,-24],[-1,-23],[33,-19],[6,-21],[35,-22],[59,-9],[50,-15],[39,-18],[51,-19],[69,-9],[68,-15],[47,-17],[52,-19],[27,-28],[14,-21],[34,20],[45,17],[49,18],[57,15],[50,16],[69,1],[68,-8],[56,-14],[18,25],[39,17],[70,1],[55,13],[52,12],[58,8],[61,10],[43,15],[-20,20],[-12,20],[0,22],[-53,-2],[-57,-9],[-55,0],[-8,21],[4,43],[13,12],[40,14],[46,13],[34,17],[34,17],[25,23],[38,10],[37,8],[19,4],[43,3],[41,8],[34,11],[34,13],[31,14],[38,18],[25,19],[26,17],[8,23],[-29,13],[9,24],[19,18],[29,11],[30,14],[29,18],[21,22],[14,27],[20,16],[33,-3],[14,-19],[33,-3],[1,22],[14,22],[30,-5],[7,-22],[33,-3],[36,10],[35,7],[32,-3],[12,-24],[30,19],[28,10],[32,8],[31,8],[28,14],[31,9],[24,12],[17,20],[21,-14],[29,8],[20,-28],[15,-20],[32,11],[13,23],[28,16],[36,-4],[11,-21],[23,21],[30,7],[33,2],[29,-1],[31,-6],[30,-4],[13,-19],[18,-17],[30,10],[33,2],[32,0],[31,2],[27,7],[30,7],[24,16],[26,10],[29,6],[21,16],[15,31],[16,19],[29,-9],[10,-20],[24,-13],[29,4],[20,-20],[20,-15],[29,14],[10,24],[25,11],[28,19],[28,8],[32,11],[22,12],[23,14],[22,12],[26,-6],[25,20],[18,16],[26,-2],[23,14],[5,20],[24,16],[22,11],[28,9],[26,5],[24,-3],[26,-6],[23,-16],[2,-25],[25,-19],[17,-16],[33,-6],[18,-16],[23,-16],[27,-3],[22,11],[24,24],[26,-13],[27,-7],[26,-6],[28,-5],[27,0],[23,-60],[-1,-14],[-3,-26],[-27,-15],[-22,-21],[4,-23],[31,1],[-3,-22],[-15,-22],[-13,-24],[22,-18],[32,-5],[32,10],[15,22],[9,22],[15,18],[18,17],[7,20],[15,28],[17,6],[32,2],[27,7],[29,9],[13,23],[8,21],[19,22],[28,14],[23,11],[15,20],[16,10],[20,9],[28,-6],[25,6],[27,7],[31,-4],[20,16],[14,38],[10,-15],[13,-27],[24,-12],[26,-4],[27,6],[28,-4],[26,-1],[18,5],[23,-3],[21,-12],[25,8],[30,0],[26,7],[29,-7],[18,19],[14,19],[19,16],[35,43],[18,-8],[21,-16],[19,-20],[35,-35],[27,-1],[26,0],[30,6],[30,8],[23,16],[19,17],[31,2],[20,13],[22,-12],[14,-18],[20,-18],[30,2],[19,-14],[34,-15],[34,-6],[29,5],[22,18],[18,18],[25,5],[25,-8],[29,-6],[26,9],[25,0],[25,-6],[26,-5],[25,10],[29,9],[29,2],[31,0],[26,6],[25,4],[8,29],[1,23],[17,-15],[5,-26],[9,-24],[12,-19],[23,-10],[32,3],[36,1],[25,3],[36,0],[27,2],[36,-3],[31,-4],[20,-18],[-6,-22],[18,-17],[30,-13],[31,-15],[36,-10],[37,-9],[29,-9],[31,-1],[18,19],[25,-16],[21,-18],[24,-13],[34,-6],[32,-7],[14,-22],[31,-14],[22,-20],[31,-9],[32,1],[30,-3],[33,1],[33,-5],[31,-8],[29,-13],[29,-12],[19,-17],[-3,-22],[-15,-20],[-12,-26],[-10,-21],[-13,-23],[-36,-9],[-17,-21],[-36,-12],[-12,-23],[-19,-21],[-20,-18],[-12,-24],[-7,-21],[-3,-26],[1,-22],[16,-22],[6,-22],[13,-20],[51,-8],[11,-25],[-50,-9],[-42,-12],[-53,-2],[-23,-33],[-5,-27],[-12,-22],[-15,-21],[37,-19],[14,-24],[24,-21],[34,-20],[39,-18],[41,-18],[64,-18],[14,-28],[80,-12],[6,-5],[20,-17],[77,15],[64,-18],[48,-14],[-9998,-1],[25,34],[50,-18],[3,2],[29,18],[4,0],[3,-1],[41,-24],[35,24],[6,3],[82,11],[26,-14],[13,-7],[42,-19],[79,-15],[62,-18],[108,-13],[80,16],[118,-12],[66,-18],[74,17],[77,16],[6,27],[-109,2],[-90,14],[-23,23],[-75,12],[5,26],[10,24],[11,21],[-6,24],[-46,16],[-21,20],[-43,18],[67,-4],[64,10],[41,-20],[49,17],[46,22],[22,19],[-10,24],[-35,15],[-41,17],[-57,4],[-50,8],[-54,5],[-18,22],[-36,18],[-22,20],[-9,65],[14,-5],[25,-18],[46,5],[44,8],[23,-25],[44,6],[37,13],[35,15],[31,20],[42,5],[-1,22],[-10,21],[8,20],[36,10],[16,-19],[43,12],[32,14],[40,1],[37,6],[38,14],[30,12],[33,12],[22,-3],[19,-5],[42,8],[37,-10],[38,1],[36,8],[38,-5],[41,-6],[39,2],[40,-1],[41,-1],[38,2],[29,17],[33,9],[35,-12],[33,10],[30,20],[18,-18],[10,-20],[18,-19],[29,17],[33,-22],[37,-7],[33,-15],[39,3],[35,10],[42,-2],[37,-8],[39,-10],[14,25],[-18,19],[-13,20],[-36,5],[-16,21],[-6,22],[-10,42],[21,-7],[37,-4],[36,4],[32,-9],[29,-17],[12,-21],[37,-3],[36,8],[38,11],[35,7],[28,-14],[37,5],[24,44],[22,-26],[32,-10],[35,5],[23,-22],[36,-2],[34,-7],[33,-13],[22,22],[11,20],[28,-22],[38,5],[28,-12],[19,-19],[37,5],[29,13],[28,14],[34,8],[39,7],[35,8],[28,12],[16,18],[6,25],[-3,24],[-9,22],[-9,23],[-9,23],[-7,20],[-2,22],[3,23],[13,21],[11,24],[4,23],[-5,25],[-4,22],[14,26],[15,17],[18,21],[19,18],[23,17],[10,25],[16,16],[17,15],[27,3],[17,18],[20,11],[23,7],[20,15],[16,18],[21,7],[17,-15],[-11,-19],[-28,-17]],[[6914,2382],[18,-18],[26,-7],[1,-11],[-8,-26],[-43,-4],[0,30],[4,24],[2,12]],[[5449,7880],[-5,-10],[-25,-1],[-14,-13],[-23,4]],[[5382,7860],[-39,15],[-6,20],[-28,-10],[-3,-11],[-17,8]],[[5289,7882],[-14,2],[-13,10],[5,14],[-2,11]],[[5265,7919],[9,3],[14,-16],[4,15],[24,-2],[20,10],[14,-2],[8,-12],[3,10],[-4,38],[10,7],[10,26]],[[5377,7996],[20,-18],[16,23],[10,5],[21,-18],[13,3],[13,-11]],[[5470,7980],[-2,-7],[3,-20]],[[5471,7953],[-2,-23],[-16,-1],[5,-12],[-9,-37]],[[6281,7413],[-19,7],[-14,27],[-5,22]],[[6357,7389],[-7,-3],[-18,30],[10,28],[-8,17],[-11,-4],[-32,-43]],[[6248,7557],[7,10],[21,-17],[15,-3],[3,6],[-13,31],[7,8]],[[6288,7592],[8,-2],[19,-34],[12,-4],[5,14],[16,23]],[[5805,5018],[17,-4],[9,33],[14,-4]],[[5845,5043],[2,-23],[6,-13],[0,-18],[-7,-13],[-11,-30],[-10,-20],[-11,-3]],[[5814,4923],[-2,69],[-7,26]],[[5170,8107],[-3,-39]],[[5167,8068],[-7,-2],[-3,-32]],[[5157,8034],[-25,26],[-14,-4],[-19,27],[-13,23],[-13,1],[-4,20]],[[5091,8139],[20,-5],[26,12],[18,-25],[15,-14]],[[5024,5815],[10,7],[5,25],[14,5],[6,18]],[[5059,5870],[9,16],[10,1],[21,-34]],[[5099,5853],[-1,-19],[6,-34],[-5,-23],[3,-16],[-14,-35],[-8,-18],[-5,-36],[0,-37],[-1,-93]],[[5051,5536],[-7,39],[1,133],[-5,11],[-1,29],[-10,20],[-9,17],[4,30]],[[4849,5779],[-2,34],[8,24],[-1,19],[22,48],[4,40],[8,14],[13,-8],[12,12],[4,15],[21,25],[5,18],[26,24],[16,8],[7,-11],[17,1]],[[5009,6042],[-2,-28],[4,-27],[16,-37],[0,-28],[32,-13],[0,-39]],[[5024,5815],[-24,1]],[[5000,5816],[-13,5],[-9,-9],[-12,4],[-49,-3],[0,-32],[3,-44]],[[4920,5737],[-19,15],[-13,-2],[-9,-15],[-13,13],[-5,19],[-12,12]],[[7472,6452],[-4,47],[-10,44],[5,34],[-17,16],[6,21],[17,21],[-20,31],[10,39],[22,-25],[13,-3],[3,-40],[26,-8],[26,1],[16,-10],[-13,-49],[-12,-3],[-9,-33],[15,-29],[5,36],[7,1],[15,-92]],[[7573,6451],[-1,-41],[-9,9],[2,-47]],[[5777,7601],[-24,8],[-29,-19]],[[5724,7590],[0,-28],[-25,-6],[-20,20],[-22,-15],[-20,1]],[[5637,7562],[-2,38],[-14,19]],[[5621,7619],[4,8],[-3,7],[5,18],[10,18],[-13,25],[-3,21],[7,13]],[[5628,7729],[8,-24],[11,5],[21,-9],[41,-3],[14,14],[33,14],[20,-21],[16,-6]],[[5533,7688],[-5,-5],[-9,-13],[-4,-32]],[[5515,7638],[-25,22],[-11,24],[-10,12],[-13,22],[-6,18],[-14,27],[6,24],[10,-14],[6,12],[13,2],[24,-10],[19,1],[13,-13]],[[5527,7765],[10,0],[-7,-25],[13,-22],[-4,-27],[-6,-3]],[[5735,8384],[17,10],[30,22]],[[5782,8416],[29,-14],[4,-14],[14,6],[28,-13],[2,-27],[-6,-16],[18,-38],[11,-10],[-2,-10],[19,-11],[8,-15],[-11,-12],[-22,2],[-5,-6],[6,-19],[7,-37]],[[5882,8182],[-24,-3],[-9,-13],[-1,-29],[-11,6],[-25,-3],[-8,13],[-10,-10],[-11,9],[-21,1],[-31,14],[-29,4],[-21,-1],[-15,-16],[-14,-2]],[[5652,8152],[0,26],[-9,26],[17,12],[0,23],[-8,22],[-1,25]],[[5651,8286],[27,0],[30,22],[7,32],[22,19],[-2,25]],[[2529,6097],[-8,0],[2,65],[0,45]],[[2523,6207],[0,9],[3,3],[5,-7],[10,34],[5,1]],[[3135,3873],[-20,-8],[-11,79],[-15,65],[9,56],[-15,24],[-3,41],[-14,40]],[[3066,4170],[18,62],[-12,48],[6,20],[-5,21],[11,29],[0,49],[2,40],[6,20],[-24,92]],[[3068,4551],[20,-5],[15,2],[6,17],[24,23],[15,22],[36,10],[-3,-43],[4,-22],[-3,-39],[31,-52],[31,-9],[11,-22],[18,-11],[12,-17],[17,1],[17,-17],[1,-34],[5,-16],[1,-25],[-9,-1],[11,-67],[53,-3],[-4,-33],[3,-23],[15,-16],[7,-36],[-5,-45],[-8,-25],[3,-33],[-9,-12]],[[3383,4020],[0,18],[-26,29],[-26,1],[-48,-17],[-13,-50],[-1,-31],[-11,-69]],[[3482,3700],[5,33],[4,34],[0,32],[-10,10],[-10,-9],[-11,2],[-3,23],[-3,52],[-5,18],[-19,15],[-11,-11],[-29,11],[2,78],[-9,32]],[[3068,4551],[-16,-10],[-12,7],[1,87],[-22,-33],[-25,1],[-10,31],[-19,3],[6,25],[-15,35],[-12,52],[7,10],[0,25],[17,16],[-3,31],[7,20],[2,27],[32,39],[23,12],[4,8],[25,-3]],[[3058,4934],[12,158],[1,25],[-5,33],[-12,21],[0,42],[16,10],[6,-6],[0,22],[-16,6],[0,36],[54,-2],[9,20],[8,-18],[5,-34],[6,7]],[[3142,5254],[15,-30],[21,3],[6,18],[20,13],[12,10],[3,24],[20,17],[-2,12],[-23,5],[-4,36],[1,39],[-12,15],[5,5],[21,-8],[22,-14],[8,14],[20,9],[31,21],[10,22],[-4,16]],[[3312,5481],[15,3],[6,-13],[-4,-26],[10,-8],[6,-27],[-7,-20],[-5,-49],[7,-29],[2,-27],[17,-27],[14,-3],[3,11],[9,3],[12,10],[9,15],[16,-5],[7,2]],[[3429,5291],[15,-4],[2,11],[-4,12],[2,17],[12,-6],[13,6],[16,-12]],[[3485,5315],[12,-12],[8,16],[7,-3],[3,-16],[14,4],[10,22],[9,43],[16,52]],[[3517,3237],[-8,33],[12,27],[-16,40],[-22,31],[-28,37],[-11,-1],[-28,44],[-18,-6]],[[8206,5496],[-2,-29],[-1,-36],[-13,1],[-6,-19],[-13,30]],[[7466,6754],[18,43],[15,14],[20,-13],[15,-1],[12,-16]],[[7546,6781],[11,-18],[-2,-36],[-22,-1],[-24,4],[-17,-9],[-26,21],[0,12]],[[5816,3910],[-39,-43],[-25,-43],[-9,-38],[-8,-22],[-15,-4],[-5,-28],[-3,-18],[-18,-13],[-23,3],[-13,16],[-12,7],[-13,-13],[-7,-28],[-13,-17],[-14,-26],[-20,-6],[-6,20],[3,35],[-17,55],[-7,9]],[[5552,3756],[0,168],[27,2],[1,205],[20,2],[43,20],[11,-24],[18,23],[8,0],[16,13]],[[5696,4165],[5,-4]],[[5701,4161],[10,-46],[6,-11],[9,-33],[31,-63],[12,-6],[0,-21],[8,-36],[22,-9],[17,-26]],[[5634,5824],[3,-25],[16,-36],[0,-24],[-4,-24],[2,-17],[9,-17]],[[5660,5681],[21,-25]],[[5681,5656],[16,-23],[0,-19],[19,-30],[11,-25],[7,-35],[21,-22],[4,-19]],[[5759,5483],[-9,-6],[-18,2],[-21,6],[-10,-5],[-4,-14],[-9,-2],[-11,12],[-31,-29],[-13,6],[-3,-4],[-9,-35],[-20,11],[-21,6],[-17,21],[-23,20],[-15,-19],[-11,-29],[-2,-40]],[[5512,5384],[-18,3],[-19,10],[-17,-31],[-14,-53]],[[5444,5313],[-3,16],[-1,26],[-13,19],[-10,30],[-3,20],[-13,30],[2,18],[-2,24],[2,45],[6,10],[14,58]],[[5423,5609],[23,5],[5,14],[5,-1],[7,-13],[35,22],[12,23],[14,20],[-2,20],[7,6],[27,-4],[26,27],[20,62],[14,24],[18,10]],[[1300,8301],[13,-7],[27,4],[-9,-65],[25,-46],[-12,0],[-16,26],[-11,27],[-14,18],[-5,25],[2,18]],[[3134,7781],[-18,33],[0,78],[-12,17],[-19,-10],[-9,15],[-21,-43],[-9,-45],[-10,-26],[-11,-9],[-9,-3],[-3,-14],[-51,0],[-42,-1],[-13,-10],[-29,-42],[-4,-4],[-9,-23],[-25,0],[-27,0],[-13,-9],[4,-11],[3,-18],[-1,-6],[-36,-28],[-28,-10],[-33,-30],[-7,0],[-9,9],[-3,8],[0,6],[6,20],[14,32],[8,34],[-6,50],[-6,52],[-29,27],[4,10],[-4,8],[-8,0],[-6,9],[-1,13],[-5,-6],[-8,2],[2,6],[-7,5],[-2,16],[-22,18],[-22,19],[-28,22],[-26,21],[-25,-16],[-9,0],[-34,14],[-22,-7],[-27,18],[-29,9],[-19,4],[-9,9],[-5,32],[-9,0],[0,-22],[-58,0],[-95,0],[-94,0],[-83,0],[-84,0],[-82,0],[-84,0],[-28,0],[-82,0],[-79,0]],[[1373,8338],[16,27],[-1,37],[-47,36],[-29,66],[-17,41],[-25,26],[-19,24],[-15,30],[-28,-19],[-27,-32],[-24,38],[-20,25],[-27,16],[-27,2],[0,327],[0,214]],[[1440,9241],[19,-7],[47,-51]],[[2457,9224],[-25,-29],[52,-11]],[[1972,9143],[-71,-9],[-49,-6]],[[1501,9320],[12,25],[19,42]],[[1653,9318],[0,-26],[-73,-27]],[[5289,7882],[-2,-23],[-12,-10],[-21,7],[-6,-23],[-13,-2],[-5,9],[-16,-19],[-13,-3],[-12,12]],[[5189,7830],[-9,26],[-14,-9],[1,26],[20,32],[-1,15],[13,-6],[7,10]],[[5206,7924],[24,0],[6,12],[29,-17]],[[3139,2021],[-9,-23],[-24,-18]],[[3106,1980],[-13,2],[-17,4]],[[3076,1986],[-20,17],[-29,9],[-35,32],[-28,31],[-39,64],[23,-12],[39,-38],[37,-21],[14,27],[9,39],[26,24],[20,-7]],[[3044,4125],[15,15],[7,30]],[[8628,7623],[-18,34],[-11,-32],[-43,-25],[4,-30],[-24,2],[-13,18],[-19,-41],[-31,-31],[-23,-37]],[[8000,6423],[-28,15],[-13,23],[4,34],[-25,10],[-13,22],[-24,-31],[-27,-7],[-22,1],[-15,-14]],[[7837,6476],[-15,-9],[5,-66],[-15,2],[-3,13]],[[7809,6416],[-1,24],[-20,-17],[-12,11],[-21,22],[9,47],[-18,12],[-7,53],[-29,-10],[3,68],[27,48],[1,48],[-1,44],[-12,14],[-9,34],[-17,-5]],[[7702,6809],[-30,9],[10,24],[-13,36],[-20,-24],[-23,14],[-32,-37],[-26,-43],[-22,-7]],[[7466,6754],[-3,45],[-16,-12]],[[7447,6787],[-33,6],[-31,13],[-23,25],[-21,12],[-10,27],[-15,9],[-28,37],[-23,18],[-11,-14]],[[7252,6920],[-39,40],[-27,37],[-8,63],[20,-8],[1,30],[-11,29],[3,47],[-30,68]],[[7161,7226],[-46,23],[-8,44],[-20,27]],[[7082,7337],[-5,33],[1,22],[-16,13],[-10,-6],[-7,54]],[[7045,7453],[8,13],[-4,13],[27,27],[19,12],[30,-8],[10,37],[36,7],[10,22],[43,32],[4,13]],[[7228,7621],[-2,32],[19,15],[-25,100],[55,23],[14,13],[20,103],[55,-19],[16,26],[1,58],[23,6],[21,38]],[[7425,8016],[11,5]],[[7436,8021],[8,-41],[23,-30],[40,-22],[19,-46],[-11,-67],[10,-25],[33,-10],[37,-8],[34,-36],[17,-6],[13,-54],[16,-34],[31,2],[57,-13],[37,8],[27,-9],[41,-35],[34,0],[12,-18],[33,31],[45,20],[41,2],[33,21],[20,30],[19,20],[-4,19],[-9,22],[14,37],[16,-5],[28,-12],[28,31],[42,22],[21,38],[19,17],[41,7],[22,-6],[3,20],[-25,40],[-23,19],[-21,-21],[-28,9],[-15,-8],[-7,24],[19,57],[14,44]],[[8240,8055],[33,-22],[39,36],[0,26],[25,61],[16,18],[-1,32],[-15,14],[23,28],[34,11],[37,1],[42,-17],[24,-21],[17,-58],[11,-25],[9,-35],[11,-57],[48,-18],[33,-41],[11,-54],[42,0],[24,23],[46,16],[-14,-51],[-11,-21],[-10,-63],[-18,-57],[-34,11],[-24,-21],[8,-49],[-4,-68],[-15,-2],[1,-29]],[[4785,5433],[2,48],[3,7],[-1,23],[-12,24],[-9,4],[-8,15],[6,26],[-3,28],[2,17]],[[4765,5625],[4,0],[2,25],[-3,11],[3,8],[10,7],[-6,46],[-7,24],[2,19],[6,5]],[[4776,5770],[4,5],[7,-9],[22,0],[5,17],[5,-2],[8,7],[4,-25],[6,8],[12,8]],[[4920,5737],[8,-82],[-12,-48],[-7,-65],[12,-50],[-1,-22]],[[5312,5312],[-45,1]],[[5235,5457],[7,41],[13,55],[8,1],[17,33],[11,1],[15,-23],[19,19],[3,24],[6,23],[4,29],[15,24],[6,40],[6,13],[4,30],[7,37],[23,44],[2,19],[3,11],[-11,23]],[[5393,5901],[1,18],[8,3]],[[5402,5922],[11,-36],[2,-39],[-1,-38],[15,-52],[-16,0],[-8,-4],[-12,6],[-6,-27],[16,-34],[12,-10],[4,-23],[9,-40],[-5,-16]],[[5444,5313],[-2,-32],[-22,14],[-23,15],[-35,3]],[[5362,5313],[-3,3],[-17,-8],[-17,8],[-13,-4]],[[5821,5105],[-8,-16],[-1,-35],[-4,-4],[-3,-32]],[[5814,4923],[5,-53],[-3,-30],[6,-33],[16,-33],[15,-72]],[[5853,4702],[-11,6],[-37,-10],[-8,-7],[-8,-37],[6,-25],[-5,-68],[-3,-58],[8,-10],[19,-23],[8,11],[2,-62],[-21,0],[-12,32],[-10,24],[-21,8],[-7,31],[-16,-19],[-23,8],[-9,26],[-18,6],[-13,-2],[-1,18],[-10,2]],[[5360,4907],[7,-6],[10,22],[15,-1],[2,-16],[10,-10],[16,36],[17,28],[7,18],[-1,48],[12,56],[12,29],[19,28],[3,19],[1,21],[4,20],[-1,32],[3,51],[6,36],[8,31],[2,35]],[[5759,5483],[17,-47],[13,-7],[7,10],[13,-4],[15,12],[7,-25],[24,-38]],[[5855,5384],[-1,-67],[11,-8],[-9,-21],[-11,-15],[-10,-30],[-6,-27],[-2,-46],[-6,-22],[0,-43]],[[5307,4953],[21,32],[-10,38],[9,14],[19,7],[2,26],[15,-28],[25,-2],[8,27],[4,38],[-3,45],[-14,34],[13,67],[-7,11],[-21,-4],[-8,29],[2,26]],[[2836,5598],[3,28],[9,-4],[6,17],[-7,34],[4,8]],[[3018,5860],[-18,-10],[-7,-28],[-11,-17],[-8,-21],[-3,-41],[-8,-34],[14,-4],[4,-26],[6,-13],[2,-23],[-3,-22],[1,-12],[7,-4],[6,-20],[36,5],[16,-7],[20,-50],[11,6],[20,-3],[16,7],[10,-10],[-5,-31],[-7,-19],[-2,-42],[6,-38],[8,-17],[1,-13],[-14,-29],[10,-12],[7,-20],[9,-58]],[[3058,4934],[-14,31],[-8,1],[17,59],[-21,27],[-17,-5],[-10,10],[-15,-15],[-21,7],[-16,60],[-13,15],[-9,27],[-18,28],[-7,-6]],[[2906,5173],[-12,14],[-14,19],[-8,-9],[-23,8],[-7,25],[-5,-1],[-28,32]],[[2618,5820],[5,8],[18,-15],[6,7],[9,-5],[5,-12],[8,-3],[6,12]],[[2706,5733],[-10,-5],[0,-24],[5,-8],[-4,-7],[1,-10],[-2,-12],[-1,-11]],[[2714,6517],[24,-4],[22,-1],[26,-19],[11,-21],[26,6],[10,-13],[23,-36],[18,-26],[9,1],[16,-12],[-2,-16],[21,-2],[21,-24],[-4,-13],[-18,-8],[-19,-3],[-19,5],[-40,-6],[19,32],[-11,15],[-18,4],[-10,17],[-6,33],[-16,-3],[-26,16],[-8,12],[-37,9],[-9,11],[10,14],[-27,3],[-20,-30],[-12,0],[-4,-14],[-13,-7],[-12,6],[14,18],[7,20],[12,13],[14,11],[21,6],[7,6]],[[5943,7201],[-3,2],[-6,-5],[-4,2],[-1,-3],[-1,6],[-2,4],[-5,0],[-8,-5],[-5,3]],[[5377,7996],[-16,25],[-14,14],[-3,24],[-5,17],[20,13],[10,14],[20,11],[7,11],[8,-6],[12,6]],[[5416,8125],[13,-19],[21,-5],[-2,-16],[15,-11],[5,14],[19,-6],[2,-18],[21,-4],[13,-28]],[[5523,8032],[-9,0],[-4,-10],[-6,-3],[-2,-13],[-5,-3],[-1,-5],[-10,-6],[-12,1],[-4,-13]],[[5391,8277],[7,-29],[-8,-15],[10,-21],[7,-31],[-2,-19],[11,-37]],[[5206,7924],[4,41],[14,40],[-40,10],[-13,15]],[[5171,8030],[1,25],[-5,13]],[[5170,8107],[-5,61],[17,0],[7,21],[7,53],[-5,20]],[[5236,8347],[21,-8],[18,9]],[[6197,5842],[-10,-31]],[[6187,5811],[-6,10],[-7,-4],[-15,1],[-1,18],[-2,16],[10,27],[9,25]],[[6175,5904],[12,-5],[9,14]],[[3007,6221],[1,16],[-7,17],[6,10],[3,22],[-3,31]],[[5118,6285],[-31,-6],[-1,37],[-12,9],[-18,17],[-6,27],[-94,125],[-94,126]],[[4862,6620],[-104,139]],[[4758,6759],[0,12],[0,4]],[[4758,6775],[0,68],[45,42],[28,9],[22,15],[11,29],[32,23],[2,43],[16,5],[12,21],[37,10],[5,22],[-8,12],[-9,61],[-2,35],[-10,37]],[[5233,7309],[-6,-29],[5,-55],[-7,-47],[-17,-33],[2,-43],[23,-34],[0,-14],[18,-23],[11,-104]],[[5262,6927],[9,-51],[2,-26],[-5,-47],[2,-27],[-4,-31],[3,-36],[-11,-24],[16,-42],[1,-25],[10,-32],[13,10],[22,-26],[12,-36]],[[5332,6534],[-95,-110],[-80,-113],[-39,-26]],[[2906,5173],[3,-44],[-8,-37],[-31,-60],[-33,-23],[-17,-50],[-5,-39],[-16,-24],[-12,29],[-11,7],[-11,-5],[-1,21],[8,14],[-3,24]],[[6023,6449],[-110,0],[-108,0],[-112,0]],[[5693,6449],[0,212],[0,205],[-8,46],[7,36],[-4,24],[10,28]],[[5951,6980],[18,-99]],[[6011,6012],[-3,23],[12,85],[3,38],[8,18],[21,9],[14,33]],[[6175,5904],[-9,19],[-12,34],[-12,18],[-7,20],[-24,23],[-19,1],[-7,12],[-16,-14],[-17,26],[-9,-43],[-32,12]],[[4946,7682],[11,-22],[51,-26],[10,12],[32,-26],[32,8]],[[4792,7318],[-2,19],[10,22],[4,15],[-10,18],[8,37],[-11,35],[12,5],[1,27],[4,8],[1,45],[13,16],[-8,29],[-16,2],[-5,-8],[-17,0],[-7,29],[-11,-9],[-10,-14]],[[5776,8607],[4,-10],[-19,-33],[8,-54],[-12,-18]],[[5757,8492],[-23,0],[-24,21],[-12,7],[-24,-10]],[[6187,5811],[-6,-20],[10,-32],[11,-28],[10,-20],[91,-69],[23,1]],[[6326,5643],[-78,-173],[-36,-3],[-25,-40],[-18,-1],[-7,-18]],[[6162,5408],[-19,0],[-12,19],[-25,-24],[-8,-24],[-19,5],[-6,6],[-6,-1],[-9,0],[-35,49],[-20,0],[-9,19],[0,32],[-15,10]],[[5979,5499],[-16,63],[-13,13],[-5,23],[-14,28],[-17,4],[10,33],[15,1],[4,18]],[[5943,5682],[-1,52]],[[5942,5734],[9,60],[13,16],[2,24],[12,44],[17,28],[11,57],[5,49]],[[5663,8983],[-9,22],[-1,89],[-44,39],[-37,28]],[[5572,9161],[17,16],[31,-31],[36,3],[30,-14],[27,25],[13,43],[43,19],[36,-23],[-12,-40]],[[5793,9159],[-4,-40],[43,-39],[-26,-43],[32,-66],[-18,-49],[25,-43],[-12,-37],[41,-40],[-10,-29],[-26,-34],[-59,-73]],[[3299,2196],[33,35],[24,-15],[17,23],[22,-25],[-8,-21],[-38,-17],[-12,20],[-24,-26],[-14,26]],[[3485,5315],[7,25],[2,26]],[[3494,5366],[5,25],[-11,34]],[[3488,5425],[-2,39],[14,49]],[[5157,8034],[6,-5],[8,1]],[[5189,7830],[-1,-16],[8,-22],[-10,-17],[8,-45],[15,-7],[-3,-25]],[[5263,5240],[9,3],[40,0],[0,69]],[[4827,8284],[-21,12],[-17,-1],[5,31],[-5,31]],[[4968,8327],[19,-9],[17,-65],[8,-23],[34,-11],[-4,-37],[-14,-17],[11,-30],[-25,-30],[-37,1],[-47,-16],[-13,11],[-18,-27],[-26,7],[-20,-22],[-14,11],[40,61],[25,12],[-43,10],[-8,23],[29,18],[-15,31],[5,37],[41,-5],[4,34]],[[4917,8291],[-18,35],[-1,1]],[[4898,8327],[-34,10],[-6,16],[10,25],[-9,16],[-15,-27],[-2,55],[-14,30],[10,59],[22,47],[22,-5],[34,5],[-30,-62],[28,8],[31,0],[-8,-47],[-25,-52],[29,-4]],[[4941,8401],[2,-6],[25,-68]],[[6109,7683],[3,7],[24,-10],[41,-9],[37,-28],[5,-11],[17,9],[26,-12],[8,-23],[18,-14]],[[6210,7548],[-27,28],[-30,-2]],[[5000,5816],[-2,-17],[11,-30],[0,-42],[3,-45],[7,-21],[-6,-52],[2,-29],[7,-36],[6,-21]],[[4715,5666],[-8,-3],[1,21],[-5,15],[1,17],[-6,24],[-8,20],[-22,1],[-6,-11],[-8,-2],[-5,-12],[-3,-16],[-15,-25]],[[4579,5818],[12,28],[9,-1],[7,9],[6,0],[4,8],[-2,19],[3,6],[0,20]],[[4618,5907],[14,-1],[20,-14],[6,1],[2,7],[15,-5],[4,3]],[[4679,5898],[2,-21],[4,0],[7,8],[5,-2],[8,-14],[12,-5],[7,12],[9,8],[7,8],[5,-1],[7,-13],[3,-16],[11,-24],[-5,-15],[-1,-19],[5,6],[4,-7],[-2,-17],[9,-16]],[[4765,5625],[-8,1],[-6,-23],[-8,0],[-5,12],[2,24],[-12,35],[-7,-7],[-6,-1]],[[4535,5965],[30,1],[6,14],[9,1],[11,-14],[9,0],[9,9],[5,-16],[-12,-13],[-12,1],[-12,12],[-10,-13],[-5,-1],[-6,-8],[-26,1]],[[4536,5895],[14,10],[10,-2],[7,6],[51,-2]],[[5583,7534],[18,5],[11,12],[15,-1],[4,10],[6,2]],[[5724,7590],[14,-15],[-9,-36],[-6,-6]],[[3700,9940],[93,34],[98,-2],[35,21],[98,6],[222,-8],[174,-45],[-51,-23],[-107,-2],[-149,-6],[14,-10],[98,6],[84,-19],[54,17],[23,-21],[-31,-33],[71,21],[135,23],[83,-11],[16,-25],[-113,-41],[-16,-13],[-89,-10],[65,-3],[-33,-42],[-22,-37],[1,-64],[33,-38],[-43,-2],[-46,-19],[51,-30],[7,-49],[-30,-5],[36,-50],[-62,-4],[32,-23],[-9,-21],[-39,-9],[-39,0],[35,-39],[1,-25],[-55,23],[-15,-15],[38,-14],[36,-36],[11,-46],[-50,-11],[-21,22],[-34,33],[9,-39],[-32,-30],[73,-3],[38,-3],[-74,-50],[-76,-45],[-81,-20],[-31,0],[-28,-23],[-39,-60],[-60,-41],[-19,-2],[-37,-14],[-40,-14],[-24,-35],[0,-41],[-14,-38],[-45,-46],[11,-45],[-13,-47],[-14,-56],[-39,-4],[-41,47],[-56,0],[-26,32],[-19,56],[-48,72],[-14,37],[-4,52],[-38,53],[10,43],[-19,20],[27,67],[42,22],[11,24],[6,45],[-32,-21],[-15,-8],[-25,-8],[-34,18],[-2,39],[11,31],[26,1],[57,-15],[-48,36],[-25,20],[-28,-8],[-23,14],[31,54],[-17,21],[-22,40],[-33,61],[-36,22],[1,24],[-75,34],[-59,4],[-74,-2],[-68,-4],[-32,18],[-48,36],[73,18],[56,4],[-119,14],[-63,24],[4,22],[105,28],[102,28],[11,21],[-75,20],[24,23],[96,41],[40,6],[-11,26],[66,15],[85,9],[85,0],[31,-18],[73,32],[67,-21],[39,-5],[57,-19],[-66,31],[4,25]],[[2437,6019],[1,17],[3,13],[-4,11],[14,47],[35,0],[1,20],[-4,3],[-4,13],[-10,13],[-10,19],[12,1],[0,32],[26,0],[26,-1]],[[2549,6088],[-13,-22],[-13,-16],[-2,-12],[2,-11],[-6,-14]],[[2517,6013],[-6,-4],[1,-7],[-5,-6],[-10,-15],[0,-8]],[[3412,5526],[-5,-52],[-17,-15],[2,-13],[-5,-30],[12,-42],[9,0],[4,-33],[17,-50]],[[3312,5481],[-19,44],[8,16],[-1,27],[17,9],[7,11],[-9,21],[2,21],[22,34]],[[2561,5953],[1,23],[-3,6],[-6,4],[-12,-7],[-1,8],[-9,9],[-6,12],[-8,5]],[[2690,6045],[-10,2],[-4,-8],[-9,-8],[-7,0],[-7,-7],[-5,3],[-5,8],[-3,-1],[-3,-14],[-3,0],[0,-11],[-10,-16],[-5,-7],[-3,-7],[-8,11],[-6,-15],[-6,0],[-7,-1],[1,-28],[-4,-1],[-4,-13],[-8,-2]],[[5515,7638],[-4,-10]],[[5380,7802],[19,-2],[5,10],[10,-10],[11,-1],[0,16],[9,6],[3,23],[22,16]],[[5459,7860],[9,-7],[21,-25],[23,-11],[10,9]],[[5522,7826],[7,-23],[9,-16],[-11,-22]],[[5471,7953],[14,-15],[10,-6],[23,7],[3,12],[11,1],[13,9],[3,-3],[13,7],[7,13],[9,4],[30,-18],[5,6]],[[5612,7970],[16,-15],[2,-16]],[[5630,7939],[-17,-12],[-13,-39],[-17,-39],[-22,-11]],[[5561,7838],[-18,3],[-21,-15]],[[5459,7860],[-5,19],[-5,1]],[[8470,4670],[3,-11],[0,-18]],[[8915,5032],[1,-187],[0,-188]],[[8045,5298],[5,-39],[19,-33],[17,12],[18,-4],[16,29],[14,5],[26,-16],[23,12],[14,80],[11,20],[9,66],[32,0],[24,-10]],[[7252,6920],[-18,-26],[-11,-54],[27,-22],[27,-28],[36,-32],[38,-8],[16,-29],[21,-6],[34,-13],[23,1],[3,23],[-4,36],[3,25]],[[7702,6809],[2,-21],[-9,-11],[2,-35],[-20,10],[-36,-40],[1,-33],[-15,-48],[-2,-28],[-12,-48],[-22,13],[-1,-59],[-6,-20],[3,-24],[-14,-14]],[[6893,6546],[18,39],[61,-1],[-5,50],[-16,29],[-3,44],[-18,26],[30,61],[33,-5],[29,61],[17,58],[27,58],[0,41],[23,33],[-22,29],[-10,39],[-10,50],[14,25],[42,-14],[31,8],[27,49]],[[6690,6900],[14,-31],[11,-34],[26,-26],[1,-50],[13,-10],[3,-26],[-40,-30],[-11,-67]],[[6348,6905],[-15,31],[-1,30],[-9,0],[5,42],[-14,44],[-34,31],[-20,55],[7,45],[14,20],[-2,33],[-18,18],[-18,68]],[[6243,7322],[-16,46],[6,18],[-9,66],[19,17]],[[6497,7324],[24,11],[20,33],[18,-2],[13,11],[19,-5],[31,-29],[22,-7],[32,-51],[21,-2],[2,-48]],[[6331,6908],[-18,5],[-21,-55]],[[6292,6858],[-51,4],[-79,116],[-41,40],[-33,16]],[[6088,7034],[-12,70]],[[6076,7104],[62,60],[10,70],[-2,42],[15,14],[14,36]],[[6175,7326],[12,9],[32,-8],[10,-14],[14,9]],[[5982,6995],[1,-22],[-14,-92]],[[5975,7087],[9,0],[2,10],[8,1]],[[5994,7098],[0,-23],[-3,-9],[0,-1]],[[5991,7065],[-5,-18]],[[5986,7047],[-10,8],[-6,-38],[7,-7],[-7,-7],[-1,-16],[13,8]],[[5382,7860],[-3,-28],[7,-25]],[[2845,6247],[18,-5],[15,-14],[5,-16],[-20,-1],[-8,-10],[-16,9],[-16,21],[4,14],[11,4],[7,-2]],[[6088,7034],[-6,-9],[-55,-29],[27,-57],[-9,-10],[-4,-19],[-22,-8],[-6,-21],[-12,-18],[-31,9]],[[5982,6995],[4,17],[0,35]],[[5991,7065],[31,-22],[54,61]],[[6554,7561],[-15,-3],[-19,45],[-19,16],[-31,-12],[-13,-19]],[[6363,7854],[-14,9],[2,30],[-17,38],[-21,-1],[-23,39],[16,43],[-8,12],[22,63],[28,-33],[4,42],[57,63],[43,1],[62,-40],[33,-23],[29,24],[44,1],[36,-29],[8,17],[39,-3],[7,27],[-45,40],[26,28],[-5,16],[27,15],[-20,39],[12,20],[104,20],[14,14],[69,21],[25,24],[50,-12],[9,-60],[29,14],[36,-20],[-3,-31],[27,3],[70,55],[-11,-18],[36,-45],[62,-146],[15,30],[38,-33],[40,15],[15,-11],[14,-33],[19,-11],[12,-25],[36,8],[14,-35]],[[7228,7621],[-17,8],[-14,21],[-41,6],[-46,1],[-10,-6],[-40,24],[-16,-12],[-4,-34],[-46,20],[-18,-8],[-6,-25]],[[6970,7616],[-16,-11],[-37,-40],[-12,-41],[-10,-1],[-8,28],[-35,2],[-6,47],[-13,0],[2,58],[-33,42],[-48,-5],[-33,-8],[-26,52],[-23,22],[-43,41],[-5,5],[-72,-34],[2,-212]],[[6088,4913],[-40,57],[-2,34],[-101,117],[-4,6]],[[5941,5127],[-1,61],[8,24],[14,38],[10,42],[-12,66],[-3,29],[-14,40]],[[5943,5427],[18,34],[18,38]],[[6162,5408],[-25,-66],[1,-209],[16,-48]],[[7045,7453],[-52,-9],[-34,18],[-31,-4],[3,33],[30,-9],[10,17]],[[6971,7499],[22,-5],[35,41],[-33,30],[-20,-14],[-20,22],[23,37],[-8,6]],[[7848,5884],[-6,69],[18,48],[35,11],[26,-8]],[[7921,6004],[23,-23],[13,40],[25,-21]],[[7982,6000],[6,-39],[-3,-69],[-47,-44],[12,-35],[-29,-4],[-24,-23]],[[8504,7356],[1,5],[13,-2],[10,26],[20,3],[12,3],[4,14]],[[5556,7634],[6,13]],[[5562,7647],[6,4],[4,20],[5,3],[4,-8],[5,-4],[4,-9],[4,-3],[6,-11],[4,1],[-3,-14],[-4,-7],[1,-4]],[[5598,7615],[-6,-3],[-16,-9],[-2,-11],[-3,0]],[[6344,6826],[-20,-1],[-7,27],[-25,6]],[[7780,6358],[6,21],[23,37]],[[7837,6476],[16,-46],[12,-52],[35,-1],[10,-50],[-17,-15],[-8,-21],[33,-34],[23,-68],[18,-51],[21,-40],[7,-41],[-5,-57]],[[7921,6004],[9,26],[2,49],[-23,50],[-1,57],[-22,46],[-21,4],[-5,-20],[-16,-1],[-9,10],[-29,-35],[-1,52],[7,61],[-19,2],[-1,35],[-12,18]],[[5999,7177],[12,-3],[5,-23],[-15,-21],[-7,-32]],[[4681,5573],[7,18],[1,17],[13,31],[13,27]],[[5262,6927],[14,14],[2,24],[-3,24],[19,22],[9,18],[14,17],[1,44]],[[5693,6449],[0,-115],[-32,0],[0,-25]],[[5661,6309],[-111,111],[-110,110],[-29,-32]],[[5411,6498],[-19,-21],[-16,32],[-44,25]],[[7271,5615],[-5,-60],[-11,-16],[-24,-13],[-14,45],[-4,83],[12,94],[19,-32],[13,-41],[14,-60]],[[5804,3515],[10,-18],[-9,-28],[-5,-19],[-15,-9],[-5,-18],[-10,-6],[-21,45],[15,36],[15,23],[13,11],[12,-17]],[[5584,8408],[32,18],[46,-4],[28,6],[3,-12],[15,-4],[27,-28]],[[5651,8286],[-6,18],[-15,6]],[[5630,8310],[-2,15],[3,16],[-12,9],[-29,10]],[[5757,8492],[13,-14],[3,-28],[9,-34]],[[4758,6775],[-4,0],[1,-31],[-17,-2],[-9,-13],[-13,0],[-10,7],[-23,-6],[-9,-45],[-9,-4],[-13,-73],[-39,-62],[-9,-79],[-11,-26],[-4,-21],[-62,-5],[-1,1]],[[4526,6416],[2,26],[10,16],[9,30],[-1,19],[9,41],[16,37],[9,9],[7,34],[1,30],[10,36],[18,21],[18,59]],[[4634,6774],[1,0],[14,22]],[[4649,6796],[25,7],[22,39],[14,16],[23,48],[-7,71],[11,50],[4,30],[18,39],[27,26],[21,24],[19,60],[8,35],[21,0],[16,-25],[27,4],[29,-12],[12,-1]],[[5783,7801],[-5,27],[3,24],[-1,25],[-16,35],[-9,24],[-8,17],[-9,6]],[[5738,7959],[7,8],[18,6],[21,-18],[11,-2],[13,-16],[-2,-19],[10,-10],[4,-24],[10,-14],[-2,-9],[5,-6],[-7,-4],[-17,2],[-3,8],[-5,-5],[2,-10],[-8,-19],[-5,-19],[-7,-7]],[[6375,4464],[7,-25],[7,-38],[5,-69],[7,-27],[-3,-27],[-5,-17],[-9,33],[-5,-17],[5,-42],[-3,-25],[-7,-13],[-2,-49],[-11,-67],[-14,-79],[-17,-109],[-10,-80],[-13,-67],[-23,-14],[-24,-24],[-16,14],[-22,21],[-7,30],[-2,51],[-10,46],[-3,42],[5,41],[13,10],[0,19],[13,44],[3,37],[-6,27],[-6,36],[-2,53],[10,33],[4,36],[13,2],[16,12],[10,11],[12,0],[16,33],[23,36],[8,29],[-3,24],[11,-7],[16,40],[0,35],[9,26],[10,-25]],[[1746,7055],[31,5],[36,6],[-3,-11],[42,-28],[63,-41],[56,1],[22,0],[0,24],[48,-1],[10,-20],[14,-18],[17,-25],[9,-31],[7,-31],[14,-18],[23,-17],[18,46],[22,1],[20,-23],[14,-40],[9,-33],[17,-33],[6,-41],[8,-27],[21,-17],[20,-13],[11,2]],[[2301,6672],[-11,-51],[-5,-41],[-2,-78],[-2,-28],[4,-31],[9,-28],[6,-45],[18,-43],[6,-33],[11,-28],[30,-15],[11,-24],[25,16],[21,6],[21,10],[17,10],[18,23],[6,34],[3,48],[5,17],[18,15],[30,14],[24,-2],[17,5],[7,-13],[-1,-27],[-15,-35],[-7,-35],[5,-10],[-4,-25],[-7,-45],[-7,15],[-6,-1]],[[5598,7615],[10,3],[13,1]],[[5118,6285],[0,-133],[-16,-38],[-2,-36],[-25,-9],[-38,-5],[-10,-20],[-18,-2]],[[4679,5898],[1,18],[-2,23],[-10,16],[-6,33],[-1,36]],[[4661,6024],[9,10],[5,34],[9,1],[19,-16],[16,12],[11,-4],[4,13],[111,1],[6,40],[-4,7],[-14,249],[-13,248],[42,1]],[[7780,6358],[-16,-14],[-16,-25],[-20,-2],[-13,-62],[-11,-11],[13,-50],[18,-42],[11,-38],[-10,-51],[-10,-10],[7,-29],[18,-46],[4,-32],[-1,-27],[11,-52],[-15,-54],[-14,-59]],[[5533,7688],[7,-10],[4,-8],[9,-6],[11,-12],[-2,-5]],[[7436,8021],[30,10],[53,49],[42,27],[24,-17],[29,-1],[19,-27],[27,-2],[40,-15],[27,40],[-11,34],[29,60],[31,-24],[25,-7],[33,-14],[5,-43],[40,-25],[26,11],[35,7],[28,-7],[27,-28],[17,-29],[26,0],[35,-9],[25,14],[37,10],[40,40],[17,-6],[15,-19],[33,5]],[[5911,3642],[-21,1]],[[5890,3643],[-3,25],[-4,26]],[[5883,3694],[-2,21],[5,64],[-7,41],[-14,81]],[[5865,3901],[30,65],[7,42],[4,5],[3,34],[-4,17],[1,43],[5,40],[0,73],[-14,18],[-13,4],[-6,14],[-13,13],[-23,-1],[-2,21]],[[5840,4289],[-3,41],[85,47]],[[5922,4377],[16,-27],[7,5],[11,-14],[2,-24],[-6,-26],[2,-41],[18,-36],[9,40],[12,13],[-3,74],[-11,41],[-10,19],[-10,-1],[-8,75],[8,44]],[[5959,4519],[21,4],[33,-16],[7,7],[20,2],[10,17],[16,-1],[31,22],[22,34]],[[4525,6391],[6,19],[109,0],[-5,83],[6,30],[26,5],[0,147],[91,-3],[0,87]],[[4661,6024],[-18,39],[-17,43],[-19,15],[-13,17],[-15,-1],[-14,-12],[-14,5],[-9,-19]],[[5922,4377],[-15,15],[8,54],[9,20],[-5,48],[5,46],[5,16],[-7,49],[-13,25]],[[5909,4650],[27,-10],[6,-16],[9,-27],[8,-78]],[[7779,5554],[5,10],[22,-25],[3,-29],[18,7],[9,23]],[[5644,4173],[23,13],[18,-3],[11,-13],[0,-5]],[[5552,3756],[0,-213],[-25,-29],[-15,-5],[-18,11],[-12,5],[-5,24],[-11,16],[-13,-29]],[[9604,3968],[22,-36],[15,-26],[-11,-14],[-15,16],[-20,26],[-18,30],[-18,41],[-4,19],[12,-1],[15,-19],[13,-20],[9,-16]],[[5411,6498],[7,-89],[11,-15],[0,-18],[12,-20],[-6,-25],[-11,-117],[-1,-75],[-36,-54],[-12,-76],[12,-21],[0,-37],[17,-1],[-2,-28]],[[5393,5901],[-5,-1],[-19,63],[-7,2],[-21,-32],[-22,16],[-15,4],[-8,-8],[-16,2],[-16,-25],[-15,-1],[-33,29],[-13,-14],[-15,1],[-10,22],[-28,21],[-30,-6],[-7,-13],[-4,-33],[-8,-23],[-2,-52]],[[5863,9187],[-47,-23],[-23,-5]],[[5572,9161],[-17,-2],[-4,-38],[-52,9],[-8,-32],[-26,0],[-19,-41],[-27,-63],[-43,-81],[10,-20],[-10,-23],[-28,1],[-18,-54],[2,-76],[18,-30],[-9,-67],[-23,-40],[-13,-33]],[[6474,6141],[-9,40],[-22,95]],[[6443,6276],[84,58],[18,115],[-13,41]],[[5545,8316],[34,-7],[51,1]],[[5652,8152],[14,-50],[-3,-16],[-13,-7],[-26,-48],[8,-26],[-6,3]],[[5626,8008],[-27,23],[-20,-9],[-13,6],[-16,-12],[-14,20],[-12,-7],[-1,3]],[[3158,6248],[14,-5],[5,-11],[-7,-15],[-21,0],[-16,-2],[-2,25],[4,8],[23,0]],[[8628,7623],[3,-10]],[[6426,6600],[-7,-4],[-9,11]],[[5783,7801],[13,-10],[13,9],[12,-10]],[[5628,7729],[-5,10],[7,10],[-7,7],[-9,-13],[-16,17],[-2,24],[-17,13],[-3,18],[-15,23]],[[5630,7939],[12,12],[17,-6],[18,0],[13,-14],[9,9],[21,5],[7,14],[11,0]],[[6061,7894],[1,26],[14,16],[27,4],[4,19],[-6,32],[11,30],[0,17],[-41,19],[-16,-1],[-17,27],[-22,-9],[-35,20],[1,12],[-10,25],[-22,2],[-3,18],[7,12],[-18,33],[-28,-6],[-9,3],[-7,-13],[-10,2]],[[5863,9187],[28,20],[46,-34],[76,-14],[105,-65],[21,-28],[2,-38],[-31,-30],[-45,-16],[-124,44],[-20,-7],[45,-42]],[[5966,8977],[2,-27],[2,-59]],[[5970,8891],[35,-17],[22,-15],[4,28]],[[6031,8887],[-17,24],[18,22]],[[6920,9133],[-28,31],[-1,12]],[[8147,9571],[22,-22],[-7,-29]],[[5821,5105],[6,-6],[17,18]],[[5844,5117],[11,-33],[-2,-34],[-8,-7]],[[6443,6276],[-80,-22],[-26,-26],[-20,-60],[-13,-10],[-7,19],[-10,-3],[-27,6],[-5,6],[-32,-1],[-8,-6],[-11,15],[-7,-28],[2,-24],[-12,-19]],[[5634,5824],[0,14],[-10,16],[0,34],[-6,22],[-10,-3],[3,21],[7,24],[-3,24],[9,17],[-6,14],[8,36],[13,42],[23,-4],[-1,228]],[[5942,5734],[0,-7]],[[5942,5727],[-4,1],[1,29],[-3,20],[-15,22],[-3,42],[3,42],[-13,4],[-1,-13],[-17,-3],[7,-16],[2,-35],[-15,-32],[-14,-41],[-14,-6],[-24,34],[-10,-12],[-3,-17],[-14,-11],[-1,-12],[-28,0],[-4,12],[-20,2],[-10,-10],[-8,5],[-14,34],[-5,15],[-20,-7],[-7,-27],[-7,-52],[-10,-10],[-9,-7]],[[5662,5678],[-2,3]],[[5943,5427],[-17,-27],[-19,0],[-22,-13],[-18,13],[-12,-16]],[[5681,5656],[-19,22]],[[5942,5727],[1,-45]],[[2541,5940],[-10,6],[-11,11]],[[6359,5839],[-1,-1],[0,-24],[0,-58],[0,-30],[-12,-35],[-20,-48]],[[3488,5425],[11,-35],[-5,-24]],[[3494,5366],[-2,-27],[-7,-24]],[[5626,8008],[-8,-15],[-6,-23]],[[5890,3643],[-6,-26],[-16,-6],[-17,31],[0,20],[8,22],[2,16],[8,4],[14,-10]],[[6003,7245],[7,12],[8,13],[1,32],[10,-11],[30,16],[15,-11],[23,0],[32,22],[15,-1],[31,9]],[[6883,7321],[16,58],[-6,43],[-21,14],[7,25],[24,-3],[13,32],[9,37],[37,14],[-6,-27],[4,-16],[11,1]],[[6554,7561],[31,0],[-5,29],[24,20],[23,34],[38,-31],[3,-46],[10,-11],[30,2],[10,-10],[13,-60],[32,-39],[18,-27],[29,-29],[37,-24],[0,-36]],[[3286,5802],[16,7],[6,-2],[-1,-43],[-24,-6],[-5,5],[8,16],[0,23]],[[8381,6587],[-16,-93],[-12,-47],[-15,49],[-3,42],[16,57],[23,44],[12,-18],[-5,-34]],[[5909,4650],[-16,18],[-18,9],[-11,10],[-11,15]],[[5844,5117],[10,7],[30,-1],[57,4]],[[3052,7697],[-15,-34],[-5,-13]],[[2952,7539],[40,11],[9,-11]],[[2896,7366],[-14,22],[-4,48]],[[2522,6928],[-11,-9],[5,-16]],[[2316,6812],[-15,-28],[-6,-25]],[[1746,7055],[-5,30],[-18,33],[-13,7],[-3,16],[-15,3],[-10,16],[-26,6],[-7,9],[-4,31],[-27,58],[-23,80],[1,14],[-12,19],[-22,48],[-3,47],[-15,31],[6,48],[-1,49],[-9,45],[11,54]],[[1551,7699],[3,52],[4,52]],[[1558,7803],[-5,78],[-9,49],[-8,27],[3,11],[40,-20],[15,-54],[7,15],[-4,47],[-10,48]],[[5816,3910],[12,-1],[13,-9],[10,6],[14,-5]],[[5840,4289],[-21,-8],[-16,-23],[-3,-20],[-10,-4],[-24,-48],[-16,-37],[-9,-1],[-9,6],[-31,7]]]}

/***/ }),
/* 41 */
/***/ (function(module, exports) {

module.exports = {"data":[{"UuidKey":"b06ead72-a0ac-4c06-bb1b-98c4ab6a4a09","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862738592189,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31506,"vrouter":"a7s12"},{"UuidKey":"b5ba466a-9e56-42e8-8cf5-e75d27c62f7a","action":"pass","agg-bytes":474325736,"agg-packets":1410948,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228799929030,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49726,"vrouter":"a7s12"},{"UuidKey":"b5ac8195-6662-4e2e-9984-782b3ce0a62e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862792622235,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32385,"vrouter":"a7s12"},{"UuidKey":"b5611e6e-85ee-46eb-98f7-fb2450299785","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863008786257,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2867,"vrouter":"a7s12"},{"UuidKey":"b54b4943-786b-4503-8e32-8821ccd34647","action":"pass","agg-bytes":1808558414,"agg-packets":5399039,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50543,"protocol":6,"setup_time":1478625028489461,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"b473ed8c-d340-4f54-8bbb-ed87a7e0b696","action":"pass","agg-bytes":473639780,"agg-packets":1408160,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228800153058,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58219,"vrouter":"a7s12"},{"UuidKey":"b3f000c6-ddc9-4f7e-8288-36f6e3b09428","action":"pass","agg-bytes":472868952,"agg-packets":1410688,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58219,"protocol":6,"setup_time":1483228800152916,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"b28c2df0-daa3-4e8f-85b7-b37feb14119c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862954756764,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1942,"vrouter":"a7s12"},{"UuidKey":"b20de521-3147-4b01-9d08-905663fd4b7e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863161886000,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5724,"vrouter":"a7s12"},{"UuidKey":"b17f4f11-1c95-44ce-80dd-d722a46845ed","action":"pass","agg-bytes":1808179662,"agg-packets":5392803,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1478625115801894,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44890,"vrouter":"a7s12"},{"UuidKey":"b5debe8f-6fe1-4a9c-abf6-2fcc97204186","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863071825952,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3868,"vrouter":"a7s12"},{"UuidKey":"afafd179-0109-4759-b435-b78a94ce6efc","action":"pass","agg-bytes":473502602,"agg-packets":1412295,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1483228799559851,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50754,"vrouter":"a7s12"},{"UuidKey":"af86f5fe-6871-44ec-b0af-523245c86810","action":"pass","agg-bytes":473410966,"agg-packets":1411745,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49726,"protocol":6,"setup_time":1483228799928947,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"ae5eca19-6464-439a-9bf2-c4e67366cc30","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862873692353,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":906,"vrouter":"a7s12"},{"UuidKey":"ae527eb6-f069-4aac-b566-713533eac584","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862648516698,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29810,"vrouter":"a7s12"},{"UuidKey":"add4a583-9c6f-4be4-9b8e-62854c00208d","action":"pass","agg-bytes":1809375098,"agg-packets":5402091,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1478625093704916,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57225,"vrouter":"a7s12"},{"UuidKey":"ac5393ea-8132-4714-b4b8-96bee9ff56e5","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863035803549,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3782,"vrouter":"a7s12"},{"UuidKey":"aac73f9c-cbb4-48ca-9b5a-d7e027c3598a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862729581094,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31438,"vrouter":"a7s12"},{"UuidKey":"aab94f33-53cb-4fb3-be22-c32606b86b1a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862630504256,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29768,"vrouter":"a7s12"},{"UuidKey":"a8d3060f-1429-4d92-a89c-b9b14ff3fd6f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862981771777,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2827,"vrouter":"a7s12"},{"UuidKey":"beee6f56-a111-4020-864c-3e5122ec2b3d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863062823413,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3834,"vrouter":"a7s12"},{"UuidKey":"c44dbc1f-4b95-4a7e-ab61-d37f379199e9","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863062823441,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3834,"vrouter":"a7s12"},{"UuidKey":"c3fd2442-b414-4e39-8e4c-e4566b127a56","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862720571085,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30724,"vrouter":"a7s12"},{"UuidKey":"c373ad13-7335-46b1-a888-0348bfd4e501","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862711568011,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30721,"vrouter":"a7s12"},{"UuidKey":"c22bd6cf-7f0a-4a2c-acd0-39d47ceb2c36","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862621492710,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29730,"vrouter":"a7s12"},{"UuidKey":"c0add3fb-3acb-45ed-ba0b-efba8f965681","action":"pass","agg-bytes":1809435586,"agg-packets":5395825,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1478625026483133,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50541,"vrouter":"a7s12"},{"UuidKey":"c094a260-ede9-4a42-ac3f-7eec6e14a77b","action":"pass","agg-bytes":1809845784,"agg-packets":5399612,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50753,"protocol":6,"setup_time":1478625100743948,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"c08a76a4-9b6c-4498-a803-3591e25cfa01","action":"pass","agg-bytes":473886608,"agg-packets":1411272,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228800094416,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53189,"vrouter":"a7s12"},{"UuidKey":"c00f6439-ba52-42a2-a03c-fcb83d6cba7c","action":"pass","agg-bytes":474609746,"agg-packets":1411657,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1483228802135433,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43882,"vrouter":"a7s12"},{"UuidKey":"bfde7a27-94e0-4c09-9e05-1cb5c6866360","action":"pass","agg-bytes":473406584,"agg-packets":1415446,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228800134161,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57222,"vrouter":"a7s12"},{"UuidKey":"a7f4abad-52f7-4050-a328-0b7dbaf945fa","action":"pass","agg-bytes":473537876,"agg-packets":1412718,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228801716987,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50540,"vrouter":"a7s12"},{"UuidKey":"be7b40a0-f6a4-45bc-aaee-3ec6c061386f","action":"pass","agg-bytes":474615638,"agg-packets":1415025,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1483228799559566,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47808,"vrouter":"a7s12"},{"UuidKey":"bb7078a1-3c80-4f4c-a683-052f6942b2d7","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863170903815,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5728,"vrouter":"a7s12"},{"UuidKey":"bae401c0-32e0-4600-b168-24a4395acf05","action":"pass","agg-bytes":1808494272,"agg-packets":5394836,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56179,"protocol":6,"setup_time":1478625044539080,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"bad7ea91-a007-4e2a-bf78-e3d5705af3d5","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863179901368,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5763,"vrouter":"a7s12"},{"UuidKey":"b9c301ab-b767-4555-9f62-85f97b69667e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862999784784,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2864,"vrouter":"a7s12"},{"UuidKey":"b823507e-e092-4844-90ee-2aa2b85ba783","action":"pass","agg-bytes":473277618,"agg-packets":1413511,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228802612312,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35156,"vrouter":"a7s12"},{"UuidKey":"b67a6c22-f3c8-4ff7-94d5-f4cdc5b2473e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863017796044,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2923,"vrouter":"a7s12"},{"UuidKey":"b610d00f-167f-4816-8aec-58c8add58f8f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862594466891,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28927,"vrouter":"a7s12"},{"UuidKey":"93a7a188-9c24-430a-aaed-9fecf725916f","action":"pass","agg-bytes":474351306,"agg-packets":1408583,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228802116453,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57224,"vrouter":"a7s12"},{"UuidKey":"99093d4b-2d2f-4a65-8465-e4cbcdf11e2b","action":"pass","agg-bytes":474041898,"agg-packets":1414279,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35154,"protocol":6,"setup_time":1483228800133483,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"97e3689f-c3bb-4f88-8f9a-e0769fd863f4","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862531418334,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27886,"vrouter":"a7s12"},{"UuidKey":"95be19d8-b567-4382-977d-77819b327179","action":"pass","agg-bytes":473839090,"agg-packets":1413705,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1483228799882423,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58424,"vrouter":"a7s12"},{"UuidKey":"9559a05a-2b3c-4f9a-b2bf-5cbfddf2e47c","action":"pass","agg-bytes":1809820638,"agg-packets":5400647,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":51384,"protocol":6,"setup_time":1478625074642454,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9111,"vrouter":"a7s12"},{"UuidKey":"94cf645d-399d-47f0-882d-2430b7433ab9","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862918732060,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1844,"vrouter":"a7s12"},{"UuidKey":"94b6df14-abd2-4c52-9bcd-efff95a8c37c","action":"pass","agg-bytes":474149102,"agg-packets":1414995,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49730,"protocol":6,"setup_time":1483228799925672,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"946370ce-2680-4a7f-96d9-7249f7a584cd","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863026800235,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3626,"vrouter":"a7s12"},{"UuidKey":"93d26c4a-0e2a-42e2-bd8d-6f3d9fa3d467","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862702558780,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30679,"vrouter":"a7s12"},{"UuidKey":"93c5cabe-6078-4b4b-8d1d-905ae6631b27","action":"pass","agg-bytes":473051156,"agg-packets":1408398,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9111,"protocol":6,"setup_time":1483228799926954,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":51387,"vrouter":"a7s12"},{"UuidKey":"9922338a-7bd4-421a-a229-950168b43fc6","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863188916527,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":5766,"vrouter":"a7s12"},{"UuidKey":"92faeb1b-3caa-4f8b-96ce-3303a5d31734","action":"pass","agg-bytes":474305144,"agg-packets":1414314,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35155,"protocol":6,"setup_time":1483228801931706,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"92c379f6-836f-4cb6-bd94-983b62050c78","action":"pass","agg-bytes":474221878,"agg-packets":1417601,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53711,"protocol":6,"setup_time":1483228800152387,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"9212cfcb-70f9-4f21-af04-dff4cb814157","action":"pass","agg-bytes":1807317112,"agg-packets":5396590,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625086674417,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36819,"vrouter":"a7s12"},{"UuidKey":"915ee779-93fb-4479-840f-46a7530015a7","action":"pass","agg-bytes":473634472,"agg-packets":1413662,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54508,"protocol":6,"setup_time":1483228800153082,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"91257fff-47a2-4ebb-8b37-558d06ec8e35","action":"pass","agg-bytes":473541810,"agg-packets":1412151,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56180,"protocol":6,"setup_time":1483228799882461,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"8f85b369-d5f9-40bc-8510-795c4bb1c61c","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862819648698,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32425,"vrouter":"a7s12"},{"UuidKey":"8f32cacb-16b1-4cfa-93af-b0e8fede592d","action":"pass","agg-bytes":473036308,"agg-packets":1409896,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1483228800153097,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54508,"vrouter":"a7s12"},{"UuidKey":"8f22de94-008c-4d0d-8fd2-df6dc50da71d","action":"pass","agg-bytes":473892802,"agg-packets":1415501,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56048,"protocol":6,"setup_time":1483228799715271,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"a0472292-b81f-4112-b563-e9a5469b2977","action":"pass","agg-bytes":473899662,"agg-packets":1414079,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58424,"protocol":6,"setup_time":1483228799882319,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"a5c68496-2dae-4af6-bb1c-23279d3305a8","action":"pass","agg-bytes":473104048,"agg-packets":1411824,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1483228800152448,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56183,"vrouter":"a7s12"},{"UuidKey":"a56a0f8a-833c-4604-adf2-524a397651de","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863008786407,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2867,"vrouter":"a7s12"},{"UuidKey":"a5570509-bf72-4a67-bcb6-ba1f76d64d1a","action":"pass","agg-bytes":473722670,"agg-packets":1412967,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":38175,"protocol":6,"setup_time":1483228800313951,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9108,"vrouter":"a7s12"},{"UuidKey":"a4e95787-8d73-4e76-b405-a18e3019ebfb","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863071825892,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3868,"vrouter":"a7s12"},{"UuidKey":"a4b743b0-40f2-466c-9335-4f59f4b40214","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862666536292,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30366,"vrouter":"a7s12"},{"UuidKey":"a3997b38-99c3-466f-9b6b-3dec0bfe174b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862540430642,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27945,"vrouter":"a7s12"},{"UuidKey":"a30039ef-9968-412e-90d4-2f062f05f422","action":"pass","agg-bytes":474035522,"agg-packets":1413301,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1483228799715309,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56048,"vrouter":"a7s12"},{"UuidKey":"a1dd6a20-bf20-4c62-b447-2c5ebceb4557","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862549439813,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28756,"vrouter":"a7s12"},{"UuidKey":"a1a86051-e143-491c-89df-e1acff3c4e76","action":"pass","agg-bytes":474452456,"agg-packets":1415496,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1483228800313467,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43884,"vrouter":"a7s12"},{"UuidKey":"c5f54fc8-b92b-48d2-8e4f-b4f6ac4e501a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862693556353,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30675,"vrouter":"a7s12"},{"UuidKey":"9fdd5c96-5417-443b-b9a5-671119452140","action":"pass","agg-bytes":1808060370,"agg-packets":5399935,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54507,"protocol":6,"setup_time":1478625071631122,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"9f69ddfc-c73c-47c4-89e9-f07081d95345","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862657518803,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29828,"vrouter":"a7s12"},{"UuidKey":"9f451c04-1931-497f-968d-3cc34dc90071","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862963760677,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2333,"vrouter":"a7s12"},{"UuidKey":"9f3326c1-15c6-49d3-a0e1-dd2612540f76","action":"pass","agg-bytes":1808961058,"agg-packets":5394777,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1478625022469775,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56051,"vrouter":"a7s12"},{"UuidKey":"9cf8bd20-b7b9-499d-9f5d-d810569cf6e7","action":"pass","agg-bytes":473824208,"agg-packets":1414136,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56183,"protocol":6,"setup_time":1483228800152434,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9105,"vrouter":"a7s12"},{"UuidKey":"9b8b2499-e9e5-47b8-90eb-acbdb305086b","action":"pass","agg-bytes":1810817926,"agg-packets":5399081,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1478625051565195,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58426,"vrouter":"a7s12"},{"UuidKey":"99f3129a-392e-493c-8764-d412b6719311","action":"pass","agg-bytes":1809998040,"agg-packets":5400958,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47805,"protocol":6,"setup_time":1478625035511532,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"9958adcf-c5a2-4cd6-a541-a303f7aaaff3","action":"pass","agg-bytes":474396986,"agg-packets":1414567,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57222,"protocol":6,"setup_time":1483228800134131,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"e942ac0f-c4cd-4bb4-9020-06d98c35e9f0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862918732140,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1844,"vrouter":"a7s12"},{"UuidKey":"ef75ee20-2fdb-4ed9-a439-825f8c91eb75","action":"pass","agg-bytes":1808475352,"agg-packets":5398312,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56050,"protocol":6,"setup_time":1478625021467206,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"ef1f1fc1-dea1-404d-a0a4-8b0752c7ab01","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862603483560,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29283,"vrouter":"a7s12"},{"UuidKey":"ed898d55-a641-4cde-8333-e4ffca1221d6","action":"pass","agg-bytes":1810035936,"agg-packets":5397686,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1478625098727092,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53192,"vrouter":"a7s12"},{"UuidKey":"eaf7a1bb-dba4-4c63-bd05-2a3417b5f4a1","action":"pass","agg-bytes":1808952820,"agg-packets":5395006,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47806,"protocol":6,"setup_time":1478625036513079,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"eab42cf7-6aff-436b-9ec6-3562a6ca4729","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862513404282,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27840,"vrouter":"a7s12"},{"UuidKey":"ea720d11-758f-4aff-9d5a-e380aeb55c7f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862810637221,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32391,"vrouter":"a7s12"},{"UuidKey":"ea637c0d-1bf2-453e-aa71-c9e207d62395","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862666531291,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30366,"vrouter":"a7s12"},{"UuidKey":"e9992025-9306-4657-93cb-e8ac9eb957bd","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862738592220,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31506,"vrouter":"a7s12"},{"UuidKey":"e942c57a-0b01-49d2-a3e7-0024c49f6048","action":"pass","agg-bytes":1808869756,"agg-packets":5399552,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35152,"protocol":6,"setup_time":1478625054576520,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"f0f6810e-2a18-407f-b6e6-7e2e97273b1a","action":"pass","agg-bytes":473071300,"agg-packets":1412790,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53189,"protocol":6,"setup_time":1483228800093438,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"e70c1d77-b78e-4967-9c5f-290edb4b323d","action":"pass","agg-bytes":474117018,"agg-packets":1415539,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1483228800153133,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44889,"vrouter":"a7s12"},{"UuidKey":"e6b87dc1-b53e-4fcc-8677-ff0ac30d63f1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862774615945,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31605,"vrouter":"a7s12"},{"UuidKey":"e66476d2-1248-4a72-bef5-444159519968","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862648516639,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29810,"vrouter":"a7s12"},{"UuidKey":"e65576a6-2adb-4e65-bf73-814e79d353a0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862783620699,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31939,"vrouter":"a7s12"},{"UuidKey":"e43a8862-2af2-404e-9b5c-5ebb0b6b4ce2","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862801631872,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32388,"vrouter":"a7s12"},{"UuidKey":"e34c5016-9a2e-4e75-b344-53ab4ba07da9","action":"pass","agg-bytes":473366428,"agg-packets":1408854,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58425,"protocol":6,"setup_time":1483228799457309,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"e300769a-cbca-4794-a1d9-263d3877170a","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863044811781,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3785,"vrouter":"a7s12"},{"UuidKey":"e2fe7f46-9426-4f9e-ac68-43d5fa18ed3f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862558441910,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28831,"vrouter":"a7s12"},{"UuidKey":"f57901f1-026b-4a72-be3a-0c034c91922f","action":"pass","agg-bytes":472767532,"agg-packets":1412274,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53188,"protocol":6,"setup_time":1483228799927657,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"ffab970b-b69b-4241-b781-56e6aa13c55b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863107850696,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4721,"vrouter":"a7s12"},{"UuidKey":"fe756ec0-f08d-492c-905c-2bc3bab0cfd7","action":"pass","agg-bytes":474026712,"agg-packets":1414718,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50883,"protocol":6,"setup_time":1483228799715592,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"fab78cb4-cb26-4e13-94f5-7dcc7886d7d6","action":"pass","agg-bytes":473870834,"agg-packets":1414431,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43882,"protocol":6,"setup_time":1483228802135396,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"fa74c8ef-0a8d-44b7-ad2f-5833ef37b397","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862891704867,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":975,"vrouter":"a7s12"},{"UuidKey":"fa6d978d-bc0f-4b71-9688-d7ec83c4284f","action":"pass","agg-bytes":473886504,"agg-packets":1409206,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228799929728,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50542,"vrouter":"a7s12"},{"UuidKey":"f7fa208a-6b04-4f5d-9108-c2140d7d62f6","action":"pass","agg-bytes":473943032,"agg-packets":1414238,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54505,"protocol":6,"setup_time":1483228806583525,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"f6cc4f54-ed81-417f-9617-92425ea2d60f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862999784595,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2864,"vrouter":"a7s12"},{"UuidKey":"f68e709c-54f3-4c7c-80c1-67346474031e","action":"pass","agg-bytes":1808759976,"agg-packets":5400208,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1478625110786654,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50880,"vrouter":"a7s12"},{"UuidKey":"f59db293-a3e0-4ff4-96b9-392a1484607b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863206936910,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6431,"vrouter":"a7s12"},{"UuidKey":"e23adc86-81ea-49cc-a4fb-49c9c90a7a22","action":"pass","agg-bytes":473708134,"agg-packets":1415077,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":47808,"protocol":6,"setup_time":1483228799559520,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9103,"vrouter":"a7s12"},{"UuidKey":"f5324dfe-c0bf-422d-9342-f643ad6f34b6","action":"pass","agg-bytes":474144448,"agg-packets":1416098,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":49727,"protocol":6,"setup_time":1483228802174776,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9102,"vrouter":"a7s12"},{"UuidKey":"f4ce69d4-7ed8-4671-9de1-70f31d4f2302","action":"pass","agg-bytes":1811276198,"agg-packets":5399977,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57225,"protocol":6,"setup_time":1478625093704814,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"f4cc14ec-e162-49bd-92f6-e7a11e0464c7","action":"pass","agg-bytes":473636494,"agg-packets":1413297,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9108,"protocol":6,"setup_time":1483228800313968,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":38175,"vrouter":"a7s12"},{"UuidKey":"f497a4b8-686b-4867-a18c-9cb5a0d7e47a","action":"pass","agg-bytes":1807918706,"agg-packets":5397917,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50752,"protocol":6,"setup_time":1478625099737770,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"f3900a9d-ea8f-43f3-b8c8-1069d7a75dfc","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862828651434,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32466,"vrouter":"a7s12"},{"UuidKey":"f2bcc6c0-b94b-4da1-ab64-53e1620e3eb9","action":"pass","agg-bytes":1808305120,"agg-packets":5394400,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1478625044539116,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56179,"vrouter":"a7s12"},{"UuidKey":"f2085188-bbc7-4463-9f2a-8412ae5d9fa0","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862846663235,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":730,"vrouter":"a7s12"},{"UuidKey":"f196e30b-dfff-4e42-bfc5-0996a97f93fa","action":"pass","agg-bytes":474317084,"agg-packets":1411390,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57223,"protocol":6,"setup_time":1483228799929652,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"cb68293c-56c4-4264-af05-193b996733df","action":"pass","agg-bytes":473068862,"agg-packets":1410621,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50540,"protocol":6,"setup_time":1483228801716947,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"d14bb5a5-9596-4986-ac00-6f1f44161673","action":"pass","agg-bytes":475271022,"agg-packets":1415953,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1483228799714232,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36817,"vrouter":"a7s12"},{"UuidKey":"cfdd289f-5aea-4633-ba61-bd351c490d2d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863215948868,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":6606,"vrouter":"a7s12"},{"UuidKey":"cebb73bd-07ea-4b11-b58e-0e6ee8f8a8ea","action":"pass","agg-bytes":1808347660,"agg-packets":5396634,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":54509,"protocol":6,"setup_time":1478625073649027,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9110,"vrouter":"a7s12"},{"UuidKey":"ce9f7a14-42e1-417a-b6a7-ecb7c5176c3a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863116859919,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4754,"vrouter":"a7s12"},{"UuidKey":"ce2f4105-2c3a-49a1-9528-7661a1fbd6c5","action":"pass","agg-bytes":473728238,"agg-packets":1413327,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50754,"protocol":6,"setup_time":1483228799559819,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"ce025d2d-f65b-47a3-98b7-7ec60b2af79f","action":"pass","agg-bytes":1807314070,"agg-packets":5394841,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50755,"protocol":6,"setup_time":1478625102750751,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"cdd4bd28-ac5f-44fb-8570-ae502e9d883a","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862927734206,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1847,"vrouter":"a7s12"},{"UuidKey":"cbe1dac6-9ce3-45fd-88a3-cd2d6b1c388b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862963760646,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2333,"vrouter":"a7s12"},{"UuidKey":"cb9731ad-e77a-49f0-b3d3-90df99b1afff","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862792622207,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32385,"vrouter":"a7s12"},{"UuidKey":"d3b5cb96-30c4-4f20-b4f7-f8f535848022","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862882695139,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":913,"vrouter":"a7s12"},{"UuidKey":"c94aa498-f8cb-457d-99aa-4bf7f92f50bb","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863161885943,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":5724,"vrouter":"a7s12"},{"UuidKey":"c8ce6452-be24-490c-aec0-14aa81210134","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862711567980,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30721,"vrouter":"a7s12"},{"UuidKey":"c844defd-a7da-4820-9972-1b76f6d214f1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862882695176,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":913,"vrouter":"a7s12"},{"UuidKey":"c83063bf-8c9d-46e3-8c70-bd97eabdeff1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863224950369,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6609,"vrouter":"a7s12"},{"UuidKey":"c826acdd-8072-4365-8da8-ff97ecc2415e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863206936884,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":6431,"vrouter":"a7s12"},{"UuidKey":"c7c2784c-f1e0-479a-81ad-5d04a62ed614","action":"pass","agg-bytes":160159146,"agg-packets":1634277,"destip":"10.1.1.6","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1483228799242850,"sourceip":"10.1.1.5","sourcevn":"default-domain:admin:frontend","sport":18401,"vrouter":"a7s12"},{"UuidKey":"c6a048fb-24b4-4805-b9a5-2277ee57524d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862936744268,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1882,"vrouter":"a7s12"},{"UuidKey":"c6120fea-c2cb-42cd-9b53-16ed373fd760","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862576453682,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28881,"vrouter":"a7s12"},{"UuidKey":"dcf42d1d-dd7e-4b22-9655-6f0220320178","action":"pass","agg-bytes":473742664,"agg-packets":1413864,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1483228800093365,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53714,"vrouter":"a7s12"},{"UuidKey":"e1e26951-8b2c-4e3f-ad98-3de8abfbf9da","action":"pass","agg-bytes":1810453624,"agg-packets":5395034,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43883,"protocol":6,"setup_time":1478625106777071,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"e1c0df42-8916-441c-b9a7-59f0b4102e4f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862531418376,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27886,"vrouter":"a7s12"},{"UuidKey":"e18267ef-661c-4285-a850-8dbb25e041c2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862747594533,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31509,"vrouter":"a7s12"},{"UuidKey":"e02becc0-5ad7-4580-8952-74a9b29b4ad7","action":"pass","agg-bytes":1809695658,"agg-packets":5394131,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":38177,"protocol":6,"setup_time":1478625062604786,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9108,"vrouter":"a7s12"},{"UuidKey":"df9b7fdc-678a-45b2-8f42-10f2e7d1ddc8","action":"pass","agg-bytes":1810967602,"agg-packets":5393905,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1478625036523438,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47806,"vrouter":"a7s12"},{"UuidKey":"df81d3d5-f68e-4aa0-90e6-1ee433cb83c8","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862765605589,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31561,"vrouter":"a7s12"},{"UuidKey":"df433a77-f3a7-4dbe-b314-3ce5fceabfbe","action":"pass","agg-bytes":1807690180,"agg-packets":5401398,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50880,"protocol":6,"setup_time":1478625110786625,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"df365c7c-e617-4921-8e7d-e6fff2e3fb18","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862945746127,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1885,"vrouter":"a7s12"},{"UuidKey":"ddd26fd6-97e4-4bb3-9c51-9e164ec8befc","action":"pass","agg-bytes":1808504882,"agg-packets":5395885,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9111,"protocol":6,"setup_time":1478625074642494,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":51384,"vrouter":"a7s12"},{"UuidKey":"8d9be6a4-9278-4f87-af26-98cbac9e5850","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862684547530,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30629,"vrouter":"a7s12"},{"UuidKey":"dbdfac51-4f48-45db-9873-b79524468f00","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863233961169,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":6622,"vrouter":"a7s12"},{"UuidKey":"db087131-8a87-47fa-8157-7842d77ca8b1","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862540430890,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27945,"vrouter":"a7s12"},{"UuidKey":"da86701b-c7ca-4281-8814-42613305a7c6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863251985171,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6661,"vrouter":"a7s12"},{"UuidKey":"d9406176-edca-4609-b99a-f23bbf344d7a","action":"pass","agg-bytes":1807746306,"agg-packets":5399477,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43881,"protocol":6,"setup_time":1478625104768837,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"d67bc661-47bd-49f7-a328-08fce2f8e021","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862981771697,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2827,"vrouter":"a7s12"},{"UuidKey":"d65b7afe-2cc0-4d9f-8bf8-543a8ed4ea4b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863026800170,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3626,"vrouter":"a7s12"},{"UuidKey":"d5536b4b-cec9-43c4-9f16-abe0881aa06e","action":"pass","agg-bytes":1809791380,"agg-packets":5396686,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56051,"protocol":6,"setup_time":1478625022469735,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"d3f0bb0a-62d6-4b7f-976c-15d05d7085c7","action":"pass","agg-bytes":1807451656,"agg-packets":5394784,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1478625068634541,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58223,"vrouter":"a7s12"},{"UuidKey":"2a43b52e-610c-4b2d-ba48-452e71bfea99","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862756604290,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31556,"vrouter":"a7s12"},{"UuidKey":"34df4ffb-5e83-4168-8cce-3bbdbeece450","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863089838404,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4651,"vrouter":"a7s12"},{"UuidKey":"3342664a-bcf5-49c0-b3eb-551fafcd63cf","action":"pass","agg-bytes":1808743556,"agg-packets":5390082,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36821,"protocol":6,"setup_time":1478625088680818,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"32f96d08-b86d-4867-ac52-cae3c808e851","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862567452548,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28848,"vrouter":"a7s12"},{"UuidKey":"3134cf1c-5c98-4556-8d26-cbba8152fb68","action":"pass","agg-bytes":473811638,"agg-packets":1412281,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228799901114,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57221,"vrouter":"a7s12"},{"UuidKey":"2fce770c-07e3-4cb4-bc30-af8a323b6561","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862972761949,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2824,"vrouter":"a7s12"},{"UuidKey":"2e5f0bdf-a536-4656-85f5-be5143fc9f2e","action":"pass","agg-bytes":474099900,"agg-packets":1413622,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228800133556,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35154,"vrouter":"a7s12"},{"UuidKey":"2dd883f4-50dd-4717-9740-627a96a00925","action":"pass","agg-bytes":1810613712,"agg-packets":5396832,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625099737870,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50752,"vrouter":"a7s12"},{"UuidKey":"2cedab73-e407-4691-80e8-73bacfc5cb9c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862828651405,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32466,"vrouter":"a7s12"},{"UuidKey":"2abdb70a-6555-4c21-b700-99756f585aa8","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862801631927,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32388,"vrouter":"a7s12"},{"UuidKey":"362bd3be-270d-487f-b54e-22c116cdd3b7","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862549440165,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28756,"vrouter":"a7s12"},{"UuidKey":"29343c95-5ee2-474e-a1c9-4f3b582390e4","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862783620656,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31939,"vrouter":"a7s12"},{"UuidKey":"2915b2b3-ee9a-48d3-9e99-bf39fba86c17","action":"pass","agg-bytes":473455276,"agg-packets":1411512,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9105,"protocol":6,"setup_time":1483228799882484,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56180,"vrouter":"a7s12"},{"UuidKey":"284f1ced-1e86-46db-a6d9-4025db293859","action":"pass","agg-bytes":160159244,"agg-packets":1634278,"destip":"10.1.1.5","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1483228799243049,"sourceip":"10.1.1.6","sourcevn":"default-domain:admin:frontend","sport":18401,"vrouter":"a7s12"},{"UuidKey":"27fc6dc4-2ec1-4490-b1e1-1801b883a38c","action":"pass","agg-bytes":1808173698,"agg-packets":5393623,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50541,"protocol":6,"setup_time":1478625026482950,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"2760018a-8e4d-4f0c-83ff-7ad47ebb0813","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862837659573,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32486,"vrouter":"a7s12"},{"UuidKey":"23cf3a36-8474-46bd-ba75-15b68073ceda","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863035803623,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3782,"vrouter":"a7s12"},{"UuidKey":"227139cf-167a-4bb6-a44d-3e04bddb8ab1","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862774615887,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31605,"vrouter":"a7s12"},{"UuidKey":"21fbc59d-7a96-4d2f-89ca-381c863fd8ec","action":"pass","agg-bytes":473693732,"agg-packets":1415202,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53714,"protocol":6,"setup_time":1483228800093325,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"214438ce-4581-4207-832b-eb36ebaa0b24","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862900717275,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":978,"vrouter":"a7s12"},{"UuidKey":"41f5c885-c8e1-4f06-88ec-67b5ad3253ae","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862639506018,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29783,"vrouter":"a7s12"},{"UuidKey":"4c18506b-9899-441d-9bf8-db3ba0947262","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862684547579,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30629,"vrouter":"a7s12"},{"UuidKey":"4c0a29b4-5c92-43f6-8af1-6b80394e2f69","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862576453783,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28881,"vrouter":"a7s12"},{"UuidKey":"4b9926b5-ff0d-47d7-99ff-3595312070b7","action":"pass","agg-bytes":473799870,"agg-packets":1410195,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57224,"protocol":6,"setup_time":1483228802116421,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"481246f8-b481-45ae-84da-815a8cc27caa","action":"pass","agg-bytes":1807742822,"agg-packets":5397827,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58426,"protocol":6,"setup_time":1478625051565043,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9106,"vrouter":"a7s12"},{"UuidKey":"47e0c661-214e-4e9b-92bb-64318ec3bbc2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863089838602,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4651,"vrouter":"a7s12"},{"UuidKey":"460f469d-f895-494a-a0cc-e876de5343e6","action":"pass","agg-bytes":473645962,"agg-packets":1413471,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9119,"protocol":6,"setup_time":1483228799928332,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44892,"vrouter":"a7s12"},{"UuidKey":"44849659-8002-4a83-a344-cc611fcd7d52","action":"pass","agg-bytes":1809675092,"agg-packets":5394322,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53710,"protocol":6,"setup_time":1478625039522789,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9104,"vrouter":"a7s12"},{"UuidKey":"42925e5c-9d51-48af-a4d7-2c6ab0e8930f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863188916554,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5766,"vrouter":"a7s12"},{"UuidKey":"42441ecb-ab13-4983-b574-0ba4edd102fa","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862657518766,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29828,"vrouter":"a7s12"},{"UuidKey":"20b78f94-1d4e-407f-a380-ac77952c30e3","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862486381967,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27548,"vrouter":"a7s12"},{"UuidKey":"4123ce43-ac18-436a-a17d-17d31320fe2e","action":"pass","agg-bytes":1809751864,"agg-packets":5397678,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1478625104768873,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43881,"vrouter":"a7s12"},{"UuidKey":"4086e356-2d01-4578-abcd-54730ca977e0","action":"pass","agg-bytes":473210892,"agg-packets":1414398,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":57221,"protocol":6,"setup_time":1483228799900927,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9114,"vrouter":"a7s12"},{"UuidKey":"40071376-a4c3-4c7e-aa5e-7c83aa2c8d60","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863098847607,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4718,"vrouter":"a7s12"},{"UuidKey":"3f097795-5f41-484a-851b-326f8ae6d10d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862495392461,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27788,"vrouter":"a7s12"},{"UuidKey":"3eb6d124-7eb0-48b0-b07d-8ad5979ac57e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862747594391,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31509,"vrouter":"a7s12"},{"UuidKey":"3e1366d0-a9b4-49d6-8b91-1448f61bd298","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862504394195,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27809,"vrouter":"a7s12"},{"UuidKey":"3dea7e29-9699-4f09-a20d-44381341ae24","action":"pass","agg-bytes":1808782488,"agg-packets":5399660,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1478625028489515,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50543,"vrouter":"a7s12"},{"UuidKey":"3b4cfbf7-2629-4b5a-820c-3834a571339c","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863152885761,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5721,"vrouter":"a7s12"},{"UuidKey":"08bd32aa-afb6-477d-b786-8a037769ca5b","action":"pass","agg-bytes":473860248,"agg-packets":1415138,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50539,"protocol":6,"setup_time":1483228799287970,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"0e939910-3e8c-43c6-bef0-c98d1c0f6e9c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862846663207,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":730,"vrouter":"a7s12"},{"UuidKey":"0d8d0ebc-3679-4228-a45c-42c282336042","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862945746184,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1885,"vrouter":"a7s12"},{"UuidKey":"0ce37063-5fa6-4650-9254-e85e37ce782b","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862990773767,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2830,"vrouter":"a7s12"},{"UuidKey":"0c339972-af63-4a9b-8cdc-3dcc338b7303","action":"pass","agg-bytes":473130260,"agg-packets":1414222,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1483228799715635,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50883,"vrouter":"a7s12"},{"UuidKey":"0bbd327d-61aa-4847-869d-86478cf1507d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862990773739,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":2830,"vrouter":"a7s12"},{"UuidKey":"0b4f5229-4b94-4e28-9340-8c44a728eca2","action":"pass","agg-bytes":474411512,"agg-packets":1416662,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36817,"protocol":6,"setup_time":1483228799714183,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"0a91e7a2-ef72-4ae3-b153-abd42d609c65","action":"pass","agg-bytes":474298886,"agg-packets":1414843,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53190,"protocol":6,"setup_time":1483228800152469,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"0a7c0e82-c66f-43f8-8d0d-9fd3e1bf9c99","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862900717314,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":978,"vrouter":"a7s12"},{"UuidKey":"08e48c40-b0bd-40cf-a020-3d152784b30e","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862513404201,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27840,"vrouter":"a7s12"},{"UuidKey":"0f77c9ec-5ae1-4a80-a834-728abfec5af8","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863152885723,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":5721,"vrouter":"a7s12"},{"UuidKey":"07c80b14-5e76-48bb-887f-821c1307fb27","action":"pass","agg-bytes":1810378852,"agg-packets":5392318,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625085672627,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36818,"vrouter":"a7s12"},{"UuidKey":"077ca2c3-e82e-4f69-8570-c2bd2edc07d7","action":"pass","agg-bytes":1809674684,"agg-packets":5395920,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9113,"protocol":6,"setup_time":1478625088681108,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":36821,"vrouter":"a7s12"},{"UuidKey":"069960c6-4d13-4049-abe7-1c6f9caa4cb0","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863098847554,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4718,"vrouter":"a7s12"},{"UuidKey":"050771a8-10ed-407c-8b82-284cd4b44918","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863215948911,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6606,"vrouter":"a7s12"},{"UuidKey":"0397e3a9-efed-4d3a-9747-fe75ec0981c2","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862864686974,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":877,"vrouter":"a7s12"},{"UuidKey":"03414545-c2c7-43f5-bc7d-79743bfdd02e","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862612483077,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29727,"vrouter":"a7s12"},{"UuidKey":"02f1735f-5562-424a-b98a-2797b5092f53","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863053816339,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":3812,"vrouter":"a7s12"},{"UuidKey":"02a04753-9be4-49d6-907b-f83f81c0138c","action":"pass","agg-bytes":474269978,"agg-packets":1413849,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":35156,"protocol":6,"setup_time":1483228802612282,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9107,"vrouter":"a7s12"},{"UuidKey":"169d10d2-4544-438f-b58c-570996303dff","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862567452637,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28848,"vrouter":"a7s12"},{"UuidKey":"2058748e-86a0-4326-97d5-1eeca27cc4f2","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862585463675,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28909,"vrouter":"a7s12"},{"UuidKey":"1fd2fc97-7338-4166-aa39-511e197ba73f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863233961237,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6622,"vrouter":"a7s12"},{"UuidKey":"1dd0c348-d47a-44fd-95bd-3062e7b7cff7","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862855665789,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":874,"vrouter":"a7s12"},{"UuidKey":"1ce0168e-e92a-4aa0-9a17-29020fcbfb33","action":"pass","agg-bytes":474359470,"agg-packets":1415209,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44892,"protocol":6,"setup_time":1483228799928278,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"1cd7c3f9-ce48-4b3e-9d8c-c8cebe341456","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862810637185,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32391,"vrouter":"a7s12"},{"UuidKey":"19be7945-7a4a-4fd2-a82c-444abaac9749","action":"pass","agg-bytes":1810743886,"agg-packets":5401979,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44278,"protocol":6,"setup_time":1478625080663103,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9112,"vrouter":"a7s12"},{"UuidKey":"18e6e4de-cb32-46a1-a895-a56b1771946f","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862630504110,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29768,"vrouter":"a7s12"},{"UuidKey":"18565b44-5c7e-4e87-adfc-f9e4b2128596","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862702558732,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30679,"vrouter":"a7s12"},{"UuidKey":"177bcb69-1524-4082-86c0-b9403bd0a98c","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862504394116,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27809,"vrouter":"a7s12"},{"UuidKey":"4d13ad6c-980a-45f2-aa24-fe2163baa273","action":"pass","agg-bytes":473509722,"agg-packets":1411481,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228799929612,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58221,"vrouter":"a7s12"},{"UuidKey":"15e3de3b-d310-44c0-933b-112501b97a99","action":"pass","agg-bytes":1808469574,"agg-packets":5393999,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36818,"protocol":6,"setup_time":1478625085672590,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"15d90ff4-0298-4d60-b919-5e3056acf0de","action":"pass","agg-bytes":1808730812,"agg-packets":5398352,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1478625021467242,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56050,"vrouter":"a7s12"},{"UuidKey":"14274b76-e6d9-4828-91d7-2d3dc1599711","action":"pass","agg-bytes":473333106,"agg-packets":1411657,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":56049,"protocol":6,"setup_time":1483228799715787,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9100,"vrouter":"a7s12"},{"UuidKey":"140684d2-01d7-4b95-9e3c-fab7d3385dfc","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862909722566,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":1774,"vrouter":"a7s12"},{"UuidKey":"12bda384-234f-496e-8275-c491dc744dac","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862819648591,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":32425,"vrouter":"a7s12"},{"UuidKey":"11fb2010-b2bf-43da-bd24-413a6fb00cbe","action":"pass","agg-bytes":473597246,"agg-packets":1414247,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228799925716,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49730,"vrouter":"a7s12"},{"UuidKey":"10dba9ea-e5ab-45c1-a8f9-6953e4f36f96","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862837659645,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":32486,"vrouter":"a7s12"},{"UuidKey":"1095681d-f823-402a-b782-917d697ef0cf","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863179901341,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":5763,"vrouter":"a7s12"},{"UuidKey":"71d7d08e-6b32-47fe-b5c7-e4f7a5f8183a","action":"pass","agg-bytes":473652506,"agg-packets":1412193,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228799927695,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53188,"vrouter":"a7s12"},{"UuidKey":"7afb2b9a-410b-4bba-bcc3-00b4ddd5242f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863080836262,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4066,"vrouter":"a7s12"},{"UuidKey":"79e2d400-28cd-4bca-a6df-382b21688906","action":"pass","agg-bytes":474097710,"agg-packets":1413661,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50756,"protocol":6,"setup_time":1483228800313726,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9116,"vrouter":"a7s12"},{"UuidKey":"7848f747-afce-402e-aa10-c5cbb732d0fe","action":"pass","agg-bytes":1808750150,"agg-packets":5400011,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1478625054576681,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35152,"vrouter":"a7s12"},{"UuidKey":"78040e3d-7754-45b0-a220-9745c2ae2274","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862927734240,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1847,"vrouter":"a7s12"},{"UuidKey":"77e54f5b-cd44-4e4d-a385-1c194d01e0ba","action":"pass","agg-bytes":474136562,"agg-packets":1418221,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1483228800152414,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53711,"vrouter":"a7s12"},{"UuidKey":"77ace095-5362-4a8a-97b8-1e63959a3d15","action":"pass","agg-bytes":474359058,"agg-packets":1415193,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9107,"protocol":6,"setup_time":1483228801931742,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":35155,"vrouter":"a7s12"},{"UuidKey":"772c875c-a8fe-4d3e-9571-9777f81e59f9","action":"pass","agg-bytes":1807965120,"agg-packets":5399510,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625102750788,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50755,"vrouter":"a7s12"},{"UuidKey":"74d78a11-f301-495e-bd54-ec91140b6a5b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862891704827,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":975,"vrouter":"a7s12"},{"UuidKey":"73ce07ee-69b1-438f-8d81-5b41d17e2640","action":"pass","agg-bytes":473772094,"agg-packets":1409831,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9114,"protocol":6,"setup_time":1483228799929675,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":57223,"vrouter":"a7s12"},{"UuidKey":"7d868439-3838-4eeb-8779-e05abe095950","action":"pass","agg-bytes":474987262,"agg-packets":1414319,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50879,"protocol":6,"setup_time":1483228800114186,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9118,"vrouter":"a7s12"},{"UuidKey":"71670f95-d881-40ea-926f-8a06daaaa6ff","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863224950323,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":6609,"vrouter":"a7s12"},{"UuidKey":"70d057df-cbf9-499d-9bbe-71312c29e41f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863125862686,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4757,"vrouter":"a7s12"},{"UuidKey":"6ffb1594-ec00-4db6-ad78-23e4aa357202","action":"pass","agg-bytes":474657274,"agg-packets":1412129,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":51387,"protocol":6,"setup_time":1483228799926918,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9111,"vrouter":"a7s12"},{"UuidKey":"6d3c9d1f-4abc-4dd0-bb6e-c3d66b7442bd","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862486381938,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27548,"vrouter":"a7s12"},{"UuidKey":"6cca97ab-8e69-476d-9336-bc7b0311c367","action":"pass","agg-bytes":474533510,"agg-packets":1414985,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9115,"protocol":6,"setup_time":1483228800152482,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53190,"vrouter":"a7s12"},{"UuidKey":"6aa30ea8-e3df-4cb3-b0e7-a0ec086e9258","action":"pass","agg-bytes":1809941446,"agg-packets":5402165,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9112,"protocol":6,"setup_time":1478625080663284,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":44278,"vrouter":"a7s12"},{"UuidKey":"69d784e8-aa3c-4cc9-ac4f-8cf3ea2aa794","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862621492757,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29730,"vrouter":"a7s12"},{"UuidKey":"69028f35-ba94-4b02-9d82-3916cc4a56ea","action":"pass","agg-bytes":474267050,"agg-packets":1414319,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58220,"protocol":6,"setup_time":1483228800153283,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"84466486-84ab-4fc5-83ef-c35243168952","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863080836236,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4066,"vrouter":"a7s12"},{"UuidKey":"8ca8f255-b89e-4483-bc71-a8247c628390","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863017796083,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2923,"vrouter":"a7s12"},{"UuidKey":"8b3b78b7-d010-4510-9abf-fe007b3cd757","action":"pass","agg-bytes":474095734,"agg-packets":1412537,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9101,"protocol":6,"setup_time":1483228799288082,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50539,"vrouter":"a7s12"},{"UuidKey":"8ad67e72-aa75-4301-8a41-96ea806e4a58","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863116860006,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4754,"vrouter":"a7s12"},{"UuidKey":"897d76da-3c37-403f-8f78-c61164990dc6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862594466938,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":28927,"vrouter":"a7s12"},{"UuidKey":"87c7ec2a-5b18-4a07-bb5c-5ff99ffd8b2f","action":"pass","agg-bytes":473642192,"agg-packets":1410308,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9106,"protocol":6,"setup_time":1483228799457594,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58425,"vrouter":"a7s12"},{"UuidKey":"87690c50-38e6-4511-92d4-4b64dd666b79","action":"pass","agg-bytes":1808486618,"agg-packets":5395303,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9117,"protocol":6,"setup_time":1478625106777115,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":43883,"vrouter":"a7s12"},{"UuidKey":"8678c61e-d9fa-4156-9f91-08807d9ff1dc","action":"pass","agg-bytes":473452468,"agg-packets":1415010,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44889,"protocol":6,"setup_time":1483228800153115,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"86661158-e19d-4aff-b9e7-5c1bded93687","action":"pass","agg-bytes":1810391096,"agg-packets":5392714,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9104,"protocol":6,"setup_time":1478625039522848,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":53710,"vrouter":"a7s12"},{"UuidKey":"8641c687-df4f-4753-9d1c-552e01682a33","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862729581064,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31438,"vrouter":"a7s12"},{"UuidKey":"685a338d-6601-4174-8ef8-66326b6e9786","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862873692483,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":906,"vrouter":"a7s12"},{"UuidKey":"832449c9-2486-401e-8b23-f1eb415499fe","action":"pass","agg-bytes":1808833378,"agg-packets":5396353,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":44890,"protocol":6,"setup_time":1478625115801862,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9119,"vrouter":"a7s12"},{"UuidKey":"830782b3-5259-4f83-b6f6-0644db65032b","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862495392495,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27788,"vrouter":"a7s12"},{"UuidKey":"829f80dd-84e6-4292-96a3-648e9d3225be","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862936744315,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1882,"vrouter":"a7s12"},{"UuidKey":"8219dbfb-bebe-4d8a-b436-d7e236e412ce","action":"pass","agg-bytes":1807732680,"agg-packets":5398932,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":36819,"protocol":6,"setup_time":1478625086674383,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9113,"vrouter":"a7s12"},{"UuidKey":"81fe7ecb-dd67-466b-b78b-f13dfd3f495d","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863143873665,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":5151,"vrouter":"a7s12"},{"UuidKey":"8163d676-6900-429e-9dda-0ea4c34e741b","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863242977177,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":6643,"vrouter":"a7s12"},{"UuidKey":"7f33dea5-97c9-4d48-9258-900ef605e167","action":"pass","agg-bytes":473516750,"agg-packets":1412733,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58221,"protocol":6,"setup_time":1483228799929416,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"7e4adafd-2027-4987-9e4a-9786e0a46702","action":"pass","agg-bytes":1809609478,"agg-packets":5395617,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9108,"protocol":6,"setup_time":1478625062604817,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":38177,"vrouter":"a7s12"},{"UuidKey":"5506a0c2-b8e4-4e9f-89bc-ee6643312f72","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862585463633,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28909,"vrouter":"a7s12"},{"UuidKey":"5f1de339-2ebe-409a-8fb6-73b5f110809e","action":"pass","agg-bytes":1807618744,"agg-packets":5389536,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":58223,"protocol":6,"setup_time":1478625068634496,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9109,"vrouter":"a7s12"},{"UuidKey":"5cbd4174-0837-474d-88a7-a449685ced27","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862603483533,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":29283,"vrouter":"a7s12"},{"UuidKey":"5c82ec78-de7b-4d0a-9ff5-ea25e1525319","action":"pass","agg-bytes":1808582458,"agg-packets":5399493,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":53192,"protocol":6,"setup_time":1478625098727034,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9115,"vrouter":"a7s12"},{"UuidKey":"5b6701e2-9bbf-451e-bc5a-d9adf3f64dc6","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862675538252,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30626,"vrouter":"a7s12"},{"UuidKey":"5a37e0e3-1648-4875-ab56-6b0c0fb61758","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862522406525,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":27844,"vrouter":"a7s12"},{"UuidKey":"58d5f36e-ed86-4185-b2cc-7bf558f391a5","action":"pass","agg-bytes":1809243854,"agg-packets":5398867,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1478625100743975,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50753,"vrouter":"a7s12"},{"UuidKey":"566068c3-a229-47a6-93e6-a82b10026275","action":"pass","agg-bytes":474523890,"agg-packets":1413687,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9118,"protocol":6,"setup_time":1483228800114228,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50879,"vrouter":"a7s12"},{"UuidKey":"557f5f52-71b1-4f91-85bc-bee786d9edf6","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862864687010,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":877,"vrouter":"a7s12"},{"UuidKey":"551273c9-2335-4f58-9f11-0a96de2f7c54","action":"pass","agg-bytes":474155390,"agg-packets":1410387,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":50542,"protocol":6,"setup_time":1483228799929707,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9101,"vrouter":"a7s12"},{"UuidKey":"5f814e1f-834b-4455-ad40-f3dd5d6fae83","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863134875537,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4800,"vrouter":"a7s12"},{"UuidKey":"5409f722-d7cb-4b3b-bd0b-5dce88cba791","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862972761975,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":2824,"vrouter":"a7s12"},{"UuidKey":"50c39545-dd69-4bbf-ac11-80299525afcc","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862558441874,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":28831,"vrouter":"a7s12"},{"UuidKey":"50932449-db6a-498b-9e25-b9f8cd2a4c77","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863125862652,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":4757,"vrouter":"a7s12"},{"UuidKey":"4fcb8848-c01d-4a1c-96b5-257ff73bd106","action":"pass","agg-bytes":1808214284,"agg-packets":5391524,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1478625073649057,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54509,"vrouter":"a7s12"},{"UuidKey":"4fc4e089-a1fc-4aaf-a331-cc1c8ce54f93","action":"pass","agg-bytes":1809363790,"agg-packets":5400923,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9103,"protocol":6,"setup_time":1478625035511579,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":47805,"vrouter":"a7s12"},{"UuidKey":"4e61865f-ec0f-47be-a667-be528d0b8573","action":"pass","agg-bytes":474009092,"agg-packets":1413866,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9102,"protocol":6,"setup_time":1483228802174811,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":49727,"vrouter":"a7s12"},{"UuidKey":"4e22e45f-00c6-4144-a7f7-f2f9062b65c4","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862675538334,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30626,"vrouter":"a7s12"},{"UuidKey":"4deedbc6-1eba-4574-b1fd-a875a6a6bf2f","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863197918397,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5809,"vrouter":"a7s12"},{"UuidKey":"6392e389-4b05-4ac4-a3e1-babad3115d9d","action":"pass","agg-bytes":473383434,"agg-packets":1413171,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9109,"protocol":6,"setup_time":1483228800153301,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":58220,"vrouter":"a7s12"},{"UuidKey":"68418cad-359b-47ed-92f8-6348a7b49c6a","action":"pass","agg-bytes":84,"agg-packets":1,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863134875569,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":4800,"vrouter":"a7s12"},{"UuidKey":"67a034dd-7ec1-47cb-a94c-76f509ea3ed5","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863053814957,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3812,"vrouter":"a7s12"},{"UuidKey":"6774bbfa-2acd-4e03-8b67-c966b250fdda","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863044811754,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":3785,"vrouter":"a7s12"},{"UuidKey":"67728105-06c9-4a41-b117-0eec7fd88f3f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862954756860,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1942,"vrouter":"a7s12"},{"UuidKey":"660be59e-4e19-4b10-a4f5-5de26f18e26b","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862720570950,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":30724,"vrouter":"a7s12"},{"UuidKey":"655acb9a-9e1c-47a9-892f-23247f1a1733","action":"pass","agg-bytes":473416150,"agg-packets":1411259,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9100,"protocol":6,"setup_time":1483228799715852,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":56049,"vrouter":"a7s12"},{"UuidKey":"64f57acc-458f-4cf3-8c2f-e3febc13035f","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484863143873692,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":5151,"vrouter":"a7s12"},{"UuidKey":"646efdec-c1fc-489a-a375-e662be3aa58c","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862909722597,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":1774,"vrouter":"a7s12"},{"UuidKey":"644bc582-8cc3-48b7-a756-c8123f905bb7","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862765605518,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":31561,"vrouter":"a7s12"},{"UuidKey":"0118202d-ed98-4f09-880f-13f2429b7786","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862756604348,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":31556,"vrouter":"a7s12"},{"UuidKey":"632ab520-11ce-4bdd-b873-d503216448fa","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862639506107,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":29783,"vrouter":"a7s12"},{"UuidKey":"63242d49-267e-45c7-b8c7-06143756d286","action":"pass","agg-bytes":0,"agg-packets":0,"destip":"30.30.31.2","destvn":"default-domain:default-project:ip-fabric","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862522406490,"sourceip":"169.254.32.0","sourcevn":"default-domain:admin:testvn_webui","sport":27844,"vrouter":"a7s12"},{"UuidKey":"629662cb-61b5-4d95-b850-e19d64986c24","action":"pass","agg-bytes":1810563144,"agg-packets":5395772,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1478625071631155,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54507,"vrouter":"a7s12"},{"UuidKey":"624efc69-e445-4a65-91d0-8195cacc53fb","action":"pass","agg-bytes":474226410,"agg-packets":1413041,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9116,"protocol":6,"setup_time":1483228800313745,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":50756,"vrouter":"a7s12"},{"UuidKey":"621005e0-73a5-4688-abb1-cc9a35376ed7","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862693556422,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":30675,"vrouter":"a7s12"},{"UuidKey":"6097b316-5aab-4182-9d7a-2aeb2b2ebe8d","action":"pass","agg-bytes":168,"agg-packets":2,"destip":"169.254.32.0","destvn":"default-domain:admin:testvn_webui","direction_ing":1,"dport":8080,"protocol":1,"setup_time":1484862855665879,"sourceip":"30.30.31.2","sourcevn":"default-domain:default-project:ip-fabric","sport":874,"vrouter":"a7s12"},{"UuidKey":"6015cf2c-f698-4361-adc8-f69091c93da5","action":"pass","agg-bytes":474822928,"agg-packets":1416000,"destip":"10.1.1.3","destvn":"default-domain:admin:frontend","direction_ing":1,"dport":43884,"protocol":6,"setup_time":1483228800313449,"sourceip":"10.2.1.3","sourcevn":"default-domain:admin:backend","sport":9117,"vrouter":"a7s12"},{"UuidKey":"5fa00954-0c99-4d2a-bd84-e7c7c132d27a","action":"pass","agg-bytes":473323238,"agg-packets":1414019,"destip":"10.2.1.3","destvn":"default-domain:admin:backend","direction_ing":1,"dport":9110,"protocol":6,"setup_time":1483228806583558,"sourceip":"10.1.1.3","sourcevn":"default-domain:admin:frontend","sport":54505,"vrouter":"a7s12"}],"total":306,"queryJSON":{"table":"FlowRecordTable","start_time":1484862660000000,"end_time":1484863260000000,"select_fields":["direction_ing","vrouter","sourcevn","sourceip","destvn","destip","protocol","sport","dport","setup_time","agg-packets","agg-bytes","action"],"filter":[[]],"limit":150000,"sort":1,"dir":1},"chunk":1,"chunkSize":306,"serverSideChunking":true}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Scale = __webpack_require__(2);

var palette = _d3Scale.schemeCategory20; /*
                                          * Copyright (c) Juniper Networks, Inc. All rights reserved.
                                          */

var paletteSoft = ['#3182bd', '#6baed6', '#9ecae1', '#c6dbef', '#e6550d', '#fd8d3c', '#fdae6b', '#fdd0a2', '#31a354', '#74c476', '#a1d99b', '#c7e9c0', '#756bb1', '#9e9ac8', '#bcbddc', '#dadaeb', '#636363', '#969696', '#bdbdbd', '#d9d9d9'];

exports.default = {
  d3ColorScheme10: _d3Scale.schemeCategory10,
  d3ColorScheme20: _d3Scale.schemeCategory20,
  paletteSoft: paletteSoft,
  palette: palette
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(35);

var _lodash = __webpack_require__(3);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(8);

var _jquery2 = _interopRequireDefault(_jquery);

var _backbone = __webpack_require__(37);

var _backbone2 = _interopRequireDefault(_backbone);

var _d = __webpack_require__(2);

var _d2 = _interopRequireDefault(_d);

__webpack_require__(36);

var _legend = __webpack_require__(19);

var _legend2 = _interopRequireDefault(_legend);

var _timeline = __webpack_require__(22);

var _timeline2 = _interopRequireDefault(_timeline);

var _tooltip = __webpack_require__(23);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _stackedBarChart = __webpack_require__(21);

var _stackedBarChart2 = _interopRequireDefault(_stackedBarChart);

var _groupedBarChart = __webpack_require__(18);

var _groupedBarChart2 = _interopRequireDefault(_groupedBarChart);

var _live = __webpack_require__(20);

var _live2 = _interopRequireDefault(_live);

var _multipleShapes = __webpack_require__(15);

var _multipleShapes2 = _interopRequireDefault(_multipleShapes);

var _map = __webpack_require__(14);

var _map2 = _interopRequireDefault(_map);

var _pie = __webpack_require__(25);

var _pie2 = _interopRequireDefault(_pie);

var _dendrogram = __webpack_require__(24);

var _dendrogram2 = _interopRequireDefault(_dendrogram);

var _basic = __webpack_require__(13);

var _basic2 = _interopRequireDefault(_basic);

var _radialLinebar = __webpack_require__(26);

var _radialLinebar2 = _interopRequireDefault(_radialLinebar);

var _navigation = __webpack_require__(17);

var _navigation2 = _interopRequireDefault(_navigation);

var _linebarPieNav = __webpack_require__(16);

var _linebarPieNav2 = _interopRequireDefault(_linebarPieNav);

var _sankey = __webpack_require__(12);

var _sankey2 = _interopRequireDefault(_sankey);

var _singleLine = __webpack_require__(30);

var _singleLine2 = _interopRequireDefault(_singleLine);

var _singleStackedBar = __webpack_require__(34);

var _singleStackedBar2 = _interopRequireDefault(_singleStackedBar);

var _singleGroupedBar = __webpack_require__(29);

var _singleGroupedBar2 = _interopRequireDefault(_singleGroupedBar);

var _singleArea = __webpack_require__(27);

var _singleArea2 = _interopRequireDefault(_singleArea);

var _singleScatterPlot = __webpack_require__(33);

var _singleScatterPlot2 = _interopRequireDefault(_singleScatterPlot);

var _singlePie = __webpack_require__(31);

var _singlePie2 = _interopRequireDefault(_singlePie);

var _singleCompositeY = __webpack_require__(28);

var _singleCompositeY2 = _interopRequireDefault(_singleCompositeY);

var _singleRadialLine = __webpack_require__(32);

var _singleRadialLine2 = _interopRequireDefault(_singleRadialLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Single

// import controls from '../../linebar-chart/control-panel'
window.Backbone = _backbone2.default;
/**
 * structure of an example:
 * 'example title': {
 *   view: instance of chart view <= required
 *   description: demonstrated features
 * }
 */

// Grouped

// Radial

// Scatter
// import scatterPlotBuckets from '../../bubble-chart/bucketization'

// LineBar
/*
 * Copyright (c) Juniper Networks, Inc. All rights reserved.
 */
/* global $ */

var allExamples = {
  'lineBar': {
    'Legend': {
      view: _legend2.default
    },
    // 'Controls': {
    // view: controls,
    // },
    'Timeline': {
      view: _timeline2.default
    },
    'Tooltips': {
      view: _tooltip2.default
    },
    'Stacked Bar': {
      view: _stackedBarChart2.default
    },
    'Grouped Bar': {
      view: _groupedBarChart2.default
    },
    'RequireJS': {
      view: {
        type: 'RJS',
        entryPoint: './examples/linebar-chart/requirejs/requirejs-config.js'
      }
    },
    'Live Data': {
      view: _live2.default
    }
  },
  'bubble': {
    // 'Buckets': {
    // view: scatterPlotBuckets,
    // },
    'Shapes': {
      view: _multipleShapes2.default
    },
    'Map': {
      view: _map2.default
    }
  },
  'radial': {
    'Dendrogram': {
      view: _dendrogram2.default
    },
    'Pie Chart': {
      view: _pie2.default
    },
    'Line Bar': {
      view: _radialLinebar2.default
    }
  },
  'area': {
    'Basic': {
      view: _basic2.default
    }
  },
  'single': {
    'Line Chart': {
      view: _singleLine2.default
    },
    'Grouped Bar Chart': {
      view: _singleGroupedBar2.default
    },
    'Stacked Bar Chart': {
      view: _singleStackedBar2.default
    },
    'Area Chart': {
      view: _singleArea2.default
    },
    'Scatter Plot': {
      view: _singleScatterPlot2.default
    },
    'Pie Chart': {
      view: _singlePie2.default,
      desc: 'After 2 seconds the chart is set with changed config and then updated with new data'
    },
    'Composite Y Chart': {
      view: _singleCompositeY2.default
    },
    'Radial Line Chart': {
      view: _singleRadialLine2.default
    }
  },
  'grouped': {
    'Navigation': {
      view: _navigation2.default,
      desc: 'Grouped chart with Navigation component for all of them. </br>\n      First line chart in second row is not updated as it is plotted with different values at x axis'
    },
    '2 LineBar 1 Pie Nav': {
      view: _linebarPieNav2.default,
      desc: 'All charts except first are updated by navigation component. </br>\n      Crosshair for the first chart needs container specified in it\'s config as there are more than one shared svg in this chart'
    }
  },
  'advance': {
    'Sankey': {
      view: _sankey2.default
    }
  }
};

$('.nav-sidebar').metisMenu();
$('.mobilebar .navbar-toggle').on('click', function (e) {
  e.preventDefault();
  $('body').addClass('showmenu');
});
$('.overlay').on('click', function (e) {
  e.preventDefault();
  $('body').removeClass('showmenu');
});

var $content = $('.crailui__content');
var $chartBox = $('#chartBox');

_lodash2.default.forEach(allExamples, function (examples, chartCategory) {
  var $links = $('#' + chartCategory + 'Links');
  _lodash2.default.forEach(examples, function (example, title) {
    example.title = title;
    example.category = chartCategory;
    var $link = createLink(example);
    $links.append($('<li>').append($link));
  });
});

function _viewRenderInit(_ref) {
  var view = _ref.view,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? '' : _ref$title,
      _ref$desc = _ref.desc,
      desc = _ref$desc === undefined ? '' : _ref$desc;

  var currentView = $chartBox.data('chartView');
  if (currentView) {
    currentView.remove();
    if (currentView.stopUpdating) currentView.stopUpdating();
  }

  $content.find('#page-title').text(title);
  $content.find('#page-description').html(desc);
  $chartBox.empty();
  // set current view
  $chartBox.data('chartView', view);
  view.render();
}

function createLink(example) {
  var chartType = example.category || '';
  var view = example.view;
  var cleaned = encodeURIComponent(example.title.replace(/\s/g, ''));
  var link = '<a class="example-link ' + chartType + cleaned + '" href="#' + chartType + cleaned + '">\n    <span class="nav-text">' + example.title + '</span>\n    </a>';
  var $link = $(link);
  $link.click(function (e) {
    $('.example-link').removeClass('active');
    $link.addClass('active');

    if (view.type === 'RJS') {
      _initRJS(example);
    } else {
      _viewRenderInit(example);
    }
  });
  return $link;
}

function _initRJS(example) {
  var RJSInitFlag = 'RJSInstantiated';
  var view = example.view;
  if (view.status && view.status === RJSInitFlag) {
    _viewRenderInit(example);
  } else {
    // Load the entry point
    var entryPoint = document.createElement('script');
    entryPoint.src = 'node_modules/requirejs/require.js';
    entryPoint.setAttribute('data-main', view.entryPoint);
    document.body.append(entryPoint);
    // Once the require entry point load is complete (not just the file load but all dependencies),
    // the script callback will invoke render callback.
    window.AMDRenderCB = function (RJSChartView) {
      example.view = _lodash2.default.extend({ status: RJSInitFlag }, view, RJSChartView);
      _viewRenderInit(example);
    };
  }
}

var exampleName = window.location.hash.substr(1) || 'lineBarLegend';
$('.' + exampleName).find('span').click();

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(6);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- Copyright (c) Juniper Networks, Inc. All rights reserved. -->\n\n<div class=\"ccpanels\">\n  <div class=\"ccpanel ccpanel--full\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"legend-panel-id\"></div>\n      <div component=\"compositey-chart-id\">\n        <div component='message-id' style=\"position: initial;\"></div>\n      </div>\n    </div>\n  </div>\n  \n  <div class=\"ccpanel ccpanel--8\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"legend-panel-id2\"></div>\n      <div component=\"compositey-chart-id2\"></div>\n    </div>\n  </div>\n  <div class=\"ccpanel ccpanel--4\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"pie-chart-id\"></div>\n      <div component='legend-pie'></div>\n    </div>\n  </div>\n  <div class=\"ccpanel ccpanel--full\"> \n    <div class=\"ccpanel__inner\">\n      <div component=\"navigation-id\"></div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(6);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<!-- Copyright (c) Juniper Networks, Inc. All rights reserved. -->\n\n<div class=\"ccpanels\">\n  <div class=\"ccpanel\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"stacked-bar-id\"></div>\n    </div>\n  </div>\n  \n  <div class=\"ccpanel\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"area-id\"></div>\n    </div>\n  </div>\n  \n  <div class=\"ccpanel\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"line-id\"></div>\n    </div>\n  </div>\n  \n  <div class=\"ccpanel\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"grouped-bar-id\"></div>\n    </div>\n  </div>\n  \n  <div class=\"ccpanel ccpanel--full\">\n    <div class=\"ccpanel__inner\">\n      <div component=\"navigation-id\"></div>\n    </div>\n  </div>\n</div>\n";
},"useData":true});

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(6);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\"> \n  <div component=\"compositey-id\" class=\"col-md-11 col-sm-11 col-xs-11\"></div> \n  <div component=\"control-panel-id\" class=\"col-md-1 col-sm-1 col-xs-1\"></div> \n</div> \n";
},"useData":true});

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(6);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div component=\"compositey-id1\" class=\"col-md-12\"></div>\n<div component=\"compositey-id2\" class=\"col-md-12\"></div>\n";
},"useData":true});

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(6);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"row\"> \n  <div component=\"donut-id\" class=\"col-md-11 col-sm-11 col-xs-11\"></div> \n  <div component=\"control-panel-id\" class=\"col-md-1 col-sm-1 col-xs-1\"></div> \n</div> \n";
},"useData":true});

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _handlebarsBase = __webpack_require__(10);

var base = _interopRequireWildcard(_handlebarsBase);

// Each of these augment the Handlebars object. No need to setup here.
// (This is done to easily share code between commonjs and browse envs)

var _handlebarsSafeString = __webpack_require__(66);

var _handlebarsSafeString2 = _interopRequireDefault(_handlebarsSafeString);

var _handlebarsException = __webpack_require__(5);

var _handlebarsException2 = _interopRequireDefault(_handlebarsException);

var _handlebarsUtils = __webpack_require__(4);

var Utils = _interopRequireWildcard(_handlebarsUtils);

var _handlebarsRuntime = __webpack_require__(65);

var runtime = _interopRequireWildcard(_handlebarsRuntime);

var _handlebarsNoConflict = __webpack_require__(64);

var _handlebarsNoConflict2 = _interopRequireDefault(_handlebarsNoConflict);

// For compatibility and usage outside of module systems, make the Handlebars object a namespace
function create() {
  var hb = new base.HandlebarsEnvironment();

  Utils.extend(hb, base);
  hb.SafeString = _handlebarsSafeString2['default'];
  hb.Exception = _handlebarsException2['default'];
  hb.Utils = Utils;
  hb.escapeExpression = Utils.escapeExpression;

  hb.VM = runtime;
  hb.template = function (spec) {
    return runtime.template(spec, hb);
  };

  return hb;
}

var inst = create();
inst.create = create;

_handlebarsNoConflict2['default'](inst);

inst['default'] = inst;

exports['default'] = inst;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultDecorators = registerDefaultDecorators;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _decoratorsInline = __webpack_require__(54);

var _decoratorsInline2 = _interopRequireDefault(_decoratorsInline);

function registerDefaultDecorators(instance) {
  _decoratorsInline2['default'](instance);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Z0NBQTJCLHFCQUFxQjs7OztBQUV6QyxTQUFTLHlCQUF5QixDQUFDLFFBQVEsRUFBRTtBQUNsRCxnQ0FBZSxRQUFRLENBQUMsQ0FBQztDQUMxQiIsImZpbGUiOiJkZWNvcmF0b3JzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHJlZ2lzdGVySW5saW5lIGZyb20gJy4vZGVjb3JhdG9ycy9pbmxpbmUnO1xuXG5leHBvcnQgZnVuY3Rpb24gcmVnaXN0ZXJEZWZhdWx0RGVjb3JhdG9ycyhpbnN0YW5jZSkge1xuICByZWdpc3RlcklubGluZShpbnN0YW5jZSk7XG59XG5cbiJdfQ==


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerDecorator('inline', function (fn, props, container, options) {
    var ret = fn;
    if (!props.partials) {
      props.partials = {};
      ret = function (context, options) {
        // Create a new partials stack frame prior to exec.
        var original = container.partials;
        container.partials = _utils.extend({}, original, props.partials);
        var ret = fn(context, options);
        container.partials = original;
        return ret;
      };
    }

    props.partials[options.args[0]] = options.fn;

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2RlY29yYXRvcnMvaW5saW5lLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQXFCLFVBQVU7O3FCQUVoQixVQUFTLFFBQVEsRUFBRTtBQUNoQyxVQUFRLENBQUMsaUJBQWlCLENBQUMsUUFBUSxFQUFFLFVBQVMsRUFBRSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsT0FBTyxFQUFFO0FBQzNFLFFBQUksR0FBRyxHQUFHLEVBQUUsQ0FBQztBQUNiLFFBQUksQ0FBQyxLQUFLLENBQUMsUUFBUSxFQUFFO0FBQ25CLFdBQUssQ0FBQyxRQUFRLEdBQUcsRUFBRSxDQUFDO0FBQ3BCLFNBQUcsR0FBRyxVQUFTLE9BQU8sRUFBRSxPQUFPLEVBQUU7O0FBRS9CLFlBQUksUUFBUSxHQUFHLFNBQVMsQ0FBQyxRQUFRLENBQUM7QUFDbEMsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsY0FBTyxFQUFFLEVBQUUsUUFBUSxFQUFFLEtBQUssQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUMxRCxZQUFJLEdBQUcsR0FBRyxFQUFFLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQy9CLGlCQUFTLENBQUMsUUFBUSxHQUFHLFFBQVEsQ0FBQztBQUM5QixlQUFPLEdBQUcsQ0FBQztPQUNaLENBQUM7S0FDSDs7QUFFRCxTQUFLLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsRUFBRSxDQUFDOztBQUU3QyxXQUFPLEdBQUcsQ0FBQztHQUNaLENBQUMsQ0FBQztDQUNKIiwiZmlsZSI6ImlubGluZS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7ZXh0ZW5kfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uKGluc3RhbmNlKSB7XG4gIGluc3RhbmNlLnJlZ2lzdGVyRGVjb3JhdG9yKCdpbmxpbmUnLCBmdW5jdGlvbihmbiwgcHJvcHMsIGNvbnRhaW5lciwgb3B0aW9ucykge1xuICAgIGxldCByZXQgPSBmbjtcbiAgICBpZiAoIXByb3BzLnBhcnRpYWxzKSB7XG4gICAgICBwcm9wcy5wYXJ0aWFscyA9IHt9O1xuICAgICAgcmV0ID0gZnVuY3Rpb24oY29udGV4dCwgb3B0aW9ucykge1xuICAgICAgICAvLyBDcmVhdGUgYSBuZXcgcGFydGlhbHMgc3RhY2sgZnJhbWUgcHJpb3IgdG8gZXhlYy5cbiAgICAgICAgbGV0IG9yaWdpbmFsID0gY29udGFpbmVyLnBhcnRpYWxzO1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBleHRlbmQoe30sIG9yaWdpbmFsLCBwcm9wcy5wYXJ0aWFscyk7XG4gICAgICAgIGxldCByZXQgPSBmbihjb250ZXh0LCBvcHRpb25zKTtcbiAgICAgICAgY29udGFpbmVyLnBhcnRpYWxzID0gb3JpZ2luYWw7XG4gICAgICAgIHJldHVybiByZXQ7XG4gICAgICB9O1xuICAgIH1cblxuICAgIHByb3BzLnBhcnRpYWxzW29wdGlvbnMuYXJnc1swXV0gPSBvcHRpb25zLmZuO1xuXG4gICAgcmV0dXJuIHJldDtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.registerDefaultHelpers = registerDefaultHelpers;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _helpersBlockHelperMissing = __webpack_require__(56);

var _helpersBlockHelperMissing2 = _interopRequireDefault(_helpersBlockHelperMissing);

var _helpersEach = __webpack_require__(57);

var _helpersEach2 = _interopRequireDefault(_helpersEach);

var _helpersHelperMissing = __webpack_require__(58);

var _helpersHelperMissing2 = _interopRequireDefault(_helpersHelperMissing);

var _helpersIf = __webpack_require__(59);

var _helpersIf2 = _interopRequireDefault(_helpersIf);

var _helpersLog = __webpack_require__(60);

var _helpersLog2 = _interopRequireDefault(_helpersLog);

var _helpersLookup = __webpack_require__(61);

var _helpersLookup2 = _interopRequireDefault(_helpersLookup);

var _helpersWith = __webpack_require__(62);

var _helpersWith2 = _interopRequireDefault(_helpersWith);

function registerDefaultHelpers(instance) {
  _helpersBlockHelperMissing2['default'](instance);
  _helpersEach2['default'](instance);
  _helpersHelperMissing2['default'](instance);
  _helpersIf2['default'](instance);
  _helpersLog2['default'](instance);
  _helpersLookup2['default'](instance);
  _helpersWith2['default'](instance);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7eUNBQXVDLGdDQUFnQzs7OzsyQkFDOUMsZ0JBQWdCOzs7O29DQUNQLDBCQUEwQjs7Ozt5QkFDckMsY0FBYzs7OzswQkFDYixlQUFlOzs7OzZCQUNaLGtCQUFrQjs7OzsyQkFDcEIsZ0JBQWdCOzs7O0FBRWxDLFNBQVMsc0JBQXNCLENBQUMsUUFBUSxFQUFFO0FBQy9DLHlDQUEyQixRQUFRLENBQUMsQ0FBQztBQUNyQywyQkFBYSxRQUFRLENBQUMsQ0FBQztBQUN2QixvQ0FBc0IsUUFBUSxDQUFDLENBQUM7QUFDaEMseUJBQVcsUUFBUSxDQUFDLENBQUM7QUFDckIsMEJBQVksUUFBUSxDQUFDLENBQUM7QUFDdEIsNkJBQWUsUUFBUSxDQUFDLENBQUM7QUFDekIsMkJBQWEsUUFBUSxDQUFDLENBQUM7Q0FDeEIiLCJmaWxlIjoiaGVscGVycy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCByZWdpc3RlckJsb2NrSGVscGVyTWlzc2luZyBmcm9tICcuL2hlbHBlcnMvYmxvY2staGVscGVyLW1pc3NpbmcnO1xuaW1wb3J0IHJlZ2lzdGVyRWFjaCBmcm9tICcuL2hlbHBlcnMvZWFjaCc7XG5pbXBvcnQgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nIGZyb20gJy4vaGVscGVycy9oZWxwZXItbWlzc2luZyc7XG5pbXBvcnQgcmVnaXN0ZXJJZiBmcm9tICcuL2hlbHBlcnMvaWYnO1xuaW1wb3J0IHJlZ2lzdGVyTG9nIGZyb20gJy4vaGVscGVycy9sb2cnO1xuaW1wb3J0IHJlZ2lzdGVyTG9va3VwIGZyb20gJy4vaGVscGVycy9sb29rdXAnO1xuaW1wb3J0IHJlZ2lzdGVyV2l0aCBmcm9tICcuL2hlbHBlcnMvd2l0aCc7XG5cbmV4cG9ydCBmdW5jdGlvbiByZWdpc3RlckRlZmF1bHRIZWxwZXJzKGluc3RhbmNlKSB7XG4gIHJlZ2lzdGVyQmxvY2tIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJFYWNoKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJIZWxwZXJNaXNzaW5nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJJZihpbnN0YW5jZSk7XG4gIHJlZ2lzdGVyTG9nKGluc3RhbmNlKTtcbiAgcmVnaXN0ZXJMb29rdXAoaW5zdGFuY2UpO1xuICByZWdpc3RlcldpdGgoaW5zdGFuY2UpO1xufVxuIl19


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerHelper('blockHelperMissing', function (context, options) {
    var inverse = options.inverse,
        fn = options.fn;

    if (context === true) {
      return fn(this);
    } else if (context === false || context == null) {
      return inverse(this);
    } else if (_utils.isArray(context)) {
      if (context.length > 0) {
        if (options.ids) {
          options.ids = [options.name];
        }

        return instance.helpers.each(context, options);
      } else {
        return inverse(this);
      }
    } else {
      if (options.data && options.ids) {
        var data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.name);
        options = { data: data };
      }

      return fn(context, options);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _utils = __webpack_require__(4);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('each', function (context, options) {
    if (!options) {
      throw new _exception2['default']('Must pass iterator to #each');
    }

    var fn = options.fn,
        inverse = options.inverse,
        i = 0,
        ret = '',
        data = undefined,
        contextPath = undefined;

    if (options.data && options.ids) {
      contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]) + '.';
    }

    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    if (options.data) {
      data = _utils.createFrame(options.data);
    }

    function execIteration(field, index, last) {
      if (data) {
        data.key = field;
        data.index = index;
        data.first = index === 0;
        data.last = !!last;

        if (contextPath) {
          data.contextPath = contextPath + field;
        }
      }

      ret = ret + fn(context[field], {
        data: data,
        blockParams: _utils.blockParams([context[field], field], [contextPath + field, null])
      });
    }

    if (context && typeof context === 'object') {
      if (_utils.isArray(context)) {
        for (var j = context.length; i < j; i++) {
          if (i in context) {
            execIteration(i, i, i === context.length - 1);
          }
        }
      } else {
        var priorKey = undefined;

        for (var key in context) {
          if (context.hasOwnProperty(key)) {
            // We're running the iterations one step out of sync so we can detect
            // the last iteration without have to scan the object twice and create
            // an itermediate keys array.
            if (priorKey !== undefined) {
              execIteration(priorKey, i - 1);
            }
            priorKey = key;
            i++;
          }
        }
        if (priorKey !== undefined) {
          execIteration(priorKey, i - 1, true);
        }
      }
    }

    if (i === 0) {
      ret = inverse(this);
    }

    return ret;
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

exports['default'] = function (instance) {
  instance.registerHelper('helperMissing', function () /* [args, ]options */{
    if (arguments.length === 1) {
      // A missing field in a {{foo}} construct.
      return undefined;
    } else {
      // Someone is actually trying to call something, blow up.
      throw new _exception2['default']('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvaGVscGVyLW1pc3NpbmcuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozt5QkFBc0IsY0FBYzs7OztxQkFFckIsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxlQUFlLEVBQUUsaUNBQWdDO0FBQ3ZFLFFBQUksU0FBUyxDQUFDLE1BQU0sS0FBSyxDQUFDLEVBQUU7O0FBRTFCLGFBQU8sU0FBUyxDQUFDO0tBQ2xCLE1BQU07O0FBRUwsWUFBTSwyQkFBYyxtQkFBbUIsR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQyxJQUFJLEdBQUcsR0FBRyxDQUFDLENBQUM7S0FDdkY7R0FDRixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJoZWxwZXItbWlzc2luZy5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBFeGNlcHRpb24gZnJvbSAnLi4vZXhjZXB0aW9uJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2hlbHBlck1pc3NpbmcnLCBmdW5jdGlvbigvKiBbYXJncywgXW9wdGlvbnMgKi8pIHtcbiAgICBpZiAoYXJndW1lbnRzLmxlbmd0aCA9PT0gMSkge1xuICAgICAgLy8gQSBtaXNzaW5nIGZpZWxkIGluIGEge3tmb299fSBjb25zdHJ1Y3QuXG4gICAgICByZXR1cm4gdW5kZWZpbmVkO1xuICAgIH0gZWxzZSB7XG4gICAgICAvLyBTb21lb25lIGlzIGFjdHVhbGx5IHRyeWluZyB0byBjYWxsIHNvbWV0aGluZywgYmxvdyB1cC5cbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ01pc3NpbmcgaGVscGVyOiBcIicgKyBhcmd1bWVudHNbYXJndW1lbnRzLmxlbmd0aCAtIDFdLm5hbWUgKyAnXCInKTtcbiAgICB9XG4gIH0pO1xufVxuIl19


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerHelper('if', function (conditional, options) {
    if (_utils.isFunction(conditional)) {
      conditional = conditional.call(this);
    }

    // Default behavior is to render the positive path if the value is truthy and not empty.
    // The `includeZero` option may be set to treat the condtional as purely not empty based on the
    // behavior of isEmpty. Effectively this determines if 0 is handled by the positive path or negative.
    if (!options.hash.includeZero && !conditional || _utils.isEmpty(conditional)) {
      return options.inverse(this);
    } else {
      return options.fn(this);
    }
  });

  instance.registerHelper('unless', function (conditional, options) {
    return instance.helpers['if'].call(this, conditional, { fn: options.inverse, inverse: options.fn, hash: options.hash });
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('log', function () /* message, options */{
    var args = [undefined],
        options = arguments[arguments.length - 1];
    for (var i = 0; i < arguments.length - 1; i++) {
      args.push(arguments[i]);
    }

    var level = 1;
    if (options.hash.level != null) {
      level = options.hash.level;
    } else if (options.data && options.data.level != null) {
      level = options.data.level;
    }
    args[0] = level;

    instance.log.apply(instance, args);
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxLQUFLLEVBQUUsa0NBQWlDO0FBQzlELFFBQUksSUFBSSxHQUFHLENBQUMsU0FBUyxDQUFDO1FBQ2xCLE9BQU8sR0FBRyxTQUFTLENBQUMsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztBQUM5QyxTQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsU0FBUyxDQUFDLE1BQU0sR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDN0MsVUFBSSxDQUFDLElBQUksQ0FBQyxTQUFTLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQztLQUN6Qjs7QUFFRCxRQUFJLEtBQUssR0FBRyxDQUFDLENBQUM7QUFDZCxRQUFJLE9BQU8sQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJLElBQUksRUFBRTtBQUM5QixXQUFLLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7S0FDNUIsTUFBTSxJQUFJLE9BQU8sQ0FBQyxJQUFJLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksSUFBSSxFQUFFO0FBQ3JELFdBQUssR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQztLQUM1QjtBQUNELFFBQUksQ0FBQyxDQUFDLENBQUMsR0FBRyxLQUFLLENBQUM7O0FBRWhCLFlBQVEsQ0FBQyxHQUFHLE1BQUEsQ0FBWixRQUFRLEVBQVMsSUFBSSxDQUFDLENBQUM7R0FDeEIsQ0FBQyxDQUFDO0NBQ0oiLCJmaWxlIjoibG9nLmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oaW5zdGFuY2UpIHtcbiAgaW5zdGFuY2UucmVnaXN0ZXJIZWxwZXIoJ2xvZycsIGZ1bmN0aW9uKC8qIG1lc3NhZ2UsIG9wdGlvbnMgKi8pIHtcbiAgICBsZXQgYXJncyA9IFt1bmRlZmluZWRdLFxuICAgICAgICBvcHRpb25zID0gYXJndW1lbnRzW2FyZ3VtZW50cy5sZW5ndGggLSAxXTtcbiAgICBmb3IgKGxldCBpID0gMDsgaSA8IGFyZ3VtZW50cy5sZW5ndGggLSAxOyBpKyspIHtcbiAgICAgIGFyZ3MucHVzaChhcmd1bWVudHNbaV0pO1xuICAgIH1cblxuICAgIGxldCBsZXZlbCA9IDE7XG4gICAgaWYgKG9wdGlvbnMuaGFzaC5sZXZlbCAhPSBudWxsKSB7XG4gICAgICBsZXZlbCA9IG9wdGlvbnMuaGFzaC5sZXZlbDtcbiAgICB9IGVsc2UgaWYgKG9wdGlvbnMuZGF0YSAmJiBvcHRpb25zLmRhdGEubGV2ZWwgIT0gbnVsbCkge1xuICAgICAgbGV2ZWwgPSBvcHRpb25zLmRhdGEubGV2ZWw7XG4gICAgfVxuICAgIGFyZ3NbMF0gPSBsZXZlbDtcblxuICAgIGluc3RhbmNlLmxvZyguLi4gYXJncyk7XG4gIH0pO1xufVxuIl19


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports['default'] = function (instance) {
  instance.registerHelper('lookup', function (obj, field) {
    return obj && obj[field];
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL2hlbHBlcnMvbG9va3VwLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7cUJBQWUsVUFBUyxRQUFRLEVBQUU7QUFDaEMsVUFBUSxDQUFDLGNBQWMsQ0FBQyxRQUFRLEVBQUUsVUFBUyxHQUFHLEVBQUUsS0FBSyxFQUFFO0FBQ3JELFdBQU8sR0FBRyxJQUFJLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQztHQUMxQixDQUFDLENBQUM7Q0FDSiIsImZpbGUiOiJsb29rdXAuanMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbihpbnN0YW5jZSkge1xuICBpbnN0YW5jZS5yZWdpc3RlckhlbHBlcignbG9va3VwJywgZnVuY3Rpb24ob2JqLCBmaWVsZCkge1xuICAgIHJldHVybiBvYmogJiYgb2JqW2ZpZWxkXTtcbiAgfSk7XG59XG4iXX0=


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

exports['default'] = function (instance) {
  instance.registerHelper('with', function (context, options) {
    if (_utils.isFunction(context)) {
      context = context.call(this);
    }

    var fn = options.fn;

    if (!_utils.isEmpty(context)) {
      var data = options.data;
      if (options.data && options.ids) {
        data = _utils.createFrame(options.data);
        data.contextPath = _utils.appendContextPath(options.data.contextPath, options.ids[0]);
      }

      return fn(context, {
        data: data,
        blockParams: _utils.blockParams([context], [data && data.contextPath])
      });
    } else {
      return options.inverse(this);
    }
  });
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _utils = __webpack_require__(4);

var logger = {
  methodMap: ['debug', 'info', 'warn', 'error'],
  level: 'info',

  // Maps a given level value to the `methodMap` indexes above.
  lookupLevel: function lookupLevel(level) {
    if (typeof level === 'string') {
      var levelMap = _utils.indexOf(logger.methodMap, level.toLowerCase());
      if (levelMap >= 0) {
        level = levelMap;
      } else {
        level = parseInt(level, 10);
      }
    }

    return level;
  },

  // Can be overridden in the host environment
  log: function log(level) {
    level = logger.lookupLevel(level);

    if (typeof console !== 'undefined' && logger.lookupLevel(logger.level) <= level) {
      var method = logger.methodMap[level];
      if (!console[method]) {
        // eslint-disable-line no-console
        method = 'log';
      }

      for (var _len = arguments.length, message = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        message[_key - 1] = arguments[_key];
      }

      console[method].apply(console, message); // eslint-disable-line no-console
    }
  }
};

exports['default'] = logger;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* global window */


exports.__esModule = true;

exports['default'] = function (Handlebars) {
  /* istanbul ignore next */
  var root = typeof global !== 'undefined' ? global : window,
      $Handlebars = root.Handlebars;
  /* istanbul ignore next */
  Handlebars.noConflict = function () {
    if (root.Handlebars === Handlebars) {
      root.Handlebars = $Handlebars;
    }
    return Handlebars;
  };
};

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL25vLWNvbmZsaWN0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7O3FCQUNlLFVBQVMsVUFBVSxFQUFFOztBQUVsQyxNQUFJLElBQUksR0FBRyxPQUFPLE1BQU0sS0FBSyxXQUFXLEdBQUcsTUFBTSxHQUFHLE1BQU07TUFDdEQsV0FBVyxHQUFHLElBQUksQ0FBQyxVQUFVLENBQUM7O0FBRWxDLFlBQVUsQ0FBQyxVQUFVLEdBQUcsWUFBVztBQUNqQyxRQUFJLElBQUksQ0FBQyxVQUFVLEtBQUssVUFBVSxFQUFFO0FBQ2xDLFVBQUksQ0FBQyxVQUFVLEdBQUcsV0FBVyxDQUFDO0tBQy9CO0FBQ0QsV0FBTyxVQUFVLENBQUM7R0FDbkIsQ0FBQztDQUNIIiwiZmlsZSI6Im5vLWNvbmZsaWN0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLyogZ2xvYmFsIHdpbmRvdyAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24oSGFuZGxlYmFycykge1xuICAvKiBpc3RhbmJ1bCBpZ25vcmUgbmV4dCAqL1xuICBsZXQgcm9vdCA9IHR5cGVvZiBnbG9iYWwgIT09ICd1bmRlZmluZWQnID8gZ2xvYmFsIDogd2luZG93LFxuICAgICAgJEhhbmRsZWJhcnMgPSByb290LkhhbmRsZWJhcnM7XG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIEhhbmRsZWJhcnMubm9Db25mbGljdCA9IGZ1bmN0aW9uKCkge1xuICAgIGlmIChyb290LkhhbmRsZWJhcnMgPT09IEhhbmRsZWJhcnMpIHtcbiAgICAgIHJvb3QuSGFuZGxlYmFycyA9ICRIYW5kbGViYXJzO1xuICAgIH1cbiAgICByZXR1cm4gSGFuZGxlYmFycztcbiAgfTtcbn1cbiJdfQ==

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(11)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.checkRevision = checkRevision;
exports.template = template;
exports.wrapProgram = wrapProgram;
exports.resolvePartial = resolvePartial;
exports.invokePartial = invokePartial;
exports.noop = noop;
// istanbul ignore next

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// istanbul ignore next

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var _utils = __webpack_require__(4);

var Utils = _interopRequireWildcard(_utils);

var _exception = __webpack_require__(5);

var _exception2 = _interopRequireDefault(_exception);

var _base = __webpack_require__(10);

function checkRevision(compilerInfo) {
  var compilerRevision = compilerInfo && compilerInfo[0] || 1,
      currentRevision = _base.COMPILER_REVISION;

  if (compilerRevision !== currentRevision) {
    if (compilerRevision < currentRevision) {
      var runtimeVersions = _base.REVISION_CHANGES[currentRevision],
          compilerVersions = _base.REVISION_CHANGES[compilerRevision];
      throw new _exception2['default']('Template was precompiled with an older version of Handlebars than the current runtime. ' + 'Please update your precompiler to a newer version (' + runtimeVersions + ') or downgrade your runtime to an older version (' + compilerVersions + ').');
    } else {
      // Use the embedded version info since the runtime doesn't know about this revision yet
      throw new _exception2['default']('Template was precompiled with a newer version of Handlebars than the current runtime. ' + 'Please update your runtime to a newer version (' + compilerInfo[1] + ').');
    }
  }
}

function template(templateSpec, env) {
  /* istanbul ignore next */
  if (!env) {
    throw new _exception2['default']('No environment passed to template');
  }
  if (!templateSpec || !templateSpec.main) {
    throw new _exception2['default']('Unknown template object: ' + typeof templateSpec);
  }

  templateSpec.main.decorator = templateSpec.main_d;

  // Note: Using env.VM references rather than local var references throughout this section to allow
  // for external users to override these as psuedo-supported APIs.
  env.VM.checkRevision(templateSpec.compiler);

  function invokePartialWrapper(partial, context, options) {
    if (options.hash) {
      context = Utils.extend({}, context, options.hash);
      if (options.ids) {
        options.ids[0] = true;
      }
    }

    partial = env.VM.resolvePartial.call(this, partial, context, options);
    var result = env.VM.invokePartial.call(this, partial, context, options);

    if (result == null && env.compile) {
      options.partials[options.name] = env.compile(partial, templateSpec.compilerOptions, env);
      result = options.partials[options.name](context, options);
    }
    if (result != null) {
      if (options.indent) {
        var lines = result.split('\n');
        for (var i = 0, l = lines.length; i < l; i++) {
          if (!lines[i] && i + 1 === l) {
            break;
          }

          lines[i] = options.indent + lines[i];
        }
        result = lines.join('\n');
      }
      return result;
    } else {
      throw new _exception2['default']('The partial ' + options.name + ' could not be compiled when running in runtime-only mode');
    }
  }

  // Just add water
  var container = {
    strict: function strict(obj, name) {
      if (!(name in obj)) {
        throw new _exception2['default']('"' + name + '" not defined in ' + obj);
      }
      return obj[name];
    },
    lookup: function lookup(depths, name) {
      var len = depths.length;
      for (var i = 0; i < len; i++) {
        if (depths[i] && depths[i][name] != null) {
          return depths[i][name];
        }
      }
    },
    lambda: function lambda(current, context) {
      return typeof current === 'function' ? current.call(context) : current;
    },

    escapeExpression: Utils.escapeExpression,
    invokePartial: invokePartialWrapper,

    fn: function fn(i) {
      var ret = templateSpec[i];
      ret.decorator = templateSpec[i + '_d'];
      return ret;
    },

    programs: [],
    program: function program(i, data, declaredBlockParams, blockParams, depths) {
      var programWrapper = this.programs[i],
          fn = this.fn(i);
      if (data || depths || blockParams || declaredBlockParams) {
        programWrapper = wrapProgram(this, i, fn, data, declaredBlockParams, blockParams, depths);
      } else if (!programWrapper) {
        programWrapper = this.programs[i] = wrapProgram(this, i, fn);
      }
      return programWrapper;
    },

    data: function data(value, depth) {
      while (value && depth--) {
        value = value._parent;
      }
      return value;
    },
    merge: function merge(param, common) {
      var obj = param || common;

      if (param && common && param !== common) {
        obj = Utils.extend({}, common, param);
      }

      return obj;
    },

    noop: env.VM.noop,
    compilerInfo: templateSpec.compiler
  };

  function ret(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var data = options.data;

    ret._setup(options);
    if (!options.partial && templateSpec.useData) {
      data = initData(context, data);
    }
    var depths = undefined,
        blockParams = templateSpec.useBlockParams ? [] : undefined;
    if (templateSpec.useDepths) {
      if (options.depths) {
        depths = context != options.depths[0] ? [context].concat(options.depths) : options.depths;
      } else {
        depths = [context];
      }
    }

    function main(context /*, options*/) {
      return '' + templateSpec.main(container, context, container.helpers, container.partials, data, blockParams, depths);
    }
    main = executeDecorators(templateSpec.main, main, container, options.depths || [], data, blockParams);
    return main(context, options);
  }
  ret.isTop = true;

  ret._setup = function (options) {
    if (!options.partial) {
      container.helpers = container.merge(options.helpers, env.helpers);

      if (templateSpec.usePartial) {
        container.partials = container.merge(options.partials, env.partials);
      }
      if (templateSpec.usePartial || templateSpec.useDecorators) {
        container.decorators = container.merge(options.decorators, env.decorators);
      }
    } else {
      container.helpers = options.helpers;
      container.partials = options.partials;
      container.decorators = options.decorators;
    }
  };

  ret._child = function (i, data, blockParams, depths) {
    if (templateSpec.useBlockParams && !blockParams) {
      throw new _exception2['default']('must pass block params');
    }
    if (templateSpec.useDepths && !depths) {
      throw new _exception2['default']('must pass parent depths');
    }

    return wrapProgram(container, i, templateSpec[i], data, 0, blockParams, depths);
  };
  return ret;
}

function wrapProgram(container, i, fn, data, declaredBlockParams, blockParams, depths) {
  function prog(context) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    var currentDepths = depths;
    if (depths && context != depths[0]) {
      currentDepths = [context].concat(depths);
    }

    return fn(container, context, container.helpers, container.partials, options.data || data, blockParams && [options.blockParams].concat(blockParams), currentDepths);
  }

  prog = executeDecorators(fn, prog, container, depths, data, blockParams);

  prog.program = i;
  prog.depth = depths ? depths.length : 0;
  prog.blockParams = declaredBlockParams || 0;
  return prog;
}

function resolvePartial(partial, context, options) {
  if (!partial) {
    if (options.name === '@partial-block') {
      var data = options.data;
      while (data['partial-block'] === noop) {
        data = data._parent;
      }
      partial = data['partial-block'];
      data['partial-block'] = noop;
    } else {
      partial = options.partials[options.name];
    }
  } else if (!partial.call && !options.name) {
    // This is a dynamic partial that returned a string
    options.name = partial;
    partial = options.partials[partial];
  }
  return partial;
}

function invokePartial(partial, context, options) {
  options.partial = true;
  if (options.ids) {
    options.data.contextPath = options.ids[0] || options.data.contextPath;
  }

  var partialBlock = undefined;
  if (options.fn && options.fn !== noop) {
    options.data = _base.createFrame(options.data);
    partialBlock = options.data['partial-block'] = options.fn;

    if (partialBlock.partials) {
      options.partials = Utils.extend({}, options.partials, partialBlock.partials);
    }
  }

  if (partial === undefined && partialBlock) {
    partial = partialBlock;
  }

  if (partial === undefined) {
    throw new _exception2['default']('The partial ' + options.name + ' could not be found');
  } else if (partial instanceof Function) {
    return partial(context, options);
  }
}

function noop() {
  return '';
}

function initData(context, data) {
  if (!data || !('root' in data)) {
    data = data ? _base.createFrame(data) : {};
    data.root = context;
  }
  return data;
}

function executeDecorators(fn, prog, container, depths, data, blockParams) {
  if (fn.decorator) {
    var props = {};
    prog = fn.decorator(prog, props, container, depths && depths[0], data, blockParams, depths);
    Utils.extend(prog, props);
  }
  return prog;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3J1bnRpbWUuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7cUJBQXVCLFNBQVM7O0lBQXBCLEtBQUs7O3lCQUNLLGFBQWE7Ozs7b0JBQzhCLFFBQVE7O0FBRWxFLFNBQVMsYUFBYSxDQUFDLFlBQVksRUFBRTtBQUMxQyxNQUFNLGdCQUFnQixHQUFHLFlBQVksSUFBSSxZQUFZLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQztNQUN2RCxlQUFlLDBCQUFvQixDQUFDOztBQUUxQyxNQUFJLGdCQUFnQixLQUFLLGVBQWUsRUFBRTtBQUN4QyxRQUFJLGdCQUFnQixHQUFHLGVBQWUsRUFBRTtBQUN0QyxVQUFNLGVBQWUsR0FBRyx1QkFBaUIsZUFBZSxDQUFDO1VBQ25ELGdCQUFnQixHQUFHLHVCQUFpQixnQkFBZ0IsQ0FBQyxDQUFDO0FBQzVELFlBQU0sMkJBQWMseUZBQXlGLEdBQ3ZHLHFEQUFxRCxHQUFHLGVBQWUsR0FBRyxtREFBbUQsR0FBRyxnQkFBZ0IsR0FBRyxJQUFJLENBQUMsQ0FBQztLQUNoSyxNQUFNOztBQUVMLFlBQU0sMkJBQWMsd0ZBQXdGLEdBQ3RHLGlEQUFpRCxHQUFHLFlBQVksQ0FBQyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUMsQ0FBQztLQUNuRjtHQUNGO0NBQ0Y7O0FBRU0sU0FBUyxRQUFRLENBQUMsWUFBWSxFQUFFLEdBQUcsRUFBRTs7QUFFMUMsTUFBSSxDQUFDLEdBQUcsRUFBRTtBQUNSLFVBQU0sMkJBQWMsbUNBQW1DLENBQUMsQ0FBQztHQUMxRDtBQUNELE1BQUksQ0FBQyxZQUFZLElBQUksQ0FBQyxZQUFZLENBQUMsSUFBSSxFQUFFO0FBQ3ZDLFVBQU0sMkJBQWMsMkJBQTJCLEdBQUcsT0FBTyxZQUFZLENBQUMsQ0FBQztHQUN4RTs7QUFFRCxjQUFZLENBQUMsSUFBSSxDQUFDLFNBQVMsR0FBRyxZQUFZLENBQUMsTUFBTSxDQUFDOzs7O0FBSWxELEtBQUcsQ0FBQyxFQUFFLENBQUMsYUFBYSxDQUFDLFlBQVksQ0FBQyxRQUFRLENBQUMsQ0FBQzs7QUFFNUMsV0FBUyxvQkFBb0IsQ0FBQyxPQUFPLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRTtBQUN2RCxRQUFJLE9BQU8sQ0FBQyxJQUFJLEVBQUU7QUFDaEIsYUFBTyxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLE9BQU8sRUFBRSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDbEQsVUFBSSxPQUFPLENBQUMsR0FBRyxFQUFFO0FBQ2YsZUFBTyxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsR0FBRyxJQUFJLENBQUM7T0FDdkI7S0FDRjs7QUFFRCxXQUFPLEdBQUcsR0FBRyxDQUFDLEVBQUUsQ0FBQyxjQUFjLENBQUMsSUFBSSxDQUFDLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0FBQ3RFLFFBQUksTUFBTSxHQUFHLEdBQUcsQ0FBQyxFQUFFLENBQUMsYUFBYSxDQUFDLElBQUksQ0FBQyxJQUFJLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxPQUFPLENBQUMsQ0FBQzs7QUFFeEUsUUFBSSxNQUFNLElBQUksSUFBSSxJQUFJLEdBQUcsQ0FBQyxPQUFPLEVBQUU7QUFDakMsYUFBTyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLEdBQUcsR0FBRyxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUUsWUFBWSxDQUFDLGVBQWUsRUFBRSxHQUFHLENBQUMsQ0FBQztBQUN6RixZQUFNLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0tBQzNEO0FBQ0QsUUFBSSxNQUFNLElBQUksSUFBSSxFQUFFO0FBQ2xCLFVBQUksT0FBTyxDQUFDLE1BQU0sRUFBRTtBQUNsQixZQUFJLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxDQUFDO0FBQy9CLGFBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxLQUFLLENBQUMsTUFBTSxFQUFFLENBQUMsR0FBRyxDQUFDLEVBQUUsQ0FBQyxFQUFFLEVBQUU7QUFDNUMsY0FBSSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLENBQUMsRUFBRTtBQUM1QixrQkFBTTtXQUNQOztBQUVELGVBQUssQ0FBQyxDQUFDLENBQUMsR0FBRyxPQUFPLENBQUMsTUFBTSxHQUFHLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQztTQUN0QztBQUNELGNBQU0sR0FBRyxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDO09BQzNCO0FBQ0QsYUFBTyxNQUFNLENBQUM7S0FDZixNQUFNO0FBQ0wsWUFBTSwyQkFBYyxjQUFjLEdBQUcsT0FBTyxDQUFDLElBQUksR0FBRywwREFBMEQsQ0FBQyxDQUFDO0tBQ2pIO0dBQ0Y7OztBQUdELE1BQUksU0FBUyxHQUFHO0FBQ2QsVUFBTSxFQUFFLGdCQUFTLEdBQUcsRUFBRSxJQUFJLEVBQUU7QUFDMUIsVUFBSSxFQUFFLElBQUksSUFBSSxHQUFHLENBQUEsQUFBQyxFQUFFO0FBQ2xCLGNBQU0sMkJBQWMsR0FBRyxHQUFHLElBQUksR0FBRyxtQkFBbUIsR0FBRyxHQUFHLENBQUMsQ0FBQztPQUM3RDtBQUNELGFBQU8sR0FBRyxDQUFDLElBQUksQ0FBQyxDQUFDO0tBQ2xCO0FBQ0QsVUFBTSxFQUFFLGdCQUFTLE1BQU0sRUFBRSxJQUFJLEVBQUU7QUFDN0IsVUFBTSxHQUFHLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQztBQUMxQixXQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsR0FBRyxFQUFFLENBQUMsRUFBRSxFQUFFO0FBQzVCLFlBQUksTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFJLE1BQU0sQ0FBQyxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsSUFBSSxJQUFJLEVBQUU7QUFDeEMsaUJBQU8sTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDO1NBQ3hCO09BQ0Y7S0FDRjtBQUNELFVBQU0sRUFBRSxnQkFBUyxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ2pDLGFBQU8sT0FBTyxPQUFPLEtBQUssVUFBVSxHQUFHLE9BQU8sQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLEdBQUcsT0FBTyxDQUFDO0tBQ3hFOztBQUVELG9CQUFnQixFQUFFLEtBQUssQ0FBQyxnQkFBZ0I7QUFDeEMsaUJBQWEsRUFBRSxvQkFBb0I7O0FBRW5DLE1BQUUsRUFBRSxZQUFTLENBQUMsRUFBRTtBQUNkLFVBQUksR0FBRyxHQUFHLFlBQVksQ0FBQyxDQUFDLENBQUMsQ0FBQztBQUMxQixTQUFHLENBQUMsU0FBUyxHQUFHLFlBQVksQ0FBQyxDQUFDLEdBQUcsSUFBSSxDQUFDLENBQUM7QUFDdkMsYUFBTyxHQUFHLENBQUM7S0FDWjs7QUFFRCxZQUFRLEVBQUUsRUFBRTtBQUNaLFdBQU8sRUFBRSxpQkFBUyxDQUFDLEVBQUUsSUFBSSxFQUFFLG1CQUFtQixFQUFFLFdBQVcsRUFBRSxNQUFNLEVBQUU7QUFDbkUsVUFBSSxjQUFjLEdBQUcsSUFBSSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUM7VUFDakMsRUFBRSxHQUFHLElBQUksQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLENBQUM7QUFDcEIsVUFBSSxJQUFJLElBQUksTUFBTSxJQUFJLFdBQVcsSUFBSSxtQkFBbUIsRUFBRTtBQUN4RCxzQkFBYyxHQUFHLFdBQVcsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFLEVBQUUsRUFBRSxJQUFJLEVBQUUsbUJBQW1CLEVBQUUsV0FBVyxFQUFFLE1BQU0sQ0FBQyxDQUFDO09BQzNGLE1BQU0sSUFBSSxDQUFDLGNBQWMsRUFBRTtBQUMxQixzQkFBYyxHQUFHLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQyxDQUFDLEdBQUcsV0FBVyxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUM7T0FDOUQ7QUFDRCxhQUFPLGNBQWMsQ0FBQztLQUN2Qjs7QUFFRCxRQUFJLEVBQUUsY0FBUyxLQUFLLEVBQUUsS0FBSyxFQUFFO0FBQzNCLGFBQU8sS0FBSyxJQUFJLEtBQUssRUFBRSxFQUFFO0FBQ3ZCLGFBQUssR0FBRyxLQUFLLENBQUMsT0FBTyxDQUFDO09BQ3ZCO0FBQ0QsYUFBTyxLQUFLLENBQUM7S0FDZDtBQUNELFNBQUssRUFBRSxlQUFTLEtBQUssRUFBRSxNQUFNLEVBQUU7QUFDN0IsVUFBSSxHQUFHLEdBQUcsS0FBSyxJQUFJLE1BQU0sQ0FBQzs7QUFFMUIsVUFBSSxLQUFLLElBQUksTUFBTSxJQUFLLEtBQUssS0FBSyxNQUFNLEFBQUMsRUFBRTtBQUN6QyxXQUFHLEdBQUcsS0FBSyxDQUFDLE1BQU0sQ0FBQyxFQUFFLEVBQUUsTUFBTSxFQUFFLEtBQUssQ0FBQyxDQUFDO09BQ3ZDOztBQUVELGFBQU8sR0FBRyxDQUFDO0tBQ1o7O0FBRUQsUUFBSSxFQUFFLEdBQUcsQ0FBQyxFQUFFLENBQUMsSUFBSTtBQUNqQixnQkFBWSxFQUFFLFlBQVksQ0FBQyxRQUFRO0dBQ3BDLENBQUM7O0FBRUYsV0FBUyxHQUFHLENBQUMsT0FBTyxFQUFnQjtRQUFkLE9BQU8seURBQUcsRUFBRTs7QUFDaEMsUUFBSSxJQUFJLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQzs7QUFFeEIsT0FBRyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQztBQUNwQixRQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sSUFBSSxZQUFZLENBQUMsT0FBTyxFQUFFO0FBQzVDLFVBQUksR0FBRyxRQUFRLENBQUMsT0FBTyxFQUFFLElBQUksQ0FBQyxDQUFDO0tBQ2hDO0FBQ0QsUUFBSSxNQUFNLFlBQUE7UUFDTixXQUFXLEdBQUcsWUFBWSxDQUFDLGNBQWMsR0FBRyxFQUFFLEdBQUcsU0FBUyxDQUFDO0FBQy9ELFFBQUksWUFBWSxDQUFDLFNBQVMsRUFBRTtBQUMxQixVQUFJLE9BQU8sQ0FBQyxNQUFNLEVBQUU7QUFDbEIsY0FBTSxHQUFHLE9BQU8sSUFBSSxPQUFPLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxHQUFHLENBQUMsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxNQUFNLENBQUMsR0FBRyxPQUFPLENBQUMsTUFBTSxDQUFDO09BQzNGLE1BQU07QUFDTCxjQUFNLEdBQUcsQ0FBQyxPQUFPLENBQUMsQ0FBQztPQUNwQjtLQUNGOztBQUVELGFBQVMsSUFBSSxDQUFDLE9BQU8sZ0JBQWU7QUFDbEMsYUFBTyxFQUFFLEdBQUcsWUFBWSxDQUFDLElBQUksQ0FBQyxTQUFTLEVBQUUsT0FBTyxFQUFFLFNBQVMsQ0FBQyxPQUFPLEVBQUUsU0FBUyxDQUFDLFFBQVEsRUFBRSxJQUFJLEVBQUUsV0FBVyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0tBQ3JIO0FBQ0QsUUFBSSxHQUFHLGlCQUFpQixDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxPQUFPLENBQUMsTUFBTSxJQUFJLEVBQUUsRUFBRSxJQUFJLEVBQUUsV0FBVyxDQUFDLENBQUM7QUFDdEcsV0FBTyxJQUFJLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0dBQy9CO0FBQ0QsS0FBRyxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUM7O0FBRWpCLEtBQUcsQ0FBQyxNQUFNLEdBQUcsVUFBUyxPQUFPLEVBQUU7QUFDN0IsUUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUU7QUFDcEIsZUFBUyxDQUFDLE9BQU8sR0FBRyxTQUFTLENBQUMsS0FBSyxDQUFDLE9BQU8sQ0FBQyxPQUFPLEVBQUUsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDOztBQUVsRSxVQUFJLFlBQVksQ0FBQyxVQUFVLEVBQUU7QUFDM0IsaUJBQVMsQ0FBQyxRQUFRLEdBQUcsU0FBUyxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsUUFBUSxFQUFFLEdBQUcsQ0FBQyxRQUFRLENBQUMsQ0FBQztPQUN0RTtBQUNELFVBQUksWUFBWSxDQUFDLFVBQVUsSUFBSSxZQUFZLENBQUMsYUFBYSxFQUFFO0FBQ3pELGlCQUFTLENBQUMsVUFBVSxHQUFHLFNBQVMsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLFVBQVUsRUFBRSxHQUFHLENBQUMsVUFBVSxDQUFDLENBQUM7T0FDNUU7S0FDRixNQUFNO0FBQ0wsZUFBUyxDQUFDLE9BQU8sR0FBRyxPQUFPLENBQUMsT0FBTyxDQUFDO0FBQ3BDLGVBQVMsQ0FBQyxRQUFRLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQztBQUN0QyxlQUFTLENBQUMsVUFBVSxHQUFHLE9BQU8sQ0FBQyxVQUFVLENBQUM7S0FDM0M7R0FDRixDQUFDOztBQUVGLEtBQUcsQ0FBQyxNQUFNLEdBQUcsVUFBUyxDQUFDLEVBQUUsSUFBSSxFQUFFLFdBQVcsRUFBRSxNQUFNLEVBQUU7QUFDbEQsUUFBSSxZQUFZLENBQUMsY0FBYyxJQUFJLENBQUMsV0FBVyxFQUFFO0FBQy9DLFlBQU0sMkJBQWMsd0JBQXdCLENBQUMsQ0FBQztLQUMvQztBQUNELFFBQUksWUFBWSxDQUFDLFNBQVMsSUFBSSxDQUFDLE1BQU0sRUFBRTtBQUNyQyxZQUFNLDJCQUFjLHlCQUF5QixDQUFDLENBQUM7S0FDaEQ7O0FBRUQsV0FBTyxXQUFXLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRSxZQUFZLENBQUMsQ0FBQyxDQUFDLEVBQUUsSUFBSSxFQUFFLENBQUMsRUFBRSxXQUFXLEVBQUUsTUFBTSxDQUFDLENBQUM7R0FDakYsQ0FBQztBQUNGLFNBQU8sR0FBRyxDQUFDO0NBQ1o7O0FBRU0sU0FBUyxXQUFXLENBQUMsU0FBUyxFQUFFLENBQUMsRUFBRSxFQUFFLEVBQUUsSUFBSSxFQUFFLG1CQUFtQixFQUFFLFdBQVcsRUFBRSxNQUFNLEVBQUU7QUFDNUYsV0FBUyxJQUFJLENBQUMsT0FBTyxFQUFnQjtRQUFkLE9BQU8seURBQUcsRUFBRTs7QUFDakMsUUFBSSxhQUFhLEdBQUcsTUFBTSxDQUFDO0FBQzNCLFFBQUksTUFBTSxJQUFJLE9BQU8sSUFBSSxNQUFNLENBQUMsQ0FBQyxDQUFDLEVBQUU7QUFDbEMsbUJBQWEsR0FBRyxDQUFDLE9BQU8sQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsQ0FBQztLQUMxQzs7QUFFRCxXQUFPLEVBQUUsQ0FBQyxTQUFTLEVBQ2YsT0FBTyxFQUNQLFNBQVMsQ0FBQyxPQUFPLEVBQUUsU0FBUyxDQUFDLFFBQVEsRUFDckMsT0FBTyxDQUFDLElBQUksSUFBSSxJQUFJLEVBQ3BCLFdBQVcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsQ0FBQyxNQUFNLENBQUMsV0FBVyxDQUFDLEVBQ3hELGFBQWEsQ0FBQyxDQUFDO0dBQ3BCOztBQUVELE1BQUksR0FBRyxpQkFBaUIsQ0FBQyxFQUFFLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLFdBQVcsQ0FBQyxDQUFDOztBQUV6RSxNQUFJLENBQUMsT0FBTyxHQUFHLENBQUMsQ0FBQztBQUNqQixNQUFJLENBQUMsS0FBSyxHQUFHLE1BQU0sR0FBRyxNQUFNLENBQUMsTUFBTSxHQUFHLENBQUMsQ0FBQztBQUN4QyxNQUFJLENBQUMsV0FBVyxHQUFHLG1CQUFtQixJQUFJLENBQUMsQ0FBQztBQUM1QyxTQUFPLElBQUksQ0FBQztDQUNiOztBQUVNLFNBQVMsY0FBYyxDQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3hELE1BQUksQ0FBQyxPQUFPLEVBQUU7QUFDWixRQUFJLE9BQU8sQ0FBQyxJQUFJLEtBQUssZ0JBQWdCLEVBQUU7QUFDckMsVUFBSSxJQUFJLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQztBQUN4QixhQUFPLElBQUksQ0FBQyxlQUFlLENBQUMsS0FBSyxJQUFJLEVBQUU7QUFDckMsWUFBSSxHQUFHLElBQUksQ0FBQyxPQUFPLENBQUM7T0FDckI7QUFDRCxhQUFPLEdBQUcsSUFBSSxDQUFDLGVBQWUsQ0FBQyxDQUFDO0FBQ2hDLFVBQUksQ0FBQyxlQUFlLENBQUMsR0FBRyxJQUFJLENBQUM7S0FDOUIsTUFBTTtBQUNMLGFBQU8sR0FBRyxPQUFPLENBQUMsUUFBUSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUMxQztHQUNGLE1BQU0sSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLElBQUksQ0FBQyxPQUFPLENBQUMsSUFBSSxFQUFFOztBQUV6QyxXQUFPLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQztBQUN2QixXQUFPLEdBQUcsT0FBTyxDQUFDLFFBQVEsQ0FBQyxPQUFPLENBQUMsQ0FBQztHQUNyQztBQUNELFNBQU8sT0FBTyxDQUFDO0NBQ2hCOztBQUVNLFNBQVMsYUFBYSxDQUFDLE9BQU8sRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFO0FBQ3ZELFNBQU8sQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO0FBQ3ZCLE1BQUksT0FBTyxDQUFDLEdBQUcsRUFBRTtBQUNmLFdBQU8sQ0FBQyxJQUFJLENBQUMsV0FBVyxHQUFHLE9BQU8sQ0FBQyxHQUFHLENBQUMsQ0FBQyxDQUFDLElBQUksT0FBTyxDQUFDLElBQUksQ0FBQyxXQUFXLENBQUM7R0FDdkU7O0FBRUQsTUFBSSxZQUFZLFlBQUEsQ0FBQztBQUNqQixNQUFJLE9BQU8sQ0FBQyxFQUFFLElBQUksT0FBTyxDQUFDLEVBQUUsS0FBSyxJQUFJLEVBQUU7QUFDckMsV0FBTyxDQUFDLElBQUksR0FBRyxrQkFBWSxPQUFPLENBQUMsSUFBSSxDQUFDLENBQUM7QUFDekMsZ0JBQVksR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLGVBQWUsQ0FBQyxHQUFHLE9BQU8sQ0FBQyxFQUFFLENBQUM7O0FBRTFELFFBQUksWUFBWSxDQUFDLFFBQVEsRUFBRTtBQUN6QixhQUFPLENBQUMsUUFBUSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsRUFBRSxFQUFFLE9BQU8sQ0FBQyxRQUFRLEVBQUUsWUFBWSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0tBQzlFO0dBQ0Y7O0FBRUQsTUFBSSxPQUFPLEtBQUssU0FBUyxJQUFJLFlBQVksRUFBRTtBQUN6QyxXQUFPLEdBQUcsWUFBWSxDQUFDO0dBQ3hCOztBQUVELE1BQUksT0FBTyxLQUFLLFNBQVMsRUFBRTtBQUN6QixVQUFNLDJCQUFjLGNBQWMsR0FBRyxPQUFPLENBQUMsSUFBSSxHQUFHLHFCQUFxQixDQUFDLENBQUM7R0FDNUUsTUFBTSxJQUFJLE9BQU8sWUFBWSxRQUFRLEVBQUU7QUFDdEMsV0FBTyxPQUFPLENBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFDO0dBQ2xDO0NBQ0Y7O0FBRU0sU0FBUyxJQUFJLEdBQUc7QUFBRSxTQUFPLEVBQUUsQ0FBQztDQUFFOztBQUVyQyxTQUFTLFFBQVEsQ0FBQyxPQUFPLEVBQUUsSUFBSSxFQUFFO0FBQy9CLE1BQUksQ0FBQyxJQUFJLElBQUksRUFBRSxNQUFNLElBQUksSUFBSSxDQUFBLEFBQUMsRUFBRTtBQUM5QixRQUFJLEdBQUcsSUFBSSxHQUFHLGtCQUFZLElBQUksQ0FBQyxHQUFHLEVBQUUsQ0FBQztBQUNyQyxRQUFJLENBQUMsSUFBSSxHQUFHLE9BQU8sQ0FBQztHQUNyQjtBQUNELFNBQU8sSUFBSSxDQUFDO0NBQ2I7O0FBRUQsU0FBUyxpQkFBaUIsQ0FBQyxFQUFFLEVBQUUsSUFBSSxFQUFFLFNBQVMsRUFBRSxNQUFNLEVBQUUsSUFBSSxFQUFFLFdBQVcsRUFBRTtBQUN6RSxNQUFJLEVBQUUsQ0FBQyxTQUFTLEVBQUU7QUFDaEIsUUFBSSxLQUFLLEdBQUcsRUFBRSxDQUFDO0FBQ2YsUUFBSSxHQUFHLEVBQUUsQ0FBQyxTQUFTLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxTQUFTLEVBQUUsTUFBTSxJQUFJLE1BQU0sQ0FBQyxDQUFDLENBQUMsRUFBRSxJQUFJLEVBQUUsV0FBVyxFQUFFLE1BQU0sQ0FBQyxDQUFDO0FBQzVGLFNBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxFQUFFLEtBQUssQ0FBQyxDQUFDO0dBQzNCO0FBQ0QsU0FBTyxJQUFJLENBQUM7Q0FDYiIsImZpbGUiOiJydW50aW1lLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0ICogYXMgVXRpbHMgZnJvbSAnLi91dGlscyc7XG5pbXBvcnQgRXhjZXB0aW9uIGZyb20gJy4vZXhjZXB0aW9uJztcbmltcG9ydCB7IENPTVBJTEVSX1JFVklTSU9OLCBSRVZJU0lPTl9DSEFOR0VTLCBjcmVhdGVGcmFtZSB9IGZyb20gJy4vYmFzZSc7XG5cbmV4cG9ydCBmdW5jdGlvbiBjaGVja1JldmlzaW9uKGNvbXBpbGVySW5mbykge1xuICBjb25zdCBjb21waWxlclJldmlzaW9uID0gY29tcGlsZXJJbmZvICYmIGNvbXBpbGVySW5mb1swXSB8fCAxLFxuICAgICAgICBjdXJyZW50UmV2aXNpb24gPSBDT01QSUxFUl9SRVZJU0lPTjtcblxuICBpZiAoY29tcGlsZXJSZXZpc2lvbiAhPT0gY3VycmVudFJldmlzaW9uKSB7XG4gICAgaWYgKGNvbXBpbGVyUmV2aXNpb24gPCBjdXJyZW50UmV2aXNpb24pIHtcbiAgICAgIGNvbnN0IHJ1bnRpbWVWZXJzaW9ucyA9IFJFVklTSU9OX0NIQU5HRVNbY3VycmVudFJldmlzaW9uXSxcbiAgICAgICAgICAgIGNvbXBpbGVyVmVyc2lvbnMgPSBSRVZJU0lPTl9DSEFOR0VTW2NvbXBpbGVyUmV2aXNpb25dO1xuICAgICAgdGhyb3cgbmV3IEV4Y2VwdGlvbignVGVtcGxhdGUgd2FzIHByZWNvbXBpbGVkIHdpdGggYW4gb2xkZXIgdmVyc2lvbiBvZiBIYW5kbGViYXJzIHRoYW4gdGhlIGN1cnJlbnQgcnVudGltZS4gJyArXG4gICAgICAgICAgICAnUGxlYXNlIHVwZGF0ZSB5b3VyIHByZWNvbXBpbGVyIHRvIGEgbmV3ZXIgdmVyc2lvbiAoJyArIHJ1bnRpbWVWZXJzaW9ucyArICcpIG9yIGRvd25ncmFkZSB5b3VyIHJ1bnRpbWUgdG8gYW4gb2xkZXIgdmVyc2lvbiAoJyArIGNvbXBpbGVyVmVyc2lvbnMgKyAnKS4nKTtcbiAgICB9IGVsc2Uge1xuICAgICAgLy8gVXNlIHRoZSBlbWJlZGRlZCB2ZXJzaW9uIGluZm8gc2luY2UgdGhlIHJ1bnRpbWUgZG9lc24ndCBrbm93IGFib3V0IHRoaXMgcmV2aXNpb24geWV0XG4gICAgICB0aHJvdyBuZXcgRXhjZXB0aW9uKCdUZW1wbGF0ZSB3YXMgcHJlY29tcGlsZWQgd2l0aCBhIG5ld2VyIHZlcnNpb24gb2YgSGFuZGxlYmFycyB0aGFuIHRoZSBjdXJyZW50IHJ1bnRpbWUuICcgK1xuICAgICAgICAgICAgJ1BsZWFzZSB1cGRhdGUgeW91ciBydW50aW1lIHRvIGEgbmV3ZXIgdmVyc2lvbiAoJyArIGNvbXBpbGVySW5mb1sxXSArICcpLicpO1xuICAgIH1cbiAgfVxufVxuXG5leHBvcnQgZnVuY3Rpb24gdGVtcGxhdGUodGVtcGxhdGVTcGVjLCBlbnYpIHtcbiAgLyogaXN0YW5idWwgaWdub3JlIG5leHQgKi9cbiAgaWYgKCFlbnYpIHtcbiAgICB0aHJvdyBuZXcgRXhjZXB0aW9uKCdObyBlbnZpcm9ubWVudCBwYXNzZWQgdG8gdGVtcGxhdGUnKTtcbiAgfVxuICBpZiAoIXRlbXBsYXRlU3BlYyB8fCAhdGVtcGxhdGVTcGVjLm1haW4pIHtcbiAgICB0aHJvdyBuZXcgRXhjZXB0aW9uKCdVbmtub3duIHRlbXBsYXRlIG9iamVjdDogJyArIHR5cGVvZiB0ZW1wbGF0ZVNwZWMpO1xuICB9XG5cbiAgdGVtcGxhdGVTcGVjLm1haW4uZGVjb3JhdG9yID0gdGVtcGxhdGVTcGVjLm1haW5fZDtcblxuICAvLyBOb3RlOiBVc2luZyBlbnYuVk0gcmVmZXJlbmNlcyByYXRoZXIgdGhhbiBsb2NhbCB2YXIgcmVmZXJlbmNlcyB0aHJvdWdob3V0IHRoaXMgc2VjdGlvbiB0byBhbGxvd1xuICAvLyBmb3IgZXh0ZXJuYWwgdXNlcnMgdG8gb3ZlcnJpZGUgdGhlc2UgYXMgcHN1ZWRvLXN1cHBvcnRlZCBBUElzLlxuICBlbnYuVk0uY2hlY2tSZXZpc2lvbih0ZW1wbGF0ZVNwZWMuY29tcGlsZXIpO1xuXG4gIGZ1bmN0aW9uIGludm9rZVBhcnRpYWxXcmFwcGVyKHBhcnRpYWwsIGNvbnRleHQsIG9wdGlvbnMpIHtcbiAgICBpZiAob3B0aW9ucy5oYXNoKSB7XG4gICAgICBjb250ZXh0ID0gVXRpbHMuZXh0ZW5kKHt9LCBjb250ZXh0LCBvcHRpb25zLmhhc2gpO1xuICAgICAgaWYgKG9wdGlvbnMuaWRzKSB7XG4gICAgICAgIG9wdGlvbnMuaWRzWzBdID0gdHJ1ZTtcbiAgICAgIH1cbiAgICB9XG5cbiAgICBwYXJ0aWFsID0gZW52LlZNLnJlc29sdmVQYXJ0aWFsLmNhbGwodGhpcywgcGFydGlhbCwgY29udGV4dCwgb3B0aW9ucyk7XG4gICAgbGV0IHJlc3VsdCA9IGVudi5WTS5pbnZva2VQYXJ0aWFsLmNhbGwodGhpcywgcGFydGlhbCwgY29udGV4dCwgb3B0aW9ucyk7XG5cbiAgICBpZiAocmVzdWx0ID09IG51bGwgJiYgZW52LmNvbXBpbGUpIHtcbiAgICAgIG9wdGlvbnMucGFydGlhbHNbb3B0aW9ucy5uYW1lXSA9IGVudi5jb21waWxlKHBhcnRpYWwsIHRlbXBsYXRlU3BlYy5jb21waWxlck9wdGlvbnMsIGVudik7XG4gICAgICByZXN1bHQgPSBvcHRpb25zLnBhcnRpYWxzW29wdGlvbnMubmFtZV0oY29udGV4dCwgb3B0aW9ucyk7XG4gICAgfVxuICAgIGlmIChyZXN1bHQgIT0gbnVsbCkge1xuICAgICAgaWYgKG9wdGlvbnMuaW5kZW50KSB7XG4gICAgICAgIGxldCBsaW5lcyA9IHJlc3VsdC5zcGxpdCgnXFxuJyk7XG4gICAgICAgIGZvciAobGV0IGkgPSAwLCBsID0gbGluZXMubGVuZ3RoOyBpIDwgbDsgaSsrKSB7XG4gICAgICAgICAgaWYgKCFsaW5lc1tpXSAmJiBpICsgMSA9PT0gbCkge1xuICAgICAgICAgICAgYnJlYWs7XG4gICAgICAgICAgfVxuXG4gICAgICAgICAgbGluZXNbaV0gPSBvcHRpb25zLmluZGVudCArIGxpbmVzW2ldO1xuICAgICAgICB9XG4gICAgICAgIHJlc3VsdCA9IGxpbmVzLmpvaW4oJ1xcbicpO1xuICAgICAgfVxuICAgICAgcmV0dXJuIHJlc3VsdDtcbiAgICB9IGVsc2Uge1xuICAgICAgdGhyb3cgbmV3IEV4Y2VwdGlvbignVGhlIHBhcnRpYWwgJyArIG9wdGlvbnMubmFtZSArICcgY291bGQgbm90IGJlIGNvbXBpbGVkIHdoZW4gcnVubmluZyBpbiBydW50aW1lLW9ubHkgbW9kZScpO1xuICAgIH1cbiAgfVxuXG4gIC8vIEp1c3QgYWRkIHdhdGVyXG4gIGxldCBjb250YWluZXIgPSB7XG4gICAgc3RyaWN0OiBmdW5jdGlvbihvYmosIG5hbWUpIHtcbiAgICAgIGlmICghKG5hbWUgaW4gb2JqKSkge1xuICAgICAgICB0aHJvdyBuZXcgRXhjZXB0aW9uKCdcIicgKyBuYW1lICsgJ1wiIG5vdCBkZWZpbmVkIGluICcgKyBvYmopO1xuICAgICAgfVxuICAgICAgcmV0dXJuIG9ialtuYW1lXTtcbiAgICB9LFxuICAgIGxvb2t1cDogZnVuY3Rpb24oZGVwdGhzLCBuYW1lKSB7XG4gICAgICBjb25zdCBsZW4gPSBkZXB0aHMubGVuZ3RoO1xuICAgICAgZm9yIChsZXQgaSA9IDA7IGkgPCBsZW47IGkrKykge1xuICAgICAgICBpZiAoZGVwdGhzW2ldICYmIGRlcHRoc1tpXVtuYW1lXSAhPSBudWxsKSB7XG4gICAgICAgICAgcmV0dXJuIGRlcHRoc1tpXVtuYW1lXTtcbiAgICAgICAgfVxuICAgICAgfVxuICAgIH0sXG4gICAgbGFtYmRhOiBmdW5jdGlvbihjdXJyZW50LCBjb250ZXh0KSB7XG4gICAgICByZXR1cm4gdHlwZW9mIGN1cnJlbnQgPT09ICdmdW5jdGlvbicgPyBjdXJyZW50LmNhbGwoY29udGV4dCkgOiBjdXJyZW50O1xuICAgIH0sXG5cbiAgICBlc2NhcGVFeHByZXNzaW9uOiBVdGlscy5lc2NhcGVFeHByZXNzaW9uLFxuICAgIGludm9rZVBhcnRpYWw6IGludm9rZVBhcnRpYWxXcmFwcGVyLFxuXG4gICAgZm46IGZ1bmN0aW9uKGkpIHtcbiAgICAgIGxldCByZXQgPSB0ZW1wbGF0ZVNwZWNbaV07XG4gICAgICByZXQuZGVjb3JhdG9yID0gdGVtcGxhdGVTcGVjW2kgKyAnX2QnXTtcbiAgICAgIHJldHVybiByZXQ7XG4gICAgfSxcblxuICAgIHByb2dyYW1zOiBbXSxcbiAgICBwcm9ncmFtOiBmdW5jdGlvbihpLCBkYXRhLCBkZWNsYXJlZEJsb2NrUGFyYW1zLCBibG9ja1BhcmFtcywgZGVwdGhzKSB7XG4gICAgICBsZXQgcHJvZ3JhbVdyYXBwZXIgPSB0aGlzLnByb2dyYW1zW2ldLFxuICAgICAgICAgIGZuID0gdGhpcy5mbihpKTtcbiAgICAgIGlmIChkYXRhIHx8IGRlcHRocyB8fCBibG9ja1BhcmFtcyB8fCBkZWNsYXJlZEJsb2NrUGFyYW1zKSB7XG4gICAgICAgIHByb2dyYW1XcmFwcGVyID0gd3JhcFByb2dyYW0odGhpcywgaSwgZm4sIGRhdGEsIGRlY2xhcmVkQmxvY2tQYXJhbXMsIGJsb2NrUGFyYW1zLCBkZXB0aHMpO1xuICAgICAgfSBlbHNlIGlmICghcHJvZ3JhbVdyYXBwZXIpIHtcbiAgICAgICAgcHJvZ3JhbVdyYXBwZXIgPSB0aGlzLnByb2dyYW1zW2ldID0gd3JhcFByb2dyYW0odGhpcywgaSwgZm4pO1xuICAgICAgfVxuICAgICAgcmV0dXJuIHByb2dyYW1XcmFwcGVyO1xuICAgIH0sXG5cbiAgICBkYXRhOiBmdW5jdGlvbih2YWx1ZSwgZGVwdGgpIHtcbiAgICAgIHdoaWxlICh2YWx1ZSAmJiBkZXB0aC0tKSB7XG4gICAgICAgIHZhbHVlID0gdmFsdWUuX3BhcmVudDtcbiAgICAgIH1cbiAgICAgIHJldHVybiB2YWx1ZTtcbiAgICB9LFxuICAgIG1lcmdlOiBmdW5jdGlvbihwYXJhbSwgY29tbW9uKSB7XG4gICAgICBsZXQgb2JqID0gcGFyYW0gfHwgY29tbW9uO1xuXG4gICAgICBpZiAocGFyYW0gJiYgY29tbW9uICYmIChwYXJhbSAhPT0gY29tbW9uKSkge1xuICAgICAgICBvYmogPSBVdGlscy5leHRlbmQoe30sIGNvbW1vbiwgcGFyYW0pO1xuICAgICAgfVxuXG4gICAgICByZXR1cm4gb2JqO1xuICAgIH0sXG5cbiAgICBub29wOiBlbnYuVk0ubm9vcCxcbiAgICBjb21waWxlckluZm86IHRlbXBsYXRlU3BlYy5jb21waWxlclxuICB9O1xuXG4gIGZ1bmN0aW9uIHJldChjb250ZXh0LCBvcHRpb25zID0ge30pIHtcbiAgICBsZXQgZGF0YSA9IG9wdGlvbnMuZGF0YTtcblxuICAgIHJldC5fc2V0dXAob3B0aW9ucyk7XG4gICAgaWYgKCFvcHRpb25zLnBhcnRpYWwgJiYgdGVtcGxhdGVTcGVjLnVzZURhdGEpIHtcbiAgICAgIGRhdGEgPSBpbml0RGF0YShjb250ZXh0LCBkYXRhKTtcbiAgICB9XG4gICAgbGV0IGRlcHRocyxcbiAgICAgICAgYmxvY2tQYXJhbXMgPSB0ZW1wbGF0ZVNwZWMudXNlQmxvY2tQYXJhbXMgPyBbXSA6IHVuZGVmaW5lZDtcbiAgICBpZiAodGVtcGxhdGVTcGVjLnVzZURlcHRocykge1xuICAgICAgaWYgKG9wdGlvbnMuZGVwdGhzKSB7XG4gICAgICAgIGRlcHRocyA9IGNvbnRleHQgIT0gb3B0aW9ucy5kZXB0aHNbMF0gPyBbY29udGV4dF0uY29uY2F0KG9wdGlvbnMuZGVwdGhzKSA6IG9wdGlvbnMuZGVwdGhzO1xuICAgICAgfSBlbHNlIHtcbiAgICAgICAgZGVwdGhzID0gW2NvbnRleHRdO1xuICAgICAgfVxuICAgIH1cblxuICAgIGZ1bmN0aW9uIG1haW4oY29udGV4dC8qLCBvcHRpb25zKi8pIHtcbiAgICAgIHJldHVybiAnJyArIHRlbXBsYXRlU3BlYy5tYWluKGNvbnRhaW5lciwgY29udGV4dCwgY29udGFpbmVyLmhlbHBlcnMsIGNvbnRhaW5lci5wYXJ0aWFscywgZGF0YSwgYmxvY2tQYXJhbXMsIGRlcHRocyk7XG4gICAgfVxuICAgIG1haW4gPSBleGVjdXRlRGVjb3JhdG9ycyh0ZW1wbGF0ZVNwZWMubWFpbiwgbWFpbiwgY29udGFpbmVyLCBvcHRpb25zLmRlcHRocyB8fCBbXSwgZGF0YSwgYmxvY2tQYXJhbXMpO1xuICAgIHJldHVybiBtYWluKGNvbnRleHQsIG9wdGlvbnMpO1xuICB9XG4gIHJldC5pc1RvcCA9IHRydWU7XG5cbiAgcmV0Ll9zZXR1cCA9IGZ1bmN0aW9uKG9wdGlvbnMpIHtcbiAgICBpZiAoIW9wdGlvbnMucGFydGlhbCkge1xuICAgICAgY29udGFpbmVyLmhlbHBlcnMgPSBjb250YWluZXIubWVyZ2Uob3B0aW9ucy5oZWxwZXJzLCBlbnYuaGVscGVycyk7XG5cbiAgICAgIGlmICh0ZW1wbGF0ZVNwZWMudXNlUGFydGlhbCkge1xuICAgICAgICBjb250YWluZXIucGFydGlhbHMgPSBjb250YWluZXIubWVyZ2Uob3B0aW9ucy5wYXJ0aWFscywgZW52LnBhcnRpYWxzKTtcbiAgICAgIH1cbiAgICAgIGlmICh0ZW1wbGF0ZVNwZWMudXNlUGFydGlhbCB8fCB0ZW1wbGF0ZVNwZWMudXNlRGVjb3JhdG9ycykge1xuICAgICAgICBjb250YWluZXIuZGVjb3JhdG9ycyA9IGNvbnRhaW5lci5tZXJnZShvcHRpb25zLmRlY29yYXRvcnMsIGVudi5kZWNvcmF0b3JzKTtcbiAgICAgIH1cbiAgICB9IGVsc2Uge1xuICAgICAgY29udGFpbmVyLmhlbHBlcnMgPSBvcHRpb25zLmhlbHBlcnM7XG4gICAgICBjb250YWluZXIucGFydGlhbHMgPSBvcHRpb25zLnBhcnRpYWxzO1xuICAgICAgY29udGFpbmVyLmRlY29yYXRvcnMgPSBvcHRpb25zLmRlY29yYXRvcnM7XG4gICAgfVxuICB9O1xuXG4gIHJldC5fY2hpbGQgPSBmdW5jdGlvbihpLCBkYXRhLCBibG9ja1BhcmFtcywgZGVwdGhzKSB7XG4gICAgaWYgKHRlbXBsYXRlU3BlYy51c2VCbG9ja1BhcmFtcyAmJiAhYmxvY2tQYXJhbXMpIHtcbiAgICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ211c3QgcGFzcyBibG9jayBwYXJhbXMnKTtcbiAgICB9XG4gICAgaWYgKHRlbXBsYXRlU3BlYy51c2VEZXB0aHMgJiYgIWRlcHRocykge1xuICAgICAgdGhyb3cgbmV3IEV4Y2VwdGlvbignbXVzdCBwYXNzIHBhcmVudCBkZXB0aHMnKTtcbiAgICB9XG5cbiAgICByZXR1cm4gd3JhcFByb2dyYW0oY29udGFpbmVyLCBpLCB0ZW1wbGF0ZVNwZWNbaV0sIGRhdGEsIDAsIGJsb2NrUGFyYW1zLCBkZXB0aHMpO1xuICB9O1xuICByZXR1cm4gcmV0O1xufVxuXG5leHBvcnQgZnVuY3Rpb24gd3JhcFByb2dyYW0oY29udGFpbmVyLCBpLCBmbiwgZGF0YSwgZGVjbGFyZWRCbG9ja1BhcmFtcywgYmxvY2tQYXJhbXMsIGRlcHRocykge1xuICBmdW5jdGlvbiBwcm9nKGNvbnRleHQsIG9wdGlvbnMgPSB7fSkge1xuICAgIGxldCBjdXJyZW50RGVwdGhzID0gZGVwdGhzO1xuICAgIGlmIChkZXB0aHMgJiYgY29udGV4dCAhPSBkZXB0aHNbMF0pIHtcbiAgICAgIGN1cnJlbnREZXB0aHMgPSBbY29udGV4dF0uY29uY2F0KGRlcHRocyk7XG4gICAgfVxuXG4gICAgcmV0dXJuIGZuKGNvbnRhaW5lcixcbiAgICAgICAgY29udGV4dCxcbiAgICAgICAgY29udGFpbmVyLmhlbHBlcnMsIGNvbnRhaW5lci5wYXJ0aWFscyxcbiAgICAgICAgb3B0aW9ucy5kYXRhIHx8IGRhdGEsXG4gICAgICAgIGJsb2NrUGFyYW1zICYmIFtvcHRpb25zLmJsb2NrUGFyYW1zXS5jb25jYXQoYmxvY2tQYXJhbXMpLFxuICAgICAgICBjdXJyZW50RGVwdGhzKTtcbiAgfVxuXG4gIHByb2cgPSBleGVjdXRlRGVjb3JhdG9ycyhmbiwgcHJvZywgY29udGFpbmVyLCBkZXB0aHMsIGRhdGEsIGJsb2NrUGFyYW1zKTtcblxuICBwcm9nLnByb2dyYW0gPSBpO1xuICBwcm9nLmRlcHRoID0gZGVwdGhzID8gZGVwdGhzLmxlbmd0aCA6IDA7XG4gIHByb2cuYmxvY2tQYXJhbXMgPSBkZWNsYXJlZEJsb2NrUGFyYW1zIHx8IDA7XG4gIHJldHVybiBwcm9nO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gcmVzb2x2ZVBhcnRpYWwocGFydGlhbCwgY29udGV4dCwgb3B0aW9ucykge1xuICBpZiAoIXBhcnRpYWwpIHtcbiAgICBpZiAob3B0aW9ucy5uYW1lID09PSAnQHBhcnRpYWwtYmxvY2snKSB7XG4gICAgICBsZXQgZGF0YSA9IG9wdGlvbnMuZGF0YTtcbiAgICAgIHdoaWxlIChkYXRhWydwYXJ0aWFsLWJsb2NrJ10gPT09IG5vb3ApIHtcbiAgICAgICAgZGF0YSA9IGRhdGEuX3BhcmVudDtcbiAgICAgIH1cbiAgICAgIHBhcnRpYWwgPSBkYXRhWydwYXJ0aWFsLWJsb2NrJ107XG4gICAgICBkYXRhWydwYXJ0aWFsLWJsb2NrJ10gPSBub29wO1xuICAgIH0gZWxzZSB7XG4gICAgICBwYXJ0aWFsID0gb3B0aW9ucy5wYXJ0aWFsc1tvcHRpb25zLm5hbWVdO1xuICAgIH1cbiAgfSBlbHNlIGlmICghcGFydGlhbC5jYWxsICYmICFvcHRpb25zLm5hbWUpIHtcbiAgICAvLyBUaGlzIGlzIGEgZHluYW1pYyBwYXJ0aWFsIHRoYXQgcmV0dXJuZWQgYSBzdHJpbmdcbiAgICBvcHRpb25zLm5hbWUgPSBwYXJ0aWFsO1xuICAgIHBhcnRpYWwgPSBvcHRpb25zLnBhcnRpYWxzW3BhcnRpYWxdO1xuICB9XG4gIHJldHVybiBwYXJ0aWFsO1xufVxuXG5leHBvcnQgZnVuY3Rpb24gaW52b2tlUGFydGlhbChwYXJ0aWFsLCBjb250ZXh0LCBvcHRpb25zKSB7XG4gIG9wdGlvbnMucGFydGlhbCA9IHRydWU7XG4gIGlmIChvcHRpb25zLmlkcykge1xuICAgIG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aCA9IG9wdGlvbnMuaWRzWzBdIHx8IG9wdGlvbnMuZGF0YS5jb250ZXh0UGF0aDtcbiAgfVxuXG4gIGxldCBwYXJ0aWFsQmxvY2s7XG4gIGlmIChvcHRpb25zLmZuICYmIG9wdGlvbnMuZm4gIT09IG5vb3ApIHtcbiAgICBvcHRpb25zLmRhdGEgPSBjcmVhdGVGcmFtZShvcHRpb25zLmRhdGEpO1xuICAgIHBhcnRpYWxCbG9jayA9IG9wdGlvbnMuZGF0YVsncGFydGlhbC1ibG9jayddID0gb3B0aW9ucy5mbjtcblxuICAgIGlmIChwYXJ0aWFsQmxvY2sucGFydGlhbHMpIHtcbiAgICAgIG9wdGlvbnMucGFydGlhbHMgPSBVdGlscy5leHRlbmQoe30sIG9wdGlvbnMucGFydGlhbHMsIHBhcnRpYWxCbG9jay5wYXJ0aWFscyk7XG4gICAgfVxuICB9XG5cbiAgaWYgKHBhcnRpYWwgPT09IHVuZGVmaW5lZCAmJiBwYXJ0aWFsQmxvY2spIHtcbiAgICBwYXJ0aWFsID0gcGFydGlhbEJsb2NrO1xuICB9XG5cbiAgaWYgKHBhcnRpYWwgPT09IHVuZGVmaW5lZCkge1xuICAgIHRocm93IG5ldyBFeGNlcHRpb24oJ1RoZSBwYXJ0aWFsICcgKyBvcHRpb25zLm5hbWUgKyAnIGNvdWxkIG5vdCBiZSBmb3VuZCcpO1xuICB9IGVsc2UgaWYgKHBhcnRpYWwgaW5zdGFuY2VvZiBGdW5jdGlvbikge1xuICAgIHJldHVybiBwYXJ0aWFsKGNvbnRleHQsIG9wdGlvbnMpO1xuICB9XG59XG5cbmV4cG9ydCBmdW5jdGlvbiBub29wKCkgeyByZXR1cm4gJyc7IH1cblxuZnVuY3Rpb24gaW5pdERhdGEoY29udGV4dCwgZGF0YSkge1xuICBpZiAoIWRhdGEgfHwgISgncm9vdCcgaW4gZGF0YSkpIHtcbiAgICBkYXRhID0gZGF0YSA/IGNyZWF0ZUZyYW1lKGRhdGEpIDoge307XG4gICAgZGF0YS5yb290ID0gY29udGV4dDtcbiAgfVxuICByZXR1cm4gZGF0YTtcbn1cblxuZnVuY3Rpb24gZXhlY3V0ZURlY29yYXRvcnMoZm4sIHByb2csIGNvbnRhaW5lciwgZGVwdGhzLCBkYXRhLCBibG9ja1BhcmFtcykge1xuICBpZiAoZm4uZGVjb3JhdG9yKSB7XG4gICAgbGV0IHByb3BzID0ge307XG4gICAgcHJvZyA9IGZuLmRlY29yYXRvcihwcm9nLCBwcm9wcywgY29udGFpbmVyLCBkZXB0aHMgJiYgZGVwdGhzWzBdLCBkYXRhLCBibG9ja1BhcmFtcywgZGVwdGhzKTtcbiAgICBVdGlscy5leHRlbmQocHJvZywgcHJvcHMpO1xuICB9XG4gIHJldHVybiBwcm9nO1xufVxuIl19


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Build out our basic SafeString type


exports.__esModule = true;
function SafeString(string) {
  this.string = string;
}

SafeString.prototype.toString = SafeString.prototype.toHTML = function () {
  return '' + this.string;
};

exports['default'] = SafeString;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL2xpYi9oYW5kbGViYXJzL3NhZmUtc3RyaW5nLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFDQSxTQUFTLFVBQVUsQ0FBQyxNQUFNLEVBQUU7QUFDMUIsTUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLENBQUM7Q0FDdEI7O0FBRUQsVUFBVSxDQUFDLFNBQVMsQ0FBQyxRQUFRLEdBQUcsVUFBVSxDQUFDLFNBQVMsQ0FBQyxNQUFNLEdBQUcsWUFBVztBQUN2RSxTQUFPLEVBQUUsR0FBRyxJQUFJLENBQUMsTUFBTSxDQUFDO0NBQ3pCLENBQUM7O3FCQUVhLFVBQVUiLCJmaWxlIjoic2FmZS1zdHJpbmcuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBCdWlsZCBvdXQgb3VyIGJhc2ljIFNhZmVTdHJpbmcgdHlwZVxuZnVuY3Rpb24gU2FmZVN0cmluZyhzdHJpbmcpIHtcbiAgdGhpcy5zdHJpbmcgPSBzdHJpbmc7XG59XG5cblNhZmVTdHJpbmcucHJvdG90eXBlLnRvU3RyaW5nID0gU2FmZVN0cmluZy5wcm90b3R5cGUudG9IVE1MID0gZnVuY3Rpb24oKSB7XG4gIHJldHVybiAnJyArIHRoaXMuc3RyaW5nO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgU2FmZVN0cmluZztcbiJdfQ==


/***/ }),
/* 67 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// loader.bundle.js